var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Knockout JavaScript library v3.5.1
 * (c) The Knockout.js team - http://knockoutjs.com/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

(function () {
    (function (n) {
        var A = this || (0, eval)("this"),
            w = A.document,
            R = A.navigator,
            v = A.jQuery,
            H = A.JSON;v || "undefined" === typeof jQuery || (v = jQuery);(function (n) {
            "function" === typeof define && define.amd ? define(["exports", "require"], n) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" === (typeof module === "undefined" ? "undefined" : _typeof(module)) ? n(module.exports || exports) : n(A.ko = {});
        })(function (S, T) {
            function K(a, c) {
                return null === a || (typeof a === "undefined" ? "undefined" : _typeof(a)) in W ? a === c : !1;
            }function X(b, c) {
                var d;return function () {
                    d || (d = a.a.setTimeout(function () {
                        d = n;b();
                    }, c));
                };
            }function Y(b, c) {
                var d;return function () {
                    clearTimeout(d);
                    d = a.a.setTimeout(b, c);
                };
            }function Z(a, c) {
                c && "change" !== c ? "beforeChange" === c ? this.pc(a) : this.gb(a, c) : this.qc(a);
            }function aa(a, c) {
                null !== c && c.s && c.s();
            }function ba(a, c) {
                var d = this.qd,
                    e = d[r];e.ra || (this.Qb && this.mb[c] ? (d.uc(c, a, this.mb[c]), this.mb[c] = null, --this.Qb) : e.I[c] || d.uc(c, a, e.J ? { da: a } : d.$c(a)), a.Ja && a.gd());
            }var a = "undefined" !== typeof S ? S : {};a.b = function (b, c) {
                for (var d = b.split("."), e = a, f = 0; f < d.length - 1; f++) {
                    e = e[d[f]];
                }e[d[d.length - 1]] = c;
            };a.L = function (a, c, d) {
                a[c] = d;
            };a.version = "3.5.1";a.b("version", a.version);a.options = { deferUpdates: !1, useOnlyNativeEvents: !1, foreachHidesDestroyed: !1 };a.a = function () {
                function b(a, b) {
                    for (var c in a) {
                        f.call(a, c) && b(c, a[c]);
                    }
                }function c(a, b) {
                    if (b) for (var c in b) {
                        f.call(b, c) && (a[c] = b[c]);
                    }return a;
                }function d(a, b) {
                    a.__proto__ = b;return a;
                }function e(b, c, d, e) {
                    var l = b[c].match(q) || [];a.a.D(d.match(q), function (b) {
                        a.a.Na(l, b, e);
                    });b[c] = l.join(" ");
                }var f = Object.prototype.hasOwnProperty,
                    g = { __proto__: [] } instanceof Array,
                    h = "function" === typeof Symbol,
                    m = {},
                    k = {};m[R && /Firefox\/2/i.test(R.userAgent) ? "KeyboardEvent" : "UIEvents"] = ["keyup", "keydown", "keypress"];m.MouseEvents = "click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave".split(" ");b(m, function (a, b) {
                    if (b.length) for (var c = 0, d = b.length; c < d; c++) {
                        k[b[c]] = a;
                    }
                });var l = { propertychange: !0 },
                    p = w && function () {
                    for (var a = 3, b = w.createElement("div"), c = b.getElementsByTagName("i"); b.innerHTML = "\x3c!--[if gt IE " + ++a + "]><i></i><![endif]--\x3e", c[0];) {}return 4 < a ? a : n;
                }(),
                    q = /\S+/g,
                    t;return { Jc: ["authenticity_token", /^__RequestVerificationToken(_.*)?$/],
                    D: function D(a, b, c) {
                        for (var d = 0, e = a.length; d < e; d++) {
                            b.call(c, a[d], d, a);
                        }
                    }, A: "function" == typeof Array.prototype.indexOf ? function (a, b) {
                        return Array.prototype.indexOf.call(a, b);
                    } : function (a, b) {
                        for (var c = 0, d = a.length; c < d; c++) {
                            if (a[c] === b) return c;
                        }return -1;
                    }, Lb: function Lb(a, b, c) {
                        for (var d = 0, e = a.length; d < e; d++) {
                            if (b.call(c, a[d], d, a)) return a[d];
                        }return n;
                    }, Pa: function Pa(b, c) {
                        var d = a.a.A(b, c);0 < d ? b.splice(d, 1) : 0 === d && b.shift();
                    }, wc: function wc(b) {
                        var c = [];b && a.a.D(b, function (b) {
                            0 > a.a.A(c, b) && c.push(b);
                        });return c;
                    }, Mb: function Mb(a, b, c) {
                        var d = [];if (a) for (var e = 0, l = a.length; e < l; e++) {
                            d.push(b.call(c, a[e], e));
                        }return d;
                    }, jb: function jb(a, b, c) {
                        var d = [];if (a) for (var e = 0, l = a.length; e < l; e++) {
                            b.call(c, a[e], e) && d.push(a[e]);
                        }return d;
                    }, Nb: function Nb(a, b) {
                        if (b instanceof Array) a.push.apply(a, b);else for (var c = 0, d = b.length; c < d; c++) {
                            a.push(b[c]);
                        }return a;
                    }, Na: function Na(b, c, d) {
                        var e = a.a.A(a.a.bc(b), c);0 > e ? d && b.push(c) : d || b.splice(e, 1);
                    }, Ba: g, extend: c, setPrototypeOf: d, Ab: g ? d : c, P: b, Ga: function Ga(a, b, c) {
                        if (!a) return a;var d = {},
                            e;for (e in a) {
                            f.call(a, e) && (d[e] = b.call(c, a[e], e, a));
                        }return d;
                    }, Tb: function Tb(b) {
                        for (; b.firstChild;) {
                            a.removeNode(b.firstChild);
                        }
                    }, Yb: function Yb(b) {
                        b = a.a.la(b);for (var c = (b[0] && b[0].ownerDocument || w).createElement("div"), d = 0, e = b.length; d < e; d++) {
                            c.appendChild(a.oa(b[d]));
                        }return c;
                    }, Ca: function Ca(b, c) {
                        for (var d = 0, e = b.length, l = []; d < e; d++) {
                            var k = b[d].cloneNode(!0);l.push(c ? a.oa(k) : k);
                        }return l;
                    }, va: function va(b, c) {
                        a.a.Tb(b);if (c) for (var d = 0, e = c.length; d < e; d++) {
                            b.appendChild(c[d]);
                        }
                    }, Xc: function Xc(b, c) {
                        var d = b.nodeType ? [b] : b;if (0 < d.length) {
                            for (var e = d[0], l = e.parentNode, k = 0, f = c.length; k < f; k++) {
                                l.insertBefore(c[k], e);
                            }k = 0;for (f = d.length; k < f; k++) {
                                a.removeNode(d[k]);
                            }
                        }
                    }, Ua: function Ua(a, b) {
                        if (a.length) {
                            for (b = 8 === b.nodeType && b.parentNode || b; a.length && a[0].parentNode !== b;) {
                                a.splice(0, 1);
                            }for (; 1 < a.length && a[a.length - 1].parentNode !== b;) {
                                a.length--;
                            }if (1 < a.length) {
                                var c = a[0],
                                    d = a[a.length - 1];for (a.length = 0; c !== d;) {
                                    a.push(c), c = c.nextSibling;
                                }a.push(d);
                            }
                        }return a;
                    }, Zc: function Zc(a, b) {
                        7 > p ? a.setAttribute("selected", b) : a.selected = b;
                    }, Db: function Db(a) {
                        return null === a || a === n ? "" : a.trim ? a.trim() : a.toString().replace(/^[\s\xa0]+|[\s\xa0]+$/g, "");
                    }, Ud: function Ud(a, b) {
                        a = a || "";return b.length > a.length ? !1 : a.substring(0, b.length) === b;
                    }, vd: function vd(a, b) {
                        if (a === b) return !0;if (11 === a.nodeType) return !1;if (b.contains) return b.contains(1 !== a.nodeType ? a.parentNode : a);if (b.compareDocumentPosition) return 16 == (b.compareDocumentPosition(a) & 16);for (; a && a != b;) {
                            a = a.parentNode;
                        }return !!a;
                    }, Sb: function Sb(b) {
                        return a.a.vd(b, b.ownerDocument.documentElement);
                    }, kd: function kd(b) {
                        return !!a.a.Lb(b, a.a.Sb);
                    }, R: function R(a) {
                        return a && a.tagName && a.tagName.toLowerCase();
                    }, Ac: function Ac(b) {
                        return a.onError ? function () {
                            try {
                                return b.apply(this, arguments);
                            } catch (c) {
                                throw a.onError && a.onError(c), c;
                            }
                        } : b;
                    }, setTimeout: function (_setTimeout) {
                        function setTimeout(_x, _x2) {
                            return _setTimeout.apply(this, arguments);
                        }

                        setTimeout.toString = function () {
                            return _setTimeout.toString();
                        };

                        return setTimeout;
                    }(function (b, c) {
                        return setTimeout(a.a.Ac(b), c);
                    }), Gc: function Gc(b) {
                        setTimeout(function () {
                            a.onError && a.onError(b);throw b;
                        }, 0);
                    }, B: function B(b, c, d) {
                        var e = a.a.Ac(d);d = l[c];if (a.options.useOnlyNativeEvents || d || !v) {
                            if (d || "function" != typeof b.addEventListener) {
                                if ("undefined" != typeof b.attachEvent) {
                                    var k = function k(a) {
                                        e.call(b, a);
                                    },
                                        f = "on" + c;b.attachEvent(f, k);a.a.K.za(b, function () {
                                        b.detachEvent(f, k);
                                    });
                                } else throw Error("Browser doesn't support addEventListener or attachEvent");
                            } else b.addEventListener(c, e, !1);
                        } else t || (t = "function" == typeof v(b).on ? "on" : "bind"), v(b)[t](c, e);
                    }, Fb: function Fb(b, c) {
                        if (!b || !b.nodeType) throw Error("element must be a DOM node when calling triggerEvent");var d;"input" === a.a.R(b) && b.type && "click" == c.toLowerCase() ? (d = b.type, d = "checkbox" == d || "radio" == d) : d = !1;if (a.options.useOnlyNativeEvents || !v || d) {
                            if ("function" == typeof w.createEvent) {
                                if ("function" == typeof b.dispatchEvent) d = w.createEvent(k[c] || "HTMLEvents"), d.initEvent(c, !0, !0, A, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, b), b.dispatchEvent(d);else throw Error("The supplied element doesn't support dispatchEvent");
                            } else if (d && b.click) b.click();else if ("undefined" != typeof b.fireEvent) b.fireEvent("on" + c);else throw Error("Browser doesn't support triggering events");
                        } else v(b).trigger(c);
                    }, f: function f(b) {
                        return a.O(b) ? b() : b;
                    }, bc: function bc(b) {
                        return a.O(b) ? b.v() : b;
                    }, Eb: function Eb(b, c, d) {
                        var l;c && ("object" === _typeof(b.classList) ? (l = b.classList[d ? "add" : "remove"], a.a.D(c.match(q), function (a) {
                            l.call(b.classList, a);
                        })) : "string" === typeof b.className.baseVal ? e(b.className, "baseVal", c, d) : e(b, "className", c, d));
                    }, Bb: function Bb(b, c) {
                        var d = a.a.f(c);if (null === d || d === n) d = "";var e = a.h.firstChild(b);!e || 3 != e.nodeType || a.h.nextSibling(e) ? a.h.va(b, [b.ownerDocument.createTextNode(d)]) : e.data = d;a.a.Ad(b);
                    }, Yc: function Yc(a, b) {
                        a.name = b;if (7 >= p) try {
                            var c = a.name.replace(/[&<>'"]/g, function (a) {
                                return "&#" + a.charCodeAt(0) + ";";
                            });a.mergeAttributes(w.createElement("<input name='" + c + "'/>"), !1);
                        } catch (d) {}
                    }, Ad: function Ad(a) {
                        9 <= p && (a = 1 == a.nodeType ? a : a.parentNode, a.style && (a.style.zoom = a.style.zoom));
                    }, wd: function wd(a) {
                        if (p) {
                            var b = a.style.width;a.style.width = 0;a.style.width = b;
                        }
                    }, Pd: function Pd(b, c) {
                        b = a.a.f(b);c = a.a.f(c);for (var d = [], e = b; e <= c; e++) {
                            d.push(e);
                        }return d;
                    }, la: function la(a) {
                        for (var b = [], c = 0, d = a.length; c < d; c++) {
                            b.push(a[c]);
                        }return b;
                    }, Da: function Da(a) {
                        return h ? Symbol(a) : a;
                    }, Zd: 6 === p, $d: 7 === p, W: p, Lc: function Lc(b, c) {
                        for (var d = a.a.la(b.getElementsByTagName("input")).concat(a.a.la(b.getElementsByTagName("textarea"))), e = "string" == typeof c ? function (a) {
                            return a.name === c;
                        } : function (a) {
                            return c.test(a.name);
                        }, l = [], k = d.length - 1; 0 <= k; k--) {
                            e(d[k]) && l.push(d[k]);
                        }return l;
                    }, Nd: function Nd(b) {
                        return "string" == typeof b && (b = a.a.Db(b)) ? H && H.parse ? H.parse(b) : new Function("return " + b)() : null;
                    }, hc: function hc(b, c, d) {
                        if (!H || !H.stringify) throw Error("Cannot find JSON.stringify(). Some browsers (e.g., IE < 8) don't support it natively, but you can overcome this by adding a script reference to json2.js, downloadable from http://www.json.org/json2.js");
                        return H.stringify(a.a.f(b), c, d);
                    }, Od: function Od(c, d, e) {
                        e = e || {};var l = e.params || {},
                            k = e.includeFields || this.Jc,
                            f = c;if ("object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && "form" === a.a.R(c)) for (var f = c.action, h = k.length - 1; 0 <= h; h--) {
                            for (var g = a.a.Lc(c, k[h]), m = g.length - 1; 0 <= m; m--) {
                                l[g[m].name] = g[m].value;
                            }
                        }d = a.a.f(d);var p = w.createElement("form");p.style.display = "none";p.action = f;p.method = "post";for (var q in d) {
                            c = w.createElement("input"), c.type = "hidden", c.name = q, c.value = a.a.hc(a.a.f(d[q])), p.appendChild(c);
                        }b(l, function (a, b) {
                            var c = w.createElement("input");
                            c.type = "hidden";c.name = a;c.value = b;p.appendChild(c);
                        });w.body.appendChild(p);e.submitter ? e.submitter(p) : p.submit();setTimeout(function () {
                            p.parentNode.removeChild(p);
                        }, 0);
                    } };
            }();a.b("utils", a.a);a.b("utils.arrayForEach", a.a.D);a.b("utils.arrayFirst", a.a.Lb);a.b("utils.arrayFilter", a.a.jb);a.b("utils.arrayGetDistinctValues", a.a.wc);a.b("utils.arrayIndexOf", a.a.A);a.b("utils.arrayMap", a.a.Mb);a.b("utils.arrayPushAll", a.a.Nb);a.b("utils.arrayRemoveItem", a.a.Pa);a.b("utils.cloneNodes", a.a.Ca);a.b("utils.createSymbolOrString", a.a.Da);a.b("utils.extend", a.a.extend);a.b("utils.fieldsIncludedWithJsonPost", a.a.Jc);a.b("utils.getFormFields", a.a.Lc);a.b("utils.objectMap", a.a.Ga);a.b("utils.peekObservable", a.a.bc);a.b("utils.postJson", a.a.Od);a.b("utils.parseJson", a.a.Nd);a.b("utils.registerEventHandler", a.a.B);a.b("utils.stringifyJson", a.a.hc);a.b("utils.range", a.a.Pd);a.b("utils.toggleDomNodeCssClass", a.a.Eb);a.b("utils.triggerEvent", a.a.Fb);a.b("utils.unwrapObservable", a.a.f);a.b("utils.objectForEach", a.a.P);a.b("utils.addOrRemoveItem", a.a.Na);a.b("utils.setTextContent", a.a.Bb);a.b("unwrap", a.a.f);Function.prototype.bind || (Function.prototype.bind = function (a) {
                var c = this;if (1 === arguments.length) return function () {
                    return c.apply(a, arguments);
                };var d = Array.prototype.slice.call(arguments, 1);return function () {
                    var e = d.slice(0);e.push.apply(e, arguments);return c.apply(a, e);
                };
            });a.a.g = new function () {
                var b = 0,
                    c = "__ko__" + new Date().getTime(),
                    d = {},
                    e,
                    f;a.a.W ? (e = function e(a, _e) {
                    var f = a[c];if (!f || "null" === f || !d[f]) {
                        if (!_e) return n;f = a[c] = "ko" + b++;d[f] = {};
                    }return d[f];
                }, f = function f(a) {
                    var b = a[c];return b ? (delete d[b], a[c] = null, !0) : !1;
                }) : (e = function e(a, b) {
                    var d = a[c];!d && b && (d = a[c] = {});return d;
                }, f = function f(a) {
                    return a[c] ? (delete a[c], !0) : !1;
                });return { get: function get(a, b) {
                        var c = e(a, !1);return c && c[b];
                    }, set: function set(a, b, c) {
                        (a = e(a, c !== n)) && (a[b] = c);
                    }, Ub: function Ub(a, b, c) {
                        a = e(a, !0);return a[b] || (a[b] = c);
                    }, clear: f, Z: function Z() {
                        return b++ + c;
                    } };
            }();a.b("utils.domData", a.a.g);a.b("utils.domData.clear", a.a.g.clear);a.a.K = new function () {
                function b(b, c) {
                    var d = a.a.g.get(b, e);
                    d === n && c && (d = [], a.a.g.set(b, e, d));return d;
                }function c(c) {
                    var e = b(c, !1);if (e) for (var e = e.slice(0), k = 0; k < e.length; k++) {
                        e[k](c);
                    }a.a.g.clear(c);a.a.K.cleanExternalData(c);g[c.nodeType] && d(c.childNodes, !0);
                }function d(b, d) {
                    for (var e = [], l, f = 0; f < b.length; f++) {
                        if (!d || 8 === b[f].nodeType) if (c(e[e.length] = l = b[f]), b[f] !== l) for (; f-- && -1 == a.a.A(e, b[f]);) {}
                    }
                }var e = a.a.g.Z(),
                    f = { 1: !0, 8: !0, 9: !0 },
                    g = { 1: !0, 9: !0 };return { za: function za(a, c) {
                        if ("function" != typeof c) throw Error("Callback must be a function");b(a, !0).push(c);
                    }, yb: function yb(c, d) {
                        var f = b(c, !1);f && (a.a.Pa(f, d), 0 == f.length && a.a.g.set(c, e, n));
                    }, oa: function oa(b) {
                        a.u.G(function () {
                            f[b.nodeType] && (c(b), g[b.nodeType] && d(b.getElementsByTagName("*")));
                        });return b;
                    }, removeNode: function removeNode(b) {
                        a.oa(b);b.parentNode && b.parentNode.removeChild(b);
                    }, cleanExternalData: function cleanExternalData(a) {
                        v && "function" == typeof v.cleanData && v.cleanData([a]);
                    } };
            }();a.oa = a.a.K.oa;a.removeNode = a.a.K.removeNode;a.b("cleanNode", a.oa);a.b("removeNode", a.removeNode);a.b("utils.domNodeDisposal", a.a.K);a.b("utils.domNodeDisposal.addDisposeCallback", a.a.K.za);a.b("utils.domNodeDisposal.removeDisposeCallback", a.a.K.yb);(function () {
                var b = [0, "", ""],
                    c = [1, "<table>", "</table>"],
                    d = [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                    e = [1, "<select multiple='multiple'>", "</select>"],
                    f = { thead: c, tbody: c, tfoot: c, tr: [2, "<table><tbody>", "</tbody></table>"], td: d, th: d, option: e, optgroup: e },
                    g = 8 >= a.a.W;a.a.ua = function (c, d) {
                    var e;if (v) {
                        if (v.parseHTML) e = v.parseHTML(c, d) || [];else {
                            if ((e = v.clean([c], d)) && e[0]) {
                                for (var l = e[0]; l.parentNode && 11 !== l.parentNode.nodeType;) {
                                    l = l.parentNode;
                                }l.parentNode && l.parentNode.removeChild(l);
                            }
                        }
                    } else {
                        (e = d) || (e = w);var l = e.parentWindow || e.defaultView || A,
                            p = a.a.Db(c).toLowerCase(),
                            q = e.createElement("div"),
                            t;t = (p = p.match(/^(?:\x3c!--.*?--\x3e\s*?)*?<([a-z]+)[\s>]/)) && f[p[1]] || b;p = t[0];t = "ignored<div>" + t[1] + c + t[2] + "</div>";"function" == typeof l.innerShiv ? q.appendChild(l.innerShiv(t)) : (g && e.body.appendChild(q), q.innerHTML = t, g && q.parentNode.removeChild(q));for (; p--;) {
                            q = q.lastChild;
                        }e = a.a.la(q.lastChild.childNodes);
                    }return e;
                };a.a.Md = function (b, c) {
                    var d = a.a.ua(b, c);return d.length && d[0].parentElement || a.a.Yb(d);
                };a.a.fc = function (b, c) {
                    a.a.Tb(b);c = a.a.f(c);if (null !== c && c !== n) if ("string" != typeof c && (c = c.toString()), v) v(b).html(c);else for (var d = a.a.ua(c, b.ownerDocument), e = 0; e < d.length; e++) {
                        b.appendChild(d[e]);
                    }
                };
            })();a.b("utils.parseHtmlFragment", a.a.ua);a.b("utils.setHtml", a.a.fc);a.aa = function () {
                function b(c, e) {
                    if (c) if (8 == c.nodeType) {
                        var f = a.aa.Uc(c.nodeValue);null != f && e.push({ ud: c, Kd: f });
                    } else if (1 == c.nodeType) for (var f = 0, g = c.childNodes, h = g.length; f < h; f++) {
                        b(g[f], e);
                    }
                }var c = {};return { Xb: function Xb(a) {
                        if ("function" != typeof a) throw Error("You can only pass a function to ko.memoization.memoize()");var b = (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1) + (4294967296 * (1 + Math.random()) | 0).toString(16).substring(1);c[b] = a;return "\x3c!--[ko_memo:" + b + "]--\x3e";
                    }, bd: function bd(a, b) {
                        var f = c[a];if (f === n) throw Error("Couldn't find any memo with ID " + a + ". Perhaps it's already been unmemoized.");try {
                            return f.apply(null, b || []), !0;
                        } finally {
                            delete c[a];
                        }
                    }, cd: function cd(c, e) {
                        var f = [];b(c, f);for (var g = 0, h = f.length; g < h; g++) {
                            var m = f[g].ud,
                                k = [m];e && a.a.Nb(k, e);a.aa.bd(f[g].Kd, k);m.nodeValue = "";m.parentNode && m.parentNode.removeChild(m);
                        }
                    }, Uc: function Uc(a) {
                        return (a = a.match(/^\[ko_memo\:(.*?)\]$/)) ? a[1] : null;
                    } };
            }();a.b("memoization", a.aa);a.b("memoization.memoize", a.aa.Xb);a.b("memoization.unmemoize", a.aa.bd);a.b("memoization.parseMemoText", a.aa.Uc);a.b("memoization.unmemoizeDomNodeAndDescendants", a.aa.cd);a.na = function () {
                function b() {
                    if (f) for (var b = f, c = 0, d; h < f;) {
                        if (d = e[h++]) {
                            if (h > b) {
                                if (5E3 <= ++c) {
                                    h = f;a.a.Gc(Error("'Too much recursion' after processing " + c + " task groups."));break;
                                }b = f;
                            }try {
                                d();
                            } catch (p) {
                                a.a.Gc(p);
                            }
                        }
                    }
                }function c() {
                    b();h = f = e.length = 0;
                }var d,
                    e = [],
                    f = 0,
                    g = 1,
                    h = 0;A.MutationObserver ? d = function (a) {
                    var b = w.createElement("div");new MutationObserver(a).observe(b, { attributes: !0 });return function () {
                        b.classList.toggle("foo");
                    };
                }(c) : d = w && "onreadystatechange" in w.createElement("script") ? function (a) {
                    var b = w.createElement("script");b.onreadystatechange = function () {
                        b.onreadystatechange = null;w.documentElement.removeChild(b);
                        b = null;a();
                    };w.documentElement.appendChild(b);
                } : function (a) {
                    setTimeout(a, 0);
                };return { scheduler: d, zb: function zb(b) {
                        f || a.na.scheduler(c);e[f++] = b;return g++;
                    }, cancel: function cancel(a) {
                        a = a - (g - f);a >= h && a < f && (e[a] = null);
                    }, resetForTesting: function resetForTesting() {
                        var a = f - h;h = f = e.length = 0;return a;
                    }, Sd: b };
            }();a.b("tasks", a.na);a.b("tasks.schedule", a.na.zb);a.b("tasks.runEarly", a.na.Sd);a.Ta = { throttle: function throttle(b, c) {
                    b.throttleEvaluation = c;var d = null;return a.$({ read: b, write: function write(e) {
                            clearTimeout(d);d = a.a.setTimeout(function () {
                                b(e);
                            }, c);
                        } });
                }, rateLimit: function rateLimit(a, c) {
                    var d, e, f;"number" == typeof c ? d = c : (d = c.timeout, e = c.method);a.Hb = !1;f = "function" == typeof e ? e : "notifyWhenChangesStop" == e ? Y : X;a.ub(function (a) {
                        return f(a, d, c);
                    });
                }, deferred: function deferred(b, c) {
                    if (!0 !== c) throw Error("The 'deferred' extender only accepts the value 'true', because it is not supported to turn deferral off once enabled.");b.Hb || (b.Hb = !0, b.ub(function (c) {
                        var e,
                            f = !1;return function () {
                            if (!f) {
                                a.na.cancel(e);e = a.na.zb(c);try {
                                    f = !0, b.notifySubscribers(n, "dirty");
                                } finally {
                                    f = !1;
                                }
                            }
                        };
                    }));
                }, notify: function notify(a, c) {
                    a.equalityComparer = "always" == c ? null : K;
                } };var W = { undefined: 1, "boolean": 1, number: 1, string: 1 };a.b("extenders", a.Ta);a.ic = function (b, c, d) {
                this.da = b;this.lc = c;this.mc = d;this.Ib = !1;this.fb = this.Jb = null;a.L(this, "dispose", this.s);a.L(this, "disposeWhenNodeIsRemoved", this.l);
            };a.ic.prototype.s = function () {
                this.Ib || (this.fb && a.a.K.yb(this.Jb, this.fb), this.Ib = !0, this.mc(), this.da = this.lc = this.mc = this.Jb = this.fb = null);
            };a.ic.prototype.l = function (b) {
                this.Jb = b;a.a.K.za(b, this.fb = this.s.bind(this));
            };
            a.T = function () {
                a.a.Ab(this, D);D.qb(this);
            };var D = { qb: function qb(a) {
                    a.U = { change: [] };a.sc = 1;
                }, subscribe: function subscribe(b, c, d) {
                    var e = this;d = d || "change";var f = new a.ic(e, c ? b.bind(c) : b, function () {
                        a.a.Pa(e.U[d], f);e.hb && e.hb(d);
                    });e.Qa && e.Qa(d);e.U[d] || (e.U[d] = []);e.U[d].push(f);return f;
                }, notifySubscribers: function notifySubscribers(b, c) {
                    c = c || "change";"change" === c && this.Gb();if (this.Wa(c)) {
                        var d = "change" === c && this.ed || this.U[c].slice(0);try {
                            a.u.xc();for (var e = 0, f; f = d[e]; ++e) {
                                f.Ib || f.lc(b);
                            }
                        } finally {
                            a.u.end();
                        }
                    }
                }, ob: function ob() {
                    return this.sc;
                },
                Dd: function Dd(a) {
                    return this.ob() !== a;
                }, Gb: function Gb() {
                    ++this.sc;
                }, ub: function ub(b) {
                    var c = this,
                        d = a.O(c),
                        e,
                        f,
                        g,
                        h,
                        m;c.gb || (c.gb = c.notifySubscribers, c.notifySubscribers = Z);var k = b(function () {
                        c.Ja = !1;d && h === c && (h = c.nc ? c.nc() : c());var a = f || m && c.sb(g, h);m = f = e = !1;a && c.gb(g = h);
                    });c.qc = function (a, b) {
                        b && c.Ja || (m = !b);c.ed = c.U.change.slice(0);c.Ja = e = !0;h = a;k();
                    };c.pc = function (a) {
                        e || (g = a, c.gb(a, "beforeChange"));
                    };c.rc = function () {
                        m = !0;
                    };c.gd = function () {
                        c.sb(g, c.v(!0)) && (f = !0);
                    };
                }, Wa: function Wa(a) {
                    return this.U[a] && this.U[a].length;
                },
                Bd: function Bd(b) {
                    if (b) return this.U[b] && this.U[b].length || 0;var c = 0;a.a.P(this.U, function (a, b) {
                        "dirty" !== a && (c += b.length);
                    });return c;
                }, sb: function sb(a, c) {
                    return !this.equalityComparer || !this.equalityComparer(a, c);
                }, toString: function toString() {
                    return "[object Object]";
                }, extend: function extend(b) {
                    var c = this;b && a.a.P(b, function (b, e) {
                        var f = a.Ta[b];"function" == typeof f && (c = f(c, e) || c);
                    });return c;
                } };a.L(D, "init", D.qb);a.L(D, "subscribe", D.subscribe);a.L(D, "extend", D.extend);a.L(D, "getSubscriptionsCount", D.Bd);a.a.Ba && a.a.setPrototypeOf(D, Function.prototype);a.T.fn = D;a.Qc = function (a) {
                return null != a && "function" == typeof a.subscribe && "function" == typeof a.notifySubscribers;
            };a.b("subscribable", a.T);a.b("isSubscribable", a.Qc);a.S = a.u = function () {
                function b(a) {
                    d.push(e);e = a;
                }function c() {
                    e = d.pop();
                }var d = [],
                    e,
                    f = 0;return { xc: b, end: c, cc: function cc(b) {
                        if (e) {
                            if (!a.Qc(b)) throw Error("Only subscribable things can act as dependencies");e.od.call(e.pd, b, b.fd || (b.fd = ++f));
                        }
                    }, G: function G(a, d, e) {
                        try {
                            return b(), a.apply(d, e || []);
                        } finally {
                            c();
                        }
                    }, qa: function qa() {
                        if (e) return e.o.qa();
                    },
                    Va: function Va() {
                        if (e) return e.o.Va();
                    }, Ya: function Ya() {
                        if (e) return e.Ya;
                    }, o: function o() {
                        if (e) return e.o;
                    } };
            }();a.b("computedContext", a.S);a.b("computedContext.getDependenciesCount", a.S.qa);a.b("computedContext.getDependencies", a.S.Va);a.b("computedContext.isInitial", a.S.Ya);a.b("computedContext.registerDependency", a.S.cc);a.b("ignoreDependencies", a.Yd = a.u.G);var I = a.a.Da("_latestValue");a.ta = function (b) {
                function c() {
                    if (0 < arguments.length) return c.sb(c[I], arguments[0]) && (c.ya(), c[I] = arguments[0], c.xa()), this;
                    a.u.cc(c);return c[I];
                }c[I] = b;a.a.Ba || a.a.extend(c, a.T.fn);a.T.fn.qb(c);a.a.Ab(c, F);a.options.deferUpdates && a.Ta.deferred(c, !0);return c;
            };var F = { equalityComparer: K, v: function v() {
                    return this[I];
                }, xa: function xa() {
                    this.notifySubscribers(this[I], "spectate");this.notifySubscribers(this[I]);
                }, ya: function ya() {
                    this.notifySubscribers(this[I], "beforeChange");
                } };a.a.Ba && a.a.setPrototypeOf(F, a.T.fn);var G = a.ta.Ma = "__ko_proto__";F[G] = a.ta;a.O = function (b) {
                if ((b = "function" == typeof b && b[G]) && b !== F[G] && b !== a.o.fn[G]) throw Error("Invalid object that looks like an observable; possibly from another Knockout instance");
                return !!b;
            };a.Za = function (b) {
                return "function" == typeof b && (b[G] === F[G] || b[G] === a.o.fn[G] && b.Nc);
            };a.b("observable", a.ta);a.b("isObservable", a.O);a.b("isWriteableObservable", a.Za);a.b("isWritableObservable", a.Za);a.b("observable.fn", F);a.L(F, "peek", F.v);a.L(F, "valueHasMutated", F.xa);a.L(F, "valueWillMutate", F.ya);a.Ha = function (b) {
                b = b || [];if ("object" != (typeof b === "undefined" ? "undefined" : _typeof(b)) || !("length" in b)) throw Error("The argument passed when initializing an observable array must be an array, or null, or undefined.");b = a.ta(b);a.a.Ab(b, a.Ha.fn);return b.extend({ trackArrayChanges: !0 });
            };a.Ha.fn = { remove: function remove(b) {
                    for (var c = this.v(), d = [], e = "function" != typeof b || a.O(b) ? function (a) {
                        return a === b;
                    } : b, f = 0; f < c.length; f++) {
                        var g = c[f];if (e(g)) {
                            0 === d.length && this.ya();if (c[f] !== g) throw Error("Array modified during remove; cannot remove item");d.push(g);c.splice(f, 1);f--;
                        }
                    }d.length && this.xa();return d;
                }, removeAll: function removeAll(b) {
                    if (b === n) {
                        var c = this.v(),
                            d = c.slice(0);this.ya();c.splice(0, c.length);this.xa();return d;
                    }return b ? this.remove(function (c) {
                        return 0 <= a.a.A(b, c);
                    }) : [];
                }, destroy: function destroy(b) {
                    var c = this.v(),
                        d = "function" != typeof b || a.O(b) ? function (a) {
                        return a === b;
                    } : b;this.ya();for (var e = c.length - 1; 0 <= e; e--) {
                        var f = c[e];d(f) && (f._destroy = !0);
                    }this.xa();
                }, destroyAll: function destroyAll(b) {
                    return b === n ? this.destroy(function () {
                        return !0;
                    }) : b ? this.destroy(function (c) {
                        return 0 <= a.a.A(b, c);
                    }) : [];
                }, indexOf: function indexOf(b) {
                    var c = this();return a.a.A(c, b);
                }, replace: function replace(a, c) {
                    var d = this.indexOf(a);0 <= d && (this.ya(), this.v()[d] = c, this.xa());
                }, sorted: function sorted(a) {
                    var c = this().slice(0);
                    return a ? c.sort(a) : c.sort();
                }, reversed: function reversed() {
                    return this().slice(0).reverse();
                } };a.a.Ba && a.a.setPrototypeOf(a.Ha.fn, a.ta.fn);a.a.D("pop push reverse shift sort splice unshift".split(" "), function (b) {
                a.Ha.fn[b] = function () {
                    var a = this.v();this.ya();this.zc(a, b, arguments);var d = a[b].apply(a, arguments);this.xa();return d === a ? this : d;
                };
            });a.a.D(["slice"], function (b) {
                a.Ha.fn[b] = function () {
                    var a = this();return a[b].apply(a, arguments);
                };
            });a.Pc = function (b) {
                return a.O(b) && "function" == typeof b.remove && "function" == typeof b.push;
            };a.b("observableArray", a.Ha);a.b("isObservableArray", a.Pc);a.Ta.trackArrayChanges = function (b, c) {
                function d() {
                    function c() {
                        if (m) {
                            var d = [].concat(b.v() || []),
                                e;if (b.Wa("arrayChange")) {
                                if (!f || 1 < m) f = a.a.Pb(k, d, b.Ob);e = f;
                            }k = d;f = null;m = 0;e && e.length && b.notifySubscribers(e, "arrayChange");
                        }
                    }e ? c() : (e = !0, h = b.subscribe(function () {
                        ++m;
                    }, null, "spectate"), k = [].concat(b.v() || []), f = null, g = b.subscribe(c));
                }b.Ob = {};c && "object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && a.a.extend(b.Ob, c);b.Ob.sparse = !0;if (!b.zc) {
                    var e = !1,
                        f = null,
                        g,
                        h,
                        m = 0,
                        k,
                        l = b.Qa,
                        p = b.hb;b.Qa = function (a) {
                        l && l.call(b, a);"arrayChange" === a && d();
                    };b.hb = function (a) {
                        p && p.call(b, a);"arrayChange" !== a || b.Wa("arrayChange") || (g && g.s(), h && h.s(), h = g = null, e = !1, k = n);
                    };b.zc = function (b, c, d) {
                        function l(a, b, c) {
                            return k[k.length] = { status: a, value: b, index: c };
                        }if (e && !m) {
                            var k = [],
                                p = b.length,
                                g = d.length,
                                h = 0;switch (c) {case "push":
                                    h = p;case "unshift":
                                    for (c = 0; c < g; c++) {
                                        l("added", d[c], h + c);
                                    }break;case "pop":
                                    h = p - 1;case "shift":
                                    p && l("deleted", b[h], h);break;case "splice":
                                    c = Math.min(Math.max(0, 0 > d[0] ? p + d[0] : d[0]), p);for (var p = 1 === g ? p : Math.min(c + (d[1] || 0), p), g = c + g - 2, h = Math.max(p, g), U = [], L = [], n = 2; c < h; ++c, ++n) {
                                        c < p && L.push(l("deleted", b[c], c)), c < g && U.push(l("added", d[n], c));
                                    }a.a.Kc(L, U);break;default:
                                    return;}f = k;
                        }
                    };
                }
            };var r = a.a.Da("_state");a.o = a.$ = function (b, c, d) {
                function e() {
                    if (0 < arguments.length) {
                        if ("function" === typeof f) f.apply(g.nb, arguments);else throw Error("Cannot write a value to a ko.computed unless you specify a 'write' option. If you wish to read the current value, don't pass any parameters.");return this;
                    }g.ra || a.u.cc(e);(g.ka || g.J && e.Xa()) && e.ha();return g.X;
                }"object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) ? d = b : (d = d || {}, b && (d.read = b));if ("function" != typeof d.read) throw Error("Pass a function that returns the value of the ko.computed");var f = d.write,
                    g = { X: n, sa: !0, ka: !0, rb: !1, jc: !1, ra: !1, wb: !1, J: !1, Wc: d.read, nb: c || d.owner, l: d.disposeWhenNodeIsRemoved || d.l || null, Sa: d.disposeWhen || d.Sa, Rb: null, I: {}, V: 0, Ic: null };e[r] = g;e.Nc = "function" === typeof f;a.a.Ba || a.a.extend(e, a.T.fn);a.T.fn.qb(e);a.a.Ab(e, C);d.pure ? (g.wb = !0, g.J = !0, a.a.extend(e, da)) : d.deferEvaluation && a.a.extend(e, ea);a.options.deferUpdates && a.Ta.deferred(e, !0);g.l && (g.jc = !0, g.l.nodeType || (g.l = null));g.J || d.deferEvaluation || e.ha();g.l && e.ja() && a.a.K.za(g.l, g.Rb = function () {
                    e.s();
                });return e;
            };var C = { equalityComparer: K, qa: function qa() {
                    return this[r].V;
                }, Va: function Va() {
                    var b = [];a.a.P(this[r].I, function (a, d) {
                        b[d.Ka] = d.da;
                    });return b;
                }, Vb: function Vb(b) {
                    if (!this[r].V) return !1;var c = this.Va();return -1 !== a.a.A(c, b) ? !0 : !!a.a.Lb(c, function (a) {
                        return a.Vb && a.Vb(b);
                    });
                }, uc: function uc(a, c, d) {
                    if (this[r].wb && c === this) throw Error("A 'pure' computed must not be called recursively");this[r].I[a] = d;d.Ka = this[r].V++;d.La = c.ob();
                }, Xa: function Xa() {
                    var a,
                        c,
                        d = this[r].I;for (a in d) {
                        if (Object.prototype.hasOwnProperty.call(d, a) && (c = d[a], this.Ia && c.da.Ja || c.da.Dd(c.La))) return !0;
                    }
                }, Jd: function Jd() {
                    this.Ia && !this[r].rb && this.Ia(!1);
                }, ja: function ja() {
                    var a = this[r];return a.ka || 0 < a.V;
                }, Rd: function Rd() {
                    this.Ja ? this[r].ka && (this[r].sa = !0) : this.Hc();
                }, $c: function $c(a) {
                    if (a.Hb) {
                        var c = a.subscribe(this.Jd, this, "dirty"),
                            d = a.subscribe(this.Rd, this);return { da: a, s: function s() {
                                c.s();d.s();
                            } };
                    }return a.subscribe(this.Hc, this);
                }, Hc: function Hc() {
                    var b = this,
                        c = b.throttleEvaluation;c && 0 <= c ? (clearTimeout(this[r].Ic), this[r].Ic = a.a.setTimeout(function () {
                        b.ha(!0);
                    }, c)) : b.Ia ? b.Ia(!0) : b.ha(!0);
                }, ha: function ha(b) {
                    var c = this[r],
                        d = c.Sa,
                        e = !1;if (!c.rb && !c.ra) {
                        if (c.l && !a.a.Sb(c.l) || d && d()) {
                            if (!c.jc) {
                                this.s();return;
                            }
                        } else c.jc = !1;c.rb = !0;try {
                            e = this.zd(b);
                        } finally {
                            c.rb = !1;
                        }return e;
                    }
                }, zd: function zd(b) {
                    var c = this[r],
                        d = !1,
                        e = c.wb ? n : !c.V,
                        d = { qd: this, mb: c.I, Qb: c.V };a.u.xc({ pd: d,
                        od: ba, o: this, Ya: e });c.I = {};c.V = 0;var f = this.yd(c, d);c.V ? d = this.sb(c.X, f) : (this.s(), d = !0);d && (c.J ? this.Gb() : this.notifySubscribers(c.X, "beforeChange"), c.X = f, this.notifySubscribers(c.X, "spectate"), !c.J && b && this.notifySubscribers(c.X), this.rc && this.rc());e && this.notifySubscribers(c.X, "awake");return d;
                }, yd: function yd(b, c) {
                    try {
                        var d = b.Wc;return b.nb ? d.call(b.nb) : d();
                    } finally {
                        a.u.end(), c.Qb && !b.J && a.a.P(c.mb, aa), b.sa = b.ka = !1;
                    }
                }, v: function v(a) {
                    var c = this[r];(c.ka && (a || !c.V) || c.J && this.Xa()) && this.ha();return c.X;
                },
                ub: function ub(b) {
                    a.T.fn.ub.call(this, b);this.nc = function () {
                        this[r].J || (this[r].sa ? this.ha() : this[r].ka = !1);return this[r].X;
                    };this.Ia = function (a) {
                        this.pc(this[r].X);this[r].ka = !0;a && (this[r].sa = !0);this.qc(this, !a);
                    };
                }, s: function s() {
                    var b = this[r];!b.J && b.I && a.a.P(b.I, function (a, b) {
                        b.s && b.s();
                    });b.l && b.Rb && a.a.K.yb(b.l, b.Rb);b.I = n;b.V = 0;b.ra = !0;b.sa = !1;b.ka = !1;b.J = !1;b.l = n;b.Sa = n;b.Wc = n;this.Nc || (b.nb = n);
                } },
                da = { Qa: function Qa(b) {
                    var c = this,
                        d = c[r];if (!d.ra && d.J && "change" == b) {
                        d.J = !1;if (d.sa || c.Xa()) d.I = null, d.V = 0, c.ha() && c.Gb();else {
                            var e = [];a.a.P(d.I, function (a, b) {
                                e[b.Ka] = a;
                            });a.a.D(e, function (a, b) {
                                var e = d.I[a],
                                    m = c.$c(e.da);m.Ka = b;m.La = e.La;d.I[a] = m;
                            });c.Xa() && c.ha() && c.Gb();
                        }d.ra || c.notifySubscribers(d.X, "awake");
                    }
                }, hb: function hb(b) {
                    var c = this[r];c.ra || "change" != b || this.Wa("change") || (a.a.P(c.I, function (a, b) {
                        b.s && (c.I[a] = { da: b.da, Ka: b.Ka, La: b.La }, b.s());
                    }), c.J = !0, this.notifySubscribers(n, "asleep"));
                }, ob: function ob() {
                    var b = this[r];b.J && (b.sa || this.Xa()) && this.ha();return a.T.fn.ob.call(this);
                } },
                ea = { Qa: function Qa(a) {
                    "change" != a && "beforeChange" != a || this.v();
                } };a.a.Ba && a.a.setPrototypeOf(C, a.T.fn);var N = a.ta.Ma;C[N] = a.o;a.Oc = function (a) {
                return "function" == typeof a && a[N] === C[N];
            };a.Fd = function (b) {
                return a.Oc(b) && b[r] && b[r].wb;
            };a.b("computed", a.o);a.b("dependentObservable", a.o);a.b("isComputed", a.Oc);a.b("isPureComputed", a.Fd);a.b("computed.fn", C);a.L(C, "peek", C.v);a.L(C, "dispose", C.s);a.L(C, "isActive", C.ja);a.L(C, "getDependenciesCount", C.qa);a.L(C, "getDependencies", C.Va);a.xb = function (b, c) {
                if ("function" === typeof b) return a.o(b, c, { pure: !0 });b = a.a.extend({}, b);b.pure = !0;return a.o(b, c);
            };a.b("pureComputed", a.xb);(function () {
                function b(a, f, g) {
                    g = g || new d();a = f(a);if ("object" != (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a || a === n || a instanceof RegExp || a instanceof Date || a instanceof String || a instanceof Number || a instanceof Boolean) return a;var h = a instanceof Array ? [] : {};g.save(a, h);c(a, function (c) {
                        var d = f(a[c]);switch (typeof d === "undefined" ? "undefined" : _typeof(d)) {case "boolean":case "number":case "string":case "function":
                                h[c] = d;break;case "object":case "undefined":
                                var l = g.get(d);h[c] = l !== n ? l : b(d, f, g);}
                    });return h;
                }function c(a, b) {
                    if (a instanceof Array) {
                        for (var c = 0; c < a.length; c++) {
                            b(c);
                        }"function" == typeof a.toJSON && b("toJSON");
                    } else for (c in a) {
                        b(c);
                    }
                }function d() {
                    this.keys = [];this.values = [];
                }a.ad = function (c) {
                    if (0 == arguments.length) throw Error("When calling ko.toJS, pass the object you want to convert.");return b(c, function (b) {
                        for (var c = 0; a.O(b) && 10 > c; c++) {
                            b = b();
                        }return b;
                    });
                };a.toJSON = function (b, c, d) {
                    b = a.ad(b);return a.a.hc(b, c, d);
                };d.prototype = { constructor: d, save: function save(b, c) {
                        var d = a.a.A(this.keys, b);0 <= d ? this.values[d] = c : (this.keys.push(b), this.values.push(c));
                    }, get: function get(b) {
                        b = a.a.A(this.keys, b);return 0 <= b ? this.values[b] : n;
                    } };
            })();a.b("toJS", a.ad);a.b("toJSON", a.toJSON);a.Wd = function (b, c, d) {
                function e(c) {
                    var e = a.xb(b, d).extend({ ma: "always" }),
                        h = e.subscribe(function (a) {
                        a && (h.s(), c(a));
                    });e.notifySubscribers(e.v());return h;
                }return "function" !== typeof Promise || c ? e(c.bind(d)) : new Promise(e);
            };a.b("when", a.Wd);(function () {
                a.w = { M: function M(b) {
                        switch (a.a.R(b)) {case "option":
                                return !0 === b.__ko__hasDomDataOptionValue__ ? a.a.g.get(b, a.c.options.$b) : 7 >= a.a.W ? b.getAttributeNode("value") && b.getAttributeNode("value").specified ? b.value : b.text : b.value;case "select":
                                return 0 <= b.selectedIndex ? a.w.M(b.options[b.selectedIndex]) : n;default:
                                return b.value;}
                    }, cb: function cb(b, c, d) {
                        switch (a.a.R(b)) {case "option":
                                "string" === typeof c ? (a.a.g.set(b, a.c.options.$b, n), "__ko__hasDomDataOptionValue__" in b && delete b.__ko__hasDomDataOptionValue__, b.value = c) : (a.a.g.set(b, a.c.options.$b, c), b.__ko__hasDomDataOptionValue__ = !0, b.value = "number" === typeof c ? c : "");break;case "select":
                                if ("" === c || null === c) c = n;for (var e = -1, f = 0, g = b.options.length, h; f < g; ++f) {
                                    if (h = a.w.M(b.options[f]), h == c || "" === h && c === n) {
                                        e = f;break;
                                    }
                                }if (d || 0 <= e || c === n && 1 < b.size) b.selectedIndex = e, 6 === a.a.W && a.a.setTimeout(function () {
                                    b.selectedIndex = e;
                                }, 0);break;default:
                                if (null === c || c === n) c = "";b.value = c;}
                    } };
            })();a.b("selectExtensions", a.w);a.b("selectExtensions.readValue", a.w.M);a.b("selectExtensions.writeValue", a.w.cb);a.m = function () {
                function b(b) {
                    b = a.a.Db(b);123 === b.charCodeAt(0) && (b = b.slice(1, -1));b += "\n,";var c = [],
                        d = b.match(e),
                        p,
                        q = [],
                        h = 0;if (1 < d.length) {
                        for (var x = 0, B; B = d[x]; ++x) {
                            var u = B.charCodeAt(0);if (44 === u) {
                                if (0 >= h) {
                                    c.push(p && q.length ? { key: p, value: q.join("") } : { unknown: p || q.join("") });p = h = 0;q = [];continue;
                                }
                            } else if (58 === u) {
                                if (!h && !p && 1 === q.length) {
                                    p = q.pop();continue;
                                }
                            } else if (47 === u && 1 < B.length && (47 === B.charCodeAt(1) || 42 === B.charCodeAt(1))) continue;else 47 === u && x && 1 < B.length ? (u = d[x - 1].match(f)) && !g[u[0]] && (b = b.substr(b.indexOf(B) + 1), d = b.match(e), x = -1, B = "/") : 40 === u || 123 === u || 91 === u ? ++h : 41 === u || 125 === u || 93 === u ? --h : p || q.length || 34 !== u && 39 !== u || (B = B.slice(1, -1));q.push(B);
                        }if (0 < h) throw Error("Unbalanced parentheses, braces, or brackets");
                    }return c;
                }var c = ["true", "false", "null", "undefined"],
                    d = /^(?:[$_a-z][$\w]*|(.+)(\.\s*[$_a-z][$\w]*|\[.+\]))$/i,
                    e = RegExp("\"(?:\\\\.|[^\"])*\"|'(?:\\\\.|[^'])*'|`(?:\\\\.|[^`])*`|/\\*(?:[^*]|\\*+[^*/])*\\*+/|//.*\n|/(?:\\\\.|[^/])+/w*|[^\\s:,/][^,\"'`{}()/:[\\]]*[^\\s,\"'`{}()/:[\\]]|[^\\s]", "g"),
                    f = /[\])"'A-Za-z0-9_$]+$/,
                    g = { "in": 1, "return": 1, "typeof": 1 },
                    h = {};return { Ra: [], wa: h, ac: b, vb: function vb(e, f) {
                        function l(b, e) {
                            var f;if (!x) {
                                var k = a.getBindingHandler(b);if (k && k.preprocess && !(e = k.preprocess(e, b, l))) return;if (k = h[b]) f = e, 0 <= a.a.A(c, f) ? f = !1 : (k = f.match(d), f = null === k ? !1 : k[1] ? "Object(" + k[1] + ")" + k[2] : f), k = f;k && q.push("'" + ("string" == typeof h[b] ? h[b] : b) + "':function(_z){" + f + "=_z}");
                            }g && (e = "function(){return " + e + " }");p.push("'" + b + "':" + e);
                        }f = f || {};var p = [],
                            q = [],
                            g = f.valueAccessors,
                            x = f.bindingParams,
                            B = "string" === typeof e ? b(e) : e;a.a.D(B, function (a) {
                            l(a.key || a.unknown, a.value);
                        });q.length && l("_ko_property_writers", "{" + q.join(",") + " }");return p.join(",");
                    }, Id: function Id(a, b) {
                        for (var c = 0; c < a.length; c++) {
                            if (a[c].key == b) return !0;
                        }return !1;
                    }, eb: function eb(b, c, d, e, f) {
                        if (b && a.O(b)) !a.Za(b) || f && b.v() === e || b(e);else if ((b = c.get("_ko_property_writers")) && b[d]) b[d](e);
                    } };
            }();a.b("expressionRewriting", a.m);a.b("expressionRewriting.bindingRewriteValidators", a.m.Ra);a.b("expressionRewriting.parseObjectLiteral", a.m.ac);a.b("expressionRewriting.preProcessBindings", a.m.vb);a.b("expressionRewriting._twoWayBindings", a.m.wa);a.b("jsonExpressionRewriting", a.m);a.b("jsonExpressionRewriting.insertPropertyAccessorsIntoJson", a.m.vb);(function () {
                function b(a) {
                    return 8 == a.nodeType && g.test(f ? a.text : a.nodeValue);
                }function c(a) {
                    return 8 == a.nodeType && h.test(f ? a.text : a.nodeValue);
                }function d(d, e) {
                    for (var f = d, h = 1, g = []; f = f.nextSibling;) {
                        if (c(f) && (a.a.g.set(f, k, !0), h--, 0 === h)) return g;g.push(f);b(f) && h++;
                    }if (!e) throw Error("Cannot find closing comment tag to match: " + d.nodeValue);return null;
                }function e(a, b) {
                    var c = d(a, b);return c ? 0 < c.length ? c[c.length - 1].nextSibling : a.nextSibling : null;
                }var f = w && "\x3c!--test--\x3e" === w.createComment("test").text,
                    g = f ? /^\x3c!--\s*ko(?:\s+([\s\S]+))?\s*--\x3e$/ : /^\s*ko(?:\s+([\s\S]+))?\s*$/,
                    h = f ? /^\x3c!--\s*\/ko\s*--\x3e$/ : /^\s*\/ko\s*$/,
                    m = { ul: !0, ol: !0 },
                    k = "__ko_matchedEndComment__";a.h = { ea: {}, childNodes: function childNodes(a) {
                        return b(a) ? d(a) : a.childNodes;
                    }, Ea: function Ea(c) {
                        if (b(c)) {
                            c = a.h.childNodes(c);for (var d = 0, e = c.length; d < e; d++) {
                                a.removeNode(c[d]);
                            }
                        } else a.a.Tb(c);
                    }, va: function va(c, d) {
                        if (b(c)) {
                            a.h.Ea(c);for (var e = c.nextSibling, f = 0, k = d.length; f < k; f++) {
                                e.parentNode.insertBefore(d[f], e);
                            }
                        } else a.a.va(c, d);
                    }, Vc: function Vc(a, c) {
                        var d;b(a) ? (d = a.nextSibling, a = a.parentNode) : d = a.firstChild;d ? c !== d && a.insertBefore(c, d) : a.appendChild(c);
                    }, Wb: function Wb(c, d, e) {
                        e ? (e = e.nextSibling, b(c) && (c = c.parentNode), e ? d !== e && c.insertBefore(d, e) : c.appendChild(d)) : a.h.Vc(c, d);
                    }, firstChild: function firstChild(a) {
                        if (b(a)) return !a.nextSibling || c(a.nextSibling) ? null : a.nextSibling;if (a.firstChild && c(a.firstChild)) throw Error("Found invalid end comment, as the first child of " + a);return a.firstChild;
                    }, nextSibling: function nextSibling(d) {
                        b(d) && (d = e(d));if (d.nextSibling && c(d.nextSibling)) {
                            var f = d.nextSibling;if (c(f) && !a.a.g.get(f, k)) throw Error("Found end comment without a matching opening comment, as child of " + d);return null;
                        }return d.nextSibling;
                    }, Cd: b, Vd: function Vd(a) {
                        return (a = (f ? a.text : a.nodeValue).match(g)) ? a[1] : null;
                    }, Sc: function Sc(d) {
                        if (m[a.a.R(d)]) {
                            var f = d.firstChild;if (f) {
                                do {
                                    if (1 === f.nodeType) {
                                        var k;k = f.firstChild;var h = null;if (k) {
                                            do {
                                                if (h) h.push(k);else if (b(k)) {
                                                    var g = e(k, !0);g ? k = g : h = [k];
                                                } else c(k) && (h = [k]);
                                            } while (k = k.nextSibling);
                                        }if (k = h) for (h = f.nextSibling, g = 0; g < k.length; g++) {
                                            h ? d.insertBefore(k[g], h) : d.appendChild(k[g]);
                                        }
                                    }
                                } while (f = f.nextSibling);
                            }
                        }
                    } };
            })();a.b("virtualElements", a.h);a.b("virtualElements.allowedBindings", a.h.ea);a.b("virtualElements.emptyNode", a.h.Ea);a.b("virtualElements.insertAfter", a.h.Wb);a.b("virtualElements.prepend", a.h.Vc);a.b("virtualElements.setDomNodeChildren", a.h.va);(function () {
                a.ga = function () {
                    this.nd = {};
                };a.a.extend(a.ga.prototype, { nodeHasBindings: function nodeHasBindings(b) {
                        switch (b.nodeType) {case 1:
                                return null != b.getAttribute("data-bind") || a.j.getComponentNameForNode(b);case 8:
                                return a.h.Cd(b);default:
                                return !1;}
                    }, getBindings: function getBindings(b, c) {
                        var d = this.getBindingsString(b, c),
                            d = d ? this.parseBindingsString(d, c, b) : null;return a.j.tc(d, b, c, !1);
                    }, getBindingAccessors: function getBindingAccessors(b, c) {
                        var d = this.getBindingsString(b, c),
                            d = d ? this.parseBindingsString(d, c, b, { valueAccessors: !0 }) : null;return a.j.tc(d, b, c, !0);
                    }, getBindingsString: function getBindingsString(b) {
                        switch (b.nodeType) {case 1:
                                return b.getAttribute("data-bind");case 8:
                                return a.h.Vd(b);default:
                                return null;}
                    },
                    parseBindingsString: function parseBindingsString(b, c, d, e) {
                        try {
                            var f = this.nd,
                                g = b + (e && e.valueAccessors || ""),
                                h;if (!(h = f[g])) {
                                var m,
                                    k = "with($context){with($data||{}){return{" + a.m.vb(b, e) + "}}}";m = new Function("$context", "$element", k);h = f[g] = m;
                            }return h(c, d);
                        } catch (l) {
                            throw l.message = "Unable to parse bindings.\nBindings value: " + b + "\nMessage: " + l.message, l;
                        }
                    } });a.ga.instance = new a.ga();
            })();a.b("bindingProvider", a.ga);(function () {
                function b(b) {
                    var c = (b = a.a.g.get(b, z)) && b.N;c && (b.N = null, c.Tc());
                }function c(c, d, e) {
                    this.node = c;this.yc = d;this.kb = [];this.H = !1;d.N || a.a.K.za(c, b);e && e.N && (e.N.kb.push(c), this.Kb = e);
                }function d(a) {
                    return function () {
                        return a;
                    };
                }function e(a) {
                    return a();
                }function f(b) {
                    return a.a.Ga(a.u.G(b), function (a, c) {
                        return function () {
                            return b()[c];
                        };
                    });
                }function g(b, c, e) {
                    return "function" === typeof b ? f(b.bind(null, c, e)) : a.a.Ga(b, d);
                }function h(a, b) {
                    return f(this.getBindings.bind(this, a, b));
                }function m(b, c) {
                    var d = a.h.firstChild(c);if (d) {
                        var e,
                            f = a.ga.instance,
                            l = f.preprocessNode;if (l) {
                            for (; e = d;) {
                                d = a.h.nextSibling(e), l.call(f, e);
                            }d = a.h.firstChild(c);
                        }for (; e = d;) {
                            d = a.h.nextSibling(e), k(b, e);
                        }
                    }a.i.ma(c, a.i.H);
                }function k(b, c) {
                    var d = b,
                        e = 1 === c.nodeType;e && a.h.Sc(c);if (e || a.ga.instance.nodeHasBindings(c)) d = p(c, null, b).bindingContextForDescendants;d && !u[a.a.R(c)] && m(d, c);
                }function l(b) {
                    var c = [],
                        d = {},
                        e = [];a.a.P(b, function ca(f) {
                        if (!d[f]) {
                            var k = a.getBindingHandler(f);k && (k.after && (e.push(f), a.a.D(k.after, function (c) {
                                if (b[c]) {
                                    if (-1 !== a.a.A(e, c)) throw Error("Cannot combine the following bindings, because they have a cyclic dependency: " + e.join(", "));
                                    ca(c);
                                }
                            }), e.length--), c.push({ key: f, Mc: k }));d[f] = !0;
                        }
                    });return c;
                }function p(b, c, d) {
                    var f = a.a.g.Ub(b, z, {}),
                        k = f.hd;if (!c) {
                        if (k) throw Error("You cannot apply bindings multiple times to the same element.");f.hd = !0;
                    }k || (f.context = d);f.Zb || (f.Zb = {});var g;if (c && "function" !== typeof c) g = c;else {
                        var p = a.ga.instance,
                            q = p.getBindingAccessors || h,
                            m = a.$(function () {
                            if (g = c ? c(d, b) : q.call(p, b, d)) {
                                if (d[t]) d[t]();if (d[B]) d[B]();
                            }return g;
                        }, null, { l: b });g && m.ja() || (m = null);
                    }var x = d,
                        u;if (g) {
                        var J = function J() {
                            return a.a.Ga(m ? m() : g, e);
                        },
                            r = m ? function (a) {
                            return function () {
                                return e(m()[a]);
                            };
                        } : function (a) {
                            return g[a];
                        };J.get = function (a) {
                            return g[a] && e(r(a));
                        };J.has = function (a) {
                            return a in g;
                        };a.i.H in g && a.i.subscribe(b, a.i.H, function () {
                            var c = (0, g[a.i.H])();if (c) {
                                var d = a.h.childNodes(b);d.length && c(d, a.Ec(d[0]));
                            }
                        });a.i.pa in g && (x = a.i.Cb(b, d), a.i.subscribe(b, a.i.pa, function () {
                            var c = (0, g[a.i.pa])();c && a.h.firstChild(b) && c(b);
                        }));f = l(g);a.a.D(f, function (c) {
                            var d = c.Mc.init,
                                e = c.Mc.update,
                                f = c.key;if (8 === b.nodeType && !a.h.ea[f]) throw Error("The binding '" + f + "' cannot be used with virtual elements");try {
                                "function" == typeof d && a.u.G(function () {
                                    var a = d(b, r(f), J, x.$data, x);if (a && a.controlsDescendantBindings) {
                                        if (u !== n) throw Error("Multiple bindings (" + u + " and " + f + ") are trying to control descendant bindings of the same element. You cannot use these bindings together on the same element.");u = f;
                                    }
                                }), "function" == typeof e && a.$(function () {
                                    e(b, r(f), J, x.$data, x);
                                }, null, { l: b });
                            } catch (k) {
                                throw k.message = 'Unable to process binding "' + f + ": " + g[f] + '"\nMessage: ' + k.message, k;
                            }
                        });
                    }f = u === n;return { shouldBindDescendants: f, bindingContextForDescendants: f && x };
                }function q(b, c) {
                    return b && b instanceof a.fa ? b : new a.fa(b, n, n, c);
                }var t = a.a.Da("_subscribable"),
                    x = a.a.Da("_ancestorBindingInfo"),
                    B = a.a.Da("_dataDependency");a.c = {};var u = { script: !0, textarea: !0, template: !0 };a.getBindingHandler = function (b) {
                    return a.c[b];
                };var J = {};a.fa = function (b, c, d, e, f) {
                    function k() {
                        var b = p ? h() : h,
                            f = a.a.f(b);c ? (a.a.extend(l, c), x in c && (l[x] = c[x])) : (l.$parents = [], l.$root = f, l.ko = a);l[t] = q;g ? f = l.$data : (l.$rawData = b, l.$data = f);d && (l[d] = f);e && e(l, c, f);if (c && c[t] && !a.S.o().Vb(c[t])) c[t]();m && (l[B] = m);return l.$data;
                    }var l = this,
                        g = b === J,
                        h = g ? n : b,
                        p = "function" == typeof h && !a.O(h),
                        q,
                        m = f && f.dataDependency;f && f.exportDependencies ? k() : (q = a.xb(k), q.v(), q.ja() ? q.equalityComparer = null : l[t] = n);
                };a.fa.prototype.createChildContext = function (b, c, d, e) {
                    !e && c && "object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && (e = c, c = e.as, d = e.extend);if (c && e && e.noChildContext) {
                        var f = "function" == typeof b && !a.O(b);return new a.fa(J, this, null, function (a) {
                            d && d(a);a[c] = f ? b() : b;
                        }, e);
                    }return new a.fa(b, this, c, function (a, b) {
                        a.$parentContext = b;a.$parent = b.$data;a.$parents = (b.$parents || []).slice(0);a.$parents.unshift(a.$parent);d && d(a);
                    }, e);
                };a.fa.prototype.extend = function (b, c) {
                    return new a.fa(J, this, null, function (c) {
                        a.a.extend(c, "function" == typeof b ? b(c) : b);
                    }, c);
                };var z = a.a.g.Z();c.prototype.Tc = function () {
                    this.Kb && this.Kb.N && this.Kb.N.sd(this.node);
                };c.prototype.sd = function (b) {
                    a.a.Pa(this.kb, b);!this.kb.length && this.H && this.Cc();
                };c.prototype.Cc = function () {
                    this.H = !0;this.yc.N && !this.kb.length && (this.yc.N = null, a.a.K.yb(this.node, b), a.i.ma(this.node, a.i.pa), this.Tc());
                };a.i = { H: "childrenComplete", pa: "descendantsComplete", subscribe: function subscribe(b, c, d, e, f) {
                        var k = a.a.g.Ub(b, z, {});k.Fa || (k.Fa = new a.T());f && f.notifyImmediately && k.Zb[c] && a.u.G(d, e, [b]);return k.Fa.subscribe(d, e, c);
                    }, ma: function ma(b, c) {
                        var d = a.a.g.get(b, z);if (d && (d.Zb[c] = !0, d.Fa && d.Fa.notifySubscribers(b, c), c == a.i.H)) if (d.N) d.N.Cc();else if (d.N === n && d.Fa && d.Fa.Wa(a.i.pa)) throw Error("descendantsComplete event not supported for bindings on this node");
                    }, Cb: function Cb(b, d) {
                        var e = a.a.g.Ub(b, z, {});e.N || (e.N = new c(b, e, d[x]));return d[x] == e ? d : d.extend(function (a) {
                            a[x] = e;
                        });
                    } };a.Td = function (b) {
                    return (b = a.a.g.get(b, z)) && b.context;
                };a.ib = function (b, c, d) {
                    1 === b.nodeType && a.h.Sc(b);return p(b, c, q(d));
                };a.ld = function (b, c, d) {
                    d = q(d);return a.ib(b, g(c, d, b), d);
                };a.Oa = function (a, b) {
                    1 !== b.nodeType && 8 !== b.nodeType || m(q(a), b);
                };a.vc = function (a, b, c) {
                    !v && A.jQuery && (v = A.jQuery);if (2 > arguments.length) {
                        if (b = w.body, !b) throw Error("ko.applyBindings: could not find document.body; has the document been loaded?");
                    } else if (!b || 1 !== b.nodeType && 8 !== b.nodeType) throw Error("ko.applyBindings: first parameter should be your view model; second parameter should be a DOM node");k(q(a, c), b);
                };a.Dc = function (b) {
                    return !b || 1 !== b.nodeType && 8 !== b.nodeType ? n : a.Td(b);
                };a.Ec = function (b) {
                    return (b = a.Dc(b)) ? b.$data : n;
                };a.b("bindingHandlers", a.c);a.b("bindingEvent", a.i);a.b("bindingEvent.subscribe", a.i.subscribe);a.b("bindingEvent.startPossiblyAsyncContentBinding", a.i.Cb);a.b("applyBindings", a.vc);a.b("applyBindingsToDescendants", a.Oa);
                a.b("applyBindingAccessorsToNode", a.ib);a.b("applyBindingsToNode", a.ld);a.b("contextFor", a.Dc);a.b("dataFor", a.Ec);
            })();(function (b) {
                function c(c, e) {
                    var k = Object.prototype.hasOwnProperty.call(f, c) ? f[c] : b,
                        l;k ? k.subscribe(e) : (k = f[c] = new a.T(), k.subscribe(e), d(c, function (b, d) {
                        var e = !(!d || !d.synchronous);g[c] = { definition: b, Gd: e };delete f[c];l || e ? k.notifySubscribers(b) : a.na.zb(function () {
                            k.notifySubscribers(b);
                        });
                    }), l = !0);
                }function d(a, b) {
                    e("getConfig", [a], function (c) {
                        c ? e("loadComponent", [a, c], function (a) {
                            b(a, c);
                        }) : b(null, null);
                    });
                }function e(c, d, f, l) {
                    l || (l = a.j.loaders.slice(0));var g = l.shift();if (g) {
                        var q = g[c];if (q) {
                            var t = !1;if (q.apply(g, d.concat(function (a) {
                                t ? f(null) : null !== a ? f(a) : e(c, d, f, l);
                            })) !== b && (t = !0, !g.suppressLoaderExceptions)) throw Error("Component loaders must supply values by invoking the callback, not by returning values synchronously.");
                        } else e(c, d, f, l);
                    } else f(null);
                }var f = {},
                    g = {};a.j = { get: function get(d, e) {
                        var f = Object.prototype.hasOwnProperty.call(g, d) ? g[d] : b;f ? f.Gd ? a.u.G(function () {
                            e(f.definition);
                        }) : a.na.zb(function () {
                            e(f.definition);
                        }) : c(d, e);
                    }, Bc: function Bc(a) {
                        delete g[a];
                    }, oc: e };a.j.loaders = [];a.b("components", a.j);a.b("components.get", a.j.get);a.b("components.clearCachedDefinition", a.j.Bc);
            })();(function () {
                function b(b, c, d, e) {
                    function g() {
                        0 === --B && e(h);
                    }var h = {},
                        B = 2,
                        u = d.template;d = d.viewModel;u ? f(c, u, function (c) {
                        a.j.oc("loadTemplate", [b, c], function (a) {
                            h.template = a;g();
                        });
                    }) : g();d ? f(c, d, function (c) {
                        a.j.oc("loadViewModel", [b, c], function (a) {
                            h[m] = a;g();
                        });
                    }) : g();
                }function c(a, b, d) {
                    if ("function" === typeof b) d(function (a) {
                        return new b(a);
                    });else if ("function" === typeof b[m]) d(b[m]);else if ("instance" in b) {
                        var e = b.instance;d(function () {
                            return e;
                        });
                    } else "viewModel" in b ? c(a, b.viewModel, d) : a("Unknown viewModel value: " + b);
                }function d(b) {
                    switch (a.a.R(b)) {case "script":
                            return a.a.ua(b.text);case "textarea":
                            return a.a.ua(b.value);case "template":
                            if (e(b.content)) return a.a.Ca(b.content.childNodes);}return a.a.Ca(b.childNodes);
                }function e(a) {
                    return A.DocumentFragment ? a instanceof DocumentFragment : a && 11 === a.nodeType;
                }function f(a, b, c) {
                    "string" === typeof b.require ? T || A.require ? (T || A.require)([b.require], function (a) {
                        a && "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && a.Xd && a["default"] && (a = a["default"]);c(a);
                    }) : a("Uses require, but no AMD loader is present") : c(b);
                }function g(a) {
                    return function (b) {
                        throw Error("Component '" + a + "': " + b);
                    };
                }var h = {};a.j.register = function (b, c) {
                    if (!c) throw Error("Invalid configuration for " + b);if (a.j.tb(b)) throw Error("Component " + b + " is already registered");h[b] = c;
                };a.j.tb = function (a) {
                    return Object.prototype.hasOwnProperty.call(h, a);
                };a.j.unregister = function (b) {
                    delete h[b];
                    a.j.Bc(b);
                };a.j.Fc = { getConfig: function getConfig(b, c) {
                        c(a.j.tb(b) ? h[b] : null);
                    }, loadComponent: function loadComponent(a, c, d) {
                        var e = g(a);f(e, c, function (c) {
                            b(a, e, c, d);
                        });
                    }, loadTemplate: function loadTemplate(b, c, f) {
                        b = g(b);if ("string" === typeof c) f(a.a.ua(c));else if (c instanceof Array) f(c);else if (e(c)) f(a.a.la(c.childNodes));else if (c.element) {
                            if (c = c.element, A.HTMLElement ? c instanceof HTMLElement : c && c.tagName && 1 === c.nodeType) f(d(c));else if ("string" === typeof c) {
                                var h = w.getElementById(c);h ? f(d(h)) : b("Cannot find element with ID " + c);
                            } else b("Unknown element type: " + c);
                        } else b("Unknown template value: " + c);
                    }, loadViewModel: function loadViewModel(a, b, d) {
                        c(g(a), b, d);
                    } };var m = "createViewModel";a.b("components.register", a.j.register);a.b("components.isRegistered", a.j.tb);a.b("components.unregister", a.j.unregister);a.b("components.defaultLoader", a.j.Fc);a.j.loaders.push(a.j.Fc);a.j.dd = h;
            })();(function () {
                function b(b, e) {
                    var f = b.getAttribute("params");if (f) {
                        var f = c.parseBindingsString(f, e, b, { valueAccessors: !0, bindingParams: !0 }),
                            f = a.a.Ga(f, function (c) {
                            return a.o(c, null, { l: b });
                        }),
                            g = a.a.Ga(f, function (c) {
                            var e = c.v();return c.ja() ? a.o({ read: function read() {
                                    return a.a.f(c());
                                }, write: a.Za(e) && function (a) {
                                    c()(a);
                                }, l: b }) : e;
                        });Object.prototype.hasOwnProperty.call(g, "$raw") || (g.$raw = f);return g;
                    }return { $raw: {} };
                }a.j.getComponentNameForNode = function (b) {
                    var c = a.a.R(b);if (a.j.tb(c) && (-1 != c.indexOf("-") || "[object HTMLUnknownElement]" == "" + b || 8 >= a.a.W && b.tagName === c)) return c;
                };a.j.tc = function (c, e, f, g) {
                    if (1 === e.nodeType) {
                        var h = a.j.getComponentNameForNode(e);if (h) {
                            c = c || {};if (c.component) throw Error('Cannot use the "component" binding on a custom element matching a component');
                            var m = { name: h, params: b(e, f) };c.component = g ? function () {
                                return m;
                            } : m;
                        }
                    }return c;
                };var c = new a.ga();9 > a.a.W && (a.j.register = function (a) {
                    return function (b) {
                        return a.apply(this, arguments);
                    };
                }(a.j.register), w.createDocumentFragment = function (b) {
                    return function () {
                        var c = b(),
                            f = a.j.dd,
                            g;for (g in f) {}return c;
                    };
                }(w.createDocumentFragment));
            })();(function () {
                function b(b, c, d) {
                    c = c.template;if (!c) throw Error("Component '" + b + "' has no template");b = a.a.Ca(c);a.h.va(d, b);
                }function c(a, b, c) {
                    var d = a.createViewModel;return d ? d.call(a, b, c) : b;
                }var d = 0;a.c.component = { init: function init(e, f, g, h, m) {
                        function k() {
                            var a = l && l.dispose;"function" === typeof a && a.call(l);q && q.s();p = l = q = null;
                        }var l,
                            p,
                            q,
                            t = a.a.la(a.h.childNodes(e));a.h.Ea(e);a.a.K.za(e, k);a.o(function () {
                            var g = a.a.f(f()),
                                h,
                                u;"string" === typeof g ? h = g : (h = a.a.f(g.name), u = a.a.f(g.params));if (!h) throw Error("No component name specified");var n = a.i.Cb(e, m),
                                z = p = ++d;a.j.get(h, function (d) {
                                if (p === z) {
                                    k();if (!d) throw Error("Unknown component '" + h + "'");b(h, d, e);var f = c(d, u, { element: e, templateNodes: t });
                                    d = n.createChildContext(f, { extend: function extend(a) {
                                            a.$component = f;a.$componentTemplateNodes = t;
                                        } });f && f.koDescendantsComplete && (q = a.i.subscribe(e, a.i.pa, f.koDescendantsComplete, f));l = f;a.Oa(d, e);
                                }
                            });
                        }, null, { l: e });return { controlsDescendantBindings: !0 };
                    } };a.h.ea.component = !0;
            })();var V = { "class": "className", "for": "htmlFor" };a.c.attr = { update: function update(b, c) {
                    var d = a.a.f(c()) || {};a.a.P(d, function (c, d) {
                        d = a.a.f(d);var g = c.indexOf(":"),
                            g = "lookupNamespaceURI" in b && 0 < g && b.lookupNamespaceURI(c.substr(0, g)),
                            h = !1 === d || null === d || d === n;h ? g ? b.removeAttributeNS(g, c) : b.removeAttribute(c) : d = d.toString();8 >= a.a.W && c in V ? (c = V[c], h ? b.removeAttribute(c) : b[c] = d) : h || (g ? b.setAttributeNS(g, c, d) : b.setAttribute(c, d));"name" === c && a.a.Yc(b, h ? "" : d);
                    });
                } };(function () {
                a.c.checked = { after: ["value", "attr"], init: function init(b, c, d) {
                        function e() {
                            var e = b.checked,
                                f = g();if (!a.S.Ya() && (e || !m && !a.S.qa())) {
                                var k = a.u.G(c);if (l) {
                                    var q = p ? k.v() : k,
                                        z = t;t = f;z !== f ? e && (a.a.Na(q, f, !0), a.a.Na(q, z, !1)) : a.a.Na(q, f, e);p && a.Za(k) && k(q);
                                } else h && (f === n ? f = e : e || (f = n)), a.m.eb(k, d, "checked", f, !0);
                            }
                        }function f() {
                            var d = a.a.f(c()),
                                e = g();l ? (b.checked = 0 <= a.a.A(d, e), t = e) : b.checked = h && e === n ? !!d : g() === d;
                        }var g = a.xb(function () {
                            if (d.has("checkedValue")) return a.a.f(d.get("checkedValue"));if (q) return d.has("value") ? a.a.f(d.get("value")) : b.value;
                        }),
                            h = "checkbox" == b.type,
                            m = "radio" == b.type;if (h || m) {
                            var k = c(),
                                l = h && a.a.f(k) instanceof Array,
                                p = !(l && k.push && k.splice),
                                q = m || l,
                                t = l ? g() : n;m && !b.name && a.c.uniqueName.init(b, function () {
                                return !0;
                            });a.o(e, null, { l: b });a.a.B(b, "click", e);a.o(f, null, { l: b });
                            k = n;
                        }
                    } };a.m.wa.checked = !0;a.c.checkedValue = { update: function update(b, c) {
                        b.value = a.a.f(c());
                    } };
            })();a.c["class"] = { update: function update(b, c) {
                    var d = a.a.Db(a.a.f(c()));a.a.Eb(b, b.__ko__cssValue, !1);b.__ko__cssValue = d;a.a.Eb(b, d, !0);
                } };a.c.css = { update: function update(b, c) {
                    var d = a.a.f(c());null !== d && "object" == (typeof d === "undefined" ? "undefined" : _typeof(d)) ? a.a.P(d, function (c, d) {
                        d = a.a.f(d);a.a.Eb(b, c, d);
                    }) : a.c["class"].update(b, c);
                } };a.c.enable = { update: function update(b, c) {
                    var d = a.a.f(c());d && b.disabled ? b.removeAttribute("disabled") : d || b.disabled || (b.disabled = !0);
                } };a.c.disable = { update: function update(b, c) {
                    a.c.enable.update(b, function () {
                        return !a.a.f(c());
                    });
                } };a.c.event = { init: function init(b, c, d, e, f) {
                    var g = c() || {};a.a.P(g, function (g) {
                        "string" == typeof g && a.a.B(b, g, function (b) {
                            var k,
                                l = c()[g];if (l) {
                                try {
                                    var p = a.a.la(arguments);e = f.$data;p.unshift(e);k = l.apply(e, p);
                                } finally {
                                    !0 !== k && (b.preventDefault ? b.preventDefault() : b.returnValue = !1);
                                }!1 === d.get(g + "Bubble") && (b.cancelBubble = !0, b.stopPropagation && b.stopPropagation());
                            }
                        });
                    });
                } };a.c.foreach = { Rc: function Rc(b) {
                    return function () {
                        var c = b(),
                            d = a.a.bc(c);
                        if (!d || "number" == typeof d.length) return { foreach: c, templateEngine: a.ba.Ma };a.a.f(c);return { foreach: d.data, as: d.as, noChildContext: d.noChildContext, includeDestroyed: d.includeDestroyed, afterAdd: d.afterAdd, beforeRemove: d.beforeRemove, afterRender: d.afterRender, beforeMove: d.beforeMove, afterMove: d.afterMove, templateEngine: a.ba.Ma };
                    };
                }, init: function init(b, c) {
                    return a.c.template.init(b, a.c.foreach.Rc(c));
                }, update: function update(b, c, d, e, f) {
                    return a.c.template.update(b, a.c.foreach.Rc(c), d, e, f);
                } };a.m.Ra.foreach = !1;a.h.ea.foreach = !0;a.c.hasfocus = { init: function init(b, c, d) {
                    function e(e) {
                        b.__ko_hasfocusUpdating = !0;var f = b.ownerDocument;if ("activeElement" in f) {
                            var g;try {
                                g = f.activeElement;
                            } catch (l) {
                                g = f.body;
                            }e = g === b;
                        }f = c();a.m.eb(f, d, "hasfocus", e, !0);b.__ko_hasfocusLastValue = e;b.__ko_hasfocusUpdating = !1;
                    }var f = e.bind(null, !0),
                        g = e.bind(null, !1);a.a.B(b, "focus", f);a.a.B(b, "focusin", f);a.a.B(b, "blur", g);a.a.B(b, "focusout", g);b.__ko_hasfocusLastValue = !1;
                }, update: function update(b, c) {
                    var d = !!a.a.f(c());b.__ko_hasfocusUpdating || b.__ko_hasfocusLastValue === d || (d ? b.focus() : b.blur(), !d && b.__ko_hasfocusLastValue && b.ownerDocument.body.focus(), a.u.G(a.a.Fb, null, [b, d ? "focusin" : "focusout"]));
                } };a.m.wa.hasfocus = !0;a.c.hasFocus = a.c.hasfocus;a.m.wa.hasFocus = "hasfocus";a.c.html = { init: function init() {
                    return { controlsDescendantBindings: !0 };
                }, update: function update(b, c) {
                    a.a.fc(b, c());
                } };(function () {
                function b(b, d, e) {
                    a.c[b] = { init: function init(b, c, h, m, k) {
                            var l,
                                p,
                                q = {},
                                t,
                                x,
                                n;if (d) {
                                m = h.get("as");var u = h.get("noChildContext");n = !(m && u);q = { as: m, noChildContext: u, exportDependencies: n };
                            }x = (t = "render" == h.get("completeOn")) || h.has(a.i.pa);a.o(function () {
                                var h = a.a.f(c()),
                                    m = !e !== !h,
                                    u = !p,
                                    r;if (n || m !== l) {
                                    x && (k = a.i.Cb(b, k));if (m) {
                                        if (!d || n) q.dataDependency = a.S.o();r = d ? k.createChildContext("function" == typeof h ? h : c, q) : a.S.qa() ? k.extend(null, q) : k;
                                    }u && a.S.qa() && (p = a.a.Ca(a.h.childNodes(b), !0));m ? (u || a.h.va(b, a.a.Ca(p)), a.Oa(r, b)) : (a.h.Ea(b), t || a.i.ma(b, a.i.H));l = m;
                                }
                            }, null, { l: b });return { controlsDescendantBindings: !0 };
                        } };a.m.Ra[b] = !1;a.h.ea[b] = !0;
                }b("if");b("ifnot", !1, !0);b("with", !0);
            })();a.c.let = { init: function init(b, c, d, e, f) {
                    c = f.extend(c);a.Oa(c, b);return { controlsDescendantBindings: !0 };
                } };a.h.ea.let = !0;var Q = {};a.c.options = { init: function init(b) {
                    if ("select" !== a.a.R(b)) throw Error("options binding applies only to SELECT elements");for (; 0 < b.length;) {
                        b.remove(0);
                    }return { controlsDescendantBindings: !0 };
                }, update: function update(b, c, d) {
                    function e() {
                        return a.a.jb(b.options, function (a) {
                            return a.selected;
                        });
                    }function f(a, b, c) {
                        var d = typeof b === "undefined" ? "undefined" : _typeof(b);return "function" == d ? b(a) : "string" == d ? a[b] : c;
                    }function g(c, d) {
                        if (x && l) a.i.ma(b, a.i.H);else if (t.length) {
                            var e = 0 <= a.a.A(t, a.w.M(d[0]));a.a.Zc(d[0], e);x && !e && a.u.G(a.a.Fb, null, [b, "change"]);
                        }
                    }var h = b.multiple,
                        m = 0 != b.length && h ? b.scrollTop : null,
                        k = a.a.f(c()),
                        l = d.get("valueAllowUnset") && d.has("value"),
                        p = d.get("optionsIncludeDestroyed");c = {};var q,
                        t = [];l || (h ? t = a.a.Mb(e(), a.w.M) : 0 <= b.selectedIndex && t.push(a.w.M(b.options[b.selectedIndex])));k && ("undefined" == typeof k.length && (k = [k]), q = a.a.jb(k, function (b) {
                        return p || b === n || null === b || !a.a.f(b._destroy);
                    }), d.has("optionsCaption") && (k = a.a.f(d.get("optionsCaption")), null !== k && k !== n && q.unshift(Q)));var x = !1;c.beforeRemove = function (a) {
                        b.removeChild(a);
                    };k = g;d.has("optionsAfterRender") && "function" == typeof d.get("optionsAfterRender") && (k = function k(b, c) {
                        g(0, c);a.u.G(d.get("optionsAfterRender"), null, [c[0], b !== Q ? b : n]);
                    });a.a.ec(b, q, function (c, e, g) {
                        g.length && (t = !l && g[0].selected ? [a.w.M(g[0])] : [], x = !0);e = b.ownerDocument.createElement("option");c === Q ? (a.a.Bb(e, d.get("optionsCaption")), a.w.cb(e, n)) : (g = f(c, d.get("optionsValue"), c), a.w.cb(e, a.a.f(g)), c = f(c, d.get("optionsText"), g), a.a.Bb(e, c));return [e];
                    }, c, k);if (!l) {
                        var B;h ? B = t.length && e().length < t.length : B = t.length && 0 <= b.selectedIndex ? a.w.M(b.options[b.selectedIndex]) !== t[0] : t.length || 0 <= b.selectedIndex;B && a.u.G(a.a.Fb, null, [b, "change"]);
                    }(l || a.S.Ya()) && a.i.ma(b, a.i.H);a.a.wd(b);m && 20 < Math.abs(m - b.scrollTop) && (b.scrollTop = m);
                } };a.c.options.$b = a.a.g.Z();a.c.selectedOptions = { init: function init(b, c, d) {
                    function e() {
                        var e = c(),
                            f = [];a.a.D(b.getElementsByTagName("option"), function (b) {
                            b.selected && f.push(a.w.M(b));
                        });a.m.eb(e, d, "selectedOptions", f);
                    }function f() {
                        var d = a.a.f(c()),
                            e = b.scrollTop;d && "number" == typeof d.length && a.a.D(b.getElementsByTagName("option"), function (b) {
                            var c = 0 <= a.a.A(d, a.w.M(b));b.selected != c && a.a.Zc(b, c);
                        });b.scrollTop = e;
                    }if ("select" != a.a.R(b)) throw Error("selectedOptions binding applies only to SELECT elements");var g;a.i.subscribe(b, a.i.H, function () {
                        g ? e() : (a.a.B(b, "change", e), g = a.o(f, null, { l: b }));
                    }, null, { notifyImmediately: !0 });
                }, update: function update() {} };a.m.wa.selectedOptions = !0;a.c.style = { update: function update(b, c) {
                    var d = a.a.f(c() || {});a.a.P(d, function (c, d) {
                        d = a.a.f(d);if (null === d || d === n || !1 === d) d = "";if (v) v(b).css(c, d);else if (/^--/.test(c)) b.style.setProperty(c, d);else {
                            c = c.replace(/-(\w)/g, function (a, b) {
                                return b.toUpperCase();
                            });var g = b.style[c];b.style[c] = d;d === g || b.style[c] != g || isNaN(d) || (b.style[c] = d + "px");
                        }
                    });
                } };a.c.submit = { init: function init(b, c, d, e, f) {
                    if ("function" != typeof c()) throw Error("The value for a submit binding must be a function");a.a.B(b, "submit", function (a) {
                        var d,
                            e = c();try {
                            d = e.call(f.$data, b);
                        } finally {
                            !0 !== d && (a.preventDefault ? a.preventDefault() : a.returnValue = !1);
                        }
                    });
                } };a.c.text = { init: function init() {
                    return { controlsDescendantBindings: !0 };
                }, update: function update(b, c) {
                    a.a.Bb(b, c());
                } };a.h.ea.text = !0;(function () {
                if (A && A.navigator) {
                    var b = function b(a) {
                        if (a) return parseFloat(a[1]);
                    },
                        c = A.navigator.userAgent,
                        d,
                        e,
                        f,
                        g,
                        h;(d = A.opera && A.opera.version && parseInt(A.opera.version())) || (h = b(c.match(/Edge\/([^ ]+)$/))) || b(c.match(/Chrome\/([^ ]+)/)) || (e = b(c.match(/Version\/([^ ]+) Safari/))) || (f = b(c.match(/Firefox\/([^ ]+)/))) || (g = a.a.W || b(c.match(/MSIE ([^ ]+)/))) || (g = b(c.match(/rv:([^ )]+)/)));
                }if (8 <= g && 10 > g) var m = a.a.g.Z(),
                    k = a.a.g.Z(),
                    l = function l(b) {
                    var c = this.activeElement;(c = c && a.a.g.get(c, k)) && c(b);
                },
                    p = function p(b, c) {
                    var d = b.ownerDocument;a.a.g.get(d, m) || (a.a.g.set(d, m, !0), a.a.B(d, "selectionchange", l));a.a.g.set(b, k, c);
                };a.c.textInput = { init: function init(b, c, k) {
                        function l(c, d) {
                            a.a.B(b, c, d);
                        }function m() {
                            var d = a.a.f(c());if (null === d || d === n) d = "";L !== n && d === L ? a.a.setTimeout(m, 4) : b.value !== d && (y = !0, b.value = d, y = !1, v = b.value);
                        }function r() {
                            w || (L = b.value, w = a.a.setTimeout(z, 4));
                        }function z() {
                            clearTimeout(w);L = w = n;var d = b.value;v !== d && (v = d, a.m.eb(c(), k, "textInput", d));
                        }var v = b.value,
                            w,
                            L,
                            A = 9 == a.a.W ? r : z,
                            y = !1;g && l("keypress", z);11 > g && l("propertychange", function (a) {
                            y || "value" !== a.propertyName || A(a);
                        });8 == g && (l("keyup", z), l("keydown", z));p && (p(b, A), l("dragend", r));(!g || 9 <= g) && l("input", A);5 > e && "textarea" === a.a.R(b) ? (l("keydown", r), l("paste", r), l("cut", r)) : 11 > d ? l("keydown", r) : 4 > f ? (l("DOMAutoComplete", z), l("dragdrop", z), l("drop", z)) : h && "number" === b.type && l("keydown", r);l("change", z);l("blur", z);a.o(m, null, { l: b });
                    } };a.m.wa.textInput = !0;a.c.textinput = { preprocess: function preprocess(a, b, c) {
                        c("textInput", a);
                    } };
            })();a.c.uniqueName = { init: function init(b, c) {
                    if (c()) {
                        var d = "ko_unique_" + ++a.c.uniqueName.rd;a.a.Yc(b, d);
                    }
                } };a.c.uniqueName.rd = 0;a.c.using = { init: function init(b, c, d, e, f) {
                    var g;d.has("as") && (g = { as: d.get("as"), noChildContext: d.get("noChildContext") });c = f.createChildContext(c, g);a.Oa(c, b);return { controlsDescendantBindings: !0 };
                } };a.h.ea.using = !0;a.c.value = { init: function init(b, c, d) {
                    var e = a.a.R(b),
                        f = "input" == e;if (!f || "checkbox" != b.type && "radio" != b.type) {
                        var g = [],
                            h = d.get("valueUpdate"),
                            m = !1,
                            k = null;h && ("string" == typeof h ? g = [h] : g = a.a.wc(h), a.a.Pa(g, "change"));var l = function l() {
                            k = null;m = !1;var e = c(),
                                f = a.w.M(b);a.m.eb(e, d, "value", f);
                        };!a.a.W || !f || "text" != b.type || "off" == b.autocomplete || b.form && "off" == b.form.autocomplete || -1 != a.a.A(g, "propertychange") || (a.a.B(b, "propertychange", function () {
                            m = !0;
                        }), a.a.B(b, "focus", function () {
                            m = !1;
                        }), a.a.B(b, "blur", function () {
                            m && l();
                        }));a.a.D(g, function (c) {
                            var d = l;a.a.Ud(c, "after") && (d = function d() {
                                k = a.w.M(b);a.a.setTimeout(l, 0);
                            }, c = c.substring(5));a.a.B(b, c, d);
                        });var p;p = f && "file" == b.type ? function () {
                            var d = a.a.f(c());null === d || d === n || "" === d ? b.value = "" : a.u.G(l);
                        } : function () {
                            var f = a.a.f(c()),
                                g = a.w.M(b);if (null !== k && f === k) a.a.setTimeout(p, 0);else if (f !== g || g === n) "select" === e ? (g = d.get("valueAllowUnset"), a.w.cb(b, f, g), g || f === a.w.M(b) || a.u.G(l)) : a.w.cb(b, f);
                        };if ("select" === e) {
                            var q;a.i.subscribe(b, a.i.H, function () {
                                q ? d.get("valueAllowUnset") ? p() : l() : (a.a.B(b, "change", l), q = a.o(p, null, { l: b }));
                            }, null, { notifyImmediately: !0 });
                        } else a.a.B(b, "change", l), a.o(p, null, { l: b });
                    } else a.ib(b, { checkedValue: c });
                }, update: function update() {} };a.m.wa.value = !0;a.c.visible = { update: function update(b, c) {
                    var d = a.a.f(c()),
                        e = "none" != b.style.display;d && !e ? b.style.display = "" : !d && e && (b.style.display = "none");
                } };a.c.hidden = { update: function update(b, c) {
                    a.c.visible.update(b, function () {
                        return !a.a.f(c());
                    });
                } };(function (b) {
                a.c[b] = { init: function init(c, d, e, f, g) {
                        return a.c.event.init.call(this, c, function () {
                            var a = {};a[b] = d();return a;
                        }, e, f, g);
                    } };
            })("click");
            a.ca = function () {};a.ca.prototype.renderTemplateSource = function () {
                throw Error("Override renderTemplateSource");
            };a.ca.prototype.createJavaScriptEvaluatorBlock = function () {
                throw Error("Override createJavaScriptEvaluatorBlock");
            };a.ca.prototype.makeTemplateSource = function (b, c) {
                if ("string" == typeof b) {
                    c = c || w;var d = c.getElementById(b);if (!d) throw Error("Cannot find template with ID " + b);return new a.C.F(d);
                }if (1 == b.nodeType || 8 == b.nodeType) return new a.C.ia(b);throw Error("Unknown template type: " + b);
            };a.ca.prototype.renderTemplate = function (a, c, d, e) {
                a = this.makeTemplateSource(a, e);return this.renderTemplateSource(a, c, d, e);
            };a.ca.prototype.isTemplateRewritten = function (a, c) {
                return !1 === this.allowTemplateRewriting ? !0 : this.makeTemplateSource(a, c).data("isRewritten");
            };a.ca.prototype.rewriteTemplate = function (a, c, d) {
                a = this.makeTemplateSource(a, d);c = c(a.text());a.text(c);a.data("isRewritten", !0);
            };a.b("templateEngine", a.ca);a.kc = function () {
                function b(b, c, d, h) {
                    b = a.m.ac(b);for (var m = a.m.Ra, k = 0; k < b.length; k++) {
                        var l = b[k].key;if (Object.prototype.hasOwnProperty.call(m, l)) {
                            var p = m[l];if ("function" === typeof p) {
                                if (l = p(b[k].value)) throw Error(l);
                            } else if (!p) throw Error("This template engine does not support the '" + l + "' binding within its templates");
                        }
                    }d = "ko.__tr_ambtns(function($context,$element){return(function(){return{ " + a.m.vb(b, { valueAccessors: !0 }) + " } })()},'" + d.toLowerCase() + "')";return h.createJavaScriptEvaluatorBlock(d) + c;
                }var c = /(<([a-z]+\d*)(?:\s+(?!data-bind\s*=\s*)[a-z0-9\-]+(?:=(?:\"[^\"]*\"|\'[^\']*\'|[^>]*))?)*\s+)data-bind\s*=\s*(["'])([\s\S]*?)\3/gi,
                    d = /\x3c!--\s*ko\b\s*([\s\S]*?)\s*--\x3e/g;return { xd: function xd(b, c, d) {
                        c.isTemplateRewritten(b, d) || c.rewriteTemplate(b, function (b) {
                            return a.kc.Ld(b, c);
                        }, d);
                    }, Ld: function Ld(a, f) {
                        return a.replace(c, function (a, c, d, e, l) {
                            return b(l, c, d, f);
                        }).replace(d, function (a, c) {
                            return b(c, "\x3c!-- ko --\x3e", "#comment", f);
                        });
                    }, md: function md(b, c) {
                        return a.aa.Xb(function (d, h) {
                            var m = d.nextSibling;m && m.nodeName.toLowerCase() === c && a.ib(m, b, h);
                        });
                    } };
            }();a.b("__tr_ambtns", a.kc.md);(function () {
                a.C = {};a.C.F = function (b) {
                    if (this.F = b) {
                        var c = a.a.R(b);this.ab = "script" === c ? 1 : "textarea" === c ? 2 : "template" == c && b.content && 11 === b.content.nodeType ? 3 : 4;
                    }
                };a.C.F.prototype.text = function () {
                    var b = 1 === this.ab ? "text" : 2 === this.ab ? "value" : "innerHTML";if (0 == arguments.length) return this.F[b];var c = arguments[0];"innerHTML" === b ? a.a.fc(this.F, c) : this.F[b] = c;
                };var b = a.a.g.Z() + "_";a.C.F.prototype.data = function (c) {
                    if (1 === arguments.length) return a.a.g.get(this.F, b + c);a.a.g.set(this.F, b + c, arguments[1]);
                };var c = a.a.g.Z();a.C.F.prototype.nodes = function () {
                    var b = this.F;
                    if (0 == arguments.length) {
                        var e = a.a.g.get(b, c) || {},
                            f = e.lb || (3 === this.ab ? b.content : 4 === this.ab ? b : n);if (!f || e.jd) {
                            var g = this.text();g && g !== e.bb && (f = a.a.Md(g, b.ownerDocument), a.a.g.set(b, c, { lb: f, bb: g, jd: !0 }));
                        }return f;
                    }e = arguments[0];this.ab !== n && this.text("");a.a.g.set(b, c, { lb: e });
                };a.C.ia = function (a) {
                    this.F = a;
                };a.C.ia.prototype = new a.C.F();a.C.ia.prototype.constructor = a.C.ia;a.C.ia.prototype.text = function () {
                    if (0 == arguments.length) {
                        var b = a.a.g.get(this.F, c) || {};b.bb === n && b.lb && (b.bb = b.lb.innerHTML);return b.bb;
                    }a.a.g.set(this.F, c, { bb: arguments[0] });
                };a.b("templateSources", a.C);a.b("templateSources.domElement", a.C.F);a.b("templateSources.anonymousTemplate", a.C.ia);
            })();(function () {
                function b(b, c, d) {
                    var e;for (c = a.h.nextSibling(c); b && (e = b) !== c;) {
                        b = a.h.nextSibling(e), d(e, b);
                    }
                }function c(c, d) {
                    if (c.length) {
                        var e = c[0],
                            f = c[c.length - 1],
                            g = e.parentNode,
                            h = a.ga.instance,
                            m = h.preprocessNode;if (m) {
                            b(e, f, function (a, b) {
                                var c = a.previousSibling,
                                    d = m.call(h, a);d && (a === e && (e = d[0] || b), a === f && (f = d[d.length - 1] || c));
                            });c.length = 0;if (!e) return;e === f ? c.push(e) : (c.push(e, f), a.a.Ua(c, g));
                        }b(e, f, function (b) {
                            1 !== b.nodeType && 8 !== b.nodeType || a.vc(d, b);
                        });b(e, f, function (b) {
                            1 !== b.nodeType && 8 !== b.nodeType || a.aa.cd(b, [d]);
                        });a.a.Ua(c, g);
                    }
                }function d(a) {
                    return a.nodeType ? a : 0 < a.length ? a[0] : null;
                }function e(b, e, f, h, m) {
                    m = m || {};var n = (b && d(b) || f || {}).ownerDocument,
                        B = m.templateEngine || g;a.kc.xd(f, B, n);f = B.renderTemplate(f, h, m, n);if ("number" != typeof f.length || 0 < f.length && "number" != typeof f[0].nodeType) throw Error("Template engine must return an array of DOM nodes");n = !1;switch (e) {case "replaceChildren":
                            a.h.va(b, f);n = !0;break;case "replaceNode":
                            a.a.Xc(b, f);n = !0;break;case "ignoreTargetNode":
                            break;default:
                            throw Error("Unknown renderMode: " + e);}n && (c(f, h), m.afterRender && a.u.G(m.afterRender, null, [f, h[m.as || "$data"]]), "replaceChildren" == e && a.i.ma(b, a.i.H));return f;
                }function f(b, c, d) {
                    return a.O(b) ? b() : "function" === typeof b ? b(c, d) : b;
                }var g;a.gc = function (b) {
                    if (b != n && !(b instanceof a.ca)) throw Error("templateEngine must inherit from ko.templateEngine");g = b;
                };a.dc = function (b, c, h, m, t) {
                    h = h || {};if ((h.templateEngine || g) == n) throw Error("Set a template engine before calling renderTemplate");t = t || "replaceChildren";if (m) {
                        var x = d(m);return a.$(function () {
                            var g = c && c instanceof a.fa ? c : new a.fa(c, null, null, null, { exportDependencies: !0 }),
                                n = f(b, g.$data, g),
                                g = e(m, t, n, g, h);"replaceNode" == t && (m = g, x = d(m));
                        }, null, { Sa: function Sa() {
                                return !x || !a.a.Sb(x);
                            }, l: x && "replaceNode" == t ? x.parentNode : x });
                    }return a.aa.Xb(function (d) {
                        a.dc(b, c, h, d, "replaceNode");
                    });
                };a.Qd = function (b, d, g, h, m) {
                    function x(b, c) {
                        a.u.G(a.a.ec, null, [h, b, u, g, r, c]);a.i.ma(h, a.i.H);
                    }
                    function r(a, b) {
                        c(b, v);g.afterRender && g.afterRender(b, a);v = null;
                    }function u(a, c) {
                        v = m.createChildContext(a, { as: z, noChildContext: g.noChildContext, extend: function extend(a) {
                                a.$index = c;z && (a[z + "Index"] = c);
                            } });var d = f(b, a, v);return e(h, "ignoreTargetNode", d, v, g);
                    }var v,
                        z = g.as,
                        w = !1 === g.includeDestroyed || a.options.foreachHidesDestroyed && !g.includeDestroyed;if (w || g.beforeRemove || !a.Pc(d)) return a.$(function () {
                        var b = a.a.f(d) || [];"undefined" == typeof b.length && (b = [b]);w && (b = a.a.jb(b, function (b) {
                            return b === n || null === b || !a.a.f(b._destroy);
                        }));x(b);
                    }, null, { l: h });x(d.v());var A = d.subscribe(function (a) {
                        x(d(), a);
                    }, null, "arrayChange");A.l(h);return A;
                };var h = a.a.g.Z(),
                    m = a.a.g.Z();a.c.template = { init: function init(b, c) {
                        var d = a.a.f(c());if ("string" == typeof d || "name" in d) a.h.Ea(b);else if ("nodes" in d) {
                            d = d.nodes || [];if (a.O(d)) throw Error('The "nodes" option must be a plain, non-observable array.');var e = d[0] && d[0].parentNode;e && a.a.g.get(e, m) || (e = a.a.Yb(d), a.a.g.set(e, m, !0));new a.C.ia(b).nodes(e);
                        } else if (d = a.h.childNodes(b), 0 < d.length) e = a.a.Yb(d), new a.C.ia(b).nodes(e);else throw Error("Anonymous template defined, but no template content was provided");return { controlsDescendantBindings: !0 };
                    }, update: function update(b, c, d, e, f) {
                        var g = c();c = a.a.f(g);d = !0;e = null;"string" == typeof c ? c = {} : (g = "name" in c ? c.name : b, "if" in c && (d = a.a.f(c["if"])), d && "ifnot" in c && (d = !a.a.f(c.ifnot)), d && !g && (d = !1));"foreach" in c ? e = a.Qd(g, d && c.foreach || [], c, b, f) : d ? (d = f, "data" in c && (d = f.createChildContext(c.data, { as: c.as, noChildContext: c.noChildContext, exportDependencies: !0 })), e = a.dc(g, d, c, b)) : a.h.Ea(b);f = e;(c = a.a.g.get(b, h)) && "function" == typeof c.s && c.s();a.a.g.set(b, h, !f || f.ja && !f.ja() ? n : f);
                    } };a.m.Ra.template = function (b) {
                    b = a.m.ac(b);return 1 == b.length && b[0].unknown || a.m.Id(b, "name") ? null : "This template engine does not support anonymous templates nested within its templates";
                };a.h.ea.template = !0;
            })();a.b("setTemplateEngine", a.gc);a.b("renderTemplate", a.dc);a.a.Kc = function (a, c, d) {
                if (a.length && c.length) {
                    var e, f, g, h, m;for (e = f = 0; (!d || e < d) && (h = a[f]); ++f) {
                        for (g = 0; m = c[g]; ++g) {
                            if (h.value === m.value) {
                                h.moved = m.index;m.moved = h.index;c.splice(g, 1);e = g = 0;break;
                            }
                        }e += g;
                    }
                }
            };a.a.Pb = function () {
                function b(b, d, e, f, g) {
                    var h = Math.min,
                        m = Math.max,
                        k = [],
                        l,
                        p = b.length,
                        q,
                        n = d.length,
                        r = n - p || 1,
                        v = p + n + 1,
                        u,
                        w,
                        z;for (l = 0; l <= p; l++) {
                        for (w = u, k.push(u = []), z = h(n, l + r), q = m(0, l - 1); q <= z; q++) {
                            u[q] = q ? l ? b[l - 1] === d[q - 1] ? w[q - 1] : h(w[q] || v, u[q - 1] || v) + 1 : q + 1 : l + 1;
                        }
                    }h = [];m = [];r = [];l = p;for (q = n; l || q;) {
                        n = k[l][q] - 1, q && n === k[l][q - 1] ? m.push(h[h.length] = { status: e, value: d[--q], index: q }) : l && n === k[l - 1][q] ? r.push(h[h.length] = { status: f, value: b[--l], index: l }) : (--q, --l, g.sparse || h.push({ status: "retained", value: d[q] }));
                    }a.a.Kc(r, m, !g.dontLimitMoves && 10 * p);return h.reverse();
                }return function (a, d, e) {
                    e = "boolean" === typeof e ? { dontLimitMoves: e } : e || {};a = a || [];d = d || [];return a.length < d.length ? b(a, d, "added", "deleted", e) : b(d, a, "deleted", "added", e);
                };
            }();a.b("utils.compareArrays", a.a.Pb);(function () {
                function b(b, c, d, h, m) {
                    var k = [],
                        l = a.$(function () {
                        var l = c(d, m, a.a.Ua(k, b)) || [];0 < k.length && (a.a.Xc(k, l), h && a.u.G(h, null, [d, l, m]));k.length = 0;a.a.Nb(k, l);
                    }, null, { l: b, Sa: function Sa() {
                            return !a.a.kd(k);
                        } });
                    return { Y: k, $: l.ja() ? l : n };
                }var c = a.a.g.Z(),
                    d = a.a.g.Z();a.a.ec = function (e, f, g, h, m, k) {
                    function l(b) {
                        y = { Aa: b, pb: a.ta(w++) };v.push(y);r || F.push(y);
                    }function p(b) {
                        y = t[b];w !== y.pb.v() && D.push(y);y.pb(w++);a.a.Ua(y.Y, e);v.push(y);
                    }function q(b, c) {
                        if (b) for (var d = 0, e = c.length; d < e; d++) {
                            a.a.D(c[d].Y, function (a) {
                                b(a, d, c[d].Aa);
                            });
                        }
                    }f = f || [];"undefined" == typeof f.length && (f = [f]);h = h || {};var t = a.a.g.get(e, c),
                        r = !t,
                        v = [],
                        u = 0,
                        w = 0,
                        z = [],
                        A = [],
                        C = [],
                        D = [],
                        F = [],
                        y,
                        I = 0;if (r) a.a.D(f, l);else {
                        if (!k || t && t._countWaitingForRemove) {
                            var E = a.a.Mb(t, function (a) {
                                return a.Aa;
                            });k = a.a.Pb(E, f, { dontLimitMoves: h.dontLimitMoves, sparse: !0 });
                        }for (var E = 0, G, H, K; G = k[E]; E++) {
                            switch (H = G.moved, K = G.index, G.status) {case "deleted":
                                    for (; u < K;) {
                                        p(u++);
                                    }H === n && (y = t[u], y.$ && (y.$.s(), y.$ = n), a.a.Ua(y.Y, e).length && (h.beforeRemove && (v.push(y), I++, y.Aa === d ? y = null : C.push(y)), y && z.push.apply(z, y.Y)));u++;break;case "added":
                                    for (; w < K;) {
                                        p(u++);
                                    }H !== n ? (A.push(v.length), p(H)) : l(G.value);}
                        }for (; w < f.length;) {
                            p(u++);
                        }v._countWaitingForRemove = I;
                    }a.a.g.set(e, c, v);q(h.beforeMove, D);a.a.D(z, h.beforeRemove ? a.oa : a.removeNode);var M, O, P;try {
                        P = e.ownerDocument.activeElement;
                    } catch (N) {}if (A.length) for (; (E = A.shift()) != n;) {
                        y = v[E];for (M = n; E;) {
                            if ((O = v[--E].Y) && O.length) {
                                M = O[O.length - 1];break;
                            }
                        }for (f = 0; u = y.Y[f]; M = u, f++) {
                            a.h.Wb(e, u, M);
                        }
                    }for (E = 0; y = v[E]; E++) {
                        y.Y || a.a.extend(y, b(e, g, y.Aa, m, y.pb));for (f = 0; u = y.Y[f]; M = u, f++) {
                            a.h.Wb(e, u, M);
                        }!y.Ed && m && (m(y.Aa, y.Y, y.pb), y.Ed = !0, M = y.Y[y.Y.length - 1]);
                    }P && e.ownerDocument.activeElement != P && P.focus();q(h.beforeRemove, C);for (E = 0; E < C.length; ++E) {
                        C[E].Aa = d;
                    }q(h.afterMove, D);
                    q(h.afterAdd, F);
                };
            })();a.b("utils.setDomNodeChildrenFromArrayMapping", a.a.ec);a.ba = function () {
                this.allowTemplateRewriting = !1;
            };a.ba.prototype = new a.ca();a.ba.prototype.constructor = a.ba;a.ba.prototype.renderTemplateSource = function (b, c, d, e) {
                if (c = (9 > a.a.W ? 0 : b.nodes) ? b.nodes() : null) return a.a.la(c.cloneNode(!0).childNodes);b = b.text();return a.a.ua(b, e);
            };a.ba.Ma = new a.ba();a.gc(a.ba.Ma);a.b("nativeTemplateEngine", a.ba);(function () {
                a.$a = function () {
                    var a = this.Hd = function () {
                        if (!v || !v.tmpl) return 0;try {
                            if (0 <= v.tmpl.tag.tmpl.open.toString().indexOf("__")) return 2;
                        } catch (a) {}return 1;
                    }();
                    this.renderTemplateSource = function (b, e, f, g) {
                        g = g || w;f = f || {};if (2 > a) throw Error("Your version of jQuery.tmpl is too old. Please upgrade to jQuery.tmpl 1.0.0pre or later.");var h = b.data("precompiled");h || (h = b.text() || "", h = v.template(null, "{{ko_with $item.koBindingContext}}" + h + "{{/ko_with}}"), b.data("precompiled", h));b = [e.$data];e = v.extend({ koBindingContext: e }, f.templateOptions);e = v.tmpl(h, b, e);e.appendTo(g.createElement("div"));v.fragments = {};return e;
                    };this.createJavaScriptEvaluatorBlock = function (a) {
                        return "{{ko_code ((function() { return " + a + " })()) }}";
                    };this.addTemplate = function (a, b) {
                        w.write("<script type='text/html' id='" + a + "'>" + b + "\x3c/script>");
                    };0 < a && (v.tmpl.tag.ko_code = { open: "__.push($1 || '');" }, v.tmpl.tag.ko_with = { open: "with($1) {", close: "} " });
                };a.$a.prototype = new a.ca();a.$a.prototype.constructor = a.$a;var b = new a.$a();0 < b.Hd && a.gc(b);a.b("jqueryTmplTemplateEngine", a.$a);
            })();
        });
    })();
})();

/*ko.viewmodel.js - version 2.0.3
 * Copyright 2013, Dave Herren http://coderenaissance.github.com/knockout.viewmodel/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)*/
/*jshint eqnull:true, boss:true, loopfunc:true, evil:true, laxbreak:true, undef:true, unused:true, browser:true, immed:true, devel:true, sub: true, maxerr:50 */
/*global ko:false */

;(function () {
    //Module declarations. For increased compression with simple settings on the closure compiler,
    //the ko functions are stored in variables. These variable names will be shortened by the compiler, 
    //whereas references to ko would not be. There is also a performance savings from this.
    var unwrap = ko.utils.unwrapObservable,
        isObservable = ko.isObservable,
        makeObservable = ko.observable,
        makeObservableArray = ko.observableArray,
        rootContext = { name: "{root}", parent: "{root}", full: "{root}" },
        fnLog,
        makeChildArraysObservable,
        badResult = function fnBadResult() {};

    //Gets settings for the specified path
    function getPathSettings(settings, context) {
        //Settings for more specific paths are chosen over less specific ones.
        var pathSettings = settings ? settings[context.full] || settings[context.parent] || settings[context.name] || {} : {};
        if (fnLog) fnLog(context, pathSettings, settings); //log what mapping will be used
        return pathSettings;
    }

    //Converts options into a dictionary of path settings
    //This allows for path settings to be looked up efficiently
    function getPathSettingsDictionary(options) {
        var result = {},
            shared = options ? options.shared || {} : {},
            settings,
            fn,
            index,
            key,
            length,
            settingType,
            childName,
            child;
        for (settingType in options) {
            settings = options[settingType] || {};
            //Settings can either be dictionaries(associative arrays) or arrays
            //ignore shared option... contains functions that can be assigned by name
            if (settingType === "shared") continue;else if (settings instanceof Array) {
                //process array list for append and exclude
                for (index = 0, length = settings.length; index < length; index++) {
                    key = settings[index];
                    result[key] = result[key] || {};
                    result[key][settingType] = true;
                    result[key].settingType = result[key].settingType ? "multiple" : settingType;
                }
            } else if (settings.constructor === Object) {
                //process associative array for extend and map
                for (key in settings) {
                    result[key] = result[key] || {};
                    fn = settings[key];
                    fn = settingType !== "arrayChildId" && fn && fn.constructor === String && shared[fn] ? shared[fn] : fn;
                    if (fn && fn.constructor === Object) {
                        //associative array for map/unmap passed in instead of map function
                        for (childName in fn) {
                            //if children of fn are strings then replace with shared function if available
                            if ((child = fn[childName]) && child.constructor == String && shared[child]) {
                                fn[childName] = shared[child];
                            }
                        }
                    }
                    result[key][settingType] = fn;
                    result[key].settingType = result[key].settingType ? "multiple" : settingType;
                }
            }
        }
        return result;
    }

    function isNullOrUndefined(obj) {
        //checks if obj is null or undefined
        return obj === null || obj === undefined;
    }

    //while dates aren't part of the JSON spec it doesn't hurt to support them as it's not unreasonable to think they might be added to the model manually.
    //undefined is also not part of the spec, but it's currently be supported to be more in line with ko.mapping and probably doesn't hurt.
    function isPrimativeOrDate(obj) {
        return obj === null || obj === undefined || obj.constructor === String || obj.constructor === Number || obj.constructor === Boolean || obj instanceof Date;
    }

    function recrusiveFrom(modelObj, settings, context, pathSettings) {
        var temp, result, p, length, idName, newContext, customPathSettings, extend, optionProcessed, childPathSettings, childObj;
        pathSettings = pathSettings || getPathSettings(settings, context);

        if (customPathSettings = pathSettings.custom) {
            optionProcessed = true;
            //custom can either be specified as a single map function or as an 
            //object with map and unmap properties
            if (typeof customPathSettings === "function") {
                result = customPathSettings(modelObj);
                if (!isNullOrUndefined(result)) {
                    result.___$mapCustom = customPathSettings;
                }
            } else {
                result = customPathSettings.map(modelObj);
                if (!isNullOrUndefined(result)) {
                    //extend object with mapping info where possible
                    result.___$mapCustom = customPathSettings.map; //preserve map function for updateFromModel calls
                    if (customPathSettings.unmap) {
                        //perserve unmap function for toModel calls
                        result.___$unmapCustom = customPathSettings.unmap;
                    }
                }
            }
        } else if (pathSettings.append) {
            //append property
            optionProcessed = true;
            result = modelObj; //append
        } else if (pathSettings.exclude) {
            optionProcessed = true;
            return badResult;
        } else if (isPrimativeOrDate(modelObj)) {
            //primative and date children of arrays aren't mapped... all others are
            result = context.parentIsArray ? modelObj : makeObservable(modelObj);
        } else if (modelObj instanceof Array) {
            result = [];

            for (p = 0, length = modelObj.length; p < length; p++) {
                result[p] = recrusiveFrom(modelObj[p], settings, {
                    name: "[i]", parent: context.name + "[i]", full: context.full + "[i]", parentIsArray: true
                });
            }

            //only makeObservableArray extend with mapping functions if it's not a nested array or mapping compatabitlity is off
            if (!context.parentIsArray || makeChildArraysObservable) {

                newContext = { name: "[i]", parent: context.name + "[i]", full: context.full + "[i]", parentIsArray: true };
                result = makeObservableArray(result);

                //if available add id name to object so it can be accessed later when updating children
                if (idName = pathSettings.arrayChildId) {
                    result.___$childIdName = idName;
                }

                //wrap array methods for adding and removing items in functions that
                //close over settings and context allowing the objects and their children to be correctly mapped.
                result.pushFromModel = function (item) {
                    item = recrusiveFrom(item, settings, newContext);
                    result.push(item);
                };
                result.unshiftFromModel = function (item) {
                    item = recrusiveFrom(item, settings, newContext);
                    result.unshift(item);
                };
                result.popToModel = function (item) {
                    item = result.pop();
                    return recrusiveTo(item, newContext);
                };
                result.shiftToModel = function (item) {
                    item = result.shift();
                    return recrusiveTo(item, newContext);
                };
            }
        } else if (modelObj.constructor === Object) {
            result = {};
            for (p in modelObj) {
                newContext = {
                    name: p,
                    parent: (context.name === "[i]" ? context.parent : context.name) + "." + p,
                    full: context.full + "." + p
                };
                childObj = modelObj[p];
                childPathSettings = isPrimativeOrDate(childObj) ? getPathSettings(settings, newContext) : undefined;

                if (childPathSettings && childPathSettings.custom) {
                    //primativish value w/ custom maping
                    //since primative children cannot store their own custom functions, handle processing here and store them in the parent
                    result.___$customChildren = result.___$customChildren || {};
                    result.___$customChildren[p] = childPathSettings.custom;

                    if (typeof childPathSettings.custom === "function") {
                        result[p] = childPathSettings.custom(modelObj[p]);
                    } else {
                        result[p] = childPathSettings.custom.map(modelObj[p]);
                    }
                } else {
                    temp = recrusiveFrom(childObj, settings, newContext, childPathSettings); //call recursive from on each child property

                    if (temp !== badResult) {
                        //properties that couldn't be mapped return badResult
                        result[p] = temp;
                    }
                }
            }
        }

        if (!optionProcessed && (extend = pathSettings.extend)) {
            if (typeof extend === "function") {
                //single map function specified
                //Extend can either modify the mapped value or replace it
                //Falsy values assumed to be undefined
                result = extend(result) || result;
            } else if (extend.constructor === Object) {
                //map and/or unmap were specified as part of object
                if (typeof extend.map === "function") {
                    result = extend.map(result) || result; //use map to get result
                }

                if (typeof extend.unmap === "function") {
                    result.___$unmapExtend = extend.unmap; //store unmap for use by toModel
                }
            }
        }
        return result;
    }

    function recrusiveTo(viewModelObj, context) {
        var result,
            p,
            length,
            temp,
            unwrapped = unwrap(viewModelObj),
            child,
            recursiveResult,
            wasWrapped = viewModelObj !== unwrapped; //this works because unwrap observable calls isObservable and returns the object unchanged if not observable

        if (fnLog) {
            fnLog(context); //log object being unmapped
        }

        if (!wasWrapped && viewModelObj && viewModelObj.constructor === Function) {
            //Exclude functions
            return badResult;
        } else if (viewModelObj && viewModelObj.___$unmapCustom) {
            //Defer to customUnmapping where specified
            result = viewModelObj.___$unmapCustom(viewModelObj);
        } else if (wasWrapped && isPrimativeOrDate(unwrapped) || isNullOrUndefined(unwrapped)) {
            //return null, undefined, values, and wrapped primativish values as is
            result = unwrapped;
        } else if (unwrapped instanceof Array) {
            //create new array to return and add unwrapped values to it
            result = [];
            for (p = 0, length = unwrapped.length; p < length; p++) {
                result[p] = recrusiveTo(unwrapped[p], {
                    name: "[i]", parent: context.name + "[i]", full: context.full + "[i]"
                });
            }
        } else if (unwrapped.constructor === Object) {
            //create new object to return and add unwrapped values to it
            result = {};
            for (p in unwrapped) {
                if (p.substr(0, 4) !== "___$") {
                    //ignore all properties starting with the magic string as internal
                    if (viewModelObj.___$customChildren && viewModelObj.___$customChildren[p] && viewModelObj.___$customChildren[p].unmap) {
                        result[p] = viewModelObj.___$customChildren[p].unmap(unwrapped[p]);
                    } else {
                        child = unwrapped[p];
                        if (!ko.isComputed(child) && !((temp = unwrap(child)) && temp.constructor === Function)) {

                            recursiveResult = recrusiveTo(child, {
                                name: p,
                                parent: (context.name === "[i]" ? context.parent : context.name) + "." + p,
                                full: context.full + "." + p
                            });

                            //if badResult wasn't returned then add property
                            if (recursiveResult !== badResult) {
                                result[p] = recursiveResult;
                            }
                        }
                    }
                }
            }
        } else {
            //If it wasn't wrapped and it's not a function then return it.
            if (!wasWrapped && typeof unwrapped !== "function") {
                result = unwrapped;
            }
        }

        if (viewModelObj && viewModelObj.___$unmapExtend) {
            //if available call extend unmap function
            result = viewModelObj.___$unmapExtend(result, viewModelObj);
        }

        return result;
    }

    function recursiveUpdate(modelObj, viewModelObj, context, parentObj, noncontiguousObjectUpdateCount) {
        var p,
            q,
            foundModels,
            foundViewmodels,
            modelId,
            viewmodelId,
            idName,
            length,
            unwrapped = unwrap(viewModelObj),
            wasWrapped = viewModelObj !== unwrapped,
            child,
            map,
            tempArray,
            childTemp,
            childMap,
            unwrappedChild,
            tempChild;

        if (fnLog) {
            fnLog(context); //log object being unmapped
        }

        if (wasWrapped && isNullOrUndefined(unwrapped) ^ isNullOrUndefined(modelObj)) {
            //if you have an observable to update and either the new or old value is 
            //null or undefined then update the observable
            viewModelObj(modelObj);
        } else if (modelObj && unwrapped && unwrapped.constructor == Object && modelObj.constructor === Object) {
            for (p in modelObj) {
                //loop through object properties and update them

                if (viewModelObj.___$customChildren && viewModelObj.___$customChildren[p]) {
                    childMap = viewModelObj.___$customChildren[p].map || viewModelObj.___$customChildren[p];
                    unwrapped[p] = childMap(modelObj[p]);
                } else {
                    child = unwrapped[p];

                    if (!wasWrapped && unwrapped.hasOwnProperty(p) && (isPrimativeOrDate(child) || child && child.constructor === Array)) {
                        unwrapped[p] = modelObj[p];
                    } else if (child && typeof child.___$mapCustom === "function") {
                        if (isObservable(child)) {
                            childTemp = child.___$mapCustom(modelObj[p], child); //get child value mapped by custom maping
                            childTemp = unwrap(childTemp); //don't nest observables... what you want is the value from the customMapping
                            child(childTemp); //update child;
                        } else {
                            //property wasn't observable? update it anyway for return to server
                            unwrapped[p] = child.___$mapCustom(modelObj[p], child);
                        }
                    } else if (isNullOrUndefined(modelObj[p]) && unwrapped[p] && unwrapped[p].constructor === Object) {
                        //Replace null or undefined with object for round trip to server; probably won't affect the view
                        //WORKAROUND: If values are going to switch between obj and null/undefined and the UI needs to be updated
                        //then the user should use the extend option to wrap the object in an observable
                        unwrapped[p] = modelObj[p];
                    } else {
                        //Recursive update everything else
                        if (!!noncontiguousObjectUpdateCount) {
                            var fnRecursivePropertyObjectUpdate = function (modelObj, viewModelObj, p) {
                                return function () {
                                    //keep in sync with else below
                                    recursiveUpdate(modelObj[p], unwrapped[p], {
                                        name: p,
                                        parent: (context.name === "[i]" ? context.parent : context.name) + "." + p,
                                        full: context.full + "." + p
                                    }, unwrapped, noncontiguousObjectUpdateCount);
                                    noncontiguousObjectUpdateCount(noncontiguousObjectUpdateCount() - 1);
                                };
                            }(modelObj, viewModelObj, p);
                            noncontiguousObjectUpdateCount(noncontiguousObjectUpdateCount() + 1);
                            setTimeout(fnRecursivePropertyObjectUpdate, 0);
                        } else {
                            //keep in sync with if above
                            recursiveUpdate(modelObj[p], unwrapped[p], {
                                name: p,
                                parent: (context.name === "[i]" ? context.parent : context.name) + "." + p,
                                full: context.full + "." + p
                            });
                        }
                    }
                }
            }
        } else if (unwrapped && unwrapped instanceof Array) {
            if (idName = viewModelObj.___$childIdName) {
                //id is specified, create, update, and delete by id
                foundModels = [];
                foundViewmodels = [];
                for (p = modelObj.length - 1; p >= 0; p--) {
                    modelId = modelObj[p][idName];
                    for (q = unwrapped.length - 1; q >= 0; q--) {
                        child = unwrapped[q];
                        unwrappedChild = unwrap(child);
                        viewmodelId = unwrap(unwrappedChild[idName]);
                        if (viewmodelId === modelId) {
                            //If updated model id equals viewmodel id then update viewmodel object with model data
                            if (child.___$mapCustom) {

                                if (ko.isObservable(child)) {
                                    tempChild = child.___$mapCustom(modelObj[p], child);
                                    if (isObservable(tempChild) && tempChild != child) {
                                        child(unwrap(tempChild));
                                    }
                                    //else custom mapping returned previous observable;
                                    //if it's smart enough to do that, assume it updated it correctly	
                                } else {
                                    unwrapped[q] = child.___$mapCustom(modelObj[p], child);
                                }
                            } else {

                                if (!!noncontiguousObjectUpdateCount) {
                                    //keep in sync with else block below
                                    var fnRecursiveArrayChildObjectUpdate = function (modelObj, viewModelObj, p, q) {
                                        return function () {
                                            recursiveUpdate(modelObj[p], unwrapped[q], {
                                                name: "[i]", parent: context.name + "[i]", full: context.full + "[i]"
                                            }, undefined, noncontiguousObjectUpdateCount);

                                            noncontiguousObjectUpdateCount(noncontiguousObjectUpdateCount() - 1);
                                        };
                                    }(modelObj, viewModelObj, p, q);
                                    noncontiguousObjectUpdateCount(noncontiguousObjectUpdateCount() + 1);
                                    setTimeout(fnRecursiveArrayChildObjectUpdate, 0);
                                } else {
                                    //keep in sync with if block above
                                    recursiveUpdate(modelObj[p], unwrapped[q], {
                                        name: "[i]", parent: context.name + "[i]", full: context.full + "[i]"
                                    });
                                }
                            }
                            foundViewmodels[q] = true;
                            foundModels[p] = true;
                            break;
                        }
                    }
                }
                for (q = unwrapped.length - 1; q >= 0; q--) {
                    if (!foundViewmodels[q]) {
                        //If missing from model remove from viewmodel
                        viewModelObj.splice(q, 1);
                    }
                }
                for (p = modelObj.length - 1; p >= 0; p--) {
                    if (!foundModels[p]) {
                        //If not found and updated in viewmodel then add to viewmodel
                        viewModelObj.pushFromModel(modelObj[p]);
                    }
                }
            } else {
                //no id specified, replace old array items with new array items
                tempArray = [];
                map = viewModelObj.___$mapCustom;
                if (typeof map === "function") {
                    //update array with mapped objects, use indexer for performance
                    for (p = 0, length = modelObj.length; p < length; p++) {
                        tempArray[p] = modelObj[p];
                    }
                    viewModelObj(map(tempArray));
                } else {
                    //Can't use indexer for assignment; have to preserve original mapping with push
                    viewModelObj(tempArray);
                    for (p = 0, length = modelObj ? modelObj.length : 0; p < length; p++) {
                        viewModelObj.pushFromModel(modelObj[p]);
                    }
                }
            }
        } else if (wasWrapped) {
            //If it makes it this far and it was wrapped then update it
            viewModelObj(modelObj);
        }

        if (context.name === "{root}" && !!noncontiguousObjectUpdateCount) {
            return {
                onComplete: function onComplete(fnOnComplete) {
                    if (fnOnComplete && typeof fnOnComplete == "function") {
                        if (!!noncontiguousObjectUpdateCount) {
                            ko.computed(function () {
                                if (fnOnComplete && noncontiguousObjectUpdateCount() === 0) {
                                    fnOnComplete();
                                    fnOnComplete = undefined;
                                }
                            }).extend({ throttle: 50 });
                        } else {
                            fnOnComplete();
                        }
                    }
                }
            };
        }
    }

    function initInternals(options, startMessage) {
        makeChildArraysObservable = options.makeChildArraysObservable;
        if (window.console && options.logging) {
            //if logging should be done then log start message and add logging function
            console.log(startMessage);

            //Updates the console with information about what has been mapped and how
            fnLog = function fnUpdateConsole(context, pathSettings, settings) {
                var msg;
                if (pathSettings && pathSettings.settingType) {
                    //if a setting will be used log it
                    //message reads: SettingType FullPath (matched: path that was matched)
                    msg = pathSettings.settingType + " " + context.full + " (matched: '" + ((settings[context.full] ? context.full : "") || (settings[context.parent] ? context.parent : "") || context.name) + "')";
                } else {
                    //log that default mapping was used for the path
                    msg = "default " + context.full;
                }
                console.log("- " + msg);
            };
        } else {
            fnLog = undefined; //setting the fn to undefined makes it easy to test if logging should be done
        }
    }

    ko.viewmodel = {
        options: {
            makeChildArraysObservable: true,
            logging: false
        },
        fromModel: function fnFromModel(model, options) {
            var settings = getPathSettingsDictionary(options);
            initInternals(this.options, "Mapping From Model");
            return recrusiveFrom(model, settings, rootContext);
        },
        toModel: function fnToModel(viewmodel) {
            initInternals(this.options, "Mapping To Model");
            return recrusiveTo(viewmodel, rootContext);
        },
        updateFromModel: function fnUpdateFromModel(viewmodel, model, makeNoncontiguousObjectUpdates) {
            var noncontiguousObjectUpdateCount = makeNoncontiguousObjectUpdates ? ko.observable(0) : undefined;
            initInternals(this.options, "Update From Model");
            return recursiveUpdate(model, viewmodel, rootContext, undefined, noncontiguousObjectUpdateCount);
        }
    };
})();
/// Knockout Mapping plugin v2.4.1
/// (c) 2013 Steven Sanderson, Roy Jacobs - http://knockoutjs.com/
/// License: MIT (http://www.opensource.org/licenses/mit-license.php)
(function (factory) {
    // Module systems magic dance.

    if (typeof require === "function" && (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && (typeof module === "undefined" ? "undefined" : _typeof(module)) === "object") {
        // CommonJS or Node: hard-coded dependency on "knockout"
        factory(require("knockout"), exports);
    } else if (typeof define === "function" && define["amd"]) {
        // AMD anonymous module with hard-coded dependency on "knockout"
        define(["knockout", "exports"], factory);
    } else {
        // <script> tag: use the global `ko` object, attaching a `mapping` property
        factory(ko, ko.mapping = {});
    }
})(function (ko, exports) {
    var DEBUG = true;
    var mappingProperty = "__ko_mapping__";
    var realKoDependentObservable = ko.dependentObservable;
    var mappingNesting = 0;
    var dependentObservables;
    var visitedObjects;
    var recognizedRootProperties = ["create", "update", "key", "arrayChanged"];
    var emptyReturn = {};

    var _defaultOptions = {
        include: ["_destroy"],
        ignore: [],
        copy: [],
        observe: []
    };
    var defaultOptions = _defaultOptions;

    // Author: KennyTM @ StackOverflow
    function unionArrays(x, y) {
        var obj = {};
        for (var i = x.length - 1; i >= 0; --i) {
            obj[x[i]] = x[i];
        }for (var i = y.length - 1; i >= 0; --i) {
            obj[y[i]] = y[i];
        }var res = [];

        for (var k in obj) {
            res.push(obj[k]);
        };

        return res;
    }

    function extendObject(destination, source) {
        var destType;

        for (var key in source) {
            if (source.hasOwnProperty(key) && source[key]) {
                destType = exports.getType(destination[key]);
                if (key && destination[key] && destType !== "array" && destType !== "string") {
                    extendObject(destination[key], source[key]);
                } else {
                    var bothArrays = exports.getType(destination[key]) === "array" && exports.getType(source[key]) === "array";
                    if (bothArrays) {
                        destination[key] = unionArrays(destination[key], source[key]);
                    } else {
                        destination[key] = source[key];
                    }
                }
            }
        }
    }

    function merge(obj1, obj2) {
        var merged = {};
        extendObject(merged, obj1);
        extendObject(merged, obj2);

        return merged;
    }

    exports.isMapped = function (viewModel) {
        var unwrapped = ko.utils.unwrapObservable(viewModel);
        return unwrapped && unwrapped[mappingProperty];
    };

    exports.fromJS = function (jsObject /*, inputOptions, target*/) {
        if (arguments.length == 0) throw new Error("When calling ko.fromJS, pass the object you want to convert.");

        try {
            if (!mappingNesting++) {
                dependentObservables = [];
                visitedObjects = new objectLookup();
            }

            var options;
            var target;

            if (arguments.length == 2) {
                if (arguments[1][mappingProperty]) {
                    target = arguments[1];
                } else {
                    options = arguments[1];
                }
            }
            if (arguments.length == 3) {
                options = arguments[1];
                target = arguments[2];
            }

            if (target) {
                options = merge(options, target[mappingProperty]);
            }
            options = fillOptions(options);

            var result = updateViewModel(target, jsObject, options);
            if (target) {
                result = target;
            }

            // Evaluate any dependent observables that were proxied.
            // Do this after the model's observables have been created
            if (! --mappingNesting) {
                while (dependentObservables.length) {
                    var DO = dependentObservables.pop();
                    if (DO) {
                        DO();

                        // Move this magic property to the underlying dependent observable
                        DO.__DO["throttleEvaluation"] = DO["throttleEvaluation"];
                    }
                }
            }

            // Save any new mapping options in the view model, so that updateFromJS can use them later.
            result[mappingProperty] = merge(result[mappingProperty], options);

            return result;
        } catch (e) {
            mappingNesting = 0;
            throw e;
        }
    };

    exports.fromJSON = function (jsonString /*, options, target*/) {
        var parsed = ko.utils.parseJson(jsonString);
        arguments[0] = parsed;
        return exports.fromJS.apply(this, arguments);
    };

    exports.updateFromJS = function (viewModel) {
        throw new Error("ko.mapping.updateFromJS, use ko.mapping.fromJS instead. Please note that the order of parameters is different!");
    };

    exports.updateFromJSON = function (viewModel) {
        throw new Error("ko.mapping.updateFromJSON, use ko.mapping.fromJSON instead. Please note that the order of parameters is different!");
    };

    exports.toJS = function (rootObject, options) {
        if (!defaultOptions) exports.resetDefaultOptions();

        if (arguments.length == 0) throw new Error("When calling ko.mapping.toJS, pass the object you want to convert.");
        if (exports.getType(defaultOptions.ignore) !== "array") throw new Error("ko.mapping.defaultOptions().ignore should be an array.");
        if (exports.getType(defaultOptions.include) !== "array") throw new Error("ko.mapping.defaultOptions().include should be an array.");
        if (exports.getType(defaultOptions.copy) !== "array") throw new Error("ko.mapping.defaultOptions().copy should be an array.");

        // Merge in the options used in fromJS
        options = fillOptions(options, rootObject[mappingProperty]);

        // We just unwrap everything at every level in the object graph
        return exports.visitModel(rootObject, function (x) {
            return ko.utils.unwrapObservable(x);
        }, options);
    };

    exports.toJSON = function (rootObject, options) {
        var plainJavaScriptObject = exports.toJS(rootObject, options);
        return ko.utils.stringifyJson(plainJavaScriptObject);
    };

    exports.defaultOptions = function () {
        if (arguments.length > 0) {
            defaultOptions = arguments[0];
        } else {
            return defaultOptions;
        }
    };

    exports.resetDefaultOptions = function () {
        defaultOptions = {
            include: _defaultOptions.include.slice(0),
            ignore: _defaultOptions.ignore.slice(0),
            copy: _defaultOptions.copy.slice(0)
        };
    };

    exports.getType = function (x) {
        if (x && (typeof x === "undefined" ? "undefined" : _typeof(x)) === "object") {
            if (x.constructor === Date) return "date";
            if (x.constructor === Array) return "array";
        }
        return typeof x === "undefined" ? "undefined" : _typeof(x);
    };

    function fillOptions(rawOptions, otherOptions) {
        var options = merge({}, rawOptions);

        // Move recognized root-level properties into a root namespace
        for (var i = recognizedRootProperties.length - 1; i >= 0; i--) {
            var property = recognizedRootProperties[i];

            // Carry on, unless this property is present
            if (!options[property]) continue;

            // Move the property into the root namespace
            if (!(options[""] instanceof Object)) options[""] = {};
            options[""][property] = options[property];
            delete options[property];
        }

        if (otherOptions) {
            options.ignore = mergeArrays(otherOptions.ignore, options.ignore);
            options.include = mergeArrays(otherOptions.include, options.include);
            options.copy = mergeArrays(otherOptions.copy, options.copy);
            options.observe = mergeArrays(otherOptions.observe, options.observe);
        }
        options.ignore = mergeArrays(options.ignore, defaultOptions.ignore);
        options.include = mergeArrays(options.include, defaultOptions.include);
        options.copy = mergeArrays(options.copy, defaultOptions.copy);
        options.observe = mergeArrays(options.observe, defaultOptions.observe);

        options.mappedProperties = options.mappedProperties || {};
        options.copiedProperties = options.copiedProperties || {};
        return options;
    }

    function mergeArrays(a, b) {
        if (exports.getType(a) !== "array") {
            if (exports.getType(a) === "undefined") a = [];else a = [a];
        }
        if (exports.getType(b) !== "array") {
            if (exports.getType(b) === "undefined") b = [];else b = [b];
        }

        return ko.utils.arrayGetDistinctValues(a.concat(b));
    }

    // When using a 'create' callback, we proxy the dependent observable so that it doesn't immediately evaluate on creation.
    // The reason is that the dependent observables in the user-specified callback may contain references to properties that have not been mapped yet.
    function withProxyDependentObservable(dependentObservables, callback) {
        var localDO = ko.dependentObservable;
        ko.dependentObservable = function (read, owner, options) {
            options = options || {};

            if (read && (typeof read === "undefined" ? "undefined" : _typeof(read)) == "object") {
                // mirrors condition in knockout implementation of DO's
                options = read;
            }

            var realDeferEvaluation = options.deferEvaluation;

            var isRemoved = false;

            // We wrap the original dependent observable so that we can remove it from the 'dependentObservables' list we need to evaluate after mapping has
            // completed if the user already evaluated the DO themselves in the meantime.
            var wrap = function wrap(DO) {
                // Temporarily revert ko.dependentObservable, since it is used in ko.isWriteableObservable
                var tmp = ko.dependentObservable;
                ko.dependentObservable = realKoDependentObservable;
                var isWriteable = ko.isWriteableObservable(DO);
                ko.dependentObservable = tmp;

                var wrapped = realKoDependentObservable({
                    read: function read() {
                        if (!isRemoved) {
                            ko.utils.arrayRemoveItem(dependentObservables, DO);
                            isRemoved = true;
                        }
                        return DO.apply(DO, arguments);
                    },
                    write: isWriteable && function (val) {
                        return DO(val);
                    },
                    deferEvaluation: true
                });
                if (DEBUG) wrapped._wrapper = true;
                wrapped.__DO = DO;
                return wrapped;
            };

            options.deferEvaluation = true; // will either set for just options, or both read/options.
            var realDependentObservable = new realKoDependentObservable(read, owner, options);

            if (!realDeferEvaluation) {
                realDependentObservable = wrap(realDependentObservable);
                dependentObservables.push(realDependentObservable);
            }

            return realDependentObservable;
        };
        ko.dependentObservable.fn = realKoDependentObservable.fn;
        ko.computed = ko.dependentObservable;
        var result = callback();
        ko.dependentObservable = localDO;
        ko.computed = ko.dependentObservable;
        return result;
    }

    function updateViewModel(mappedRootObject, rootObject, options, parentName, parent, parentPropertyName, mappedParent) {
        var isArray = exports.getType(ko.utils.unwrapObservable(rootObject)) === "array";

        parentPropertyName = parentPropertyName || "";

        // If this object was already mapped previously, take the options from there and merge them with our existing ones.
        if (exports.isMapped(mappedRootObject)) {
            var previousMapping = ko.utils.unwrapObservable(mappedRootObject)[mappingProperty];
            options = merge(previousMapping, options);
        }

        var callbackParams = {
            data: rootObject,
            parent: mappedParent || parent
        };

        var hasCreateCallback = function hasCreateCallback() {
            return options[parentName] && options[parentName].create instanceof Function;
        };

        var createCallback = function createCallback(data) {
            return withProxyDependentObservable(dependentObservables, function () {

                if (ko.utils.unwrapObservable(parent) instanceof Array) {
                    return options[parentName].create({
                        data: data || callbackParams.data,
                        parent: callbackParams.parent,
                        skip: emptyReturn
                    });
                } else {
                    return options[parentName].create({
                        data: data || callbackParams.data,
                        parent: callbackParams.parent
                    });
                }
            });
        };

        var hasUpdateCallback = function hasUpdateCallback() {
            return options[parentName] && options[parentName].update instanceof Function;
        };

        var updateCallback = function updateCallback(obj, data) {
            var params = {
                data: data || callbackParams.data,
                parent: callbackParams.parent,
                target: ko.utils.unwrapObservable(obj)
            };

            if (ko.isWriteableObservable(obj)) {
                params.observable = obj;
            }

            return options[parentName].update(params);
        };

        var alreadyMapped = visitedObjects.get(rootObject);
        if (alreadyMapped) {
            return alreadyMapped;
        }

        parentName = parentName || "";

        if (!isArray) {
            // For atomic types, do a direct update on the observable
            if (!canHaveProperties(rootObject)) {
                switch (exports.getType(rootObject)) {
                    case "function":
                        if (hasUpdateCallback()) {
                            if (ko.isWriteableObservable(rootObject)) {
                                rootObject(updateCallback(rootObject));
                                mappedRootObject = rootObject;
                            } else {
                                mappedRootObject = updateCallback(rootObject);
                            }
                        } else {
                            mappedRootObject = rootObject;
                        }
                        break;
                    default:
                        if (ko.isWriteableObservable(mappedRootObject)) {
                            if (hasUpdateCallback()) {
                                var valueToWrite = updateCallback(mappedRootObject);
                                mappedRootObject(valueToWrite);
                                return valueToWrite;
                            } else {
                                var valueToWrite = ko.utils.unwrapObservable(rootObject);
                                mappedRootObject(valueToWrite);
                                return valueToWrite;
                            }
                        } else {
                            var hasCreateOrUpdateCallback = hasCreateCallback() || hasUpdateCallback();

                            if (hasCreateCallback()) {
                                mappedRootObject = createCallback();
                            } else {
                                mappedRootObject = ko.observable(ko.utils.unwrapObservable(rootObject));
                            }

                            if (hasUpdateCallback()) {
                                mappedRootObject(updateCallback(mappedRootObject));
                            }

                            if (hasCreateOrUpdateCallback) return mappedRootObject;
                        }
                }
            } else {
                mappedRootObject = ko.utils.unwrapObservable(mappedRootObject);
                if (!mappedRootObject) {
                    if (hasCreateCallback()) {
                        var result = createCallback();

                        if (hasUpdateCallback()) {
                            result = updateCallback(result);
                        }

                        return result;
                    } else {
                        if (hasUpdateCallback()) {
                            return updateCallback(result);
                        }

                        mappedRootObject = {};
                    }
                }

                if (hasUpdateCallback()) {
                    mappedRootObject = updateCallback(mappedRootObject);
                }

                visitedObjects.save(rootObject, mappedRootObject);
                if (hasUpdateCallback()) return mappedRootObject;

                // For non-atomic types, visit all properties and update recursively
                visitPropertiesOrArrayEntries(rootObject, function (indexer) {
                    var fullPropertyName = parentPropertyName.length ? parentPropertyName + "." + indexer : indexer;

                    if (ko.utils.arrayIndexOf(options.ignore, fullPropertyName) != -1) {
                        return;
                    }

                    if (ko.utils.arrayIndexOf(options.copy, fullPropertyName) != -1) {
                        mappedRootObject[indexer] = rootObject[indexer];
                        return;
                    }

                    if (_typeof(rootObject[indexer]) != "object" && typeof rootObject[indexer] != "array" && options.observe.length > 0 && ko.utils.arrayIndexOf(options.observe, fullPropertyName) == -1) {
                        mappedRootObject[indexer] = rootObject[indexer];
                        options.copiedProperties[fullPropertyName] = true;
                        return;
                    }

                    // In case we are adding an already mapped property, fill it with the previously mapped property value to prevent recursion.
                    // If this is a property that was generated by fromJS, we should use the options specified there
                    var prevMappedProperty = visitedObjects.get(rootObject[indexer]);
                    var retval = updateViewModel(mappedRootObject[indexer], rootObject[indexer], options, indexer, mappedRootObject, fullPropertyName, mappedRootObject);
                    var value = prevMappedProperty || retval;

                    if (options.observe.length > 0 && ko.utils.arrayIndexOf(options.observe, fullPropertyName) == -1) {
                        mappedRootObject[indexer] = value();
                        options.copiedProperties[fullPropertyName] = true;
                        return;
                    }

                    if (ko.isWriteableObservable(mappedRootObject[indexer])) {
                        value = ko.utils.unwrapObservable(value);
                        if (mappedRootObject[indexer]() !== value) {
                            mappedRootObject[indexer](value);
                        }
                    } else {
                        value = mappedRootObject[indexer] === undefined ? value : ko.utils.unwrapObservable(value);
                        mappedRootObject[indexer] = value;
                    }

                    options.mappedProperties[fullPropertyName] = true;
                });
            }
        } else {
            //mappedRootObject is an array
            var changes = [];

            var hasKeyCallback = false;
            var keyCallback = function keyCallback(x) {
                return x;
            };
            if (options[parentName] && options[parentName].key) {
                keyCallback = options[parentName].key;
                hasKeyCallback = true;
            }

            if (!ko.isObservable(mappedRootObject)) {
                // When creating the new observable array, also add a bunch of utility functions that take the 'key' of the array items into account.
                mappedRootObject = ko.observableArray([]);

                mappedRootObject.mappedRemove = function (valueOrPredicate) {
                    var predicate = typeof valueOrPredicate == "function" ? valueOrPredicate : function (value) {
                        return value === keyCallback(valueOrPredicate);
                    };
                    return mappedRootObject.remove(function (item) {
                        return predicate(keyCallback(item));
                    });
                };

                mappedRootObject.mappedRemoveAll = function (arrayOfValues) {
                    var arrayOfKeys = filterArrayByKey(arrayOfValues, keyCallback);
                    return mappedRootObject.remove(function (item) {
                        return ko.utils.arrayIndexOf(arrayOfKeys, keyCallback(item)) != -1;
                    });
                };

                mappedRootObject.mappedDestroy = function (valueOrPredicate) {
                    var predicate = typeof valueOrPredicate == "function" ? valueOrPredicate : function (value) {
                        return value === keyCallback(valueOrPredicate);
                    };
                    return mappedRootObject.destroy(function (item) {
                        return predicate(keyCallback(item));
                    });
                };

                mappedRootObject.mappedDestroyAll = function (arrayOfValues) {
                    var arrayOfKeys = filterArrayByKey(arrayOfValues, keyCallback);
                    return mappedRootObject.destroy(function (item) {
                        return ko.utils.arrayIndexOf(arrayOfKeys, keyCallback(item)) != -1;
                    });
                };

                mappedRootObject.mappedIndexOf = function (item) {
                    var keys = filterArrayByKey(mappedRootObject(), keyCallback);
                    var key = keyCallback(item);
                    return ko.utils.arrayIndexOf(keys, key);
                };

                mappedRootObject.mappedGet = function (item) {
                    return mappedRootObject()[mappedRootObject.mappedIndexOf(item)];
                };

                mappedRootObject.mappedCreate = function (value) {
                    if (mappedRootObject.mappedIndexOf(value) !== -1) {
                        throw new Error("There already is an object with the key that you specified.");
                    }

                    var item = hasCreateCallback() ? createCallback(value) : value;
                    if (hasUpdateCallback()) {
                        var newValue = updateCallback(item, value);
                        if (ko.isWriteableObservable(item)) {
                            item(newValue);
                        } else {
                            item = newValue;
                        }
                    }
                    mappedRootObject.push(item);
                    return item;
                };
            }

            var currentArrayKeys = filterArrayByKey(ko.utils.unwrapObservable(mappedRootObject), keyCallback).sort();
            var newArrayKeys = filterArrayByKey(rootObject, keyCallback);
            if (hasKeyCallback) newArrayKeys.sort();
            var editScript = ko.utils.compareArrays(currentArrayKeys, newArrayKeys);

            var ignoreIndexOf = {};

            var i, j;

            var unwrappedRootObject = ko.utils.unwrapObservable(rootObject);
            var itemsByKey = {};
            var optimizedKeys = true;
            for (i = 0, j = unwrappedRootObject.length; i < j; i++) {
                var key = keyCallback(unwrappedRootObject[i]);
                if (key === undefined || key instanceof Object) {
                    optimizedKeys = false;
                    break;
                }
                itemsByKey[key] = unwrappedRootObject[i];
            }

            var newContents = [];
            var passedOver = 0;
            for (i = 0, j = editScript.length; i < j; i++) {
                var key = editScript[i];
                var mappedItem;
                var fullPropertyName = parentPropertyName + "[" + i + "]";
                switch (key.status) {
                    case "added":
                        var item = optimizedKeys ? itemsByKey[key.value] : getItemByKey(ko.utils.unwrapObservable(rootObject), key.value, keyCallback);
                        mappedItem = updateViewModel(undefined, item, options, parentName, mappedRootObject, fullPropertyName, parent);
                        if (!hasCreateCallback()) {
                            mappedItem = ko.utils.unwrapObservable(mappedItem);
                        }

                        var index = ignorableIndexOf(ko.utils.unwrapObservable(rootObject), item, ignoreIndexOf);

                        if (mappedItem === emptyReturn) {
                            passedOver++;
                        } else {
                            newContents[index - passedOver] = mappedItem;
                        }

                        ignoreIndexOf[index] = true;
                        break;
                    case "retained":
                        var item = optimizedKeys ? itemsByKey[key.value] : getItemByKey(ko.utils.unwrapObservable(rootObject), key.value, keyCallback);
                        mappedItem = getItemByKey(mappedRootObject, key.value, keyCallback);
                        updateViewModel(mappedItem, item, options, parentName, mappedRootObject, fullPropertyName, parent);

                        var index = ignorableIndexOf(ko.utils.unwrapObservable(rootObject), item, ignoreIndexOf);
                        newContents[index] = mappedItem;
                        ignoreIndexOf[index] = true;
                        break;
                    case "deleted":
                        mappedItem = getItemByKey(mappedRootObject, key.value, keyCallback);
                        break;
                }

                changes.push({
                    event: key.status,
                    item: mappedItem
                });
            }

            mappedRootObject(newContents);

            if (options[parentName] && options[parentName].arrayChanged) {
                ko.utils.arrayForEach(changes, function (change) {
                    options[parentName].arrayChanged(change.event, change.item);
                });
            }
        }

        return mappedRootObject;
    }

    function ignorableIndexOf(array, item, ignoreIndices) {
        for (var i = 0, j = array.length; i < j; i++) {
            if (ignoreIndices[i] === true) continue;
            if (array[i] === item) return i;
        }
        return null;
    }

    function mapKey(item, callback) {
        var mappedItem;
        if (callback) mappedItem = callback(item);
        if (exports.getType(mappedItem) === "undefined") mappedItem = item;

        return ko.utils.unwrapObservable(mappedItem);
    }

    function getItemByKey(array, key, callback) {
        array = ko.utils.unwrapObservable(array);
        for (var i = 0, j = array.length; i < j; i++) {
            var item = array[i];
            if (mapKey(item, callback) === key) return item;
        }

        throw new Error("When calling ko.update*, the key '" + key + "' was not found!");
    }

    function filterArrayByKey(array, callback) {
        return ko.utils.arrayMap(ko.utils.unwrapObservable(array), function (item) {
            if (callback) {
                return mapKey(item, callback);
            } else {
                return item;
            }
        });
    }

    function visitPropertiesOrArrayEntries(rootObject, visitorCallback) {
        if (exports.getType(rootObject) === "array") {
            for (var i = 0; i < rootObject.length; i++) {
                visitorCallback(i);
            }
        } else {
            for (var propertyName in rootObject) {
                visitorCallback(propertyName);
            }
        }
    };

    function canHaveProperties(object) {
        var type = exports.getType(object);
        return (type === "object" || type === "array") && object !== null;
    }

    // Based on the parentName, this creates a fully classified name of a property

    function getPropertyName(parentName, parent, indexer) {
        var propertyName = parentName || "";
        if (exports.getType(parent) === "array") {
            if (parentName) {
                propertyName += "[" + indexer + "]";
            }
        } else {
            if (parentName) {
                propertyName += ".";
            }
            propertyName += indexer;
        }
        return propertyName;
    }

    exports.visitModel = function (rootObject, callback, options) {
        options = options || {};
        options.visitedObjects = options.visitedObjects || new objectLookup();

        var mappedRootObject;
        var unwrappedRootObject = ko.utils.unwrapObservable(rootObject);

        if (!canHaveProperties(unwrappedRootObject)) {
            return callback(rootObject, options.parentName);
        } else {
            options = fillOptions(options, unwrappedRootObject[mappingProperty]);

            // Only do a callback, but ignore the results
            callback(rootObject, options.parentName);
            mappedRootObject = exports.getType(unwrappedRootObject) === "array" ? [] : {};
        }

        options.visitedObjects.save(rootObject, mappedRootObject);

        var parentName = options.parentName;
        visitPropertiesOrArrayEntries(unwrappedRootObject, function (indexer) {
            if (options.ignore && ko.utils.arrayIndexOf(options.ignore, indexer) != -1) return;

            var propertyValue = unwrappedRootObject[indexer];
            options.parentName = getPropertyName(parentName, unwrappedRootObject, indexer);

            // If we don't want to explicitly copy the unmapped property...
            if (ko.utils.arrayIndexOf(options.copy, indexer) === -1) {
                // ...find out if it's a property we want to explicitly include
                if (ko.utils.arrayIndexOf(options.include, indexer) === -1) {
                    // The mapped properties object contains all the properties that were part of the original object.
                    // If a property does not exist, and it is not because it is part of an array (e.g. "myProp[3]"), then it should not be unmapped.
                    if (unwrappedRootObject[mappingProperty] && unwrappedRootObject[mappingProperty].mappedProperties && !unwrappedRootObject[mappingProperty].mappedProperties[indexer] && unwrappedRootObject[mappingProperty].copiedProperties && !unwrappedRootObject[mappingProperty].copiedProperties[indexer] && !(exports.getType(unwrappedRootObject) === "array")) {
                        return;
                    }
                }
            }

            var outputProperty;
            switch (exports.getType(ko.utils.unwrapObservable(propertyValue))) {
                case "object":
                case "array":
                case "undefined":
                    var previouslyMappedValue = options.visitedObjects.get(propertyValue);
                    mappedRootObject[indexer] = exports.getType(previouslyMappedValue) !== "undefined" ? previouslyMappedValue : exports.visitModel(propertyValue, callback, options);
                    break;
                default:
                    mappedRootObject[indexer] = callback(propertyValue, options.parentName);
            }
        });

        return mappedRootObject;
    };

    function simpleObjectLookup() {
        var keys = [];
        var values = [];
        this.save = function (key, value) {
            var existingIndex = ko.utils.arrayIndexOf(keys, key);
            if (existingIndex >= 0) values[existingIndex] = value;else {
                keys.push(key);
                values.push(value);
            }
        };
        this.get = function (key) {
            var existingIndex = ko.utils.arrayIndexOf(keys, key);
            var value = existingIndex >= 0 ? values[existingIndex] : undefined;
            return value;
        };
    };

    function objectLookup() {
        var buckets = {};

        var findBucket = function findBucket(key) {
            var bucketKey;
            try {
                bucketKey = key; //JSON.stringify(key);
            } catch (e) {
                bucketKey = "$$$";
            }

            var bucket = buckets[bucketKey];
            if (bucket === undefined) {
                bucket = new simpleObjectLookup();
                buckets[bucketKey] = bucket;
            }
            return bucket;
        };

        this.save = function (key, value) {
            findBucket(key).save(key, value);
        };
        this.get = function (key) {
            return findBucket(key).get(key);
        };
    };
});
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function () {

    // Baseline setup
    // --------------

    // Establish the root object, `window` in the browser, or `exports` on the server.
    var root = this;

    // Save the previous value of the `_` variable.
    var previousUnderscore = root._;

    // Save bytes in the minified (but not gzipped) version:
    var ArrayProto = Array.prototype,
        ObjProto = Object.prototype,
        FuncProto = Function.prototype;

    // Create quick reference variables for speed access to core prototypes.
    var push = ArrayProto.push,
        slice = ArrayProto.slice,
        toString = ObjProto.toString,
        hasOwnProperty = ObjProto.hasOwnProperty;

    // All **ECMAScript 5** native function implementations that we hope to use
    // are declared here.
    var nativeIsArray = Array.isArray,
        nativeKeys = Object.keys,
        nativeBind = FuncProto.bind,
        nativeCreate = Object.create;

    // Naked function reference for surrogate-prototype-swapping.
    var Ctor = function Ctor() {};

    // Create a safe reference to the Underscore object for use below.
    var _ = function _(obj) {
        if (obj instanceof _) return obj;
        if (!(this instanceof _)) return new _(obj);
        this._wrapped = obj;
    };

    // Export the Underscore object for **Node.js**, with
    // backwards-compatibility for the old `require()` API. If we're in
    // the browser, add `_` as a global object.
    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = _;
        }
        exports._ = _;
    } else {
        root._ = _;
    }

    // Current version.
    _.VERSION = '1.8.3';

    // Internal function that returns an efficient (for current engines) version
    // of the passed-in callback, to be repeatedly applied in other Underscore
    // functions.
    var optimizeCb = function optimizeCb(func, context, argCount) {
        if (context === void 0) return func;
        switch (argCount == null ? 3 : argCount) {
            case 1:
                return function (value) {
                    return func.call(context, value);
                };
            case 2:
                return function (value, other) {
                    return func.call(context, value, other);
                };
            case 3:
                return function (value, index, collection) {
                    return func.call(context, value, index, collection);
                };
            case 4:
                return function (accumulator, value, index, collection) {
                    return func.call(context, accumulator, value, index, collection);
                };
        }
        return function () {
            return func.apply(context, arguments);
        };
    };

    // A mostly-internal function to generate callbacks that can be applied
    // to each element in a collection, returning the desired result — either
    // identity, an arbitrary callback, a property matcher, or a property accessor.
    var cb = function cb(value, context, argCount) {
        if (value == null) return _.identity;
        if (_.isFunction(value)) return optimizeCb(value, context, argCount);
        if (_.isObject(value)) return _.matcher(value);
        return _.property(value);
    };
    _.iteratee = function (value, context) {
        return cb(value, context, Infinity);
    };

    // An internal function for creating assigner functions.
    var createAssigner = function createAssigner(keysFunc, undefinedOnly) {
        return function (obj) {
            var length = arguments.length;
            if (length < 2 || obj == null) return obj;
            for (var index = 1; index < length; index++) {
                var source = arguments[index],
                    keys = keysFunc(source),
                    l = keys.length;
                for (var i = 0; i < l; i++) {
                    var key = keys[i];
                    if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
                }
            }
            return obj;
        };
    };

    // An internal function for creating a new object that inherits from another.
    var baseCreate = function baseCreate(prototype) {
        if (!_.isObject(prototype)) return {};
        if (nativeCreate) return nativeCreate(prototype);
        Ctor.prototype = prototype;
        var result = new Ctor();
        Ctor.prototype = null;
        return result;
    };

    var property = function property(key) {
        return function (obj) {
            return obj == null ? void 0 : obj[key];
        };
    };

    // Helper for collection methods to determine whether a collection
    // should be iterated as an array or as an object
    // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
    // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
    var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
    var getLength = property('length');
    var isArrayLike = function isArrayLike(collection) {
        var length = getLength(collection);
        return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
    };

    // Collection Functions
    // --------------------

    // The cornerstone, an `each` implementation, aka `forEach`.
    // Handles raw objects in addition to array-likes. Treats all
    // sparse array-likes as if they were dense.
    _.each = _.forEach = function (obj, iteratee, context) {
        iteratee = optimizeCb(iteratee, context);
        var i, length;
        if (isArrayLike(obj)) {
            for (i = 0, length = obj.length; i < length; i++) {
                iteratee(obj[i], i, obj);
            }
        } else {
            var keys = _.keys(obj);
            for (i = 0, length = keys.length; i < length; i++) {
                iteratee(obj[keys[i]], keys[i], obj);
            }
        }
        return obj;
    };

    // Return the results of applying the iteratee to each element.
    _.map = _.collect = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length,
            results = Array(length);
        for (var index = 0; index < length; index++) {
            var currentKey = keys ? keys[index] : index;
            results[index] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
    };

    // Create a reducing function iterating left or right.
    function createReduce(dir) {
        // Optimized iterator function as using arguments.length
        // in the main function will deoptimize the, see #1991.
        function iterator(obj, iteratee, memo, keys, index, length) {
            for (; index >= 0 && index < length; index += dir) {
                var currentKey = keys ? keys[index] : index;
                memo = iteratee(memo, obj[currentKey], currentKey, obj);
            }
            return memo;
        }

        return function (obj, iteratee, memo, context) {
            iteratee = optimizeCb(iteratee, context, 4);
            var keys = !isArrayLike(obj) && _.keys(obj),
                length = (keys || obj).length,
                index = dir > 0 ? 0 : length - 1;
            // Determine the initial value if none is provided.
            if (arguments.length < 3) {
                memo = obj[keys ? keys[index] : index];
                index += dir;
            }
            return iterator(obj, iteratee, memo, keys, index, length);
        };
    }

    // **Reduce** builds up a single result from a list of values, aka `inject`,
    // or `foldl`.
    _.reduce = _.foldl = _.inject = createReduce(1);

    // The right-associative version of reduce, also known as `foldr`.
    _.reduceRight = _.foldr = createReduce(-1);

    // Return the first value which passes a truth test. Aliased as `detect`.
    _.find = _.detect = function (obj, predicate, context) {
        var key;
        if (isArrayLike(obj)) {
            key = _.findIndex(obj, predicate, context);
        } else {
            key = _.findKey(obj, predicate, context);
        }
        if (key !== void 0 && key !== -1) return obj[key];
    };

    // Return all the elements that pass a truth test.
    // Aliased as `select`.
    _.filter = _.select = function (obj, predicate, context) {
        var results = [];
        predicate = cb(predicate, context);
        _.each(obj, function (value, index, list) {
            if (predicate(value, index, list)) results.push(value);
        });
        return results;
    };

    // Return all the elements for which a truth test fails.
    _.reject = function (obj, predicate, context) {
        return _.filter(obj, _.negate(cb(predicate)), context);
    };

    // Determine whether all of the elements match a truth test.
    // Aliased as `all`.
    _.every = _.all = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length;
        for (var index = 0; index < length; index++) {
            var currentKey = keys ? keys[index] : index;
            if (!predicate(obj[currentKey], currentKey, obj)) return false;
        }
        return true;
    };

    // Determine if at least one element in the object matches a truth test.
    // Aliased as `any`.
    _.some = _.any = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj),
            length = (keys || obj).length;
        for (var index = 0; index < length; index++) {
            var currentKey = keys ? keys[index] : index;
            if (predicate(obj[currentKey], currentKey, obj)) return true;
        }
        return false;
    };

    // Determine if the array or object contains a given item (using `===`).
    // Aliased as `includes` and `include`.
    _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
        if (!isArrayLike(obj)) obj = _.values(obj);
        if (typeof fromIndex != 'number' || guard) fromIndex = 0;
        return _.indexOf(obj, item, fromIndex) >= 0;
    };

    // Invoke a method (with arguments) on every item in a collection.
    _.invoke = function (obj, method) {
        var args = slice.call(arguments, 2);
        var isFunc = _.isFunction(method);
        return _.map(obj, function (value) {
            var func = isFunc ? method : value[method];
            return func == null ? func : func.apply(value, args);
        });
    };

    // Convenience version of a common use case of `map`: fetching a property.
    _.pluck = function (obj, key) {
        return _.map(obj, _.property(key));
    };

    // Convenience version of a common use case of `filter`: selecting only objects
    // containing specific `key:value` pairs.
    _.where = function (obj, attrs) {
        return _.filter(obj, _.matcher(attrs));
    };

    // Convenience version of a common use case of `find`: getting the first object
    // containing specific `key:value` pairs.
    _.findWhere = function (obj, attrs) {
        return _.find(obj, _.matcher(attrs));
    };

    // Return the maximum element (or element-based computation).
    _.max = function (obj, iteratee, context) {
        var result = -Infinity,
            lastComputed = -Infinity,
            value,
            computed;
        if (iteratee == null && obj != null) {
            obj = isArrayLike(obj) ? obj : _.values(obj);
            for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value > result) {
                    result = value;
                }
            }
        } else {
            iteratee = cb(iteratee, context);
            _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                    result = value;
                    lastComputed = computed;
                }
            });
        }
        return result;
    };

    // Return the minimum element (or element-based computation).
    _.min = function (obj, iteratee, context) {
        var result = Infinity,
            lastComputed = Infinity,
            value,
            computed;
        if (iteratee == null && obj != null) {
            obj = isArrayLike(obj) ? obj : _.values(obj);
            for (var i = 0, length = obj.length; i < length; i++) {
                value = obj[i];
                if (value < result) {
                    result = value;
                }
            }
        } else {
            iteratee = cb(iteratee, context);
            _.each(obj, function (value, index, list) {
                computed = iteratee(value, index, list);
                if (computed < lastComputed || computed === Infinity && result === Infinity) {
                    result = value;
                    lastComputed = computed;
                }
            });
        }
        return result;
    };

    // Shuffle a collection, using the modern version of the
    // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
    _.shuffle = function (obj) {
        var set = isArrayLike(obj) ? obj : _.values(obj);
        var length = set.length;
        var shuffled = Array(length);
        for (var index = 0, rand; index < length; index++) {
            rand = _.random(0, index);
            if (rand !== index) shuffled[index] = shuffled[rand];
            shuffled[rand] = set[index];
        }
        return shuffled;
    };

    // Sample **n** random values from a collection.
    // If **n** is not specified, returns a single random element.
    // The internal `guard` argument allows it to work with `map`.
    _.sample = function (obj, n, guard) {
        if (n == null || guard) {
            if (!isArrayLike(obj)) obj = _.values(obj);
            return obj[_.random(obj.length - 1)];
        }
        return _.shuffle(obj).slice(0, Math.max(0, n));
    };

    // Sort the object's values by a criterion produced by an iteratee.
    _.sortBy = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        return _.pluck(_.map(obj, function (value, index, list) {
            return {
                value: value,
                index: index,
                criteria: iteratee(value, index, list)
            };
        }).sort(function (left, right) {
            var a = left.criteria;
            var b = right.criteria;
            if (a !== b) {
                if (a > b || a === void 0) return 1;
                if (a < b || b === void 0) return -1;
            }
            return left.index - right.index;
        }), 'value');
    };

    // An internal function used for aggregate "group by" operations.
    var group = function group(behavior) {
        return function (obj, iteratee, context) {
            var result = {};
            iteratee = cb(iteratee, context);
            _.each(obj, function (value, index) {
                var key = iteratee(value, index, obj);
                behavior(result, value, key);
            });
            return result;
        };
    };

    // Groups the object's values by a criterion. Pass either a string attribute
    // to group by, or a function that returns the criterion.
    _.groupBy = group(function (result, value, key) {
        if (_.has(result, key)) result[key].push(value);else result[key] = [value];
    });

    // Indexes the object's values by a criterion, similar to `groupBy`, but for
    // when you know that your index values will be unique.
    _.indexBy = group(function (result, value, key) {
        result[key] = value;
    });

    // Counts instances of an object that group by a certain criterion. Pass
    // either a string attribute to count by, or a function that returns the
    // criterion.
    _.countBy = group(function (result, value, key) {
        if (_.has(result, key)) result[key]++;else result[key] = 1;
    });

    // Safely create a real, live array from anything iterable.
    _.toArray = function (obj) {
        if (!obj) return [];
        if (_.isArray(obj)) return slice.call(obj);
        if (isArrayLike(obj)) return _.map(obj, _.identity);
        return _.values(obj);
    };

    // Return the number of elements in an object.
    _.size = function (obj) {
        if (obj == null) return 0;
        return isArrayLike(obj) ? obj.length : _.keys(obj).length;
    };

    // Split a collection into two arrays: one whose elements all satisfy the given
    // predicate, and one whose elements all do not satisfy the predicate.
    _.partition = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var pass = [],
            fail = [];
        _.each(obj, function (value, key, obj) {
            (predicate(value, key, obj) ? pass : fail).push(value);
        });
        return [pass, fail];
    };

    // Array Functions
    // ---------------

    // Get the first element of an array. Passing **n** will return the first N
    // values in the array. Aliased as `head` and `take`. The **guard** check
    // allows it to work with `_.map`.
    _.first = _.head = _.take = function (array, n, guard) {
        if (array == null) return void 0;
        if (n == null || guard) return array[0];
        return _.initial(array, array.length - n);
    };

    // Returns everything but the last entry of the array. Especially useful on
    // the arguments object. Passing **n** will return all the values in
    // the array, excluding the last N.
    _.initial = function (array, n, guard) {
        return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
    };

    // Get the last element of an array. Passing **n** will return the last N
    // values in the array.
    _.last = function (array, n, guard) {
        if (array == null) return void 0;
        if (n == null || guard) return array[array.length - 1];
        return _.rest(array, Math.max(0, array.length - n));
    };

    // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
    // Especially useful on the arguments object. Passing an **n** will return
    // the rest N values in the array.
    _.rest = _.tail = _.drop = function (array, n, guard) {
        return slice.call(array, n == null || guard ? 1 : n);
    };

    // Trim out all falsy values from an array.
    _.compact = function (array) {
        return _.filter(array, _.identity);
    };

    // Internal implementation of a recursive `flatten` function.
    var flatten = function flatten(input, shallow, strict, startIndex) {
        var output = [],
            idx = 0;
        for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
            var value = input[i];
            if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
                //flatten current level of array or arguments object
                if (!shallow) value = flatten(value, shallow, strict);
                var j = 0,
                    len = value.length;
                output.length += len;
                while (j < len) {
                    output[idx++] = value[j++];
                }
            } else if (!strict) {
                output[idx++] = value;
            }
        }
        return output;
    };

    // Flatten out an array, either recursively (by default), or just one level.
    _.flatten = function (array, shallow) {
        return flatten(array, shallow, false);
    };

    // Return a version of the array that does not contain the specified value(s).
    _.without = function (array) {
        return _.difference(array, slice.call(arguments, 1));
    };

    // Produce a duplicate-free version of the array. If the array has already
    // been sorted, you have the option of using a faster algorithm.
    // Aliased as `unique`.
    _.uniq = _.unique = function (array, isSorted, iteratee, context) {
        if (!_.isBoolean(isSorted)) {
            context = iteratee;
            iteratee = isSorted;
            isSorted = false;
        }
        if (iteratee != null) iteratee = cb(iteratee, context);
        var result = [];
        var seen = [];
        for (var i = 0, length = getLength(array); i < length; i++) {
            var value = array[i],
                computed = iteratee ? iteratee(value, i, array) : value;
            if (isSorted) {
                if (!i || seen !== computed) result.push(value);
                seen = computed;
            } else if (iteratee) {
                if (!_.contains(seen, computed)) {
                    seen.push(computed);
                    result.push(value);
                }
            } else if (!_.contains(result, value)) {
                result.push(value);
            }
        }
        return result;
    };

    // Produce an array that contains the union: each distinct element from all of
    // the passed-in arrays.
    _.union = function () {
        return _.uniq(flatten(arguments, true, true));
    };

    // Produce an array that contains every item shared between all the
    // passed-in arrays.
    _.intersection = function (array) {
        var result = [];
        var argsLength = arguments.length;
        for (var i = 0, length = getLength(array); i < length; i++) {
            var item = array[i];
            if (_.contains(result, item)) continue;
            for (var j = 1; j < argsLength; j++) {
                if (!_.contains(arguments[j], item)) break;
            }
            if (j === argsLength) result.push(item);
        }
        return result;
    };

    // Take the difference between one array and a number of other arrays.
    // Only the elements present in just the first array will remain.
    _.difference = function (array) {
        var rest = flatten(arguments, true, true, 1);
        return _.filter(array, function (value) {
            return !_.contains(rest, value);
        });
    };

    // Zip together multiple lists into a single array -- elements that share
    // an index go together.
    _.zip = function () {
        return _.unzip(arguments);
    };

    // Complement of _.zip. Unzip accepts an array of arrays and groups
    // each array's elements on shared indices
    _.unzip = function (array) {
        var length = array && _.max(array, getLength).length || 0;
        var result = Array(length);

        for (var index = 0; index < length; index++) {
            result[index] = _.pluck(array, index);
        }
        return result;
    };

    // Converts lists into objects. Pass either a single array of `[key, value]`
    // pairs, or two parallel arrays of the same length -- one of keys, and one of
    // the corresponding values.
    _.object = function (list, values) {
        var result = {};
        for (var i = 0, length = getLength(list); i < length; i++) {
            if (values) {
                result[list[i]] = values[i];
            } else {
                result[list[i][0]] = list[i][1];
            }
        }
        return result;
    };

    // Generator function to create the findIndex and findLastIndex functions
    function createPredicateIndexFinder(dir) {
        return function (array, predicate, context) {
            predicate = cb(predicate, context);
            var length = getLength(array);
            var index = dir > 0 ? 0 : length - 1;
            for (; index >= 0 && index < length; index += dir) {
                if (predicate(array[index], index, array)) return index;
            }
            return -1;
        };
    }

    // Returns the first index on an array-like that passes a predicate test
    _.findIndex = createPredicateIndexFinder(1);
    _.findLastIndex = createPredicateIndexFinder(-1);

    // Use a comparator function to figure out the smallest index at which
    // an object should be inserted so as to maintain order. Uses binary search.
    _.sortedIndex = function (array, obj, iteratee, context) {
        iteratee = cb(iteratee, context, 1);
        var value = iteratee(obj);
        var low = 0,
            high = getLength(array);
        while (low < high) {
            var mid = Math.floor((low + high) / 2);
            if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
        }
        return low;
    };

    // Generator function to create the indexOf and lastIndexOf functions
    function createIndexFinder(dir, predicateFind, sortedIndex) {
        return function (array, item, idx) {
            var i = 0,
                length = getLength(array);
            if (typeof idx == 'number') {
                if (dir > 0) {
                    i = idx >= 0 ? idx : Math.max(idx + length, i);
                } else {
                    length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
                }
            } else if (sortedIndex && idx && length) {
                idx = sortedIndex(array, item);
                return array[idx] === item ? idx : -1;
            }
            if (item !== item) {
                idx = predicateFind(slice.call(array, i, length), _.isNaN);
                return idx >= 0 ? idx + i : -1;
            }
            for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
                if (array[idx] === item) return idx;
            }
            return -1;
        };
    }

    // Return the position of the first occurrence of an item in an array,
    // or -1 if the item is not included in the array.
    // If the array is large and already in sort order, pass `true`
    // for **isSorted** to use binary search.
    _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
    _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

    // Generate an integer Array containing an arithmetic progression. A port of
    // the native Python `range()` function. See
    // [the Python documentation](http://docs.python.org/library/functions.html#range).
    _.range = function (start, stop, step) {
        if (stop == null) {
            stop = start || 0;
            start = 0;
        }
        step = step || 1;

        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var range = Array(length);

        for (var idx = 0; idx < length; idx++, start += step) {
            range[idx] = start;
        }

        return range;
    };

    // Function (ahem) Functions
    // ------------------

    // Determines whether to execute a function as a constructor
    // or a normal function with the provided arguments
    var executeBound = function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
        if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
        var self = baseCreate(sourceFunc.prototype);
        var result = sourceFunc.apply(self, args);
        if (_.isObject(result)) return result;
        return self;
    };

    // Create a function bound to a given object (assigning `this`, and arguments,
    // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
    // available.
    _.bind = function (func, context) {
        if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
        if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
        var args = slice.call(arguments, 2);
        var bound = function bound() {
            return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
        };
        return bound;
    };

    // Partially apply a function by creating a version that has had some of its
    // arguments pre-filled, without changing its dynamic `this` context. _ acts
    // as a placeholder, allowing any combination of arguments to be pre-filled.
    _.partial = function (func) {
        var boundArgs = slice.call(arguments, 1);
        var bound = function bound() {
            var position = 0,
                length = boundArgs.length;
            var args = Array(length);
            for (var i = 0; i < length; i++) {
                args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
            }
            while (position < arguments.length) {
                args.push(arguments[position++]);
            }return executeBound(func, bound, this, this, args);
        };
        return bound;
    };

    // Bind a number of an object's methods to that object. Remaining arguments
    // are the method names to be bound. Useful for ensuring that all callbacks
    // defined on an object belong to it.
    _.bindAll = function (obj) {
        var i,
            length = arguments.length,
            key;
        if (length <= 1) throw new Error('bindAll must be passed function names');
        for (i = 1; i < length; i++) {
            key = arguments[i];
            obj[key] = _.bind(obj[key], obj);
        }
        return obj;
    };

    // Memoize an expensive function by storing its results.
    _.memoize = function (func, hasher) {
        var memoize = function memoize(key) {
            var cache = memoize.cache;
            var address = '' + (hasher ? hasher.apply(this, arguments) : key);
            if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
            return cache[address];
        };
        memoize.cache = {};
        return memoize;
    };

    // Delays a function for the given number of milliseconds, and then calls
    // it with the arguments supplied.
    _.delay = function (func, wait) {
        var args = slice.call(arguments, 2);
        return setTimeout(function () {
            return func.apply(null, args);
        }, wait);
    };

    // Defers a function, scheduling it to run after the current call stack has
    // cleared.
    _.defer = _.partial(_.delay, _, 1);

    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run
    // as much as it can, without ever going more than once per `wait` duration;
    // but if you'd like to disable the execution on the leading edge, pass
    // `{leading: false}`. To disable execution on the trailing edge, ditto.
    _.throttle = function (func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) options = {};
        var later = function later() {
            previous = options.leading === false ? 0 : _.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function () {
            var now = _.now();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    _.debounce = function (func, wait, immediate) {
        var timeout, args, context, timestamp, result;

        var later = function later() {
            var last = _.now() - timestamp;

            if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                }
            }
        };

        return function () {
            context = this;
            args = arguments;
            timestamp = _.now();
            var callNow = immediate && !timeout;
            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) {
                result = func.apply(context, args);
                context = args = null;
            }

            return result;
        };
    };

    // Returns the first function passed as an argument to the second,
    // allowing you to adjust arguments, run code before and after, and
    // conditionally execute the original function.
    _.wrap = function (func, wrapper) {
        return _.partial(wrapper, func);
    };

    // Returns a negated version of the passed-in predicate.
    _.negate = function (predicate) {
        return function () {
            return !predicate.apply(this, arguments);
        };
    };

    // Returns a function that is the composition of a list of functions, each
    // consuming the return value of the function that follows.
    _.compose = function () {
        var args = arguments;
        var start = args.length - 1;
        return function () {
            var i = start;
            var result = args[start].apply(this, arguments);
            while (i--) {
                result = args[i].call(this, result);
            }return result;
        };
    };

    // Returns a function that will only be executed on and after the Nth call.
    _.after = function (times, func) {
        return function () {
            if (--times < 1) {
                return func.apply(this, arguments);
            }
        };
    };

    // Returns a function that will only be executed up to (but not including) the Nth call.
    _.before = function (times, func) {
        var memo;
        return function () {
            if (--times > 0) {
                memo = func.apply(this, arguments);
            }
            if (times <= 1) func = null;
            return memo;
        };
    };

    // Returns a function that will be executed at most one time, no matter how
    // often you call it. Useful for lazy initialization.
    _.once = _.partial(_.before, 2);

    // Object Functions
    // ----------------

    // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
    var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
    var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

    function collectNonEnumProps(obj, keys) {
        var nonEnumIdx = nonEnumerableProps.length;
        var constructor = obj.constructor;
        var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

        // Constructor is a special case.
        var prop = 'constructor';
        if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

        while (nonEnumIdx--) {
            prop = nonEnumerableProps[nonEnumIdx];
            if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
                keys.push(prop);
            }
        }
    }

    // Retrieve the names of an object's own properties.
    // Delegates to **ECMAScript 5**'s native `Object.keys`
    _.keys = function (obj) {
        if (!_.isObject(obj)) return [];
        if (nativeKeys) return nativeKeys(obj);
        var keys = [];
        for (var key in obj) {
            if (_.has(obj, key)) keys.push(key);
        } // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
    };

    // Retrieve all the property names of an object.
    _.allKeys = function (obj) {
        if (!_.isObject(obj)) return [];
        var keys = [];
        for (var key in obj) {
            keys.push(key);
        } // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
    };

    // Retrieve the values of an object's properties.
    _.values = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var values = Array(length);
        for (var i = 0; i < length; i++) {
            values[i] = obj[keys[i]];
        }
        return values;
    };

    // Returns the results of applying the iteratee to each element of the object
    // In contrast to _.map it returns an object
    _.mapObject = function (obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = _.keys(obj),
            length = keys.length,
            results = {},
            currentKey;
        for (var index = 0; index < length; index++) {
            currentKey = keys[index];
            results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
    };

    // Convert an object into a list of `[key, value]` pairs.
    _.pairs = function (obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var pairs = Array(length);
        for (var i = 0; i < length; i++) {
            pairs[i] = [keys[i], obj[keys[i]]];
        }
        return pairs;
    };

    // Invert the keys and values of an object. The values must be serializable.
    _.invert = function (obj) {
        var result = {};
        var keys = _.keys(obj);
        for (var i = 0, length = keys.length; i < length; i++) {
            result[obj[keys[i]]] = keys[i];
        }
        return result;
    };

    // Return a sorted list of the function names available on the object.
    // Aliased as `methods`
    _.functions = _.methods = function (obj) {
        var names = [];
        for (var key in obj) {
            if (_.isFunction(obj[key])) names.push(key);
        }
        return names.sort();
    };

    // Extend a given object with all the properties in passed-in object(s).
    _.extend = createAssigner(_.allKeys);

    // Assigns a given object with all the own properties in the passed-in object(s)
    // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
    _.extendOwn = _.assign = createAssigner(_.keys);

    // Returns the first key on an object that passes a predicate test
    _.findKey = function (obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = _.keys(obj),
            key;
        for (var i = 0, length = keys.length; i < length; i++) {
            key = keys[i];
            if (predicate(obj[key], key, obj)) return key;
        }
    };

    // Return a copy of the object only containing the whitelisted properties.
    _.pick = function (object, oiteratee, context) {
        var result = {},
            obj = object,
            iteratee,
            keys;
        if (obj == null) return result;
        if (_.isFunction(oiteratee)) {
            keys = _.allKeys(obj);
            iteratee = optimizeCb(oiteratee, context);
        } else {
            keys = flatten(arguments, false, false, 1);
            iteratee = function iteratee(value, key, obj) {
                return key in obj;
            };
            obj = Object(obj);
        }
        for (var i = 0, length = keys.length; i < length; i++) {
            var key = keys[i];
            var value = obj[key];
            if (iteratee(value, key, obj)) result[key] = value;
        }
        return result;
    };

    // Return a copy of the object without the blacklisted properties.
    _.omit = function (obj, iteratee, context) {
        if (_.isFunction(iteratee)) {
            iteratee = _.negate(iteratee);
        } else {
            var keys = _.map(flatten(arguments, false, false, 1), String);
            iteratee = function iteratee(value, key) {
                return !_.contains(keys, key);
            };
        }
        return _.pick(obj, iteratee, context);
    };

    // Fill in a given object with default properties.
    _.defaults = createAssigner(_.allKeys, true);

    // Creates an object that inherits from the given prototype object.
    // If additional properties are provided then they will be added to the
    // created object.
    _.create = function (prototype, props) {
        var result = baseCreate(prototype);
        if (props) _.extendOwn(result, props);
        return result;
    };

    // Create a (shallow-cloned) duplicate of an object.
    _.clone = function (obj) {
        if (!_.isObject(obj)) return obj;
        return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
    };

    // Invokes interceptor with the obj, and then returns obj.
    // The primary purpose of this method is to "tap into" a method chain, in
    // order to perform operations on intermediate results within the chain.
    _.tap = function (obj, interceptor) {
        interceptor(obj);
        return obj;
    };

    // Returns whether an object has a given set of `key:value` pairs.
    _.isMatch = function (object, attrs) {
        var keys = _.keys(attrs),
            length = keys.length;
        if (object == null) return !length;
        var obj = Object(object);
        for (var i = 0; i < length; i++) {
            var key = keys[i];
            if (attrs[key] !== obj[key] || !(key in obj)) return false;
        }
        return true;
    };

    // Internal recursive comparison function for `isEqual`.
    var eq = function eq(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // A strict comparison is necessary because `null == undefined`.
        if (a == null || b == null) return a === b;
        // Unwrap any wrapped objects.
        if (a instanceof _) a = a._wrapped;
        if (b instanceof _) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = toString.call(a);
        if (className !== toString.call(b)) return false;
        switch (className) {
            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
            case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
        }

        var areArrays = className === '[object Array]';
        if (!areArrays) {
            if ((typeof a === "undefined" ? "undefined" : _typeof(a)) != 'object' || (typeof b === "undefined" ? "undefined" : _typeof(b)) != 'object') return false;

            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor,
                bCtor = b.constructor;
            if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
            }
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while (length--) {
            // Linear search. Performance is inversely proportional to the number of
            // unique nested structures.
            if (aStack[length] === a) return bStack[length] === b;
        }

        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);

        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.
            while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
            }
        } else {
            // Deep compare objects.
            var keys = _.keys(a),
                key;
            length = keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if (_.keys(b).length !== length) return false;
            while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
            }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
    };

    // Perform a deep comparison to check if two objects are equal.
    _.isEqual = function (a, b) {
        return eq(a, b);
    };

    // Is a given array, string, or object empty?
    // An "empty" object has no enumerable own-properties.
    _.isEmpty = function (obj) {
        if (obj == null) return true;
        if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
        return _.keys(obj).length === 0;
    };

    // Is a given value a DOM element?
    _.isElement = function (obj) {
        return !!(obj && obj.nodeType === 1);
    };

    // Is a given value an array?
    // Delegates to ECMA5's native Array.isArray
    _.isArray = nativeIsArray || function (obj) {
        return toString.call(obj) === '[object Array]';
    };

    // Is a given variable an object?
    _.isObject = function (obj) {
        var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
        return type === 'function' || type === 'object' && !!obj;
    };

    // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
    _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
        _['is' + name] = function (obj) {
            return toString.call(obj) === '[object ' + name + ']';
        };
    });

    // Define a fallback version of the method in browsers (ahem, IE < 9), where
    // there isn't any inspectable "Arguments" type.
    if (!_.isArguments(arguments)) {
        _.isArguments = function (obj) {
            return _.has(obj, 'callee');
        };
    }

    // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
    // IE 11 (#1621), and in Safari 8 (#1929).
    if (typeof /./ != 'function' && (typeof Int8Array === "undefined" ? "undefined" : _typeof(Int8Array)) != 'object') {
        _.isFunction = function (obj) {
            return typeof obj == 'function' || false;
        };
    }

    // Is a given object a finite number?
    _.isFinite = function (obj) {
        return isFinite(obj) && !isNaN(parseFloat(obj));
    };

    // Is the given value `NaN`? (NaN is the only number which does not equal itself).
    _.isNaN = function (obj) {
        return _.isNumber(obj) && obj !== +obj;
    };

    // Is a given value a boolean?
    _.isBoolean = function (obj) {
        return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
    };

    // Is a given value equal to null?
    _.isNull = function (obj) {
        return obj === null;
    };

    // Is a given variable undefined?
    _.isUndefined = function (obj) {
        return obj === void 0;
    };

    // Shortcut function for checking if an object has a given property directly
    // on itself (in other words, not on a prototype).
    _.has = function (obj, key) {
        return obj != null && hasOwnProperty.call(obj, key);
    };

    // Utility Functions
    // -----------------

    // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
    // previous owner. Returns a reference to the Underscore object.
    _.noConflict = function () {
        root._ = previousUnderscore;
        return this;
    };

    // Keep the identity function around for default iteratees.
    _.identity = function (value) {
        return value;
    };

    // Predicate-generating functions. Often useful outside of Underscore.
    _.constant = function (value) {
        return function () {
            return value;
        };
    };

    _.noop = function () {};

    _.property = property;

    // Generates a function for a given object that returns a given property.
    _.propertyOf = function (obj) {
        return obj == null ? function () {} : function (key) {
            return obj[key];
        };
    };

    // Returns a predicate for checking whether an object has a given set of
    // `key:value` pairs.
    _.matcher = _.matches = function (attrs) {
        attrs = _.extendOwn({}, attrs);
        return function (obj) {
            return _.isMatch(obj, attrs);
        };
    };

    // Run a function **n** times.
    _.times = function (n, iteratee, context) {
        var accum = Array(Math.max(0, n));
        iteratee = optimizeCb(iteratee, context, 1);
        for (var i = 0; i < n; i++) {
            accum[i] = iteratee(i);
        }return accum;
    };

    // Return a random integer between min and max (inclusive).
    _.random = function (min, max) {
        if (max == null) {
            max = min;
            min = 0;
        }
        return min + Math.floor(Math.random() * (max - min + 1));
    };

    // A (possibly faster) way to get the current timestamp as an integer.
    _.now = Date.now || function () {
        return new Date().getTime();
    };

    // List of HTML entities for escaping.
    var escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;'
    };
    var unescapeMap = _.invert(escapeMap);

    // Functions for escaping and unescaping strings to/from HTML interpolation.
    var createEscaper = function createEscaper(map) {
        var escaper = function escaper(match) {
            return map[match];
        };
        // Regexes for identifying a key that needs to be escaped
        var source = '(?:' + _.keys(map).join('|') + ')';
        var testRegexp = RegExp(source);
        var replaceRegexp = RegExp(source, 'g');
        return function (string) {
            string = string == null ? '' : '' + string;
            return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
        };
    };
    _.escape = createEscaper(escapeMap);
    _.unescape = createEscaper(unescapeMap);

    // If the value of the named `property` is a function then invoke it with the
    // `object` as context; otherwise, return it.
    _.result = function (object, property, fallback) {
        var value = object == null ? void 0 : object[property];
        if (value === void 0) {
            value = fallback;
        }
        return _.isFunction(value) ? value.call(object) : value;
    };

    // Generate a unique integer id (unique within the entire client session).
    // Useful for temporary DOM ids.
    var idCounter = 0;
    _.uniqueId = function (prefix) {
        var id = ++idCounter + '';
        return prefix ? prefix + id : id;
    };

    // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.
    _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
    };

    // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.
    var noMatch = /(.)^/;

    // Certain characters need to be escaped so that they can be put into a
    // string literal.
    var escapes = {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        "\u2028": 'u2028',
        "\u2029": 'u2029'
    };

    var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

    var escapeChar = function escapeChar(match) {
        return '\\' + escapes[match];
    };

    // JavaScript micro-templating, similar to John Resig's implementation.
    // Underscore templating handles arbitrary delimiters, preserves whitespace,
    // and correctly escapes quotes within interpolated code.
    // NB: `oldSettings` only exists for backwards compatibility.
    _.template = function (text, settings, oldSettings) {
        if (!settings && oldSettings) settings = oldSettings;
        settings = _.defaults({}, settings, _.templateSettings);

        // Combine delimiters into one regular expression via alternation.
        var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');

        // Compile the template source, escaping string literals appropriately.
        var index = 0;
        var source = "__p+='";
        text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
            source += text.slice(index, offset).replace(escaper, escapeChar);
            index = offset + match.length;

            if (escape) {
                source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
            } else if (interpolate) {
                source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
            } else if (evaluate) {
                source += "';\n" + evaluate + "\n__p+='";
            }

            // Adobe VMs need the match returned to produce the correct offest.
            return match;
        });
        source += "';\n";

        // If a variable is not specified, place data values in local scope.
        if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

        source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';

        try {
            var render = new Function(settings.variable || 'obj', '_', source);
        } catch (e) {
            e.source = source;
            throw e;
        }

        var template = function template(data) {
            return render.call(this, data, _);
        };

        // Provide the compiled source as a convenience for precompilation.
        var argument = settings.variable || 'obj';
        template.source = 'function(' + argument + '){\n' + source + '}';

        return template;
    };

    // Add a "chain" function. Start chaining a wrapped Underscore object.
    _.chain = function (obj) {
        var instance = _(obj);
        instance._chain = true;
        return instance;
    };

    // OOP
    // ---------------
    // If Underscore is called as a function, it returns a wrapped object that
    // can be used OO-style. This wrapper holds altered versions of all the
    // underscore functions. Wrapped objects may be chained.

    // Helper function to continue chaining intermediate results.
    var result = function result(instance, obj) {
        return instance._chain ? _(obj).chain() : obj;
    };

    // Add your own custom functions to the Underscore object.
    _.mixin = function (obj) {
        _.each(_.functions(obj), function (name) {
            var func = _[name] = obj[name];
            _.prototype[name] = function () {
                var args = [this._wrapped];
                push.apply(args, arguments);
                return result(this, func.apply(_, args));
            };
        });
    };

    // Add all of the Underscore functions to the wrapper object.
    _.mixin(_);

    // Add all mutator Array functions to the wrapper.
    _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
            var obj = this._wrapped;
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
            return result(this, obj);
        };
    });

    // Add all accessor Array functions to the wrapper.
    _.each(['concat', 'join', 'slice'], function (name) {
        var method = ArrayProto[name];
        _.prototype[name] = function () {
            return result(this, method.apply(this._wrapped, arguments));
        };
    });

    // Extracts the result from a wrapped and chained object.
    _.prototype.value = function () {
        return this._wrapped;
    };

    // Provide unwrapping proxy for some methods used in engine operations
    // such as arithmetic and JSON stringification.
    _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

    _.prototype.toString = function () {
        return '' + this._wrapped;
    };

    // AMD registration happens at the end for compatibility with AMD loaders
    // that may not enforce next-turn semantics on modules. Even though general
    // practice for AMD registration is to be anonymous, underscore registers
    // as a named module because, like jQuery, it is a base library that is
    // popular enough to be bundled in a third party lib, but not be part of
    // an AMD load request. Those cases could generate an error when an
    // anonymous define() is called outside of a loader request.
    if (typeof define === 'function' && define.amd) {
        define('underscore', [], function () {
            return _;
        });
    }
}).call(undefined);
;(function (win, ko, $, undefined) {

    if (parseFloat($.fn.jquery) >= 3) {
        $.fn.size = function () {
            return this && this.length || 0;
        };
    }

    if (!win.app) win.app = {};(function () {
        var unified = win.console || {};
        var dummy = {};
        _.each(["assert", "clear", "count", "debug", "dir", "dirxml", "error", "group", "groupCollapsed", "groupEnd", "info", "log", "time", "timeEnd", "trace", "warn", "table"], function (m) {
            if (!unified[m]) unified[m] = _.noop;
            dummy[m] = _.noop;
        });

        win.app.enableConsole = function () {
            win.app.consoleEnabled = true;
            win.app.console = unified;
        };
        win.app.disableConsole = function () {
            win.app.consoleEnabled = false;
            win.app.console = dummy;
        };
        win.app.enableConsole();
    })();

    /**
     * Define win app.utils functions
     */
    win.app.utils = {
        ajaxResult: function ajaxResult() {
            if (!window['OmniFaces'] || !OmniFaces.Ajax) return undefined;
            return OmniFaces.Ajax.data;
        },

        stringEndsWith: function stringEndsWith(s, suffix) {
            s = s + "";
            return s.indexOf(suffix, s.length - suffix.length) !== -1;
        },

        trimString: function trimString(s) {
            s = s.replace(/^\s+/, "");
            for (var i = s.length - 1; i >= 0; i--) {
                if (/\S/.test(s.charAt(i))) {
                    s = s.substring(0, i + 1);
                    break;
                }
            }
            return s;
        },

        isFutureDate: function isFutureDate(day) {
            var date = new Date();
            date.setDate(date.getDate() - 1);
            return day.date.getTime() - date.getTime() >= 0;
        },

        idToSelector: function idToSelector(id) {
            return id.replace(/:/g, "\\:");
        },

        setSelection: function setSelection(field, start, end) {
            var el = $(field).get(0);
            el.focus();
            if (el.setSelectionRange) {
                el.setSelectionRange(start, end);
            } else if (el.createTextRange) {
                var range = el.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', start);
                range.select();
            }
        },

        sequence: function () {
            var _id = 0;
            return {
                next: function next() {
                    _id = _id + 1;
                    return _id;
                },
                peek: function peek() {
                    return _id;
                }
            };
        }(),

        getIfromeWindow: function getIfromeWindow(iframe) {
            var $frame = $(iframe);
            if ($frame.length === 0) return undefined;
            var el = $frame[0];
            return el.contentWindow ? el.contentWindow : el.contentDocument.defaultView;
        },

        pluralize: function () {
            // Rule storage - pluralize and singularize need to be run sequentially,
            // while other rules can be optimized using an object for instant lookups.
            var pluralRules = [];
            var singularRules = [];
            var uncountables = {};
            var irregularPlurals = {};
            var irregularSingles = {};

            /**
             * Title case a string.
             *
             * @param  {string} str
             * @return {string}
             */
            function toTitleCase(str) {
                return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
            }

            /**
             * Sanitize a pluralization rule to a usable regular expression.
             *
             * @param  {(RegExp|string)} rule
             * @return {RegExp}
             */
            function sanitizeRule(rule) {
                if (typeof rule === 'string') {
                    return new RegExp('^' + rule + '$', 'i');
                }

                return rule;
            }

            /**
             * Pass in a word token to produce a function that can replicate the case on
             * another word.
             *
             * @param  {string}   word
             * @param  {string}   token
             * @return {Function}
             */
            function restoreCase(word, token) {
                // Tokens are an exact match.
                if (word === token) {
                    return token;
                }

                // Upper cased words. E.g. "HELLO".
                if (word === word.toUpperCase()) {
                    return token.toUpperCase();
                }

                // Title cased words. E.g. "Title".
                if (word[0] === word[0].toUpperCase()) {
                    return toTitleCase(token);
                }

                // Lower cased words. E.g. "test".
                return token.toLowerCase();
            }

            /**
             * Interpolate a regexp string.
             *
             * @param  {string} str
             * @param  {Array}  args
             * @return {string}
             */
            function interpolate(str, args) {
                return str.replace(/\$(\d{1,2})/g, function (match, index) {
                    return args[index] || '';
                });
            }

            /**
             * Sanitize a word by passing in the word and sanitization rules.
             *
             * @param  {string}   token
             * @param  {string}   word
             * @param  {Array}    collection
             * @return {string}
             */
            function sanitizeWord(token, word, collection) {
                // Empty string or doesn't need fixing.
                if (!token.length || uncountables.hasOwnProperty(token)) {
                    return word;
                }

                var len = collection.length;

                // Iterate over the sanitization rules and use the first one to match.

                var _loop = function _loop() {
                    var rule = collection[len];

                    // If the rule passes, return the replacement.
                    if (rule[0].test(word)) {
                        return {
                            v: word.replace(rule[0], function (match, index, word) {
                                var result = interpolate(rule[1], arguments);

                                if (match === '') {
                                    return restoreCase(word[index - 1], result);
                                }

                                return restoreCase(match, result);
                            })
                        };
                    }
                };

                while (len--) {
                    var _ret = _loop();

                    if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
                }

                return word;
            }

            /**
             * Replace a word with the updated word.
             *
             * @param  {Object}   replaceMap
             * @param  {Object}   keepMap
             * @param  {Array}    rules
             * @return {Function}
             */
            function replaceWord(replaceMap, keepMap, rules) {
                return function (word) {
                    // Get the correct token and case restoration functions.
                    var token = word.toLowerCase();

                    // Check against the keep object map.
                    if (keepMap.hasOwnProperty(token)) {
                        return restoreCase(word, token);
                    }

                    // Check against the replacement map for a direct word replacement.
                    if (replaceMap.hasOwnProperty(token)) {
                        return restoreCase(word, replaceMap[token]);
                    }

                    // Run all the rules against the word.
                    return sanitizeWord(token, word, rules);
                };
            }

            /**
             * Pluralize or singularize a word based on the passed in count.
             *
             * @param  {string}  word
             * @param  {number}  count
             * @param  {boolean} inclusive
             * @return {string}
             */
            function pluralize(word, count, inclusive) {
                var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);

                return (inclusive ? count + ' ' : '') + pluralized;
            }

            /**
             * Pluralize a word.
             *
             * @type {Function}
             */
            pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);

            /**
             * Singularize a word.
             *
             * @type {Function}
             */
            pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);

            /**
             * Add a pluralization rule to the collection.
             *
             * @param {(string|RegExp)} rule
             * @param {string}          replacement
             */
            pluralize.addPluralRule = function (rule, replacement) {
                pluralRules.push([sanitizeRule(rule), replacement]);
            };

            /**
             * Add a singularization rule to the collection.
             *
             * @param {(string|RegExp)} rule
             * @param {string}          replacement
             */
            pluralize.addSingularRule = function (rule, replacement) {
                singularRules.push([sanitizeRule(rule), replacement]);
            };

            /**
             * Add an uncountable word rule.
             *
             * @param {(string|RegExp)} word
             */
            pluralize.addUncountableRule = function (word) {
                if (typeof word === 'string') {
                    uncountables[word.toLowerCase()] = true;
                    return;
                }

                // Set singular and plural references for the word.
                pluralize.addPluralRule(word, '$0');
                pluralize.addSingularRule(word, '$0');
            };

            /**
             * Add an irregular word definition.
             *
             * @param {string} single
             * @param {string} plural
             */
            pluralize.addIrregularRule = function (single, plural) {
                plural = plural.toLowerCase();
                single = single.toLowerCase();

                irregularSingles[single] = plural;
                irregularPlurals[plural] = single;
            };

            /**
             * Irregular rules.
             */
            [
            // Pronouns.
            ['I', 'we'], ['me', 'us'], ['he', 'they'], ['she', 'they'], ['them', 'them'], ['myself', 'ourselves'], ['yourself', 'yourselves'], ['itself', 'themselves'], ['herself', 'themselves'], ['himself', 'themselves'], ['themself', 'themselves'], ['is', 'are'], ['was', 'were'], ['has', 'have'], ['this', 'these'], ['that', 'those'],
            // Words ending in with a consonant and `o`.
            ['echo', 'echoes'], ['dingo', 'dingoes'], ['volcano', 'volcanoes'], ['tornado', 'tornadoes'], ['torpedo', 'torpedoes'],
            // Ends with `us`.
            ['genus', 'genera'], ['viscus', 'viscera'],
            // Ends with `ma`.
            ['stigma', 'stigmata'], ['stoma', 'stomata'], ['dogma', 'dogmata'], ['lemma', 'lemmata'], ['schema', 'schemata'], ['anathema', 'anathemata'],
            // Other irregular rules.
            ['ox', 'oxen'], ['axe', 'axes'], ['die', 'dice'], ['yes', 'yeses'], ['foot', 'feet'], ['eave', 'eaves'], ['goose', 'geese'], ['tooth', 'teeth'], ['quiz', 'quizzes'], ['human', 'humans'], ['proof', 'proofs'], ['carve', 'carves'], ['valve', 'valves'], ['looey', 'looies'], ['thief', 'thieves'], ['groove', 'grooves'], ['pickaxe', 'pickaxes'], ['whiskey', 'whiskies']].forEach(function (rule) {
                return pluralize.addIrregularRule(rule[0], rule[1]);
            });

            /**
             * Pluralization rules.
             */
            [[/s?$/i, 's'], [/[^\u0000-\u007F]$/i, '$0'], [/([^aeiou]ese)$/i, '$1'], [/(ax|test)is$/i, '$1es'], [/(alias|[^aou]us|tlas|gas|ris)$/i, '$1es'], [/(e[mn]u)s?$/i, '$1s'], [/([^l]ias|[aeiou]las|[emjzr]as|[iu]am)$/i, '$1'], [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'], [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'], [/(seraph|cherub)(?:im)?$/i, '$1im'], [/(her|at|gr)o$/i, '$1oes'], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'], [/sis$/i, 'ses'], [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'], [/([^aeiouy]|qu)y$/i, '$1ies'], [/([^ch][ieo][ln])ey$/i, '$1ies'], [/(x|ch|ss|sh|zz)$/i, '$1es'], [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'], [/([ml])(?:ice|ouse)$/i, '$1ice'], [/(pe)(?:rson|ople)$/i, '$1ople'], [/(child)(?:ren)?$/i, '$1ren'], [/eaux$/i, '$0'], [/m[ae]n$/i, 'men'], ['thou', 'you']].forEach(function (rule) {
                return pluralize.addPluralRule(rule[0], rule[1]);
            });

            /**
             * Singularization rules.
             */
            [[/s$/i, ''], [/(ss)$/i, '$1'], [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(?:sis|ses)$/i, '$1sis'], [/(^analy)(?:sis|ses)$/i, '$1sis'], [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'], [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'], [/ies$/i, 'y'], [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'], [/\b(mon|smil)ies$/i, '$1ey'], [/([ml])ice$/i, '$1ouse'], [/(seraph|cherub)im$/i, '$1'], [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|tlas|gas|(?:her|at|gr)o|ris)(?:es)?$/i, '$1'], [/(e[mn]u)s?$/i, '$1'], [/(movie|twelve)s$/i, '$1'], [/(cris|test|diagnos)(?:is|es)$/i, '$1is'], [/(alumn|syllab|octop|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'], [/(alumn|alg|vertebr)ae$/i, '$1a'], [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'], [/(matr|append)ices$/i, '$1ix'], [/(pe)(rson|ople)$/i, '$1rson'], [/(child)ren$/i, '$1'], [/(eau)x?$/i, '$1'], [/men$/i, 'man']].forEach(function (rule) {
                return pluralize.addSingularRule(rule[0], rule[1]);
            });

            /**
             * Uncountable rules.
             */
            [
            // Singular words with no plurals.
            'advice', 'adulthood', 'agenda', 'aid', 'alcohol', 'ammo', 'athletics', 'bison', 'blood', 'bream', 'buffalo', 'butter', 'carp', 'cash', 'chassis', 'chess', 'clothing', 'commerce', 'cod', 'cooperation', 'corps', 'digestion', 'debris', 'diabetes', 'energy', 'equipment', 'elk', 'excretion', 'expertise', 'flounder', 'fun', 'gallows', 'garbage', 'graffiti', 'headquarters', 'health', 'herpes', 'highjinks', 'homework', 'housework', 'information', 'jeans', 'justice', 'kudos', 'labour', 'literature', 'machinery', 'mackerel', 'mail', 'media', 'mews', 'moose', 'music', 'news', 'pike', 'plankton', 'pliers', 'pollution', 'premises', 'rain', 'research', 'rice', 'salmon', 'scissors', 'series', 'sewage', 'shambles', 'shrimp', 'species', 'staff', 'swine', 'trout', 'traffic', 'transporation', 'tuna', 'wealth', 'welfare', 'whiting', 'wildebeest', 'wildlife', 'you',
            // Regexes.
            /pox$/i, // "chickpox", "smallpox"
            /ois$/i, /deer$/i, // "deer", "reindeer"
            /fish$/i, // "fish", "blowfish", "angelfish"
            /sheep$/i, /measles$/i, /[^aeiou]ese$/i // "chinese", "japanese"
            ].forEach(pluralize.addUncountableRule);

            return pluralize;
        }(),

        preprocessVue: function preprocessVue(rootElement) {
            function bindExpression(el, expression) {
                var firstEqualPos = expression.indexOf("=");
                if (firstEqualPos === -1) {
                    $(el).attr(expression, '');
                } else {
                    $(el).attr(expression.substring(0, firstEqualPos), expression.substring(firstEqualPos + 1));
                }
            }
            function attachBulkBinding(el, expression) {
                var regex = new RegExp(/\(\((.*?)\)\)/g);
                var match = void 0;
                while ((match = regex.exec(expression)) !== null) {
                    bindExpression(this, match[1]);
                }
            }
            $.each($(rootElement).find("[vue-bulkbind]"), function () {
                attachBulkBinding(this, $(this).attr('vue-bulkbind'));
            });
            $.each($(rootElement).find("[vue-bind-children]"), function () {
                var element = this;
                $.each(element.attributes, function () {
                    try {
                        var attr = this,
                            _name = void 0,
                            value = void 0,
                            parts = void 0;
                        if (attr.specified) {
                            _name = attr.name;
                            if (_name.match(/^data-bind-child(?:-\d+)?$/i)) {
                                value = attr.value;
                                parts = value.split(/\s*@\s*/);
                                if (parts.length === 2) {
                                    $(element).find(parts[1]).each(function () {
                                        var expression = parts[0];
                                        if (expression[0] === '(' && expression[1] === '(') {
                                            attachBulkBinding(this, expression);
                                        } else {
                                            bindExpression(this, expression);
                                        }
                                    });
                                } else {
                                    app.console.error("Invalid v-bind-child content: " + value);
                                }
                            }
                        }
                    } catch (err) {
                        app.console.error(err);
                    }
                });
            });
        }
    };(function () {
        function intervalBind(vm, elem) {
            if (vm.__type__ === 'vue') {
                app.utils.preprocessVue(elem);
                if (!vm.__vue__) vm.__vue__ = [];
                var opts = $.extend({}, vm.vueOptions || {}, {
                    el: elem,
                    data: vm.data,
                    computed: vm.computed,
                    watch: vm.watch,
                    methods: vm.methods
                });
                vm.__vue__.push(new Vue(opts));
            } else {
                ko.applyBindings(vm, elem);
            }

            function isElementInDom(e) {
                if (document.contains) return document.contains(e);
                if (document.body.contains) return document.body.contains(e);
                while (elem && ko.utils.tagNameLower(elem) !== "html") {
                    elem = elem.parent;
                }return !!elem;
            }

            //clean up bound element list
            var parts = _.partition(vm.__elements__, isElementInDom);
            vm.__elements__ = parts[0];
            //clean up orphan elements
            if (vm.__type__ !== 'vue') {
                _.each(parts[1], function (e) {
                    ko.cleanNode(e);
                });
            }

            //clean up vue model
            if (vm.__type__ === 'vue') {
                var vueArrayParts = _.partition(vm.__vue__, function (vm) {
                    return isElementInDom(vm.$el);
                });
                vm.__vue__ = vueArrayParts[0];
                vm.m = vm.__vue__[0];
                _.each(vueArrayParts[1], function (e) {
                    return e.$destroy();
                });
            }

            //record bound element
            vm.__elements__.push(elem);

            //invoke __init__ callback
            try {
                if (vm.__init__) vm.__init__(elem);
            } catch (e) {
                win.app.console.error(e);
            }
        }

        function bind(elem) {
            var selector = elem;
            elem = $(elem);
            var vm = this;
            if (elem.size() > 0) {
                elem.each(function (idx, el) {
                    var vmName = $(this).attr("data-vm");
                    if (vmName === vm.__vmName__) {
                        if (_.indexOf(vm.__elements__, el) < 0) {
                            intervalBind(vm, el);
                        } else {
                            win.app.console.error("Element has already been bound to the same VM.");
                            win.app.console.error(element);
                        }
                    } else {
                        win.app.console.error("Element must have data-vm attribute refer to " + vm.__vmName__);
                        win.app.console.error(this);
                    }
                });
            } else {
                win.app.console.error("Element " + selector + " not found");
            }
        }

        function addVM(vmName, vm) {
            /* Clean up exiting vm */
            if (win.app.vm[vmName]) {
                var oldVM = win.app.vm[vmName];
                if (oldVM.__type__ === 'vue') {
                    if (oldVM.__vue__) {
                        _.each(oldVM.__vue__, function (v) {
                            try {
                                if (v.__destroy__) v.__destroy__();
                            } catch (e) {
                                app.console.error("Failed calling __destroy__ in " + oldVM.__vmName__);
                                app.console.error(e);
                            }
                            v.$destroy();
                        });
                    }
                } else {
                    try {
                        if (oldVM.__destroy__) oldVM.__destroy__();
                    } catch (e) {
                        app.console.error("Failed calling __destroy__ in " + oldVM.__vmName__);
                        app.console.error(e);
                    }
                    _.each(oldVM.__elements__, function (el) {
                        ko.cleanNode(el);
                    });
                }
                for (var p in oldVM) {
                    try {
                        if (oldVM.hasOwnProperty(p) && _.isFunction(oldVM[p]['dispose'])) {
                            oldVM[p].dispose.call(oldVM);
                        }
                    } catch (e) {}
                }
                oldVM.__elements__ = null;
                oldVM.__vue__ = null;
            }

            vm.__vmName__ = vmName;
            vm.__elements__ = [];
            win.app.vm[vmName] = vm;
        }

        function createVmOnConstructor(constructorName, vmNames) {
            if (!vmNames) vmNames = constructorName;
            if (!_.isArray(vmNames)) vmNames = [vmNames];
            _.each(vmNames, function (vmName) {
                win.app.createVM(constructorName, vmName);
            });
            return app.vm.constructor[constructorName];
        }

        _.extend(win.app, {
            constructors: {},
            vm: {},

            registerConstructor: function registerConstructor(name, type, func, isStatic) {
                if (_.isFunction(type)) {
                    isStatic = func;
                    func = type;
                    type = "ko";
                }
                if (isStatic && this.constructors[name]) return;

                func.prototype.bind = bind;
                func.prototype.__from__ = "Ctor-" + name;
                func.prototype.__type__ = type;

                var self = this;
                self.constructors[name] = function (vmName, options) {
                    if (_.isObject(vmName)) {
                        options = vmName;
                        vmName = undefined;
                    }
                    if (!vmName) vmName = name;
                    var vm = new func(options);
                    addVM(vmName, vm);
                    return vm;
                };

                self.constructors[name].name = name;
                self.constructors[name].createVM = function (vmNames) {
                    return createVmOnConstructor(name, vmNames);
                };

                return self.constructors[name];
            },

            createVM: function createVM() {
                var constructor = void 0,
                    vmName = void 0,
                    options = void 0,
                    vm = void 0,
                    self = this;
                /* Adjust arguments */
                if (_.isObject(arguments[0])) {
                    vm = arguments[0];
                    vmName = arguments[1];
                } else if (_.isString(arguments[1])) {
                    constructor = arguments[0];
                    vmName = arguments[1];
                    options = arguments[2];
                } else if (_.isObject(arguments[1])) {
                    vmName = constructor = arguments[0];
                    options = arguments[1];
                } else if (_.isUndefined(arguments[1])) {
                    if (_.isString(arguments[0])) {
                        vmName = constructor = arguments[0];
                    }
                }

                if (constructor) {
                    //Build from constructor
                    if (self.constructors[constructor]) {
                        vm = self.constructors[constructor](vmName, options);
                    } else {
                        self.console.error("Constructor " + constructor + " not defined.");
                    }
                } else if (vm) {
                    //Build from JS model
                    //TODO VUE: adapt vue
                    if (_.isUndefined(vmName)) {
                        vmName = "vm_" + win.app.utils.id.next();
                    }
                    vm = ko.viewmodel.fromModel(vm);
                    vm.bind = bind;
                    vm.__from__ = "ko.viewmodel";
                    addVM(vmName, vm);
                } else {
                    self.console.error("Illegal arguments.");
                    return;
                }
                return vm;
            },

            updateVM: function updateVM(vmName, viewModel, addNewProperty) {
                var vm = _.isString(vmName) ? app.vm[vmName] : vmName;
                if (!vm) {
                    app.console.error("VM " + vmName + " not found!");
                    return;
                }
                //TODO VUE: adapt vue
                if (vm.__type__ === 'vue') return;

                function updatePropertyIfComplex(prop, value) {
                    if (ko.isWriteableObservable(prop)) {
                        prop(value);
                    } else if (_.isArray(prop)) {
                        if (_.isArray(value)) updateArray(prop, value);
                    } else if (_.isObject(prop)) {
                        if (_.isObject(value)) updateObject(prop, value);
                    } else {
                        return false;
                    }
                    return true;
                }

                function updateObject(target, source) {
                    var pairs = _.pairs(source);
                    _.each(pairs, function (p) {
                        if (target.hasOwnProperty(p[0])) {
                            if (!updatePropertyIfComplex(target[p[0]], p[1])) {
                                target[p[0]] = p[1];
                            }
                        } else if (addNewProperty) {
                            target[p[0]] = p[1];
                        }
                    });
                }

                function getId(obj) {
                    if (_.isFunction(obj.getId)) return obj.getId();
                    if (!_.isUndefined(obj._$id$)) return ko.unwrap(obj._$id$);
                    if (!_.isUndefined(obj.id)) return ko.unwrap(obj.id);
                }

                function removeById(arr, id) {
                    for (var i = arr.length - 1; i >= 0; i--) {
                        if (getId(arr[i]) === id) arr.splice(i, 1);
                    }
                }

                function findById(arr, id) {
                    return _.find(arr, function (el) {
                        return getId(el) === id;
                    });
                }

                function updateArray(target, source) {
                    if (source.length === 0) return;
                    target = ko.unwrap(target);
                    if (!_.isArray(target)) return;
                    var id = void 0,
                        targetEl = void 0;
                    if (_.isObject(source[0])) {
                        if (source[0]._$clear$) {
                            if (target.removeAll) target.removeAll();else target = [];
                        } else {
                            _.each(source, function (sourceEl) {
                                if (_.isObject(sourceEl)) {
                                    if (sourceEl._$add$) {
                                        delete sourceEl["_$add$"];
                                        target.push(ko.viewmodel.fromModel(sourceEl));
                                    } else if (sourceEl._$remove$) {
                                        id = getId(sourceEl);
                                        targetEl = removeById(target, id);
                                    } else {
                                        id = getId(sourceEl);
                                        targetEl = findById(target, id);
                                        if (!_.isUndefined(targetEl)) {
                                            updateObject(targetEl, sourceEl);
                                        }
                                    }
                                }
                            });
                        }
                    } else {
                        var len = Math.min(target.length, source.length);
                        for (var i = 0; i < len; i++) {
                            if (ko.isObservable(target[i])) {
                                target[i](source[i]);
                            } else {
                                target[i] = source[i];
                            }
                        }
                        if (source.length < target.length) {
                            target = target.splice(0, source.length);
                        }
                    }
                }

                if (_.isObject(viewModel)) {
                    if (vm.__form__ === "ko.viewmodel" && viewModel.__form__ === "ko.viewmodel") {
                        delete viewModel.__form__;
                        ko.viewModel.updateFromModel(vm, viewModel);
                    } else {
                        updateObject(vm, viewModel);
                    }
                } else if (_.isArray(viewModel)) {
                    updateArray(vm, viewModel);
                }
            }
        });
    })();

    win.vue = app.vm;
})(window, ko, jQuery);

/***** The Global vm *****/
(function ($) {
    app.registerConstructor("Global", function () {
        this.isSpringboard = false;
        this.viewPort = {
            height: ko.observable(0),
            width: ko.observable(0),
            docWidth: ko.observable(0),
            docHeight: ko.observable(0)
        };
        this.parentScrollTop = function () {
            if (window !== window.parent) {
                $(window.parent.document).find('html, body').animate({ scrollTop: 0 });
            }
        };
        this.getScrollViewportPosition = function () {
            var $win = $(window);
            var viewport = {
                top: $win.scrollTop(),
                left: $win.scrollLeft()
            };
            viewport.bottom = viewport.top + $win.height();
            viewport.right = viewport.left + $win.width();
            return viewport;
        };
        this.showClientMessage = function () {
            app.console.error("showClientMessage is not implemented.");
        };
        this.showLoadingBox = _.noop; //to be implemented by sub systems
        this.hideLoadingBox = _.noop; //to be implemented by sub systems
        this.__resize__ = function () {
            var self = this;
            self.viewPort.width($(window).width());
            self.viewPort.height($(window).height());
            self.viewPort.docWidth($(document).width());
            self.viewPort.docHeight($(document).height());
            var viewPort = {
                height: self.viewPort.height(),
                width: self.viewPort.width(),
                docWidth: self.viewPort.docWidth(),
                docHeight: self.viewPort.docHeight()
            };
            for (var vmName in app.vm) {
                if (app.vm.hasOwnProperty(vmName)) {
                    if (vmName !== 'Global' && app.vm[vmName].__resize__) {
                        app.vm[vmName].__resize__(viewPort);
                    }
                }
            }
        };
        this.$$resizeTimeout = 0;

        this.runWhen = function (action, checker, retry, delay, interval) {
            var t = null;
            if (typeof interval === "undefined") interval = 250;
            function run() {
                if (checker()) {
                    action();
                } else {
                    if (retry-- > 0) {
                        t = setTimeout(run, interval);
                    } else {
                        if (t) clearTimeout(t);
                    }
                }
            }
            if (delay === 0) delay = undefined;
            if (delay) {
                setTimeout(run, delay);
            } else {
                run();
            }
        };

        this.runUntil = function (action, checker, retry, delay, interval) {
            var t = null;
            if (typeof interval === "undefined") interval = 250;
            function run() {
                action();
                if (!checker()) {
                    if (retry-- > 0) {
                        t = setTimeout(run, interval);
                    } else {
                        if (t) clearTimeout(t);
                    }
                }
            }
            if (delay === 0) delay = undefined;
            if (delay) {
                setTimeout(run, delay);
            } else {
                run();
            }
        };

        this.runTick = function (action, interval, immediate) {
            var t = null;
            if (typeof interval === "undefined") interval = 5000;
            if (typeof immediate === "undefined") immediate = true;
            var stopTick = function stopTick() {
                if (t != null) {
                    clearTimeout(t);
                }
            };
            var nextTick = function nextTick() {
                stopTick();
                t = setTimeout(function () {
                    action(nextTick);
                }, interval);
            };
            if (immediate) {
                action(nextTick);
            } else {
                nextTick();
            }
            return stopTick;
        };

        /*--- Fix View State --- */
        /* Copied from OmniFaces.FixViewState but also handles encodeURL for portlet environment */
        this.FixViewState = function (window, document) {

            // "Constant" fields ----------------------------------------------------------------------------------------------

            var VIEW_STATE_PARAM = "javax.faces.ViewState";
            var ENCODED_URL_PARAM = "javax.faces.encodedURL";
            var VIEW_STATE_REGEX = new RegExp("^([\\w]+:)?" + VIEW_STATE_PARAM.replace(/\./g, "\\.") + "(:[0-9]+)?$");
            var RASP_CID_PARAM = new RegExp("(c_id|c_new)=[^&]*&?", "g");

            // Private static fields ------------------------------------------------------------------------------------------

            var self = {};

            // Public static functions ----------------------------------------------------------------------------------------

            function removeRaspConversationParameter(encodedURL) {
                var questionMarkPos = encodedURL.indexOf("?");
                if (questionMarkPos < 0) return encodedURL;
                var base = encodedURL.substring(0, questionMarkPos);
                var queryString = encodedURL.substring(questionMarkPos + 1).replace(RASP_CID_PARAM, "").replace(/&+$/, "");
                if (queryString.length > 0) {
                    return base + "?" + queryString;
                } else {
                    return base;
                }
            }

            /**
             * Apply the "fix view state" on the current document based on the given XML response.
             * @param {XMLHttpRequest} xhr The XMLHttpRequest in the ajax callback
             */
            self.apply = function (xhr) {
                if (typeof xhr === "undefined") return;
                var responseXML = xhr.responseXML;
                var encodedURL = xhr.pfSettings && xhr.pfSettings.url;
                if (typeof responseXML === "undefined" || typeof encodedURL === "undefined") {
                    return;
                }

                var viewStateValue = getViewStateValue(responseXML);

                if (!viewStateValue) {
                    return;
                }

                var encodedURLWithoutRaspCid = removeRaspConversationParameter(encodedURL);

                for (var i = 0; i < document.forms.length; i++) {
                    var form = document.forms[i];
                    var viewStateElement = form[VIEW_STATE_PARAM];
                    var encodedURLElement = form[ENCODED_URL_PARAM];

                    if (form.method === "post" && encodedURLElement && encodedURLElement.value === encodedURL && !viewStateElement) {
                        // This POST form doesn't have a view state. This isn't right. Create it.
                        createViewStateElement(form, viewStateValue);
                    }

                    if (form.method === "post" && encodedURLElement && !viewStateElement) {
                        if (removeRaspConversationParameter(encodedURLElement.value) === encodedURLWithoutRaspCid) {
                            // This POST form doesn't have a view state. This isn't right. Create it.
                            createViewStateElement(form, viewStateValue);
                        }
                    }
                }
            };

            // Private static functions ---------------------------------------------------------------------------------------

            /**
             * Returns the view state value from the given XML response.
             * @param {Document} responseXML The XML response of the XMLHttpRequest.
             * @return {string} The view state value from the given XML response.
             */
            function getViewStateValue(responseXML) {
                var updates = responseXML.getElementsByTagName("update");

                for (var i = 0; i < updates.length; i++) {
                    var update = updates[i];

                    if (VIEW_STATE_REGEX.exec(update.getAttribute("id"))) {
                        return update.textContent || update.innerText;
                    }
                }

                return null;
            }

            /**
             * Create view state hidden input element with given view state value and add it to given form.
             * @param {HTMLFormElement} form The form to add the view state hidden input element to.
             * @param {string} viewStateValue The view state value to be added to the newly created view state hidden input element.
             */
            function createViewStateElement(form, viewStateValue) {
                var hidden = void 0;

                try {
                    hidden = document.createElement("<input name='" + VIEW_STATE_PARAM + "'>"); // IE6-8.
                } catch (e) {
                    hidden = document.createElement("input");
                    hidden.setAttribute("name", VIEW_STATE_PARAM);
                }

                hidden.setAttribute("type", "hidden");
                hidden.setAttribute("value", viewStateValue);
                hidden.setAttribute("autocomplete", "off");
                form.appendChild(hidden);
            }
            return self;
        }(window, document);

        /**
         * Check whether the current browser supports a given css property.
         *
         * Example:
         * app.vm.Global.browserSupportsCSSProperty('animation')
         *
         * returns true in modern browsers and false in IE9 or below.
         * @param propertyName
         * @returns {boolean}
         */
        this.browserSupportsCSSProperty = function (propertyName) {
            var elm = document.createElement('div');
            propertyName = propertyName.toLowerCase();

            if (elm.style[propertyName] !== undefined) return true;

            var propertyNameCapital = propertyName.charAt(0).toUpperCase() + propertyName.substr(1),
                domPrefixes = 'Webkit Moz ms O'.split(' ');

            for (var i = 0; i < domPrefixes.length; i++) {
                if (elm.style[domPrefixes[i] + propertyNameCapital] !== undefined) return true;
            }
            return false;
        };
    }, true);
})(jQuery);

app.createVM("Global");

(function ($) {
    $(document).ready(function () {
        $(window).on('resize', function () {
            if (app.vm.Global.$$resizeTimeout) {
                clearTimeout(app.vm.Global.$$resizeTimeout);
            }
            app.vm.Global.$$resizeTimeout = setTimeout(function () {
                app.vm.Global.__resize__();
            }, 200);
        });

        app.vm.Global.__resize__();
    });
})(jQuery);

/***** Custom bindings *****/

(function ($) {
    ko.bindingHandlers.slideVisible = {
        init: function init(element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            if (!value) $(element).hide();
        },
        update: function update(element, valueAccessor, allBindings) {
            var value = ko.unwrap(valueAccessor());
            var duration = allBindings.get('duration') || 400;
            if (value) $(element).slideDown(duration);else $(element).slideUp(duration);
        }
    };
})(jQuery);(function ($) {
    ko.bindingHandlers.fadeVisible = {
        init: function init(element, valueAccessor) {
            var value = ko.unwrap(valueAccessor());
            if (!value) $(element).hide();
        },
        update: function update(element, valueAccessor, allBindings) {
            var value = ko.unwrap(valueAccessor());
            var duration = allBindings.get('duration') || 400;
            if (value) $(element).fadeIn(duration);else $(element).fadeOut(duration);
        }
    };
})(jQuery);(function ($) {
    ko.bindingHandlers.hover = {
        init: function init(element, valueAccessor) {
            var className = ko.unwrap(valueAccessor());
            $(element).hover(function () {
                $(this).addClass(className);
            }, function () {
                $(this).removeClass(className);
            });
        }
    };
})(jQuery);

ko.bindingHandlers.href = {
    update: function update(element, valueAccessor) {
        ko.bindingHandlers.attr.update(element, function () {
            return { href: valueAccessor() };
        });
    }
};

ko.bindingHandlers.src = {
    update: function update(element, valueAccessor) {
        ko.bindingHandlers.attr.update(element, function () {
            return { src: valueAccessor() };
        });
    }
};

ko.bindingHandlers.disabled = {
    update: function update(element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        if (value) {
            $(element).addClass('disabled');
        } else {
            $(element).removeClass('disabled');
        }
        ko.bindingHandlers.attr.update(element, function () {
            return { disabled: value };
        });
    }
};
ko.bindingHandlers.enabled = {
    update: function update(element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        if (value) {
            $(element).removeClass('disabled');
        } else {
            $(element).addClass('disabled');
        }
        ko.bindingHandlers.attr.update(element, function () {
            return { disabled: !value };
        });
    }
};

ko.bindingHandlers.hidden = {
    update: function update(element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        ko.bindingHandlers.visible.update(element, function () {
            return !value;
        });
    }
};

ko.bindingHandlers.toggle = {
    init: function init(element, valueAccessor) {
        var value = valueAccessor();
        ko.applyBindingsToNode(element, {
            click: function click() {
                value(!value());
            }
        });
    }
};

(function () {
    var factory = function factory(n) {
        return {
            init: function init(element, valueAccessor) {
                var classNames = ko.unwrap(valueAccessor());
                var el = $(element);
                el.addClass(classNames).data("prev-class-" + n, classNames);
            },
            update: function update(element, valueAccessor) {
                var el = $(element);
                var prev = el.data("prev-class-" + n);
                var current = " " + ko.unwrap(valueAccessor()) + " ";
                var toRemove = ko.utils.arrayFilter((prev || "").split(/\s+/), function (item) {
                    return app.utils.trimString(item).length > 0 && current.indexOf(" " + item + " ") < 0;
                }).join(" ");
                if (toRemove.length > 0) el.removeClass(toRemove);
                el.addClass(current);
            }
        };
    };

    ko.bindingHandlers.styleClass = factory(0);
    for (var i = 1; i < 10; i++) {
        ko.bindingHandlers['styleClass' + i] = factory(i);
    }
})(jQuery);

ko.bindingHandlers.stop = {
    init: function init() {
        return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.stop = true;

ko.bindingHandlers.noKnockout = {
    init: function init() {
        return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.noKnockout = true;(function ($) {
    ko.bindingHandlers.bindChildren = {
        init: function init(element) {
            $.each(element.attributes, function () {
                try {
                    var attr = this,
                        _name2 = void 0,
                        value = void 0,
                        parts = void 0;
                    if (attr.specified) {
                        _name2 = attr.name;
                        if (_name2.match(/^data-bind-child(?:-\d+)?$/i)) {
                            value = attr.value;
                            parts = value.split(/\s*@\s*/);
                            if (parts.length === 2) {
                                $(element).find(parts[1]).each(function () {
                                    $(this).attr("data-bind", parts[0]);
                                });
                            } else {
                                app.console.error("Invalid data-bind-child content: " + value);
                            }
                        }
                    }
                } catch (err) {
                    app.console.error(err);
                }
            });
        }
    };
})(jQuery);

ko.virtualElements.allowedBindings.bindChildren = true;(function ($) {
    ko.bindingHandlers.select2 = {
        init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (element.tagName.toLowerCase() !== "select") {
                app.console.error("select2 binging must apply on a <select> element.");
                app.console.log(element);
                return;
            }
            if (!$ || !$.fn || !$.fn.select2) {
                app.console.error("jQuery with select2 plugin is required.");
                app.console.log(element);
                return;
            }

            // bind descendant elements
            ko.applyBindingsToDescendants(bindingContext, element);
            // apply select2 plugin
            var opts = ko.unwrap(valueAccessor());
            if ((typeof opts === "undefined" ? "undefined" : _typeof(opts)) !== "object") {
                $(element).select2();
            } else {
                $(element).select2(opts);
            }
            // Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
            return { controlsDescendantBindings: true };
        },

        update: function update(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var selected = ko.unwrap(allBindings.get("selectedOptions"));
            $(element).select2("val", selected);
        }
    };
})(jQuery);

(function ($) {
    ko.bindingHandlers.expandableTextField = {
        init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (ko.utils.tagNameLower(element) !== "input") {
                app.console.error("expandableTextfield binging must apply on a <input> element.");
                app.console.log(element);
                return;
            }
            if (!$ || !$.fn || !$.fn.expandableTextfield) {
                app.console.error("jQuery with expandableTextfield plugin is required.");
                app.console.log(element);
                return;
            }

            var opts = ko.unwrap(valueAccessor());
            if (_.isObject(opts)) {
                $(element).expandableTextfield();
            } else {
                $(element).expandableTextfield(opts);
            }
        }
    };
})(jQuery);

//Shortcut for common events

_.each(["dblclick", "onBlur", "onFocus", "onChange"], function (eventName) {
    ko.bindingHandlers[eventName] = {
        'init': function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var newValueAccessor = function newValueAccessor() {
                var result = {};
                result[eventName] = valueAccessor();
                return result;
            };
            return ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindings, viewModel, bindingContext);
        }
    };
})

//Wrap the textInput and value handler to handle keepInitialValue binding 
;(function ($) {
    var textInputHandler = ko.bindingHandlers.textInput;
    var valueHandler = ko.bindingHandlers.value;
    var initViewModel = function initViewModel(element, valueAccessor, allBindings) {
        if (allBindings.has("keepInitialValue")) {
            if (ko.isWritableObservable(valueAccessor())) {
                valueAccessor()($(element).val());
            }
        }
    };

    ko.bindingHandlers.textInput = {
        'init': function init(element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            textInputHandler.init(element, valueAccessor, allBindings);
        }
    };
    ko.bindingHandlers.textInput.__proto__ = textInputHandler;

    ko.bindingHandlers.value = {
        'init': function init(element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            valueHandler.init(element, valueAccessor, allBindings);
        }
    };
    ko.bindingHandlers.value.__proto__ = valueHandler;
})(jQuery);

//Wrap the checked handler to handle keepInitialValue binding 
(function () {
    var checkedHandler = ko.bindingHandlers.checked;
    var initViewModel = function initViewModel(element, valueAccessor, allBindings) {
        function updateModel() {
            /* A simplified version of internal helper function in ko.bindingHandlers.checked */

            var isCheckbox = element.type === "checkbox",
                isRadio = element.type === "radio",
                isChecked = element.checked;
            var useCheckedValue = isRadio || isValueArray;
            var elemValue = useCheckedValue ? checkedValue() : isChecked;

            // We can ignore unchecked radio buttons, because some other radio
            // button will be getting checked, and that one can take care of updating state.
            if (isRadio && !isChecked) {
                return;
            }
            var isValueArray = isCheckbox && ko.utils.unwrapObservable(valueAccessor()) instanceof Array;
            if (isValueArray) {
                app.console.error('"keepInitialValue" does not support array value on the "checked" binding.');
            } else {
                valueAccessor()(elemValue);
            }
        }

        if (allBindings.has("keepInitialValue")) {
            if (ko.isWritableObservable(valueAccessor())) {
                updateModel();
            }
        }
    };

    ko.bindingHandlers.checked = {
        'init': function init(element, valueAccessor, allBindings) {
            initViewModel(element, valueAccessor, allBindings);
            checkedHandler.init(element, valueAccessor, allBindings);
        }
    };
    ko.bindingHandlers.checked.__proto__ = checkedHandler;
})();

(function ($) {
    var selectedOptionsHandler = ko.bindingHandlers.selectedOptions;
    ko.bindingHandlers.selectedOptions = {
        'init': function init(element, valueAccessor, allBindings) {
            if (allBindings.has("keepInitialValue")) {
                (function () {
                    var value = valueAccessor(),
                        valueToWrite = [];
                    ko.utils.arrayForEach(element.getElementsByTagName("option"), function (node) {
                        if (node.selected) valueToWrite.push(ko.selectExtensions.readValue(node));
                    });
                    value(valueToWrite);
                })();
            }
            selectedOptionsHandler.init(element, valueAccessor, allBindings);
        },
        'update': function update(element, valueAccessor, allBindings, viewModel, bindingContext) {
            if (allBindings.has("select2")) {
                if (element.tagName.toLowerCase() !== "select") {
                    app.console.error("select2 binging must apply on a <select> element.");
                    app.console.log(element);
                    return;
                }
                if (!$ || !$.fn || !$.fn.select2) {
                    app.console.error("jQuery with select2 plugin is required.");
                    app.console.log(element);
                    return;
                }
                var selected = ko.unwrap(valueAccessor());
                $(element).select2("val", selected);
            }
            selectedOptionsHandler.update(element, valueAccessor, allBindings, viewModel, bindingContext);
        }

    };
    ko.bindingHandlers.selectedOptions.__proto__ = selectedOptionsHandler;
})(jQuery);

ko.bindingHandlers.currency = {
    symbol: "$",
    decimal: 2,
    update: function update(element, valueAccessor, allBindingsAccessor) {
        return ko.bindingHandlers.text.update(element, function () {
            var value = +(ko.utils.unwrapObservable(valueAccessor()) || 0),
                symbol = ko.utils.unwrapObservable(allBindingsAccessor().symbol !== undefined ? allBindingsAccessor().symbol : ko.bindingHandlers.currency.symbol);
            decimal = ko.utils.unwrapObservable(allBindingsAccessor().decimal !== undefined ? allBindingsAccessor().decimal : ko.bindingHandlers.currency.decimal);
            return symbol + value.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?:\.|$))/g, "$1,");
        });
    }
};

(function () {
    ko.bindingHandlers.inputmask = {
        init: function init(element, valueAccessor, allBindingsAccessor) {

            var mask = valueAccessor();

            var observable = mask.value;

            if (ko.isObservable(observable)) {

                $(element).on('focusout change', function () {

                    if ($(element).inputmask('isComplete')) {
                        observable($(element).val());
                    } else {
                        observable(null);
                    }
                });
            }

            $(element).inputmask(mask);
        },
        update: function update(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var mask = valueAccessor();

            var observable = mask.value;

            if (ko.isObservable(observable)) {

                var valuetoWrite = observable();

                $(element).val(valuetoWrite);
            }
        }

    };
})();

/** Knockout Extensions **/

ko.extenders.url = function (target, protocal) {
    if (!protocal) protocal = "http";
    var newComputedObservable = ko.pureComputed({
        read: target,
        write: function write(newValue) {
            var current = target();
            var valueToWrite = newValue || "";
            if (app.utils.trimString(valueToWrite).length > 0 && current.indexOf("://") >= 0 && valueToWrite.indexOf("://") < 0) {
                valueToWrite = current.substring(current.indexOf("://") + 3);
            }
            if (valueToWrite.length > 10 && valueToWrite.indexOf("://") < 0 && valueToWrite[0] !== "/") {
                valueToWrite = protocal + "://" + valueToWrite;
            }
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always' });

    //initialize with current value to make sure it is rounded appropriately
    newComputedObservable(target());

    //return the new computed observable
    return newComputedObservable;
};

/** Vue filters **/
if (window['Vue']) {
    Vue.filter('removeUnderScore', function (value, replacement) {
        return value.replace(/_/g, replacement || ' ');
    });

    Vue.filter('gt0', function (value) {
        return value > 0;
    });

    Vue.filter('gt1', function (value) {
        return value > 1;
    });

    Vue.filter('pluralizedLabel', function (value, label) {
        return app.utils.pluralize(label, value);
    });

    Vue.filter('attachPluralizedLabel', function (value, label) {
        return app.utils.pluralize(label, value, true);
    });
}
/** Vue filters ends **/

/* Patch PF to output better error message */
(function () {
    if (!window['PF']) return;
    if (window['originalPF']) return;
    window.originalPF = window.PF;
    window.PF = function () {
        var result = window.originalPF.apply(this, arguments);
        if (typeof result === 'undefined') {
            app.console.info('PF(%o) is undefined', arguments);
        }
        return result;
    };
})();

if (!window['HRX']) HRX = {};

if (!HRX['PAGESCOPE']) HRX.PAGESCOPE = {};

if (!HRX['calendar']) HRX.calendar = {};

if (!HRX['components']) HRX.components = {};

if (!HRX['RF_Patch']) HRX.RF_Patch = {};

if (!HRX['NAV']) HRX.NAV = {};

HRX.calendar.isFutureDate = function (day) {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    return day.date.getTime() - date.getTime() >= 0;
};

HRX.calendar.disabledPassedDayClass = function (day) {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    return day.date.getTime() - date.getTime() < 0 ? "rich-calendar-boundary-dates" : "";
};

HRX.getValueFromArrayOrLast = function (arr, index) {
    return arr instanceof Array ? arr.length > 0 ? arr.length > index ? arr[index] : arr[arr.length - 1] : null : arr;
};

HRX.getValueFromArrayOrNull = function (arr, index) {
    return arr instanceof Array ? arr.length > index ? arr[index] : null : arr;
};

HRX.getViewport = function () {
    var win = jQuery(window);
    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.bottom = viewport.top + win.height();
    viewport.right = viewport.left + win.width();
    return viewport;
};
HRX.RF_Patch._suggestDropdownCheckCounter = 0;
HRX.RF_Patch.startSuggestReposition = function () {
    var $ = jQuery,
        patch = HRX.RF_Patch;
    function stopInterval() {
        patch._suggestDropdownCheckCounter = 0;
        if (patch._suggestDropdownChecker) {
            clearInterval(patch._suggestDropdownChecker);
            delete patch._suggestDropdownChecker;
        }
    }
    if (patch._suggestDropdownCheckCounter > 0) patch._suggestDropdownCheckCounter = 15;
    if (!patch._suggestDropdownChecker) {
        patch._suggestDropdownCheckCounter = 15;

        patch._suggestDropdownChecker = setInterval(function () {
            patch._suggestDropdownCheckCounter--;
            if (patch._suggestDropdownCheckCounter <= 0) stopInterval();
            var panel = $('body>div.dr-sb-common-container.rich-sb-common-container:visible');
            if (panel.size() && panel.eq(0).offset().top > 0) {
                stopInterval();
                var viewport = HRX.getViewport();
                panel.each(function () {
                    var $this = jQuery(this);
                    var bounds = $this.offset();
                    bounds.bottom = bounds.top + $this.outerHeight();
                    if (viewport.bottom < bounds.bottom) $this.offset({ top: bounds.top - $this.outerHeight() - 25 });
                });
            }
        }, 20);
    }
};

/**
 * sessionRefresher
 */

HRX.SessionRefresher = function (interval) {
    this.interval = typeof interval !== "undefined" ? interval : 0;
    this.timer = null;
    this.started = false;
};

HRX.SessionRefresher.prototype.start = function () {
    if (!this.started && this.interval > 0) {
        this.started = true;
        this.timer = setInterval(function () {
            refreshSession();
        }, this.interval);
    }
};

HRX.SessionRefresher.prototype.stop = function () {
    if (this.started && this.timer) {
        clearInterval(this.timer);
    }
    this.started = false;
};

/**
 * Save mouse position
 */
if (!HRX['cursor']) HRX.cursor = { X: 0, Y: 0 };
HRX.SaveEventCursorPosition = function (event) {
    if (typeof event.pageX !== 'undefined') {
        HRX.cursor.X = event.pageX;
        HRX.cursor.Y = event.pageY;
    } else if (typeof event.clientX !== 'undefined') {
        HRX.cursor.X = event.clientX + jQuery(window).scrollLeft();
        HRX.cursor.Y = event.clientY + jQuery(window).scrollTop();
    } else {
        HRX.cursor.X = jQuery(this).offset().left;
        HRX.cursor.Y = jQuery(this).offset().top;
    }
};

/*focus selector*/
jQuery.expr[':'].focus = function (elem) {
    return elem === document.activeElement && (elem.type || elem.href);
};

/*JSF id to selector*/
HRX.idToSelector = function (id) {
    return id.replace(/:/g, "\\:");
};

/*caret plugin*/
HRX.setSelection = function (field, start, end) {
    var el = jQuery(field).get(0);
    el.focus();
    if (el.setSelectionRange) {
        el.setSelectionRange(start, end);
    } else if (el.createTextRange) {
        var range = el.createTextRange();
        range.collapse(true);
        range.moveEnd('character', end);
        range.moveStart('character', start);
        range.select();
    }
};(function ($, len, createRange, duplicate) {
    $.fn.caret = function (options, opt2) {
        var start = void 0,
            end = void 0,
            t = this[0],
            browser = $.browser.msie;
        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object" && typeof options.start === "number" && typeof options.end === "number") {
            start = options.start;
            end = options.end;
        } else if (typeof options === "number" && typeof opt2 === "number") {
            start = options;
            end = opt2;
        } else if (typeof options === "string") {
            if ((start = t.value.indexOf(options)) > -1) end = start + options[len];else start = null;
        } else if (Object.prototype.toString.call(options) === "[object RegExp]") {
            var re = options.exec(t.value);
            if (re !== null) {
                start = re.index;
                end = start + re[0][len];
            }
        }
        if (typeof start !== "undefined") {
            if (browser) {
                var selRange = this[0].createTextRange();
                selRange.collapse(true);
                selRange.moveStart('character', start);
                selRange.moveEnd('character', end - start);
                selRange.select();
            } else {
                this[0].selectionStart = start;
                this[0].selectionEnd = end;
            }
            this[0].focus();
            return this;
        } else {
            var range = void 0,
                s = void 0,
                e = void 0;
            if (browser) {
                var selection = document.selection;
                if (this[0].tagName.toLowerCase() !== "textarea") {
                    var val = this.val();
                    range = selection[createRange]()[duplicate]();
                    range.moveEnd("character", val[len]);
                    s = range.text === "" ? val[len] : val.lastIndexOf(range.text);
                    range = selection[createRange]()[duplicate]();
                    range.moveStart("character", -val[len]);
                    e = range.text[len];
                } else {
                    range = selection[createRange]();
                    var stored_range = range[duplicate]();
                    stored_range.moveToElementText(this[0]);
                    stored_range.setEndPoint('EndToEnd', range);
                    s = stored_range.text[len] - range.text[len];
                    e = s + range.text[len];
                }
            } else {
                s = t.selectionStart;
                e = t.selectionEnd;
            }
            var te = t.value.substring(s, e);
            return {
                start: s,
                end: e,
                text: te,
                replace: function replace(st) {
                    return t.value.substring(0, s) + st + t.value.substring(e, t.value[len]);
                }
            };
        }
    };
})(jQuery, "length", "createRange", "duplicate")

/* component plugins*/
;(function ($) {
    /* CheckBoxCombo */
    $.fn.hrxDropdown = function (options) {

        var opts = jQuery.extend({}, $.fn.hrxDropdown.defaults, options);

        var img = new Image();
        img.src = opts.image;
        img.src = opts.checkedImage;
        img = null;

        var removeDropdown = function removeDropdown(dropdown) {
            if (dropdown.length > 0) {
                dropdown.remove();
            }
        };
        var adjustItemsByValue = function adjustItemsByValue(opts) {
            var fieldValue = opts.field.val() + opts.separator;
            _(opts.items).each(function (item) {
                item.isChecked = fieldValue.indexOf(item.value + opts.separator) >= 0;
            });
        };
        $('.' + opts.optionClassName).die('click');

        return this.each(function () {
            var button = $(this);
            if (opts.field) {
                opts.field = $(opts.field);
            } else {
                opts.field = button.parent().children("input");
            }
            var onclick = function onclick(e) {
                var offset = opts.field.offset();
                var top = offset.top + opts.positionOffset;
                var width = opts.field.outerWidth();
                if ($('.' + opts.className).length > 0) {
                    removeDropdown(jQuery('.' + opts.className));
                } else if (opts.items.length) {
                    adjustItemsByValue(opts);
                    var dropdown = $('<div class="' + opts.className + '" tabindex="-1"></div>').css({
                        top: top,
                        left: offset.left,
                        width: width,
                        display: "none"
                    }).blur(function () {
                        removeDropdown($('.' + opts.className));
                    }).appendTo('body');
                    var upward = top - $(window).scrollTop() + dropdown.outerHeight() > $(window).height();
                    if (upward) {
                        dropdown.css({
                            top: offset.top - dropdown.outerHeight()
                        });
                    } /*setting focus in the callback is not working*/
                    dropdown.show().focus();
                    $.each(opts.items, function (i, item) {
                        var image = item.isChecked ? opts.checkedImage : opts.image;
                        $('<div class="' + opts.optionClassName + '" style="cursor:default" id="' + item.key + '" ><img src="' + image + '" />' + item.value + '</div>').click(function () {
                            var img = $(this).children('img:first');
                            var isChecked = false;
                            if (img.attr('src') === opts.checkedImage) {
                                img.attr('src', opts.image);
                                item.isChecked = false;
                            } else {
                                img.attr('src', opts.checkedImage);
                                item.isChecked = true;
                                isChecked = true;
                            }
                            if (opts.autoFill) {
                                opts.field.val(opts.items.filter(function (v) {
                                    return v.isChecked;
                                }).map(function (v) {
                                    return v.value;
                                }).join(opts.separator));
                            }
                            opts.itemClick(opts.field, opts.items, $(this).attr('id'), jQuery(this).text(), isChecked, opts.separator);
                            e.preventDefault();
                        }).appendTo('.' + opts.className);
                    });
                    $('.' + opts.className).show();
                }
                e.preventDefault();
                return false;
            };
            $(button).click(onclick);
            opts.field.mousedown(onclick);
            onclick = null;
        });
    };

    $.fn.hrxDropdown.defaults = {
        items: [],
        image: '/rasp6/img/components/checkboxcombo/checkbox.gif',
        checkedImage: '/rasp6/img/components/checkboxcombo/checked.gif',
        positionOffset: 20,
        className: 'dropDownMenu',
        optionClassName: 'optionCheckbox',
        field: null,
        autoFill: false,
        dropdownHeight: 200,
        itemClick: function itemClick(key, value, isChecked) {},
        separator: ', '
    }; /* End of CheckBoxCombo */

    /* Expendable Textfield */
    $.fn.hrxExpandableTextfield = function (options) {
        //for safari, only work on version 5.1.1 or above
        var opts = $.extend({}, jQuery.fn.hrxExpandableTextfield.defaults, options);
        return this.each(function () {
            var field = $(this);
            var popupField = null;
            var onfocus = function onfocus() {
                var offset = field.offset();
                var height = field.height();
                var width = opts.width || field.outerWidth();
                if (opts.widthAnchor) {
                    if ($(opts.widthAnchor).length > 0) {
                        width = $(opts.widthAnchor).outerWidth() - (offset.left - $(opts.widthAnchor).offset().left) - opts.rightMargin;
                    }
                }
                var wrapper = $('<div class="' + opts.wrapperClass + '"><h1>' + opts.header + '</h1><input class="' + opts.popupClass + '"/></div>').css({
                    width: width + opts.wrapperPadding * 2 - 20,
                    padding: opts.wrapperPadding
                }).appendTo('body');
                wrapper.attr('id', field.attr('id') + 'PopupWrapper');
                if (!opts.freePosition) wrapper.css({
                    top: offset.top - opts.wrapperPadding + opts.offsetTop,
                    left: offset.left - opts.wrapperPadding + opts.offsetLeft
                });
                popupField = wrapper.children('input').eq(0).val(field.val()).css({
                    width: width,
                    height: height
                }).keyup(function () {
                    field.val($(this).val());
                }).blur(function () {
                    field.val($(this).val());
                    setTimeout(function () {
                        if (!field.is(':focus')) wrapper.remove();
                    }, 50);
                });
                popupField.attr('id', field.attr('id') + 'PopupField');
                if (opts.autoFocus) {
                    HRX.setSelection(popupField, field.caret().start, field.caret().end);
                    popupField.focus();
                }
            };
            $(field).focus(onfocus).keyup(function () {
                if (popupField) popupField.val($(this).val());
            }).blur(function () {
                setTimeout(function () {
                    if (!popupField.is(':focus')) popupField.parent().remove();
                }, 50);
            });
        });
    };

    $.fn.hrxExpandableTextfield.defaults = {
        offsetTop: 0,
        offsetLeft: 0,
        freePosition: false,
        width: null,
        popupClass: 'popupTextfield',
        wrapperClass: 'popupTextfieldWrapper',
        wrapperPadding: 10,
        widthAnchor: null,
        rightMargin: 10,
        autoFocus: false,
        header: ''
    }; /* End of expandable textfield */
})(jQuery)

/*
 * Auto-growing textareas
 */
;(function ($) {
    $.fn.hrxAutoGrowTextArea = function (options) {
        var opts = $.extend({}, $.fn.hrxAutoGrowTextArea.defaults, options);
        if (opts.lengthErrorElement) opts.lengthErrorElement = $(opts.lengthErrorElement);
        if (opts.remainCounter) opts.remainCounter = $(opts.remainCounter);
        this.filter('textarea').each(function () {

            var $this = $(this),
                minHeight = $this.height(),
                lineHeight = $this.css('lineHeight'),
                lengthAlerted = false;

            var shadow = $('<div></div>').css({
                position: 'absolute',
                top: -10000,
                left: -10000,
                width: $(this).width() - parseInt($this.css('paddingLeft')) - parseInt($this.css('paddingRight')),
                fontSize: $this.css('fontSize'),
                fontFamily: $this.css('fontFamily'),
                lineHeight: $this.css('lineHeight'),
                resize: 'none'
            }).appendTo(document.body);

            var update = function update() {

                var times = function times(string, number) {
                    for (var i = 0, r = ''; i < number; i++) {
                        r += string;
                    }return r;
                };

                var val = this.value.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/\n$/, '<br/>&nbsp;').replace(/\n/g, '<br/>').replace(/ {2,}/g, function (space) {
                    return times('&nbsp;', space.length - 1) + ' ';
                });
                var len = this.value.length;
                if (opts.lengthLimit) {
                    if (len > opts.lengthLimit) {
                        if (opts.remainCounter) opts.remainCounter.text(len - opts.lengthLimit + " characters exceeded.").addClass("exceeded").removeClass("remaining");
                        if (opts.lengthErrorElement) {
                            if (!opts.lengthErrorElement.is(':visible')) opts.lengthErrorElement.fadeIn(300);
                        } else if (!lengthAlerted) {
                            lengthAlerted = true;
                            alert("Content length exceeds " + opts.lengthLimit + " characters. It is very likely not able to save correctly.");
                        }
                    } else {
                        if (opts.remainCounter) opts.remainCounter.text(opts.lengthLimit - len + " characters remaining.").addClass("remaining").removeClass("exceeded");
                        if (opts.lengthErrorElement && opts.lengthErrorElement.length > 0 && opts.lengthErrorElement.is(':visible')) opts.lengthErrorElement.fadeOut(300);
                        lengthAlerted = false;
                    }
                }

                shadow.html(val);
                $(this).css('height', Math.min(opts.maxHeight, Math.max(shadow.height() + 20, minHeight)));
            };

            $(this).change(update).keyup(update).keydown(update);

            update.apply(this);
        });
        return this;
    };

    $.fn.hrxAutoGrowTextArea.defaults = {
        maxHeight: 600,
        lengthLimit: 0,
        remainCounter: null,
        lengthErrorElement: null
    };
})(jQuery)

/*iOS style toggle button*/
;(function ($) {
    $.fn.iToggle = function (options) {

        clickEnabled = true;

        var defaults = {
            type: 'checkbox',
            keepLabel: true,
            easing: false,
            speed: 200,
            skin: '/rasp/mercury/themes/spring/components/itoggle/itoggle.png',
            width: 93,
            height: 27,
            onClick: function onClick() {},
            onClickOn: function onClickOn() {},
            onClickOff: function onClickOff() {},
            onSlide: function onSlide() {},
            onSlideOn: function onSlideOn() {},
            onSlideOff: function onSlideOff() {}
        },
            settings = $.extend({}, defaults, options);

        this.each(function () {
            var $this = $(this);
            if ($this.attr('tagName') == 'INPUT') {
                var id = $this.attr('id');
                label(settings.keepLabel, id);
                $this.addClass('iT_checkbox');
                $('<label class="itoggle" for="' + id + '"><span></span></label>').insertBefore($this).click(function () {
                    toggle($(this));return false;
                });
                if ($this.attr('checked')) {
                    $this.prev('label').addClass('iTon');
                } else {
                    $this.prev('label').addClass('iToff');
                }
            } else {
                $this.children('input:' + settings.type).each(function () {
                    var id = $(this).attr('id');
                    label(settings.keepLabel, id);
                    $(this).addClass('iT_checkbox').before('<label class="itoggle" for="' + id + '"><span></span></label>');
                    if ($(this).attr('checked')) {
                        $(this).prev('label').addClass('iTon');
                    } else {
                        $(this).prev('label').addClass('iToff');
                    }
                    if (settings.type == 'radio') {
                        $(this).prev('label').addClass('iT_radio');
                    }
                });
            }
            $this.prev('label').css('background-image', 'url("' + settings.skin + '")').css('width', settings.width).css('height', settings.height);
            $(this).get(0).slideOff = function () {
                var itoggle = $(this).prev('label.itoggle').eq(0);
                if (itoggle.hasClass('iTon')) {
                    toggle(itoggle, true);
                }
                clickEnabled = true;
            };
            $(this).get(0).slideOn = function () {
                var itoggle = $(this).prev('label.itoggle').eq(0);
                if (itoggle.hasClass('iToff')) {
                    toggle(itoggle, true);
                }
                clickEnabled = true;
            };
        });

        function label(e, id) {
            if (e === true) {
                if (settings.type == 'radio') {
                    $('label[for=' + id + ']').addClass('ilabel_radio');
                } else {
                    $('label[for=' + id + ']').addClass('ilabel').click(toggleLabel);
                }
            } else {
                $('label[for=' + id + ']').remove();
            }
        }

        function toggle(itoggleLabel, programmatic) {
            if (clickEnabled === true) {
                clickEnabled = false;
                if (itoggleLabel.hasClass('iT_radio')) {
                    if (itoggleLabel.hasClass('iTon')) {
                        clickEnabled = true;
                    } else {
                        slide(itoggleLabel, true, programmatic);
                    }
                } else {
                    slide(itoggleLabel, false, programmatic);
                }
            }
            return false;
        }

        function toggleLabel() {
            if (clickEnabled === true) {
                clickEnabled = false;
                slide($(this).next('label.itoggle').eq(0));
            }
            return false;
        }

        function slide($object, radio, programmatic) {
            if (typeof programmatic == "undefined") programmatic = false;
            if (!programmatic) settings.onClick.call($object); //Generic click callback for click at any state
            h = $object.innerHeight();
            t = HRX.idToSelector($object.attr('for'));
            if ($object.hasClass('iTon')) {
                if (!programmatic) settings.onClickOff.call($object); //Click that turns the toggle to off position
                $object.animate({
                    backgroundPosition: '100% -' + h + 'px'
                }, settings.speed, settings.easing, function () {
                    $object.removeClass('iTon').addClass('iToff');
                    clickEnabled = true;
                    if (!programmatic) settings.onSlide.call(this); //Generic callback after the slide has finnished
                    if (!programmatic) settings.onSlideOff.call(this); //Callback after the slide turns the toggle off
                });
                $('input#' + t).removeAttr('checked');
            } else {
                if (!programmatic) settings.onClickOn.call($object);
                $object.animate({
                    backgroundPosition: '0% -' + h + 'px'
                }, settings.speed, settings.easing, function () {
                    $object.removeClass('iToff').addClass('iTon');
                    clickEnabled = true;
                    if (!programmatic) settings.onSlide.call(this); //Generic callback after the slide has finnished
                    if (!programmatic) settings.onSlideOn.call(this); //Callback after the slide turns the toggle on
                });
                $('input#' + t).attr('checked', 'checked');
            }
            if (radio === true) {
                name = $('#' + t).attr('name');
                slide($object.siblings('label[for]'), false, programmatic);
            }
        }
    };
})(jQuery)

/*
 * Field merger
 */
;(function ($) {
    $.fn.hrxFieldMerger = function (options) {
        var opts = $.extend({}, $.fn.hrxFieldMerger.defaults, options);
        opts.actualField = opts.field;
        opts.field = $(opts.field);
        //TODO US2069 No prototype.js anymore. For now as we testing migration on new browser the array should have sufficient APIs. We need to fix this when we start considering support old browsers.
        // opts.values = $A(opts.values);
        // opts.styleClasses = $A(opts.styleClasses);
        var fillField = function fillField(value) {
            if (opts.handler) opts.handler(opts.field, value);else opts.field.val(value);
            if (opts.field.hasClass("ui-selectonemenu")) {
                if (PrimeFaces != undefined && PrimeFaces.getWidgetById(opts.field.attr("id")) != null) {
                    PrimeFaces.getWidgetById(opts.field.attr("id")).selectValue(value);
                }
            }
        };
        // const newValue = HRX.getValueFromArrayOrLast(opts.values, 0);
        // const newClass = HRX.getValueFromArrayOrLast(opts.styleClasses, 0);
        // const newLabel = HRX.getValueFromArrayOrNull(opts.labels, 0);
        var setValueStyle = function setValueStyle() {
            _.each(opts.styleClasses, function (c) {
                return opts.field.removeClass(c);
            });
            var valueIdx = opts.values.indexOf(opts.field.val());
            if (valueIdx >= 0) {
                opts.field.addClass(HRX.getValueFromArrayOrLast(opts.styleClasses, valueIdx));
            }
            if (opts.triggerStyle === "toggle") {
                if (valueIdx > 0) opts.itoggle.slideOff();else opts.itoggle.slideOn();
            }
        };
        return this.each(function () {
            var button = $(this);
            button.addClass('hrxMergeButton');
            button.get(0).setTo = function (idx) {
                var value = opts.values[idx];
                fillField(value);
                setValueStyle();
                if (opts.triggerStyle === "dropdown") $('.fieldMergerPopup').remove();
            };
            if (opts.adjustFieldWidth > 0) opts.field.width(opts.adjustFieldWidth);
            if (opts.triggerStyle === "dropdown") {
                var onclick = function onclick(e) {
                    var offset = opts.field.offset().top > 0 ? opts.field.offset() : $(opts.actualField).offset();
                    var top = offset.top + opts.offsetTop;
                    var width = opts.field.width();
                    if (opts.minWidth && width > opts.minWidth) width = opts.minWidth;
                    if ($('.fieldMergerPopup').length > 0) {
                        $('.fieldMergerPopup').remove();
                    } else {
                        var dropdown = $('<div class="fieldMergerPopup" style="position:absolute" tabindex="-1"></div>').css({
                            top: top,
                            left: offset.left,
                            width: width,
                            display: "none"
                        }).blur(function () {
                            $('.fieldMergerPopup').remove();
                        }).appendTo('body');
                        var upward = top - $(window).scrollTop() + dropdown.outerHeight() > $(window).height();
                        if (upward) {
                            dropdown.css({
                                top: offset.top - dropdown.outerHeight()
                            });
                        }
                        dropdown.show().focus();
                        _(opts.values).each(function (v, i) {
                            var label = HRX.getValueFromArrayOrNull(opts.labels, i);
                            if (!label) label = v;
                            var img = opts.optionIcons.length > 0 ? '<img src="' + HRX.getValueFromArrayOrLast(opts.optionIcons, i) + '"/>' : '';
                            var emptyOption = opts.emptyIcon ? '<img src="' + opts.emptyIcon + '"/>' : '[blank]';
                            $('<div class=".' + (i > 1 ? 'oldValueItem' : 'newValueItem') + '" style="cursor:pointer">' + img + (label ? label : emptyOption) + '</div>').click(function (e) {
                                button.get(0).setTo(i);
                                e.preventDefault();
                            }).appendTo('.fieldMergerPopup');
                        });
                        $('.fieldMergerPopup').show();
                    }
                    e.preventDefault();
                };
                button.mousedown(onclick);
                onclick = null;
            } else if (opts.triggerStyle === "toggle") {
                button.iToggle({
                    onClickOn: function onClickOn() {
                        button.get(0).setTo(0);
                    },
                    onClickOff: function onClickOff() {
                        button.get(0).setTo(1);
                    },
                    keepLabel: false,
                    skin: '/rasp/mercury/themes/spring/components/fieldmerger/itoggle_small.png',
                    width: 47,
                    height: 14
                });
                opts.itoggle = button.get(0);
            }

            opts.field.bind("keyup change", setValueStyle).addClass(opts.fieldClass);
            if (opts.defaultNew) button.get(0).setTo(0);else setValueStyle();
        });
    };

    $.fn.hrxFieldMerger.defaults = {
        field: null,
        fieldClass: "merge_field",
        triggerStyle: "toggle",
        adjustFieldWidth: 0,
        offsetTop: 20,
        minWidth: 0,
        optionIcons: ['/rasp/mercury/themes/spring/components/fieldmerger/new.gif', '/rasp/mercury/themes/spring/components/fieldmerger/old.gif'],
        emptyIcon: null,
        values: ['', ''],
        styleClasses: ["merge_newvalue", "merge_oldvalue"],
        labels: [],
        defaultNew: false,
        handler: null
    };
})(jQuery);

/**
 * jQuery.ScrollTo
 * Copyright (c) 2007-2009 Ariel Flesler - aflesler(at)gmail(dot)com | http://flesler.blogspot.com
 * Dual licensed under MIT and GPL.
 * Date: 5/25/2009
 *
 * @projectDescription Easy element scrolling using jQuery.
 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
 * Works with jQuery +1.2.6. Tested on FF 2/3, IE 6/7/8, Opera 9.5/6, Safari 3, Chrome 1 on WinXP.
 *
 * @author Ariel Flesler
 * @version 1.4.2
 *
 * @id jQuery.scrollTo
 * @id jQuery.fn.scrollTo
 * @param {String, Number, DOMElement, jQuery, Object} target Where to scroll the matched elements.
 *	  The different options for target are:
 *		- A number position (will be applied to all axes).
 *		- A string position ('44', '100px', '+=90', etc ) will be applied to all axes
 *		- A jQuery/DOM element ( logically, child of the element to scroll )
 *		- A string selector, that will be relative to the element to scroll ( 'li:eq(2)', etc )
 *		- A hash { top:x, left:y }, x and y can be any kind of number/string like above.
*		- A percentage of the container's dimension/s, for example: 50% to go to the middle.
 *		- The string 'max' for go-to-end. 
 * @param {Number} duration The OVERALL length of the animation, this argument can be the settings object instead.
 * @param {Object,Function} settings Optional set of settings or the onAfter callback.
 *	 @option {String} axis Which axis must be scrolled, use 'x', 'y', 'xy' or 'yx'.
 *	 @option {Number} duration The OVERALL length of the animation.
 *	 @option {String} easing The easing method for the animation.
 *	 @option {Boolean} margin If true, the margin of the target element will be deducted from the final position.
 *	 @option {Object, Number} offset Add/deduct from the end position. One number for both axes or { top:x, left:y }.
 *	 @option {Object, Number} over Add/deduct the height/width multiplied by 'over', can be { top:x, left:y } when using both axes.
 *	 @option {Boolean} queue If true, and both axis are given, the 2nd axis will only be animated after the first one ends.
 *	 @option {Function} onAfter Function to be called after the scrolling ends. 
 *	 @option {Function} onAfterFirst If queuing is activated, this function will be called after the first scrolling ends.
 * @return {jQuery} Returns the same jQuery object, for chaining.
 *
 * @desc Scroll to a fixed position
 * @example $('div').scrollTo( 340 );
 *
 * @desc Scroll relatively to the actual position
 * @example $('div').scrollTo( '+=340px', { axis:'y' } );
 *
 * @dec Scroll using a selector (relative to the scrolled element)
 * @example $('div').scrollTo( 'p.paragraph:eq(2)', 500, { easing:'swing', queue:true, axis:'xy' } );
 *
 * @ Scroll to a DOM element (same for jQuery object)
 * @example var second_child = document.getElementById('container').firstChild.nextSibling;
 *			$('#container').scrollTo( second_child, { duration:500, axis:'x', onAfter:function(){
 *				alert('scrolled!!');																   
 *			}});
 *
 * @desc Scroll on both axes, to different values
 * @example $('div').scrollTo( { top: 300, left:'+=200' }, { axis:'xy', offset:-20 } );
 */
;(function ($) {

    var $scrollTo = $.scrollTo = function (target, duration, settings) {
        $(window).scrollTo(target, duration, settings);
    };

    $scrollTo.defaults = {
        axis: 'xy',
        duration: parseFloat($.fn.jquery) >= 1.3 ? 0 : 1
    };

    // Returns the element that needs to be animated to scroll the window.
    // Kept for backwards compatibility (specially for localScroll & serialScroll)
    $scrollTo.window = function (scope) {
        return $(window)._scrollable();
    };

    // Hack, hack, hack :)
    // Returns the real elements to scroll (supports window/iframes, documents and regular nodes)
    $.fn._scrollable = function () {
        return this.map(function () {
            var elem = this,
                isWin = !elem.nodeName || $.inArray(elem.nodeName.toLowerCase(), ['iframe', '#document', 'html', 'body']) !== -1;

            if (!isWin) return elem;

            var doc = (elem.contentWindow || elem).document || elem.ownerDocument || elem;

            return $.browser.safari || doc.compatMode === 'BackCompat' ? doc.body : doc.documentElement;
        });
    };

    $.fn.scrollTo = function (target, duration, settings) {
        if ((typeof duration === "undefined" ? "undefined" : _typeof(duration)) == 'object') {
            settings = duration;
            duration = 0;
        }
        if (typeof settings == 'function') settings = { onAfter: settings };

        if (target == 'max') target = 9e9;

        settings = $.extend({}, $scrollTo.defaults, settings);
        // Speed is still recognized for backwards compatibility
        duration = duration || settings.speed || settings.duration;
        // Make sure the settings are given right
        settings.queue = settings.queue && settings.axis.length > 1;

        if (settings.queue)
            // Let's keep the overall duration
            duration /= 2;
        settings.offset = both(settings.offset);
        settings.over = both(settings.over);

        return this._scrollable().each(function () {
            var elem = this,
                $elem = $(elem),
                targ = target,
                toff,
                attr = {},
                win = $elem.is('html,body');

            switch (typeof targ === "undefined" ? "undefined" : _typeof(targ)) {
                // A number will pass the regex
                case 'number':
                case 'string':
                    if (/^([+-]=)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
                        targ = both(targ);
                        // We are done
                        break;
                    }
                    // Relative selector, no break!
                    targ = $(targ, this);
                case 'object':
                    // DOMElement / jQuery
                    if (targ.is || targ.style)
                        // Get the real position of the target
                        toff = (targ = $(targ)).offset();
            }
            $.each(settings.axis.split(''), function (i, axis) {
                var Pos = axis == 'x' ? 'Left' : 'Top',
                    pos = Pos.toLowerCase(),
                    key = 'scroll' + Pos,
                    old = elem[key],
                    max = $scrollTo.max(elem, axis);

                if (toff) {
                    // jQuery / DOMElement
                    attr[key] = toff[pos] + (win ? 0 : old - $elem.offset()[pos]);

                    // If it's a dom element, reduce the margin
                    if (settings.margin) {
                        attr[key] -= parseInt(targ.css('margin' + Pos)) || 0;
                        attr[key] -= parseInt(targ.css('border' + Pos + 'Width')) || 0;
                    }

                    attr[key] += settings.offset[pos] || 0;

                    if (settings.over[pos])
                        // Scroll to a fraction of its width/height
                        attr[key] += targ[axis == 'x' ? 'width' : 'height']() * settings.over[pos];
                } else {
                    var val = targ[pos];
                    // Handle percentage values
                    attr[key] = val.slice && val.slice(-1) == '%' ? parseFloat(val) / 100 * max : val;
                }

                // Number or 'number'
                if (/^\d+$/.test(attr[key]))
                    // Check the limits
                    attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);

                // Queueing axes
                if (!i && settings.queue) {
                    // Don't waste time animating, if there's no need.
                    if (old != attr[key])
                        // Intermediate animation
                        animate(settings.onAfterFirst);
                    // Don't animate this axis again in the next iteration.
                    delete attr[key];
                }
            });

            animate(settings.onAfter);

            function animate(callback) {
                $elem.animate(attr, duration, settings.easing, callback && function () {
                    callback.call(this, target, settings);
                });
            }
        }).end();
    };

    // Max scrolling position, works on quirks mode
    // It only fails (not too badly) on IE, quirks mode.
    $scrollTo.max = function (elem, axis) {
        var Dim = axis == 'x' ? 'Width' : 'Height',
            scroll = 'scroll' + Dim;

        if (!$(elem).is('html,body')) return elem[scroll] - $(elem)[Dim.toLowerCase()]();

        var size = 'client' + Dim,
            html = elem.ownerDocument.documentElement,
            body = elem.ownerDocument.body;

        return Math.max(html[scroll], body[scroll]) - Math.min(html[size], body[size]);
    };

    function both(val) {
        return (typeof val === "undefined" ? "undefined" : _typeof(val)) == 'object' ? val : { top: val, left: val };
    }
})(jQuery);(function ($) {
    if (!HRX['hideColumnFilterOnBlur']) {
        HRX.hideColumnFilterOnBlur = function (e) {
            var popup = $('.RaspPopupPanel:visible');
            if (popup.size === 0) {
                $(document).unbind('click', HRX.hideColumnFilterOnBlur);
            } else {
                var popupContent = popup.children('.tip');
                var offset = popupContent.offset();
                if (offset && offset.left && (e.pageX < offset.left || e.pageX > offset.left + popupContent.outerWidth() || e.pageY < offset.top || e.pageY > offset.top + popupContent.outerHeight())) {
                    //the column header will check on visibility of the popup to prevent it shows up again.
                    setTimeout(function () {
                        jQuery(".RaspPopupPanel:visible").hide();
                    }, 50);
                    $(document).unbind('click', HRX.hideColumnFilterOnBlur);
                }
            }
        };
    }

    if (!HRX['showColumnFilter']) {
        HRX.showColumnFilter = function (columnName, container, offsetX) {
            var adjustPosition = function adjustPosition(popup) {
                var deltaX = popup.offset().left - popup.position().left;
                var popupWidth = popup.children('.tip').outerWidth();
                var left = HRX.cursor.X + offsetX;
                var containerRight = $(container).offset().left + $(container).width();
                if (left + popupWidth > containerRight) left = containerRight - popupWidth - 10;
                left = left - deltaX;
                if (left < 5) left = 5;
                popup.css('left', left);
            };
            var popupPanel = $(HRX.idToSelector('#' + columnName + '-popup'));
            if (!popupPanel.is(':visible')) {
                popupPanel.show();
                adjustPosition(popupPanel);
                $(document).bind('click', HRX.hideColumnFilterOnBlur);
            } else popupPanel.hide();
        };
    }
})(jQuery);

/**
 * IFrame enhancement
 */

HRX.iframeRedirect = function (selector, url, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    HRX.iframeSquirt(ifm, squirt);
    ifm.attr('src', url);
};

HRX.iframeSquirt = function (selector, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    if (typeof squirt !== 'undefined') {
        var el = ifm.get(0);
        var doc = el.contentDocument || el.contentWindow.document;
        doc.open();
        doc.writeln(squirt);
        doc.close();
    }
};(function ($) {

    var timer;

    $.fn.src = function (url, onLoad, options) {
        setIFrames($(this), onLoad, options, function () {
            this.src = url;
        });
        return $(this);
    };

    $.fn.squirt = function (content, onLoad, options) {

        setIFrames($(this), onLoad, options, function () {
            var doc = null;
            if (typeof this.contentDocument != 'unknown') {
                doc = this.contentDocument;
            } else if (typeof this.contentWindow != "unknown" && typeof this.contentWindow.document != "unknown") {
                doc = this.contentWindow.document;
            }
            if (doc) {
                doc.open();
                doc.writeln(content);
                doc.close();
            }
        });
        return this;
    };

    function setIFrames(iframes, onLoad, options, iFrameSetter) {
        iframes.each(function () {
            if (this.tagName == "IFRAME") setIFrame(this, onLoad, options, iFrameSetter);
        });
    }

    function setIFrame(iframe, onLoad, options, iFrameSetter) {
        var timer;
        iframe.onload = null;
        if (timer) clearTimeout(timer);

        var defaults = {
            timeoutDuration: 0,
            timeout: null
        };
        var opts = $.extend(defaults, options);
        if (opts.timeout && !opts.timeoutDuration) opts.timeoutDuration = 60000;

        opts.frameactive = true;
        var startTime = new Date().getTime();
        if (opts.timeout) {
            timer = setTimeout(function () {
                opts.frameactive = false;
                iframe.onload = null;
                if (opts.timeout) opts.timeout(iframe, opts.timeout);
            }, opts.timeoutDuration);
        }

        var onloadHandler = function onloadHandler() {
            var duration = new Date().getTime() - startTime;
            if (timer) clearTimeout(timer);
            if (onLoad && opts.frameactive) onLoad.apply(iframe, [duration]);
            opts.frameactive = false;
        };
        iFrameSetter.apply(iframe);
        iframe.onload = onloadHandler;
        opts.completeReadyStateChanges = 0;
        iframe.onreadystatechange = function () {
            // IE ftw
            if (++opts.completeReadyStateChanges == 3) onloadHandler();
        };
        return iframe;
    }
})(jQuery);

/**
 * Really Simple Color Picker in jQuery
 * 
 * Licensed under the MIT (MIT-LICENSE.txt) licenses.
 *
 * Copyright (c) 2008 Lakshan Perera (www.laktek.com)
 *                    Daniel Lacy (daniellacy.com)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

;(function ($) {
    /**
     * Create a couple private variables.
    **/
    var selectorOwner,
        activePalette,
        cItterate = 0,
        templates = {
        control: $('<div class="colorPicker-picker">&nbsp;</div>'),
        palette: $('<div id="colorPicker_palette" class="colorPicker-palette" />'),
        clearButton: $('<div class="colorPicker-swatch colorPicker-empty">&nbsp;</div>'),
        swatch: $('<div class="colorPicker-swatch">&nbsp;</div>'),
        hexLabel: $('<label for="colorPicker_hex">Code</label>'),
        hexField: $('<input type="text" id="colorPicker_hex" />')
    },
        transparent = "transparent",
        lastColor;

    /**
     * Create our colorPicker function
    **/
    $.fn.simpleColorPicker = function (options) {
        return this.each(function () {
            // Setup time. Clone new elements from our templates, set some IDs, make shortcuts, jazzercise.
            var element = $(this),
                opts = $.extend({}, $.fn.simpleColorPicker.defaults, options),
                defaultColor = element.val().length > 0 ? $.fn.simpleColorPicker.toHex(element.val()) : '',
                newControl = templates.control.clone(),
                newPalette = templates.palette.clone().attr('id', 'colorPicker_palette-' + cItterate),
                newHexLabel = templates.hexLabel.clone(),
                newHexField = templates.hexField.clone(),
                newClearButton = templates.clearButton.clone(),
                paletteId = newPalette[0].id,
                swatch;

            /**
             * Build a color palette.
            **/
            $.each(opts.colors, function (i) {
                swatch = templates.swatch.clone();

                if (opts.colors[i] === transparent) {
                    swatch.addClass(transparent).text('X');

                    $.fn.simpleColorPicker.bindPalette(newHexField, swatch, transparent);
                } else {
                    swatch.css("background-color", "#" + this);
                    if (opts.colorLabels.length > i) {
                        swatch.attr('title', opts.colorLabels[i]);
                    }

                    $.fn.simpleColorPicker.bindPalette(newHexField, swatch);
                }

                swatch.appendTo(newPalette);
            });

            newClearButton.appendTo(newPalette).css("background-color", "#FFF").attr('title', 'Clear');
            $.fn.simpleColorPicker.bindEmptySwatch(newHexField, newClearButton);

            newHexField.attr({
                'id': 'colorPicker_hex-' + cItterate,
                'value': defaultColor
            });

            newHexField.bind("keydown", function (event) {
                if (event.keyCode === 13) {
                    $.fn.simpleColorPicker.changeColor($.fn.simpleColorPicker.toHex($(this).val()));
                }
                if (event.keyCode === 27) {
                    $.fn.simpleColorPicker.hidePalette(paletteId);
                }
            });

            $('<div class="colorPicker_hexWrap" />').appendTo(newPalette);

            newPalette.find('.colorPicker_hexWrap').append(newHexField);

            $("body").append(newPalette);

            newPalette.hide();

            /**
             * Build replacement interface for original color input.
            **/
            newControl.css("background-color", defaultColor);

            newControl.bind("click", function () {
                $.fn.simpleColorPicker.togglePalette($('#' + paletteId), $(this));
            });

            element.after(newControl);

            element.bind("change", function () {
                var $this = $(this);
                if ($this.val() === "") {
                    element.next(".colorPicker-picker").css("background-color", "#FFF").addClass("colorPicker_clear");
                } else {
                    element.next(".colorPicker-picker").css("background-color", $.fn.simpleColorPicker.toHex($this.val())).removeClass("colorPicker_clear");
                }
            });

            element.change();

            // Hide the original input.
            element.val(defaultColor).hide();

            cItterate++;
        });
    };

    /**
     * Extend colorPicker with... all our functionality.
    **/
    $.extend(true, $.fn.simpleColorPicker, {
        /**
         * Return a Hex color, convert an RGB value and return Hex, or return false.
         *
         * Inspired by http://code.google.com/p/jquery-color-utils
        **/
        toHex: function toHex(color) {
            // If we have a standard or shorthand Hex color, return that value.
            if (color.match(/[0-9A-F]{6}|[0-9A-F]{3}$/i)) {
                return color.charAt(0) === "#" ? color : "#" + color;

                // Alternatively, check for RGB color, then convert and return it as Hex.
            } else if (color.match(/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/)) {
                var c = [parseInt(RegExp.$1, 10), parseInt(RegExp.$2, 10), parseInt(RegExp.$3, 10)],
                    pad = function pad(str) {
                    if (str.length < 2) {
                        for (var i = 0, len = 2 - str.length; i < len; i++) {
                            str = '0' + str;
                        }
                    }

                    return str;
                };

                if (c.length === 3) {
                    var r = pad(c[0].toString(16)),
                        g = pad(c[1].toString(16)),
                        b = pad(c[2].toString(16));

                    return '#' + r + g + b;
                }

                // Otherwise we wont do anything.
            } else {
                return false;
            }
        },

        /**
         * Check whether user clicked on the selector or owner.
        **/
        checkMouse: function checkMouse(event, paletteId) {
            var selector = activePalette,
                selectorParent = $(event.target).parents("#" + selector.attr('id')).length;

            if (event.target === $(selector)[0] || event.target === selectorOwner || selectorParent > 0) {
                return;
            }

            $.fn.simpleColorPicker.hidePalette();
        },

        /**
         * Hide the color palette modal.
        **/
        hidePalette: function hidePalette(paletteId) {
            $(document).unbind("mousedown", $.fn.simpleColorPicker.checkMouse);

            $('.colorPicker-palette').hide();
        },

        /**
         * Show the color palette modal.
        **/
        showPalette: function showPalette(palette) {
            var hexColor = selectorOwner.prev("input").val();

            palette.css({
                top: selectorOwner.offset().top + selectorOwner.outerHeight(),
                left: selectorOwner.offset().left
            });

            $("#color_value").val(hexColor);

            palette.show();

            $(document).bind("mousedown", $.fn.simpleColorPicker.checkMouse);
        },

        /**
         * Toggle visibility of the colorPicker palette.
        **/
        togglePalette: function togglePalette(palette, origin) {
            // selectorOwner is the clicked .colorPicker-picker.
            if (origin) {
                selectorOwner = origin;
            }

            activePalette = palette;

            if (activePalette.is(':visible')) {
                $.fn.simpleColorPicker.hidePalette();
            } else {
                $.fn.simpleColorPicker.showPalette(palette);
            }
        },

        /**
         * Update the input with a newly selected color.
        **/
        changeColor: function changeColor(value) {
            selectorOwner.css("background-color", value);
            selectorOwner.prev("input").val(value).change();
            $.fn.simpleColorPicker.hidePalette();
        },

        clearColor: function clearColor() {
            selectorOwner.css("background-color", "#FFF");
            selectorOwner.prev("input").val("").change();
            $.fn.simpleColorPicker.hidePalette();
        },

        /**
         * Bind events to the color palette swatches.
        */
        bindPalette: function bindPalette(paletteInput, element, color) {
            color = color ? color : $.fn.simpleColorPicker.toHex(element.css("background-color"));

            element.bind('click', function (ev) {
                lastColor = color;

                $.fn.simpleColorPicker.changeColor(color);
            });
            element.bind('mouseover', function (ev) {
                lastColor = paletteInput.val();

                $(this).css("border-color", "#598FEF");

                paletteInput.val(color);
            });
            element.bind('mouseout', function (ev) {
                $(this).css("border-color", "#000");

                paletteInput.val(selectorOwner.css("background-color"));

                paletteInput.val(lastColor);
            });
        },

        /**
         *
         */
        bindEmptySwatch: function bindEmptySwatch(paletteInput, element) {
            element.bind('click', function (ev) {
                lastColor = "";
                $.fn.simpleColorPicker.clearColor();
            });
            element.bind('mouseover', function (ev) {
                lastColor = paletteInput.val();

                $(this).css("border-color", "#598FEF");

                paletteInput.val("");
            });
            element.bind('mouseout', function (ev) {
                $(this).css("border-color", "#000");

                paletteInput.val(selectorOwner.css("background-color"));

                paletteInput.val(lastColor);
            });
        }
    });

    /**
     * Default colorPicker options.
     *
     * These are publibly available for global modification using a setting such as:
     *
     * $.fn.simpleColorPicker.defaults.colors = ['151337', '111111']
     *
     * They can also be applied on a per-bound element basis like so:
     *
     * $('#element1').colorPicker({pickerDefault: 'efefef', transparency: true});
     * $('#element2').colorPicker({pickerDefault: '333333', colors: ['333333', '111111']});
     *
    **/
    $.fn.simpleColorPicker.defaults = {
        // colorPicker default selected color.
        pickerDefault: "FFFFFF",

        // Default color set.
        colors: ['339966', '33CCCC', '3366FF', '800080', '999999'],

        colorLabels: [],

        // If we want to simply add more colors to the default set, use addColors.
        addColors: []
    };
})(jQuery);

//TinyMCE
;(function () {
    if (typeof tinymce === 'undefined') return;
    var defaultOptions = {
        mode: "specific_textareas",
        theme: "advanced",
        plugins: "pagebreak,style,table,save,advhr,advimage,advlink,iespell,insertdatetime,inlinepopups,preview,media,searchreplace,contextmenu,paste,directionality,fullscreen,noneditable,visualchars,nonbreaking,xhtmlxtras,template,advlist,spellchecker,fullpage",
        pagebreak_separator: "<div style=\"page-break-after: always;\"><span style=\"display: none;\"></span></div>",
        theme_advanced_buttons1: "bold,italic,underline,|,justifyleft,justifycenter,justifyright,justifyfull,fontselect,fontsizeselect,forecolor,charmap",
        theme_advanced_buttons2: "cut,copy,paste,pastetext,pasteword,|,search,replace,|,bullist,numlist,|,outdent,indent,|,undo,redo,|,link,unlink,anchor,image,help,code, spellchecker",
        theme_advanced_buttons3_add: "fullpage",
        theme_advanced_buttons4: "",
        theme_advanced_toolbar_location: "top",
        theme_advanced_toolbar_align: "left",
        theme_advanced_statusbar_location: "bottom",
        theme_advanced_resizing: true,
        add_form_submit_trigger: false,
        theme_advanced_path: false,
        spellchecker_languages: "+English=en-AU",
        spellchecker_rpc_url: "/rasp6/jazzy-spellchecker",
        content_css: "css/content.css",
        template_external_list_url: "lists/template_list.js",
        external_link_list_url: "lists/link_list.js",
        external_image_list_url: "lists/image_list.js",
        media_external_list_url: "lists/media_list.js",
        fullpage_default_title: "Springboard Announcement",
        relative_urls: false,
        remove_script_host: false,
        convert_urls: false,
        invalid_elements: "script,javascript,expression,embed,object",
        style_formats: [{ title: 'Bold text', inline: 'b' }, { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } }, { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } }, { title: 'Example 1', inline: 'span', classes: 'example1' }, { title: 'Example 2', inline: 'span', classes: 'example2' }, { title: 'Table styles' }, { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' }]
    };
    var defaultFinder = function defaultFinder() {
        return true;
    };

    /**
     * Remove a tinymce editor from the page environment.
     * tinymce.remove (at least up to 3.5.11) does not remove the editor from editors array.
     * We need to do it manually. -- DD 31/03/2016 11:20:04 am
     */
    HRX.removeTinyMCEInstance = function (editor) {
        var oldLength = tinymce.editors.size();
        tinymce.remove(editor);
        if (oldLength === tinymce.editors.size()) {
            tinymce.editors.remove(editor);
        }
    };

    HRX.initTinyMCE = function (selector, options, finder) {
        if (!finder) finder = defaultFinder;
        tinymce.editors.filter(finder).each(function (e) {
            try {
                HRX.removeTinyMCEInstance(e);
            } catch (err) {
                LOG.error(err);
            }
        });
        var opt = jQuery.extend(true, {}, defaultOptions, options, { editor_selector: selector });
        tinymce.init(opt);
    };

    /**
     * Remove tinymce editors for each id group except the last one.
     */
    HRX.cleanUpTinyMCE = function () {
        _.chain(tinymce.editors).groupBy(function (editor) {
            return editor.id;
        }).values().each(function (editors) {
            _.chain(editors).initial().each(function (leakedEditor) {
                try {
                    HRX.removeTinyMCEInstance(leakedEditor);
                } catch (err) {
                    app.console.error(err);
                }
            });
        });
    };
})();

app.registerConstructor("AjaxIndicators", function () {
    window.indicators = {};

    var AjaxIndicator = function AjaxIndicator(opts) {
        var self = this;
        var stopTimer = null;
        this.jqId = opts.jqId;
        this.varName = opts.varName;
        this.holdPlace = opts.holdPlace;
        this.timeout = opts.timeout;
        this.onstart = opts.onstart || _.noop;
        this.onstop = opts.onstop || _.noop;

        function clearStopTimer() {
            if (stopTimer) {
                clearTimeout(stopTimer);
                stopTimer = null;
            }
        }

        /**
         * Start the indicator
         * @param options
         */
        this.start = function (options) {
            clearStopTimer();
            var timeout = options && options.timeout || self.timeout;
            if (timeout && timeout > 0) {
                stopTimer = setTimeout(function () {
                    self.stop();
                }, timeout);
            }
            if (self.holdPlace) {
                $(self.jqId).css("visibility", "visible");
            } else {
                $(self.jqId).css("display", "inline-block");
            }
            self.onstart(self);
        };

        this.stop = function () {
            clearStopTimer();
            if (self.holdPlace) {
                $(self.jqId).css("visibility", "hidden");
            } else {
                $(self.jqId).css("display", "none");
            }
            self.onstop(self);
        };
    };

    /**
     * Creates a ajax indicator js model
     * @param {string} jqId - The client id of the wrapping element
     * @param {string} varName - The unique name to be used to refer the indicator.
     * @param {boolean} holdPlace - Reserve space when the icon is hidden.
     * @param timeout - stop the indicator if it is not explicitly stopped before the timeout in milliseconds.
     */
    this.createIndicator = function (jqId, varName, holdPlace, timeout, onstart, onstop) {
        jqId = jqId.replace(/:/g, "\\:");
        window.indicators[varName] = new AjaxIndicator({
            jqId: jqId,
            varName: varName,
            holdPlace: holdPlace,
            timeout: timeout,
            onstart: _.isString(onstart) ? new Function('vm', onstart) : null,
            onstop: _.isString(onstop) ? new Function('vm', onstop) : null
        });
    };
}).createVM();

//TK VIC JOBS BOARDS WCAGE fix 12/07/2023
function frontendPortlet() {
    mobileMenu();

    $('form.candidate-profile-tab-form').attr('role', 'presentation');
    $('#candidateProfileUploaderId').attr('role', 'presentation');

    //remove aria-describedby fron div and input
    $("div[aria-describedby],input[aria-describedby]").each(function () {
        $(this).removeAttr("aria-describedby");
    });

    //add some text for read
    $("input.uppy-Dashboard-input").each(function () {
        $(this).attr("aria-label", "Drag & Drop Files Here or browse");
    });

    $("input.ui-inputfield").each(function () {
        if (!$(this).is(':visible')) {
            $(this).attr("aria-label", "hidden input");
        }
    });
    $(".ui-selectonemenu-trigger").each(function () {
        if (!$(this).is(':visible')) {
            $(this).attr("aria-label", "hidden input");
        }
    });

    //add placeholder for date formet
    $("input[id*='p_dateOfBirth_input']").attr("placeholder", "DD-MMM-YYYY");

    //add tabindx on headings for focus    
    $("h1,h4,h3, #privacy-section-heading").attr("role", "heading");
    $(".panel-title").removeAttr("aria-hidden");
    $('.formio-component-select .form-control[tabindex="0"] select[tabindex="-1"]').each(function () {
        $(this).closest('.formio-component-select').find('.control-label').removeAttr('for');
        $(this).closest('.formio-choices').attr('aria-label', 'button');
        $(this).closest('.formio-choices').removeAttr('role');
        $(this).closest('.form-control[tabindex="0"]').attr('role', 'button');
    });

    //add label and tabindex to select box
    $(".ui-selectonemenu.form-control").each(function () {
        $(this).find('.ui-selectonemenu-trigger').attr('tabindex', '-1');
        $(this).find('.ui-selectonemenu-trigger').attr('aria-hidden', 'true');
    });

    $('.formio-component .input-group .form-control[placeholder="dd/MM/yyyy"]').each(function () {
        var input = $(this);
        var IDdate = input.attr('id');
        if (!IDdate) {
            input.closest('.input-group').find('.form-control').removeAttr('id');
            var IDInput = input.closest('.formio-component').find('.control-label').attr('for');
            input.attr('id', IDInput);
        }
        input.closest('.input-group').find('.fa').attr('aria-hidden', 'true');
        input.closest('.input-group').find('.input-group-addon').attr({
            'tabindex': '0',
            'role': 'button',
            'aria-label': 'Open Calendar'
        });
    });

    setTimeout(function () {
        $(document).keyup(function (e) {
            var activeItem = document.activeElement;

            //add label and tabindex to select box
            $(".ui-selectcheckboxmenu-token.ui-state-active").each(function () {
                var selectcheckboxmenuText = $(this).text();
                $(this).find('.ui-selectcheckboxmenu-token-icon').attr('tabindex', '0');
                $(this).find('.ui-selectcheckboxmenu-token-icon').attr('role', 'button');
                $(this).find('.ui-selectcheckboxmenu-token-icon').attr('aria-label', 'use enter and space for remove ' + selectcheckboxmenuText);
            });

            //any arrow key
            if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) {
                $('.ui-button.ui-state-focus').removeClass('ui-state-focus');
                if ($(activeItem).hasClass('ui-helper-hidden-accessible')) {
                    $(activeItem).parent('.ui-button').addClass('ui-state-focus');
                }
            }

            // enter and space key
            if (e.keyCode == 32 || e.keyCode == 13) {
                setTimeout(function () {
                    if ($('.ui-messages').text().length > 1) {
                        $('.ui-messages').focus();
                    }
                }, 500);

                if ($(activeItem).hasClass('ui-selectcheckboxmenu-token-icon')) {
                    $(activeItem).click();
                }

                if ($(activeItem).hasClass('mdi-trash-can-outline')) {
                    $(activeItem).addClass('ui-dialog-open');
                }

                if ($(activeItem).hasClass('btn-secondary')) {
                    if ($('.ui-dialog').is(':visible')) {
                        $('.ui-dialog-open').focus();
                        $('.ui-dialog-open').removeClass('ui-dialog-open');
                    }
                }

                if ($(activeItem).hasClass('ui-state-default')) {
                    $('input.hasDatepicker-Show').focus();
                    $('input.hasDatepicker-Show').removeClass('hasDatepicker-Show');
                    setTimeout(function () {
                        $('#ui-datepicker-div').hide();
                    }, 200);
                }

                if ($(activeItem).hasClass('btn-back-to-top')) {
                    setTimeout(function () {
                        $(".theme-heading").attr("tabindex", "0").focus();
                    }, 200);
                }

                setTimeout(function () {
                    if ($('.ui-dialog').is(':visible')) {
                        $('.ui-dialog').find(':focusable').first().focus();
                    }

                    if (!$('.ui-dialog').is(':visible')) {
                        $('.ui-dialog-open').focus();
                        $('.ui-dialog-open').removeClass('ui-dialog-open');
                    }
                }, 200);
            }

            // tab key
            if (e.keyCode == 9) {
                if ($(activeItem).hasClass('hasDatepicker')) {
                    $(activeItem).addClass('hasDatepicker-Show');
                    setTimeout(function () {
                        $('#ui-datepicker-div').attr('tabindex', '0');
                        $('#ui-datepicker-div .ui-datepicker-prev').attr('tabindex', '0').focus();
                    }, 200);
                }
            }

            // esc key
            if (e.keyCode == 27) {
                if ($('#ui-datepicker-div').is(':visible')) {
                    $('input.hasDatepicker-Show').focus();
                    $('#ui-datepicker-div').hide();
                    $('input.hasDatepicker-Show').removeClass('hasDatepicker-Show');
                }

                if ($('.ui-dialog-open').length) {
                    setTimeout(function () {
                        $('.ui-dialog-open').focus();
                        $('.ui-dialog-open').removeClass('ui-dialog-open');
                    }, 200);
                }

                if ($('.ui-dialog').is(':visible')) {
                    $('.ui-dialog-open').focus();
                    $('.ui-dialog-open').removeClass('ui-dialog-open');
                    $('.ui-dialog .ui-button[name*="cancelUppyButton"]').click();
                }
            }
        });

        $(document).keydown(function (e) {
            if (e.keyCode == 9) {
                if ($('#ui-datepicker-div').is(':visible')) {
                    if ($('#ui-datepicker-div').has(document.activeElement).length) {
                        var lastFocusDate = $('#ui-datepicker-div').find(':focusable').last();
                        if (document.activeElement === lastFocusDate[0]) {
                            $('#ui-datepicker-div').focus();
                        }
                    } else {
                        $('#ui-datepicker-div').focus();
                    }
                }

                if ($('.ui-dialog').is(':visible')) {
                    var firstDialogLink = $('.ui-dialog').find(':focusable').first();
                    var lastDialogLink = $('.ui-dialog').find(':focusable').last();
                    if (document.activeElement === lastDialogLink[0]) {
                        setTimeout(function () {
                            firstDialogLink.focus();
                        }, 100);
                    }
                }
            }

            if (e.shiftKey && e.keyCode == 9) {
                if ($('#ui-datepicker-div').is(':visible')) {
                    var lastFocusDate = $('#ui-datepicker-div').find(':focusable').last();
                    if ($(document.activeElement).hasClass('ui-datepicker-prev')) {
                        lastFocusDate.focus();
                        setTimeout(function () {
                            lastFocusDate.focus();
                        }, 100);
                    }
                }
            }
        });
    }, 300);
}

function mobileMenu() {
    var isMobile = /Mobi/i.test(navigator.userAgent);
    if (isMobile) {
        $(document).keydown(function (e) {
            if ($('.navbar.navbar-collapse.collapse.in').length) {
                var activeMenuLink = document.activeElement;
                var firstMenuLink = $('.site-header').find(':focusable').first();
                var lastMenuLink = $('.site-header').find(':focusable').last();

                if (e.keyCode == 27) {
                    if ($('.navbar-toggle.active').length) {
                        $('.navbar-toggle.active').click();
                    }
                }

                if (e.keyCode == 9) {
                    if (document.activeElement === lastMenuLink[0]) {
                        firstMenuLink.focus();
                        setTimeout(function () {
                            firstMenuLink.focus();
                        }, 100);
                    }
                }

                if (e.shiftKey && e.keyCode == 9) {
                    if (document.activeElement === firstMenuLink[0]) {
                        lastMenuLink.focus();
                        //                        setTimeout(function () {
                        //                            lastMenuLink.focus();
                        //                        }, 100);
                    }
                }
            }
        });
    }
}

;(function (global, $, undefined) {
    /**
     * View model constructor for Attachment Picker
     */
    app.registerConstructor("AttachmentPickerCtrl", function (opts) {
        var self = this;
        this.expended = ko.observable(opts.expended);
        this.hasApplForm = ko.observable(opts.hasApplForm);
        this.fileLimit = opts.fileLimit;
        this.attachmentCount = ko.observable(opts.attachmentCount);
        this.uploaderVM = null;

        this.toggleLinkLabel = ko.pureComputed(function () {
            var expended = this.expended();
            return expended ? opts.Messages.Hide : opts.Messages.AddMore;
        }, this);

        this.toggleExpended = function () {
            self.expended(!self.expended());
        };

        this.hasAttachment = ko.pureComputed(function () {
            return this.attachmentCount() > 0;
        }, this);

        this.tooManyAttachment = ko.pureComputed(function () {
            return this.attachmentCount() >= this.fileLimit;
        }, this);

        this.updateAttachmentState = function (data) {
            if (data) {
                if (data.count !== undefined) this.attachmentCount(data.count);
                this.hasApplForm(data.hasApplForm);
            }
        };
        this.attachmentCount.subscribe(function (newValue) {
            if (this.uploaderVM) {
                this.uploaderVM.setUploaderDocumentCount(newValue);
            }
        }, this);
    });

    /**
     * View model constructor for Local File Uploader
     */
    app.registerConstructor("LocalFileUploaderCtrl", function (opts) {
        var self = this;
        this.isShowListHeader = ko.observable(true);
        this.selector = opts.selector || 'none';
        this.autoSelectStrategy = opts.autoSelectStrategy || 'none';
        this.selectedDocumentNames = ko.observable("");

        function initDoc(doc) {
            if (!doc.docType) doc.docType = "";
            if (!doc.notes) doc.notes = "";
            if (!doc.userName) doc.userName = "";
            if (!doc.createdDate) doc.createdDate = "";

            doc.editing = !doc.docType;
            doc.newNotes = doc.notes;
            doc.newDocType = doc.docType;
            doc.selected = false;
        }

        ko.utils.arrayForEach(opts.documents, function (doc) {
            initDoc(doc);
        });

        this.onSelectItem = function (doc) {
            if (self.selector === 'radio') {
                _.each(_.filter(self.documents(), function (d) {
                    return d !== doc;
                }), function (d) {
                    return d.selected(false);
                });
            }
            self.updateSelectedDocumentNames();
            return true;
        };

        this.updateSelectedDocumentNames = function () {
            self.selectedDocumentNames(_(self.documents()).filter(function (d) {
                return d.selected();
            }).map(function (d) {
                return d.name();
            }).join(","));
        };

        this.getSelectedDocumentIds = function () {
            return _(self.documents()).filter(function (d) {
                return d.selected();
            }).map(function (d) {
                return d.id();
            });
        };

        /**
         * update uploadedFileCount for the primefaces uploader
         */
        this.setUploaderDocumentCount = function (count) {
            var w = PF(opts.uploaderWigetVar);
            if (w) {
                PF(opts.uploaderWigetVar).uploadedFileCount = count;
            } else {
                app.console.error("PF('" + opts.uploaderWigetVar + "') is undefined. ");
            }
        };

        this.__init__ = function () {
            $("div#uploadedDocumentList").find("tr:not(:visible)").show();
            app.vm.Global.runWhen(function () {
                self.setUploaderDocumentCount(self.documents().length);
            }, function () {
                return PF(opts.uploaderWigetVar);
            }, 40);
        };

        /**
         * Uploaded document list
         */
        /* ko.mapping.fromJS turns the plain JS array into an arrayObservable and also
         * turns the properties on each element into observables*/
        this.documents = ko.mapping.fromJS(opts.documents);

        /**
         * Options of document type dropdown
         */
        this.docTypes = opts.docTypes;

        /**
         * Document properties for the next upload
         */
        this.newUploadProperties = {
            docType: ko.observable(""),
            notes: ko.observable("")
        };

        /**
         * Maximum numbers of file can be uploaded
         */
        this.fileLimit = opts.fileLimit;

        /**
         * Whether the number of uploaded file reaches the fileLimit
         */
        this.isReachLimit = ko.pureComputed(function () {
            return this.documents().length >= this.fileLimit;
        }, this);

        /**
         * Whether a document item is valid to be saved
         */
        this.canSave = function (doc) {
            return (doc.newDocType() !== doc.docType() || doc.newNotes() !== doc.notes()) && doc.newDocType() !== '';
        };

        /**
         *  Controls whether to show additional properties. e.g. Notes and File type.
         * @type {boolean}
         */
        this.showFilePropertyFields = opts.showFilePropertyFields;

        /**
         * To remove a document item. This function invokes the p:remoteCommand stub to fire an ajax submission.
         */
        this.remove = function (doc) {
            if (confirm && !confirm(doc.name() + ' is going to be deleted. Are you sure?')) {
                return;
            }
            if (doc.selected()) {
                self.updateSelectedDocumentNames();
            }
            remoteRemoveDocument([{ name: "docId", value: doc.id() }, { name: "hash", value: doc.hash() }]);
        };

        /**
         * Callback when the removal ajax submission completed. This function updates the document view model based on the result.
         */
        this.onRemoveComplete = function (args) {
            if (args && args.success) {
                var id = args.docId;
                var docItem = self.findDocById(id);
                if (docItem) {
                    self.documents.remove(docItem);
                    self.setUploaderDocumentCount(self.documents().length);
                    if (docItem.selected()) {
                        self.selectedDocumentNames("");
                    }
                    self.enableUploader();
                }
            }
        };

        this.enableUploader = function () {
            var uploader = PF(opts.uploaderWigetVar);
            uploader.enableButton(uploader.chooseButton);
            uploader.chooseButton.find('input[type="file"]').removeAttr('disabled');
        };

        this.disableUploader = function () {
            var uploader = PF(opts.uploaderWigetVar);
            uploader.disableButton(uploader.chooseButton);
            uploader.chooseButton.find('input[type="file"]').attr('disabled', 'disabled');
        };

        /**
         * View document content in a new window
         */
        this.open = function (doc) {
            window.open(doc.url(), 'documentsPopup', 'resizable=yes,scrollbars=yes,toolbar=no ');
        };

        /**
         * Highlight the last modified item
         */
        this.highlightDoc = function (id, color, delay) {
            if (!color) color = '#dff0d8';
            if (!delay) delay = 500;
            $("tr#doc-" + id).css({ 'background-color': color });
            setTimeout(function () {
                $("tr#doc-" + id).animate({ 'background-color': '#fff' }, 800, function () {
                    $("tr#doc-" + id).css("background-color", "");
                });
            }, delay);
        };

        function autoSelect(newDoc) {
            var shouldSelect = false;
            if (self.selector !== "none") {
                if (self.autoSelectStrategy === 'first') {
                    if (self.documents().length === 1) {
                        shouldSelect = true;
                    }
                } else if (self.autoSelectStrategy === 'notEmpty') {
                    if (self.getSelectedDocumentIds().length === 0) {
                        shouldSelect = true;
                    }
                } else if (self.autoSelectStrategy === 'last') {
                    shouldSelect = true;
                }
            }
            if (shouldSelect) {
                newDoc.selected(true);
                self.onSelectItem(newDoc);
            }
        }

        /**
         * Callback when an upload submission is completed. It updates the view model based on ajax result.
         */
        this.onUploadComplete = function (args) {
            if (args && args.success) {
                var doc = args.doc;
                initDoc(doc);
                //ko.mapping.fromJS turns the properties on doc into observables
                var newDoc = ko.mapping.fromJS(doc);
                self.documents.push(newDoc);
                self.newUploadProperties.notes("");
                self.highlightDoc(doc.id);
                autoSelect(newDoc);
            }

            //always update document count
            self.setUploaderDocumentCount(self.documents().length);
        };

        /**
         * Utility function to find a document item by its id
         */
        this.findDocById = function (id) {
            return ko.utils.arrayFirst(self.documents(), function (item) {
                return item.id() == id; //Use == on purpose
            });
        };

        /**
         * Exit edit mode without saving
         */
        this.cancelEdit = function (doc) {
            if (!doc.editing()) return;
            if (doc.docType() === "") {
                alert("Please specify a document type.");
                return;
            }
            if (self.canSave(doc)) {
                if (confirm && !confirm('Your change will be lost. Are you sure?')) {
                    return;
                }
            }
            self.exitEdit(doc);
            self.highlightDoc(doc.id(), null, 200);
        };

        /**
         * Save user inputed file properties
         */
        this.saveEdit = function (doc) {
            if (doc.newDocType() === "") {
                alert("Please specify a document type.");
                return;
            }
            if (self.canSave(doc)) {
                remoteSaveDocumentInfo([{ name: 'docId', value: doc.id() }, { name: 'hash', value: doc.hash() }, { name: 'docType', value: doc.newDocType() }, { name: 'notes', value: doc.newNotes() }]);
            }
        };

        /**
         * Callback when file properties has been saved. It updates the view model based on ajax result.
         */
        this.onSaveInfoComplete = function (args) {
            if (args) {
                var id = args.docId;
                var doc = self.findDocById(id);
                if (!doc) return;
                if (args.success) {
                    doc.docType(doc.newDocType());
                    doc.notes(doc.newNotes());
                    self.exitEdit(doc);
                    self.highlightDoc(id);
                } else {
                    self.highlightDoc(id, '#FFBABA', 200);
                }
            }
        };

        /**
         * Enter edit mode for a document item
         */
        this.enterEdit = function (doc) {
            if (doc.editing()) return;
            doc.newDocType(doc.docType());
            doc.newNotes(doc.notes());
            var $docNote = $('textarea#docNotes-' + doc.id());
            $docNote.height($('div#docNotesSpan-' + doc.id()).height());
            doc.editing(true);
            if ($docNote.height() < 100) {
                $docNote.stop().animate({ height: 100 }, 200);
            }
        };

        /**
         * Exit edit mode for a document item
         */
        this.exitEdit = function (doc) {
            if (!doc.editing()) return;
            var noteSpan = $('div#docNotesSpan-' + doc.id());
            var textarea = $('textarea#docNotes-' + doc.id());
            if (noteSpan.height() > 0 && textarea.height() > noteSpan.height()) {
                textarea.stop().animate({ height: noteSpan.height() }, 200, function () {
                    doc.editing(false);
                });
            } else {
                doc.editing(false);
            }
        };

        // Animation callbacks for the document list
        this.showItemAnimation = function (elem) {
            if (elem.nodeType === 1) {
                var el = $(elem);
                el.css({ 'background-color': '#d4edda' });
                setTimeout(function () {
                    el.animate({ 'background-color': '#fff' }, 800, function () {
                        el.css("background-color", "");
                    });
                }, 500);
            }
        };

        this.removeItemAnimation = function (elem) {
            if (elem.nodeType === 1) {
                $(elem).fadeOut(function () {
                    $(elem).remove();
                });
            }
        };

        //Attach drag-and-drop indication event
        (function () {
            $(document).on('dragover dragenter', function () {
                $("div.raspDragAndDropUploader div.ui-fileupload.ui-widget").addClass('is-dragover');
            }).on('dragleave dragend drop', function () {
                $("div.raspDragAndDropUploader div.ui-fileupload.ui-widget").removeClass('is-dragover');
            });
        })();
    });
})(window, jQuery);

;(function ($, undefined) {
    /**
     * View model constructor for Attachment Picker
     */
    app.registerConstructor("CandidateProfile", function (opts) {
        var self = this;
        this.__init__ = function () {
            //init fonts for CVMessageResizer
            var resizer = $("#CVMessageResizer"),
                CVMField = $("textarea.CVMessage");
            resizer.css({
                position: 'absolute',
                top: -10000,
                left: -10000,
                width: CVMField.width() - parseInt(CVMField.css('paddingLeft')) - parseInt(CVMField.css('paddingRight')),
                fontSize: CVMField.css('fontSize'),
                fontFamily: CVMField.css('fontFamily'),
                lineHeight: CVMField.css('lineHeight'),
                resize: 'none'
            }).show();
        };
        this.noteLengthLimit = ko.observable(4000);
        this.$$FORM_SELECTOR = "form.candidate-profile-tab-form";
        this.mandatoryInfo = ko.observable("");
        this.form = {};
        _.each(opts.form, function (field) {
            self.form[field] = ko.observable();
        });
        this.form.foreignState = ko.observable();
        this.fields = ko.viewmodel.fromModel(opts.fields);
        if (this.form.website1) this.form.website1 = this.form.website1.extend({ url: "http" });
        if (this.form.website2) this.form.website2 = this.form.website2.extend({ url: "http" });
        this.style = {
            fieldWidth: ko.observable(270)
        };

        this.__resize__ = function () {
            var fieldWidth = Math.min($("#rasp_profile_tmpl").width() / 2 - 20, 270);
            self.style.fieldWidth(fieldWidth);
            $("div.select2-container").css("min-width", fieldWidth + "px");
            $(".inputfield").css("width", fieldWidth + "px");
        };

        this.canSubmit = function () {
            if ($(self.$$FORM_SELECTOR).validationEngine("validate")) {
                return true;
            } else {
                app.vm.Global.showClientMessage({ summary: "Please correct the invalid fields before submit.", severity: "error" });
                return false;
            }
        };
        this.updateBackup = function () {
            self.formBackup = ko.toJS(self.form);
            if (PF('uiDateAvailable')) {
                self.formBackup.dateAvailable = PF('uiDateAvailable').getDate();
            }
        };
        this.reset = function (data, event) {
            for (var p in self.formBackup) {
                if (self.formBackup.hasOwnProperty(p) && self.form.hasOwnProperty(p)) {
                    self.form[p](self.formBackup[p]);
                }
            }

            //reset complex components
            $("select.prefEmpType").select2("val", self.formBackup.employmentTypes);
            $("select.prefLocation").select2("val", self.formBackup.preferLocations);
            if (PF('uiDateAvailable')) {
                PF('uiDateAvailable').setDate(self.formBackup.dateAvailable);
            }

            app.vm.Global.showClientMessage({ summary: "Form has been reset.", severity: "info" });
            event && event.stopPropagation();
        };
        this.form.CVMessage.subscribe(function (newValue) {
            function times(string, number) {
                for (var i = 0, r = ''; i < number; i++) {
                    r += string;
                }return r;
            }
            _.find(this.__elements__, function (root) {
                var el = $(root).find("textarea.CVMessage");
                var h = el.height();
                var resizer = $("div#CVMessageResizer");
                if (resizer.width() != el.width()) resizer.width(el.width());
                var val = newValue.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/\n$/, '<br/>&nbsp;').replace(/\n/g, '<br/>').replace(/ {2,}/g, function (space) {
                    return times('&nbsp;', space.length - 1) + ' ';
                });
                resizer.html(val);
                var realH = resizer.height();
                if (h != realH) {
                    el.height(Math.max(realH + 20, 100));
                }
            });
        }, this);

        this.updateCurrentSalaryFromSlider = function (event, ui) {
            self.form.currentSalary(ui.value);
        };

        this.updateDesiredSalaryFromSlider = function (event, ui) {
            self.form.desiredSalary(ui.value);
        };

        this.customMultiCheckboxMenu = function (pfWidgetId, maxSize) {
            setTimeout(function () {

                var innerHelperList = $(PF(pfWidgetId).label.prevObject[0]).find('div.ui-helper-hidden');
                var selected = PF(pfWidgetId).getJQ().find(':checked').not('[readonly="readonly"]').map(function () {
                    return $(this);
                }).get();

                if (selected && selected.length > 0) {
                    var innerContainerList = $(PF(pfWidgetId).label.prevObject[0]).find('ul.ui-selectcheckboxmenu-multiple-container');

                    if (selected.length > maxSize) {
                        var listSize = selected.length;
                        innerContainerList[0].innerHTML = '<li class=\ "ui-selectcheckboxmenu-token ui-state-active ui-corner-all\" data-item-value=\ "' + listSize + ' Items Selected' + '\"> <span class=\ "ui-selectcheckboxmenu-token-label\">' + listSize + ' Items Selected' + '</span> </li>';
                    } else {

                        var selectedLabels = [];
                        $(selected).each(function () {
                            selectedLabels.push([$(this)[0].id, $(this)[0].value]);
                        });

                        var newContent = '';

                        $(selectedLabels).each(function () {
                            newContent += ' <li class=\ "ui-selectcheckboxmenu-token ui-state-active ui-corner-all\" data-item-value=\ "' + this[1] + '\">' + '<span class=\ "ui-selectcheckboxmenu-token-icon ui-icon ui-icon-close\"></span>' + '<span class=\ "ui-selectcheckboxmenu-token-label\">' + $(innerHelperList).find('input[id="' + this[0] + '"]')[0].value + '</span>' + ' </li> ';
                        });

                        innerContainerList[0].innerHTML = newContent;
                    }
                } else {
                    var title = PF(pfWidgetId).jq.attr("title");
                    var children = $(PF(pfWidgetId).jqId).children('.ui-selectcheckboxmenu-multiple-container');
                    if (children.text() == "") {
                        $(children)[0].innerHTML = '<li class="LABEL_TITLE_' + pfWidgetId + '">' + 'Please select...' + '</li>';
                    }
                }
            }, 0);
        };
    });
})(jQuery);

app.registerConstructor('CandidateFrontend', function () {

    this.resetUserExistsMessage = function () {
        setTimeout(function () {
            resetUserExists();
        }, 500);
    };

    this.displayForgotPasswordLink = function () {
        if (jQuery('#forgottenPwd').length === 1) {
            jQuery("#legacyPasswordResetLink").css("display", "none");
            jQuery("#modalPasswordResetLink").css("display", "inline-block");
        }
    };
});
app.createVM('CandidateFrontend');

;(function ($, undefined) {
    /**
     * View model constructor for Candidate Skills
     */
    app.registerConstructor("CandidateSkills", function () {
        var self = this;
        //To be initialized in page
        self.parentLoadingIcon = ko.observable();

        //To be initialized in page
        self.sid = {
            rasp: ko.observable(),
            company: ko.observable()
            //To be initialized in page
        };self.filterVisible = {
            competencies: ko.observable(true),
            qualifications: ko.observable(true),
            companies: ko.observable(true),
            talentManagement: ko.observable(true),
            boards: ko.observable(true)

            //To be initialized in page
        };self.resourcePath = ko.observable("");

        self.safeParentLoadingIcon = ko.pureComputed(function () {
            return self.parentLoadingIcon() || {
                show: _.noop,
                hide: _.noop
            };
        });

        self.workHistoryModal = {
            frameSrc: ko.observable(""),
            onHide: function onHide() {
                self.workHistoryModal.frameSrc("about:blank");
                self.modal.blockUI(false);
            },
            onShow: function onShow() {
                self.modal.blockUI(true);
            }
        };
        self.workHistoryModal.frameSrc.subscribe(function (newValue) {
            if (app.utils.trimString(newValue) && newValue != "about:blank") {
                try {
                    $('#editWorkHistoryFrame').squirt('<h4 style="text-align: center;font-family:arial;font-size:12px"> Loading ...</h4>');
                } catch (ignored) {}
            }
        });

        self.modal = {
            blockUI: ko.observable(false),
            reposition: function reposition(widget) {
                if (widget.jq) {
                    widget = widget.jq;
                } else {
                    widget = $(widget);
                }
                widget.css("top", ~~($(document).scrollTop() + $(window).height() / 2) - widget.height() / 2);
            }
        };

        self.openMailTo = function (e) {
            var email = "support@springboard.com.au";
            var subject = "Springboard upgrade request - Populate from Resume";
            var mailto_link = 'mailto:' + email + '?subject=' + subject;
            var body_message = "Hi,%0A%0AI would like to upgrade our Springboard account to include the 'Populate from Resume' module.%0A%0AThanking you";
            var mailto_link = 'mailto:' + email + '?subject=' + subject + '&body=' + body_message;
            win = window.open(mailto_link, 'emailWindow');
            if (win && win.open && !win.closed) win.close();
            e.preventDefault();
            return false;
        };

        self.repositionPaginationIcon = function () {
            $('.companiesPanel .companiesTable .ui-paginator-prev').css('top', $('.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);
            $('.companiesPanel .companiesTable .ui-paginator-next').css('top', $('.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);

            $('.qualificationsPanel .qualificationsTable .ui-paginator-prev').css('top', $('.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);
            $('.qualificationsPanel .qualificationsTable .ui-paginator-next').css('top', $('.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);

            $('.competenciesPanel .competenciesTable .ui-paginator-prev').css('top', $('.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);
            $('.competenciesPanel .competenciesTable .ui-paginator-next').css('top', $('.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);

            $('.boardsPanel .boardsTable .ui-paginator-prev').css('top', $('.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
            $('.boardsPanel .boardsTable .ui-paginator-next').css('top', $('.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
        };

        self.showHideFilters = function (sectionName) {
            if (sectionName == 'competenciesPanel') {
                if (self.filterVisible.competencies()) {
                    //Show filter if checked
                    $("." + sectionName + " .ui-column-filter").css("display", "block");
                    self.updateNav(sectionName);
                } else {
                    //Hide & clear filter if unchecked
                    $("." + sectionName + " .ui-column-filter").css("display", "none");
                    self.updateNav(sectionName);
                }
            }

            if (sectionName == 'qualificationsPanel') {
                if (self.filterVisible.qualifications()) {
                    //Show filter if checked
                    $("." + sectionName + " .ui-column-filter").css("display", "block");
                    self.updateNav(sectionName);
                } else {
                    //Hide & clear filter if unchecked
                    $("." + sectionName + " .ui-column-filter").css("display", "none");
                    self.updateNav(sectionName);
                }
            }

            if (sectionName == 'companiesPanel') {
                if (self.filterVisible.companies()) {
                    //Show filter if checked
                    $("." + sectionName + " .ui-column-filter").css("display", "block");
                    self.updateNav(sectionName);
                } else {
                    //Hide & clear filter if unchecked
                    $("." + sectionName + " .ui-column-filter").css("display", "none");
                    self.updateNav(sectionName);
                }
            }
            if (sectionName == 'boardsPanel') {

                if (self.filterVisible.boards()) {

                    //Show filter if checked
                    $("." + sectionName + " .ui-column-filter").css("display", "block");
                    self.updateNav(sectionName);
                } else {

                    //Hide & clear filter if unchecked
                    $("." + sectionName + " .ui-column-filter").css("display", "none");
                    self.updateNav(sectionName);
                }
            }

            if (sectionName == 'talentManagementPanel') {
                if (self.filterVisible.talentManagement()) {
                    //Show filter if checked
                    $("." + sectionName + " .ui-column-filter").css("display", "block");
                    self.updateNav(sectionName);
                } else {
                    //Hide & clear filter if unchecked
                    $("." + sectionName + " .ui-column-filter").css("display", "none");
                    self.updateNav(sectionName);
                }
            }
        };

        self.cancelEditWorkHistoryRow = function () {
            PF('editWorkHistoryModal').hide();
        };

        self.saveEditWorkHistoryRow = function () {
            self.ajaxStarted();
        };

        self.ajaxStarted = function (opts) {
            self.safeParentLoadingIcon().show("", opts);
        };

        self.ajaxFinished = function () {
            self.safeParentLoadingIcon().hide();
        };

        self.finishEditWorkHistoryRow = function (msg) {
            remoteRefreshCompanyRelationships([{
                name: 'message',
                value: msg
            }]);
            PF('editWorkHistoryModal').hide();
        };

        self.showEditWorkHistoryRow = function (rowId) {
            self.workHistoryModal.frameSrc("/rasp-companies/includes/companies/contact/edit-relationship.seam;jsessionid=" + self.sid.company() + "?sessionId=" + self.sid.rasp() + "&from=tab&rId=" + rowId);
            PF('editWorkHistoryModal').show();
        };

        self.showAddWorkHistoryRow = function (candId) {
            self.workHistoryModal.frameSrc("/rasp-companies/includes/companies/contact/edit-relationship.seam;jsessionid=" + self.sid.company() + "?sessionId=" + self.sid.rasp() + "&from=tab&candId=" + candId);
            PF('editWorkHistoryModal').show();
        };

        self.updateCompNav = function () {
            $('.companiesPanel .companiesTable .ui-paginator-prev').css('top', $('.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);
            $('.companiesPanel .companiesTable .ui-paginator-next').css('top', $('.companiesPanel .companiesTable .ui-datatable-tablewrapper').height() / 2);
        };

        self.showActionButtons = function () {
            $('.actionButtons').css("display", "inline-block");
            $('body').find('td.actions .ui-icon-pencil').css("display", "inline-block");
        };

        self.hideActionButtons = function () {
            $('.actionButtons').css("display", "none");
            $('body').find('td.actions .ui-icon-pencil').css("display", "none");
        };

        self.showEditCompetency = function () {
            $('#competenciesForm\\:competenciesPanel\\:competencies\\:0\\:competenciesRowEditor').find('span.ui-icon-pencil').each(function () {
                $(this).click();
            });
        };

        self.updateNav = function (section) {
            if (section == 'competenciesPanel') {
                $('.competenciesPanel .competenciesTable .ui-paginator-prev').css('top', $('.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);
                $('.competenciesPanel .competenciesTable .ui-paginator-next').css('top', $('.competenciesPanel .competenciesTable .ui-datatable-tablewrapper').height() / 2);
            }

            if (section == 'boardsPanel') {
                $('.boardsPanel .boardsTable .ui-paginator-prev').css('top', $('.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
                $('.boardsPanel .boardsTable .ui-paginator-next').css('top', $('.boardsPanel .boardsTable .ui-datatable-tablewrapper').height() / 2);
            }

            if (section == 'qualificationsPanel') {
                $('.qualificationsPanel .qualificationsTable .ui-paginator-prev').css('top', $('.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);
                $('.qualificationsPanel .qualificationsTable .ui-paginator-next').css('top', $('.qualificationsPanel .qualificationsTable .ui-datatable-tablewrapper').height() / 2);
            }

            if (section == 'companiesPanel') {
                $('.companiesPanel .relationshipsTable .ui-paginator-prev').css('top', $('.companiesPanel .relationshipsTable .ui-datatable-tablewrapper').height() / 2);
                $('.companiesPanel .relationshipsTable .ui-paginator-next').css('top', $('.companiesPanel .relationshipsTable .ui-datatable-tablewrapper').height() / 2);
            }
        };

        self.hideAllFiltersOnLoad = function () {
            $(document).ready(function () {
                //Hide all filters on page load
                $(".ui-column-filter").css("display", "none");
                $('.competenciesShowLess').css("display", "none");
                $('.boardsShowLess').css("display", "none");
                $('.qualificationsShowLess').css("display", "none");
                $('.relationshipsShowLess').css("display", "none");
                $('.talentManagementShowLess').css("display", "none");
            });
        };

        function setPagenater(select, number) {
            if (!_.find(select.find('option').map(function (i, e) {
                return e.value;
            }).toArray(), function (e) {
                return e == number;
            })) {
                number = select.find('option').last().val();
            }
            select.val(number).change();
        }

        self.update = function (section, number) {
            if (section == 'competencies') {
                setPagenater($('.competenciesTable select.ui-paginator-rpp-options'), number);
                if (number == 5) {
                    $('.competenciesShowLess').css("display", "none");
                    $('.competenciesShowMore').css("display", "block");
                } else {
                    $('.competenciesShowMore').css("display", "none");
                    $('.competenciesShowLess').css("display", "block");
                }
            }

            if (section == 'talentManagement') {
                setPagenater($('.talentManagementTable select.ui-paginator-rpp-options'), number);
                if (number == 5) {
                    $('.talentManagementShowLess').css("display", "none");
                    $('.talentManagementShowMore').css("display", "block");
                } else {
                    $('.talentManagementShowMore').css("display", "none");
                    $('.talentManagementShowLess').css("display", "block");
                }
            }

            if (section == 'boards') {
                setPagenater($('.boardsTable select.ui-paginator-rpp-options'), number);
                if (number == 5) {
                    $('.boardsShowLess').css("display", "none");
                    $('.boardsShowMore').css("display", "block");
                } else {
                    $('.boardsShowMore').css("display", "none");
                    $('.boardsShowLess').css("display", "block");
                }
            }

            if (section == 'qualifications') {
                setPagenater($('.qualificationsTable select.ui-paginator-rpp-options'), number);
                if (number == 5) {
                    $('.qualificationsShowLess').css("display", "none");
                    $('.qualificationsShowMore').css("display", "block");
                } else {
                    $('.qualificationsShowMore').css("display", "none");
                    $('.qualificationsShowLess').css("display", "block");
                }
            }

            if (section == 'relationships') {
                setPagenater($('.relationshipsTable select.ui-paginator-rpp-options'), number);
                if (number == 5) {
                    $('.relationshipsShowLess').css("display", "none");
                    $('.relationshipsShowMore').css("display", "block");
                } else {
                    $('.relationshipsShowMore').css("display", "none");
                    $('.relationshipsShowLess').css("display", "block");
                }
            }
        };

        self.addIconTitle = function () {
            $('.ui-icon-check').attr("title", "Save");
            $('.ui-icon-close').attr("title", "Cancel");
        };

        self.attachExpandAction = function () {

            if (!$('.expandcollapse').prop('actionBound')) {

                $('.expandcollapse').prop('actionBound', true).click(function () {
                    self.onExpandCollapseExperienceClick($(this));
                });
            }
        };

        self.onExpandCollapseExperienceClick = function (source) {
            if ($(source).hasClass('competency')) {
                self.expandCollapseExperience(source, 'competenciesPanel');
            }

            if ($(source).hasClass('boards')) {

                self.expandCollapseExperience(source, 'boardsPanel');
            }

            if ($(source).hasClass('qualification')) {
                self.expandCollapseExperience(source, 'qualificationsPanel');
            }

            if ($(source).hasClass('relationship')) {
                self.expandCollapseExperience(source, 'companiesPanel');
            }

            if ($(source).hasClass('talentManagement')) {
                self.expandCollapseExperience(source, 'talentManagementPanel');
            }
        };

        self.expandCollapseExperience = function (elm, section) {
            var panelName = section;

            if ($(elm).hasClass('expanded')) {
                $(elm).removeClass('expanded');
                $('.' + panelName).removeClass('expanded');

                $('.alert').css("display", "block");
                $('.upgrade').css("display", "none");

                if (panelName == 'competenciesPanel') {
                    self.update('competencies', 5);
                    $('.qualificationsPanel').css("display", "block");
                    $('.companiesPanel').css("display", "block");
                    $('.boardsPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
                }
                if (panelName == 'qualificationsPanel') {
                    self.update('qualifications', 5);
                    $('.competenciesPanel').css("display", "block");
                    $('.companiesPanel').css("display", "block");
                    $('.boardsPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
                }
                if (panelName == 'companiesPanel') {
                    self.update('relationships', 5);
                    $('.competenciesPanel').css("display", "block");
                    $('.qualificationsPanel').css("display", "block");
                    $('.boardsPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
                }
                if (panelName == 'boardsPanel') {
                    self.update('boards', 5);
                    $('.competenciesPanel').css("display", "block");
                    $('.qualificationsPanel').css("display", "block");
                    $('.companiesPanel').css("display", "block");
                    $('.talentManagementPanel').css("display", "block");
                }
                if (panelName == 'talentManagementPanel') {
                    self.update('talentManagement', 5);
                    $('.competenciesPanel').css("display", "block");
                    $('.qualificationsPanel').css("display", "block");
                    $('.companiesPanel').css("display", "block");
                    $('.boardsPanel').css("display", "block");
                }
                $('.' + panelName).css("width", "100%").css("left", "").css("right", "").css("padding-left", "");

                if ($('.' + panelName).find('table thead th').hasClass('filterEnabled')) {
                    $('.' + panelName + ' .ui-column-filter').css("display", "inline-block");
                } else {
                    $('.' + panelName + ' .ui-column-filter').css("display", "none");
                }
                $(elm).attr("src", self.resourcePath() + "/includes/modules/images/expand.png");
                $(elm).attr("title", "Expand");
            } else {
                $(elm).addClass('expanded');

                $('.alert').css("display", "none");
                $('.upgrade').css("display", "none");

                if (panelName == 'competenciesPanel') {
                    remoteRefreshCompetency();
                    $('.qualificationsPanel').css("display", "none");
                    $('.companiesPanel').css("display", "none");
                    $('.boardsPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
                }
                if (panelName == 'boardsPanel') {
                    remoteRefreshCompetency();
                    $('.qualificationsPanel').css("display", "none");
                    $('.companiesPanel').css("display", "none");
                    $('.competenciesPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
                }
                if (panelName == 'qualificationsPanel') {
                    remoteRefreshQualification();
                    $('.competenciesPanel').css("display", "none");
                    $('.companiesPanel').css("display", "none");
                    $('.boardsPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
                }
                if (panelName == 'companiesPanel') {
                    remoteRefreshCompany();
                    $('.competenciesPanel').css("display", "none");
                    $('.qualificationsPanel').css("display", "none");
                    $('.boardsPanel').css("display", "none");
                    $('.talentManagementPanel').css("display", "none");
                }
                if (panelName == 'talentManagementPanel') {
                    remoteRefreshTalentManagement();
                    $('.qualificationsPanel').css("display", "none");
                    $('.companiesPanel').css("display", "none");
                    $('.boardsPanel').css("display", "none");
                    $('.competenciesPanel').css("display", "none");
                }

                $('.' + panelName).css("left", "0").css("right", "0").css("padding-left", "4px").css("width", "98.6%").addClass('expanded');

                if ($('.' + panelName).find('table thead th').hasClass('filterEnabled')) {
                    $('.' + panelName + ' .ui-column-filter').css("display", "inline-block");
                } else {
                    $('.' + panelName + ' .ui-column-filter').css("display", "none");
                }
                $(elm).attr("src", self.resourcePath() + "/includes/modules/images/collapse.png");
                $(elm).attr("title", "Collapse");
            }
        };

        self.closeAddCompetenciesOverlayPanel = function () {
            if (!$('#competenciesForm\\:competenciesPanel\\:competenciesInputTable').find('span.ui-message-error-detail').is(":visible")) {
                PF('addCompetenciesOverlayPanel').hide();
            }
        };

        self.closeAddTalentDetailOverlayPanel = function () {
            if (!$('#detailTalentCreatorForm\\:talentInputTable').find('span.ui-message-error-detail').is(":visible")) {
                PF('addDetailedTalentOverlayPanel').hide();
            }
        };

        self.showEditQualification = function () {
            $('#qualificationsForm\\:qualificationsPanel\\:qualifications\\:0\\:qualificationsRowEditor').find('span.ui-icon-pencil').each(function () {
                $(this).click();
            });
        };

        self.showClearButton = function (rowIndexVar, calFieldId) {
            if ($('button.ui-datepicker-clear').length == 0) {
                $('.ui-datepicker-buttonpane').append('<button class="ui-datepicker-clear ui-state-default ui-priority-primary ui-corner-all" onclick="mainVM.clearDate(' + rowIndexVar + ', &apos;' + calFieldId + '&apos;);">Clear</button>');
            }
        };

        self.clearDate = function (rowIndexVar, calFieldId) {
            var dateField = '#qualificationsForm\\:qualificationsPanel\\:qualifications\\:' + rowIndexVar + '\\:' + calFieldId + '_input';
            $(dateField).val(null);
        };
        self.windowclose = function () {
            if (!$('#qualificationsForm\\:qualificationsPanel\\:qualificationsInputTable').find('span.ui-message-error-detail').is(":visible")) {
                PF('addQualificationOverlayPanel').hide();
            }
        };

        self.showClearButtonAdd = function (rowIndexVar, calFieldId) {
            if ($('button.ui-datepicker-clear').length == 0) {
                $('.ui-datepicker-buttonpane').append('<button class="ui-datepicker-clear ui-state-default ui-priority-primary ui-corner-all" onclick="clearDateAdd(' + rowIndexVar + ', &apos;' + calFieldId + '&apos;);">Clear</button>');
            }
        };

        self.clearDateAdd = function (rowIndexVar, calFieldId) {
            var dateField = '#qualificationsForm\\:qualificationsPanel\\:qualificationsInputTable\\:' + rowIndexVar + '\\:' + calFieldId + '_input';
            $(dateField).val(null);
        };

        self.preventViewMode = function (dataTableWidgetVar) {
            PF(dataTableWidgetVar).viewMode = _.noop;
        };

        self.saveInCellCheckbox = function (source, table) {
            table.doCellEditRequest($(source).closest('td'), table);
        };
    });
})(jQuery);

window.mainVM = app.createVM("CandidateSkills");

/*
 json2.js
 2014-02-04

 Public Domain.

 NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

 See http://www.JSON.org/js.html


 This code should be minified before deployment.
 See http://javascript.crockford.com/jsmin.html

 USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
 NOT CONTROL.


 This file creates a global JSON object containing two methods: stringify
 and parse.

 JSON.stringify(value, replacer, space)
 value       any JavaScript value, usually an object or array.

 replacer    an optional parameter that determines how object
 values are stringified for objects. It can be a
 function or an array of strings.

 space       an optional parameter that specifies the indentation
 of nested structures. If it is omitted, the text will
 be packed without extra whitespace. If it is a number,
 it will specify the number of spaces to indent at each
 level. If it is a string (such as '\t' or '&nbsp;'),
 it contains the characters used to indent at each level.

 This method produces a JSON text from a JavaScript value.

 When an object value is found, if the object contains a toJSON
 method, its toJSON method will be called and the result will be
 stringified. A toJSON method does not serialize: it returns the
 value represented by the name/value pair that should be serialized,
 or undefined if nothing should be serialized. The toJSON method
 will be passed the key associated with the value, and this will be
 bound to the value

 For example, this would serialize Dates as ISO strings.

 Date.prototype.toJSON = function (key) {
 function f(n) {
 // Format integers to have at least two digits.
 return n < 10 ? '0' + n : n;
 }

 return this.getUTCFullYear()   + '-' +
 f(this.getUTCMonth() + 1) + '-' +
 f(this.getUTCDate())      + 'T' +
 f(this.getUTCHours())     + ':' +
 f(this.getUTCMinutes())   + ':' +
 f(this.getUTCSeconds())   + 'Z';
 };

 You can provide an optional replacer method. It will be passed the
 key and value of each member, with this bound to the containing
 object. The value that is returned from your method will be
 serialized. If your method returns undefined, then the member will
 be excluded from the serialization.

 If the replacer parameter is an array of strings, then it will be
 used to select the members to be serialized. It filters the results
 such that only members with keys listed in the replacer array are
 stringified.

 Values that do not have JSON representations, such as undefined or
 functions, will not be serialized. Such values in objects will be
 dropped; in arrays they will be replaced with null. You can use
 a replacer function to replace those with JSON values.
 JSON.stringify(undefined) returns undefined.

 The optional space parameter produces a stringification of the
 value that is filled with line breaks and indentation to make it
 easier to read.

 If the space parameter is a non-empty string, then that string will
 be used for indentation. If the space parameter is a number, then
 the indentation will be that many spaces.

 Example:

 text = JSON.stringify(['e', {pluribus: 'unum'}]);
 // text is '["e",{"pluribus":"unum"}]'


 text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
 // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

 text = JSON.stringify([new Date()], function (key, value) {
 return this[key] instanceof Date ?
 'Date(' + this[key] + ')' : value;
 });
 // text is '["Date(---current time---)"]'


 JSON.parse(text, reviver)
 This method parses a JSON text to produce an object or array.
 It can throw a SyntaxError exception.

 The optional reviver parameter is a function that can filter and
 transform the results. It receives each of the keys and values,
 and its return value is used instead of the original value.
 If it returns what it received, then the structure is not modified.
 If it returns undefined then the member is deleted.

 Example:

 // Parse the text. Values that look like ISO date strings will
 // be converted to Date objects.

 myData = JSON.parse(text, function (key, value) {
 var a;
 if (typeof value === 'string') {
 a =
 /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
 if (a) {
 return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
 +a[5], +a[6]));
 }
 }
 return value;
 });

 myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
 var d;
 if (typeof value === 'string' &&
 value.slice(0, 5) === 'Date(' &&
 value.slice(-1) === ')') {
 d = new Date(value.slice(5, -1));
 if (d) {
 return d;
 }
 }
 return value;
 });


 This is a reference implementation. You are free to copy, modify, or
 redistribute.
 */

/*jslint evil: true, regexp: true */

/* --- members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
 call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
 getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
 lastIndex, length, parse, prototype, push, replace, slice, stringify,
 test, toJSON, toString, valueOf
 */

// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if ((typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) !== 'object') {
    JSON = {};
}

(function () {
    'use strict';

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? '0' + n : n;
    }

    if (typeof Date.prototype.toJSON !== 'function') {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf()) ? this.getUTCFullYear() + '-' + f(this.getUTCMonth() + 1) + '-' + f(this.getUTCDate()) + 'T' + f(this.getUTCHours()) + ':' + f(this.getUTCMinutes()) + ':' + f(this.getUTCSeconds()) + 'Z' : null;
        };

        String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function () {
            return this.valueOf();
        };
    }

    var cx, escapable, gap, indent, meta, rep;

    function quote(string) {

        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.

        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
            var c = meta[a];
            return typeof c === 'string' ? c : "\\u" + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }

    function str(key, holder) {

        // Produce a string from holder[key].

        var i,
            // The loop counter.
        k,
            // The member key.
        v,
            // The member value.
        length,
            mind = gap,
            partial,
            value = holder[key];

        // If the value has a toJSON method, call it to obtain a replacement value.

        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && typeof value.toJSON === 'function') {
            value = value.toJSON(key);
        }

        // If we were called with a replacer function, then call the replacer to
        // obtain a replacement value.

        if (typeof rep === 'function') {
            value = rep.call(holder, key, value);
        }

        // What happens next depends on the value's type.

        switch (typeof value === "undefined" ? "undefined" : _typeof(value)) {
            case 'string':
                return quote(value);

            case 'number':

                // JSON numbers must be finite. Encode non-finite numbers as null.

                return isFinite(value) ? String(value) : 'null';

            case 'boolean':
            case 'null':

                // If the value is a boolean or null, convert it to a string. Note:
                // typeof null does not produce 'null'. The case is included here in
                // the remote chance that this gets fixed someday.

                return String(value);

            // If the type is 'object', we might be dealing with an object or an array or
            // null.

            case 'object':

                // Due to a specification blunder in ECMAScript, typeof null is 'object',
                // so watch out for that case.

                if (!value) {
                    return 'null';
                }

                // Make an array to hold the partial results of stringifying this object value.

                gap += indent;
                partial = [];

                // Is the value an array?

                if (Object.prototype.toString.apply(value) === '[object Array]') {

                    // The value is an array. Stringify every element. Use null as a placeholder
                    // for non-JSON values.

                    length = value.length;
                    for (i = 0; i < length; i += 1) {
                        partial[i] = str(i, value) || 'null';
                    }

                    // Join all of the elements together, separated with commas, and wrap them in
                    // brackets.

                    v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                    gap = mind;
                    return v;
                }

                // If the replacer is an array, use it to select the members to be stringified.

                if (rep && (typeof rep === "undefined" ? "undefined" : _typeof(rep)) === 'object') {
                    length = rep.length;
                    for (i = 0; i < length; i += 1) {
                        if (typeof rep[i] === 'string') {
                            k = rep[i];
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }
                } else {

                    // Otherwise, iterate through all of the keys in the object.

                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }
                }

                // Join all of the member texts together, separated with commas,
                // and wrap them in braces.

                v = partial.length === 0 ? '{}' : gap ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}' : '{' + partial.join(',') + '}';
                gap = mind;
                return v;
        }
    }

    // If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== 'function') {
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
        meta = { // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"': '\\"',
            '\\': '\\\\'
        };
        JSON.stringify = function (value, replacer, space) {

            // The stringify method takes a value and an optional replacer, and an optional
            // space parameter, and returns a JSON text. The replacer can be a function
            // that can replace values, or an array of strings that will select the keys.
            // A default replacer method can be provided. Use of the space parameter can
            // produce text that is more easily readable.

            var i;
            gap = '';
            indent = '';

            // If the space parameter is a number, make an indent string containing that
            // many spaces.

            if (typeof space === 'number') {
                for (i = 0; i < space; i += 1) {
                    indent += ' ';
                }

                // If the space parameter is a string, it will be used as the indent string.
            } else if (typeof space === 'string') {
                indent = space;
            }

            // If there is a replacer, it must be a function or an array.
            // Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== 'function' && ((typeof replacer === "undefined" ? "undefined" : _typeof(replacer)) !== 'object' || typeof replacer.length !== 'number')) {
                throw new Error('JSON.stringify');
            }

            // Make a fake root object containing our value under the key of ''.
            // Return the result of stringifying the value.

            return str('', { '': value });
        };
    }

    // If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== 'function') {
        cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
        JSON.parse = function (text, reviver) {

            // The parse method takes a text and an optional reviver function, and returns
            // a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

                // The walk method is used to recursively walk the resulting structure so
                // that modifications can be made.

                var k,
                    v,
                    value = holder[key];
                if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }

            // Parsing happens in four stages. In the first stage, we replace certain
            // Unicode characters with escape sequences. JavaScript handles many characters
            // incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            cx.lastIndex = 0;
            if (cx.test(text)) {
                text = text.replace(cx, function (a) {
                    return "\\u" + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

            // In the second stage, we run the text against regular expressions that look
            // for non-JSON patterns. We are especially concerned with '()' and 'new'
            // because they can cause invocation, and '=' because it can cause mutation.
            // But just to be safe, we want to reject all unexpected forms.

            // We split the second stage into 4 regexp operations in order to work around
            // crippling inefficiencies in IE's and Safari's regexp engines. First we
            // replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
            // replace all simple value tokens with ']' characters. Third, we delete all
            // open brackets that follow a colon or comma or that begin the text. Finally,
            // we look to see that the remaining characters are only whitespace or ']' or
            // ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.

            if (/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

                // In the third stage we use the eval function to compile the text into a
                // JavaScript structure. The '{' operator is subject to a syntactic ambiguity
                // in JavaScript: it can begin a block or an object literal. We wrap the text
                // in parens to eliminate the ambiguity.

                j = eval('(' + text + ')');

                // In the optional fourth stage, we recursively walk the new structure, passing
                // each name/value pair to a reviver function for possible transformation.

                return typeof reviver === 'function' ? walk({ '': j }, '') : j;
            }

            // If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError('JSON.parse');
        };
    }
})();

/**
 * History.js jQuery Adapter
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

// Closure
(function (window, undefined) {
    "use strict";

    // Localise Globals

    var History = window.History = window.History || {},
        jQuery = window.jQuery;

    // Check Existence
    if (typeof History.Adapter !== 'undefined') {
        window['console'] && console.log && console.error('History.js Adapter has already been loaded...');
        return;
    }

    // Add the Adapter
    History.Adapter = {
        /**
         * History.Adapter.bind(el,event,callback)
         * @param {Element|string} el
         * @param {string} event - custom and standard events
         * @param {function} callback
         * @return {void}
         */
        bind: function bind(el, event, callback) {
            jQuery(el).bind(event, callback);
        },

        /**
         * History.Adapter.trigger(el,event)
         * @param {Element|string} el
         * @param {string} event - custom and standard events
         * @param {Object=} extra - a object of extra event data (optional)
         * @return {void}
         */
        trigger: function trigger(el, event, extra) {
            jQuery(el).trigger(event, extra);
        },

        /**
         * History.Adapter.extractEventData(key,event,extra)
         * @param {string} key - key for the event data to extract
         * @param {string} event - custom and standard events
         * @param {Object=} extra - a object of extra event data (optional)
         * @return {mixed}
         */
        extractEventData: function extractEventData(key, event, extra) {
            // jQuery Native then jQuery Custom
            var result = event && event.originalEvent && event.originalEvent[key] || extra && extra[key] || undefined;

            // Return
            return result;
        },

        /**
         * History.Adapter.onDomLoad(callback)
         * @param {function} callback
         * @return {void}
         */
        onDomLoad: function onDomLoad(callback) {
            jQuery(callback);
        }
    };

    // Try and Initialise History
    if (typeof History.init !== 'undefined') {
        History.init();
    }
})(window);

/**
 * History.js HTML4 Support
 * Depends on the HTML5 Support
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

(function (window, undefined) {
    "use strict";

    // ========================================================================
    // Initialise

    // Localise Globals

    var document = window.document,
        // Make sure we are using the correct document
    setTimeout = window.setTimeout || setTimeout,
        clearTimeout = window.clearTimeout || clearTimeout,
        setInterval = window.setInterval || setInterval,
        History = window.History = window.History || {}; // Public History Object

    // Check Existence
    if (typeof History.initHtml4 !== 'undefined') {
        window['console'] && console.log && console.error('History.js HTML4 Support has already been loaded...');
        return;
    }

    // ========================================================================
    // Initialise HTML4 Support

    // Initialise HTML4 Support
    History.initHtml4 = function () {
        // Initialise
        if (typeof History.initHtml4.initialized !== 'undefined') {
            // Already Loaded
            return false;
        } else {
            History.initHtml4.initialized = true;
        }

        // ====================================================================
        // Properties

        /**
         * History.enabled
         * Is History enabled?
         */
        History.enabled = true;

        // ====================================================================
        // Hash Storage

        /**
         * History.savedHashes
         * Store the hashes in an array
         */
        History.savedHashes = [];

        /**
         * History.isLastHash(newHash)
         * Checks if the hash is the last hash
         * @param {string} newHash
         * @return {boolean} true
         */
        History.isLastHash = function (newHash) {
            // Prepare
            var oldHash = History.getHashByIndex(),
                isLast;

            // Check
            isLast = newHash === oldHash;

            // Return isLast
            return isLast;
        };

        /**
         * History.isHashEqual(newHash, oldHash)
         * Checks to see if two hashes are functionally equal
         * @param {string} newHash
         * @param {string} oldHash
         * @return {boolean} true
         */
        History.isHashEqual = function (newHash, oldHash) {
            newHash = encodeURIComponent(newHash).replace(/%25/g, "%");
            oldHash = encodeURIComponent(oldHash).replace(/%25/g, "%");
            return newHash === oldHash;
        };

        /**
         * History.saveHash(newHash)
         * Push a Hash
         * @param {string} newHash
         * @return {boolean} true
         */
        History.saveHash = function (newHash) {
            // Check Hash
            if (History.isLastHash(newHash)) {
                return false;
            }

            // Push the Hash
            History.savedHashes.push(newHash);

            // Return true
            return true;
        };

        /**
         * History.getHashByIndex()
         * Gets a hash by the index
         * @param {integer} index
         * @return {string}
         */
        History.getHashByIndex = function (index) {
            // Prepare
            var hash = null;

            // Handle
            if (typeof index === 'undefined') {
                // Get the last inserted
                hash = History.savedHashes[History.savedHashes.length - 1];
            } else if (index < 0) {
                // Get from the end
                hash = History.savedHashes[History.savedHashes.length + index];
            } else {
                // Get from the beginning
                hash = History.savedHashes[index];
            }

            // Return hash
            return hash;
        };

        // ====================================================================
        // Discarded States

        /**
         * History.discardedHashes
         * A hashed array of discarded hashes
         */
        History.discardedHashes = {};

        /**
         * History.discardedStates
         * A hashed array of discarded states
         */
        History.discardedStates = {};

        /**
         * History.discardState(State)
         * Discards the state by ignoring it through History
         * @param {object} State
         * @return {true}
         */
        History.discardState = function (discardedState, forwardState, backState) {
            //History.debug('History.discardState', arguments);
            // Prepare
            var discardedStateHash = History.getHashByState(discardedState),
                discardObject;

            // Create Discard Object
            discardObject = {
                'discardedState': discardedState,
                'backState': backState,
                'forwardState': forwardState
            };

            // Add to DiscardedStates
            History.discardedStates[discardedStateHash] = discardObject;

            // Return true
            return true;
        };

        /**
         * History.discardHash(hash)
         * Discards the hash by ignoring it through History
         * @param {string} hash
         * @return {true}
         */
        History.discardHash = function (discardedHash, forwardState, backState) {
            //History.debug('History.discardState', arguments);
            // Create Discard Object
            var discardObject = {
                'discardedHash': discardedHash,
                'backState': backState,
                'forwardState': forwardState
            };

            // Add to discardedHash
            History.discardedHashes[discardedHash] = discardObject;

            // Return true
            return true;
        };

        /**
         * History.discardedState(State)
         * Checks to see if the state is discarded
         * @param {object} State
         * @return {bool}
         */
        History.discardedState = function (State) {
            // Prepare
            var StateHash = History.getHashByState(State),
                discarded;

            // Check
            discarded = History.discardedStates[StateHash] || false;

            // Return true
            return discarded;
        };

        /**
         * History.discardedHash(hash)
         * Checks to see if the state is discarded
         * @param {string} State
         * @return {bool}
         */
        History.discardedHash = function (hash) {
            // Check
            var discarded = History.discardedHashes[hash] || false;

            // Return true
            return discarded;
        };

        /**
         * History.recycleState(State)
         * Allows a discarded state to be used again
         * @param {object} data
         * @param {string} title
         * @param {string} url
         * @return {true}
         */
        History.recycleState = function (State) {
            //History.debug('History.recycleState', arguments);
            // Prepare
            var StateHash = History.getHashByState(State);

            // Remove from DiscardedStates
            if (History.discardedState(State)) {
                delete History.discardedStates[StateHash];
            }

            // Return true
            return true;
        };

        // ====================================================================
        // HTML4 HashChange Support

        if (History.emulated.hashChange) {
            /*
             * We must emulate the HTML4 HashChange Support by manually checking for hash changes
             */

            /**
             * History.hashChangeInit()
             * Init the HashChange Emulation
             */
            History.hashChangeInit = function () {
                // Define our Checker Function
                History.checkerFunction = null;

                // Define some variables that will help in our checker function
                var lastDocumentHash = '',
                    iframeId,
                    iframe,
                    lastIframeHash,
                    checkerRunning,
                    startedWithHash = Boolean(History.getHash());

                // Handle depending on the browser
                if (History.isInternetExplorer()) {
                    // IE6 and IE7
                    // We need to use an iframe to emulate the back and forward buttons

                    // Create iFrame
                    iframeId = 'historyjs-iframe';
                    iframe = document.createElement('iframe');

                    // Adjust iFarme
                    // IE 6 requires iframe to have a src on HTTPS pages, otherwise it will throw a
                    // "This page contains both secure and nonsecure items" warning.
                    iframe.setAttribute('id', iframeId);
                    iframe.setAttribute('src', '#');
                    iframe.style.display = 'none';

                    // Append iFrame
                    document.body.appendChild(iframe);

                    // Create initial history entry
                    iframe.contentWindow.document.open();
                    iframe.contentWindow.document.close();

                    // Define some variables that will help in our checker function
                    lastIframeHash = '';
                    checkerRunning = false;

                    // Define the checker function
                    History.checkerFunction = function () {
                        // Check Running
                        if (checkerRunning) {
                            return false;
                        }

                        // Update Running
                        checkerRunning = true;

                        // Fetch
                        var documentHash = History.getHash(),
                            iframeHash = History.getHash(iframe.contentWindow.document);

                        // The Document Hash has changed (application caused)
                        if (documentHash !== lastDocumentHash) {
                            // Equalise
                            lastDocumentHash = documentHash;

                            // Create a history entry in the iframe
                            if (iframeHash !== documentHash) {
                                //History.debug('hashchange.checker: iframe hash change', 'documentHash (new):', documentHash, 'iframeHash (old):', iframeHash);

                                // Equalise
                                lastIframeHash = iframeHash = documentHash;

                                // Create History Entry
                                iframe.contentWindow.document.open();
                                iframe.contentWindow.document.close();

                                // Update the iframe's hash
                                iframe.contentWindow.document.location.hash = History.escapeHash(documentHash);
                            }

                            // Trigger Hashchange Event
                            History.Adapter.trigger(window, 'hashchange');
                        }

                        // The iFrame Hash has changed (back button caused)
                        else if (iframeHash !== lastIframeHash) {
                                //History.debug('hashchange.checker: iframe hash out of sync', 'iframeHash (new):', iframeHash, 'documentHash (old):', documentHash);

                                // Equalise
                                lastIframeHash = iframeHash;

                                // If there is no iframe hash that means we're at the original
                                // iframe state.
                                // And if there was a hash on the original request, the original
                                // iframe state was replaced instantly, so skip this state and take
                                // the user back to where they came from.
                                if (startedWithHash && iframeHash === '') {
                                    History.back();
                                } else {
                                    // Update the Hash
                                    History.setHash(iframeHash, false);
                                }
                            }

                        // Reset Running
                        checkerRunning = false;

                        // Return true
                        return true;
                    };
                } else {
                    // We are not IE
                    // Firefox 1 or 2, Opera

                    // Define the checker function
                    History.checkerFunction = function () {
                        // Prepare
                        var documentHash = History.getHash() || '';

                        // The Document Hash has changed (application caused)
                        if (documentHash !== lastDocumentHash) {
                            // Equalise
                            lastDocumentHash = documentHash;

                            // Trigger Hashchange Event
                            History.Adapter.trigger(window, 'hashchange');
                        }

                        // Return true
                        return true;
                    };
                }

                // Apply the checker function
                History.intervalList.push(setInterval(History.checkerFunction, History.options.hashChangeInterval));

                // Done
                return true;
            }; // History.hashChangeInit

            // Bind hashChangeInit
            History.Adapter.onDomLoad(History.hashChangeInit);
        } // History.emulated.hashChange


        // ====================================================================
        // HTML5 State Support

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /*
             * We must emulate the HTML5 State Management by using HTML4 HashChange
             */

            /**
             * History.onHashChange(event)
             * Trigger HTML5's window.onpopstate via HTML4 HashChange Support
             */
            History.onHashChange = function (event) {
                //History.debug('History.onHashChange', arguments);

                // Prepare
                var currentUrl = event && event.newURL || History.getLocationHref(),
                    currentHash = History.getHashByUrl(currentUrl),
                    currentState = null,
                    currentStateHash = null,
                    currentStateHashExits = null,
                    discardObject;

                // Check if we are the same state
                if (History.isLastHash(currentHash)) {
                    // There has been no change (just the page's hash has finally propagated)
                    //History.debug('History.onHashChange: no change');
                    History.busy(false);
                    return false;
                }

                // Reset the double check
                History.doubleCheckComplete();

                // Store our location for use in detecting back/forward direction
                History.saveHash(currentHash);

                // Expand Hash
                if (currentHash && History.isTraditionalAnchor(currentHash)) {
                    //History.debug('History.onHashChange: traditional anchor', currentHash);
                    // Traditional Anchor Hash
                    History.Adapter.trigger(window, 'anchorchange');
                    History.busy(false);
                    return false;
                }

                // Create State
                currentState = History.extractState(History.getFullUrl(currentHash || History.getLocationHref()), true);

                // Check if we are the same state
                if (History.isLastSavedState(currentState)) {
                    //History.debug('History.onHashChange: no change');
                    // There has been no change (just the page's hash has finally propagated)
                    History.busy(false);
                    return false;
                }

                // Create the state Hash
                currentStateHash = History.getHashByState(currentState);

                // Check if we are DiscardedState
                discardObject = History.discardedState(currentState);
                if (discardObject) {
                    // Ignore this state as it has been discarded and go back to the state before it
                    if (History.getHashByIndex(-2) === History.getHashByState(discardObject.forwardState)) {
                        // We are going backwards
                        //History.debug('History.onHashChange: go backwards');
                        History.back(false);
                    } else {
                        // We are going forwards
                        //History.debug('History.onHashChange: go forwards');
                        History.forward(false);
                    }
                    return false;
                }

                // Push the new HTML5 State
                //History.debug('History.onHashChange: success hashchange');
                History.pushState(currentState.data, currentState.title, encodeURI(currentState.url), false);

                // End onHashChange closure
                return true;
            };
            History.Adapter.bind(window, 'hashchange', History.onHashChange);

            /**
             * History.pushState(data,title,url)
             * Add a new State to the history object, become it, and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.pushState = function (data, title, url, queue) {
                //History.debug('History.pushState: called', arguments);

                // We assume that the URL passed in is URI-encoded, but this makes
                // sure that it's fully URI encoded; any '%'s that are encoded are
                // converted back into '%'s
                url = encodeURI(url).replace(/%25/g, "%");

                // Check the State
                if (History.getHashByUrl(url)) {
                    throw new Error('History.js does not support states with fragment-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.pushState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.pushState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy
                History.busy(true);

                // Fetch the State Object
                var newState = History.createStateObject(data, title, url),
                    newStateHash = History.getHashByState(newState),
                    oldState = History.getState(false),
                    oldStateHash = History.getHashByState(oldState),
                    html4Hash = History.getHash(),
                    wasExpected = History.expectedStateId == newState.id;

                // Store the newState
                History.storeState(newState);
                History.expectedStateId = newState.id;

                // Recycle the State
                History.recycleState(newState);

                // Force update of the title
                History.setTitle(newState);

                // Check if we are the same State
                if (newStateHash === oldStateHash) {
                    //History.debug('History.pushState: no change', newStateHash);
                    History.busy(false);
                    return false;
                }

                // Update HTML5 State
                History.saveState(newState);

                // Fire HTML5 Event
                if (!wasExpected) History.Adapter.trigger(window, 'statechange');

                // Update HTML4 Hash
                if (!History.isHashEqual(newStateHash, html4Hash) && !History.isHashEqual(newStateHash, History.getShortUrl(History.getLocationHref()))) {
                    History.setHash(newStateHash, false);
                }

                History.busy(false);

                // End pushState closure
                return true;
            };

            /**
             * History.replaceState(data,title,url)
             * Replace the State and trigger onpopstate
             * We have to trigger for HTML4 compatibility
             * @param {object} data
             * @param {string} title
             * @param {string} url
             * @return {true}
             */
            History.replaceState = function (data, title, url, queue) {
                //History.debug('History.replaceState: called', arguments);

                // We assume that the URL passed in is URI-encoded, but this makes
                // sure that it's fully URI encoded; any '%'s that are encoded are
                // converted back into '%'s
                url = encodeURI(url).replace(/%25/g, "%");

                // Check the State
                if (History.getHashByUrl(url)) {
                    throw new Error('History.js does not support states with fragment-identifiers (hashes/anchors).');
                }

                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.replaceState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.replaceState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }

                // Make Busy
                History.busy(true);

                // Fetch the State Objects
                var newState = History.createStateObject(data, title, url),
                    newStateHash = History.getHashByState(newState),
                    oldState = History.getState(false),
                    oldStateHash = History.getHashByState(oldState),
                    previousState = History.getStateByIndex(-2);

                // Discard Old State
                History.discardState(oldState, newState, previousState);

                // If the url hasn't changed, just store and save the state
                // and fire a statechange event to be consistent with the
                // html 5 api
                if (newStateHash === oldStateHash) {
                    // Store the newState
                    History.storeState(newState);
                    History.expectedStateId = newState.id;

                    // Recycle the State
                    History.recycleState(newState);

                    // Force update of the title
                    History.setTitle(newState);

                    // Update HTML5 State
                    History.saveState(newState);

                    // Fire HTML5 Event
                    //History.debug('History.pushState: trigger popstate');
                    History.Adapter.trigger(window, 'statechange');
                    History.busy(false);
                } else {
                    // Alias to PushState
                    History.pushState(newState.data, newState.title, newState.url, false);
                }

                // End replaceState closure
                return true;
            };
        } // History.emulated.pushState


        // ====================================================================
        // Initialise

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /**
             * Ensure initial state is handled correctly
             */
            if (History.getHash() && !History.emulated.hashChange) {
                History.Adapter.onDomLoad(function () {
                    History.Adapter.trigger(window, 'hashchange');
                });
            }
        } // History.emulated.pushState
    }; // History.initHtml4

    // Try to Initialise History
    if (typeof History.init !== 'undefined') {
        History.init();
    }
})(window);
/**
 * History.js Core
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

(function (window, undefined) {
    "use strict";

    // ========================================================================
    // Initialise

    // Localise Globals

    var console = window.console || undefined,
        // Prevent a JSLint complain
    document = window.document,
        // Make sure we are using the correct document
    navigator = window.navigator,
        // Make sure we are using the correct navigator
    sessionStorage = false,
        // sessionStorage
    setTimeout = window.setTimeout,
        clearTimeout = window.clearTimeout,
        setInterval = window.setInterval,
        clearInterval = window.clearInterval,
        JSON = window.JSON,
        alert = window.alert,
        History = window.History = window.History || {},
        // Public History Object
    history = window.history; // Old History Object

    try {
        sessionStorage = window.sessionStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
        sessionStorage.setItem('TEST', '1');
        sessionStorage.removeItem('TEST');
    } catch (e) {
        sessionStorage = false;
    }

    // MooTools Compatibility
    JSON.stringify = JSON.stringify || JSON.encode;
    JSON.parse = JSON.parse || JSON.decode;

    // Check Existence
    if (typeof History.init !== 'undefined') {
        window['console'] && console.log && console.error('History.js Core has already been loaded...');
        return;
    }

    // Initialise History
    History.init = function (options) {
        // Check Load Status of Adapter
        if (typeof History.Adapter === 'undefined') {
            return false;
        }

        // Check Load Status of Core
        if (typeof History.initCore !== 'undefined') {
            History.initCore();
        }

        // Check Load Status of HTML4 Support
        if (typeof History.initHtml4 !== 'undefined') {
            History.initHtml4();
        }

        // Return true
        return true;
    };

    // ========================================================================
    // Initialise Core

    // Initialise Core
    History.initCore = function (options) {
        // Initialise
        if (typeof History.initCore.initialized !== 'undefined') {
            // Already Loaded
            return false;
        } else {
            History.initCore.initialized = true;
        }

        // ====================================================================
        // Options

        /**
         * History.options
         * Configurable options
         */
        History.options = History.options || {};

        /**
         * History.options.hashChangeInterval
         * How long should the interval be before hashchange checks
         */
        History.options.hashChangeInterval = History.options.hashChangeInterval || 100;

        /**
         * History.options.safariPollInterval
         * How long should the interval be before safari poll checks
         */
        History.options.safariPollInterval = History.options.safariPollInterval || 500;

        /**
         * History.options.doubleCheckInterval
         * How long should the interval be before we perform a double check
         */
        History.options.doubleCheckInterval = History.options.doubleCheckInterval || 500;

        /**
         * History.options.disableSuid
         * Force History not to append suid
         */
        History.options.disableSuid = History.options.disableSuid || false;

        /**
         * History.options.storeInterval
         * How long should we wait between store calls
         */
        History.options.storeInterval = History.options.storeInterval || 1000;

        /**
         * History.options.busyDelay
         * How long should we wait between busy events
         */
        History.options.busyDelay = History.options.busyDelay || 250;

        /**
         * History.options.debug
         * If true will enable debug messages to be logged
         */
        History.options.debug = History.options.debug || false;

        /**
         * History.options.initialTitle
         * What is the title of the initial state
         */
        History.options.initialTitle = History.options.initialTitle || document.title;

        /**
         * History.options.html4Mode
         * If true, will force HTMl4 mode (hashtags)
         */
        History.options.html4Mode = History.options.html4Mode || false;

        /**
         * History.options.delayInit
         * Want to override default options and call init manually.
         */
        History.options.delayInit = History.options.delayInit || false;

        // ====================================================================
        // Interval record

        /**
         * History.intervalList
         * List of intervals set, to be cleared when document is unloaded.
         */
        History.intervalList = [];

        /**
         * History.clearAllIntervals
         * Clears all setInterval instances.
         */
        History.clearAllIntervals = function () {
            var i,
                il = History.intervalList;
            if (typeof il !== "undefined" && il !== null) {
                for (i = 0; i < il.length; i++) {
                    clearInterval(il[i]);
                }
                History.intervalList = null;
            }
        };

        // ====================================================================
        // Debug

        /**
         * History.debug(message,...)
         * Logs the passed arguments if debug enabled
         */
        History.debug = function () {
            if (History.options.debug || false) {
                History.log.apply(History, arguments);
            }
        };

        /**
         * History.log(message,...)
         * Logs the passed arguments
         */
        History.log = function () {
            // Prepare
            var consoleExists = !(typeof console === 'undefined' || typeof console.log === 'undefined' || typeof console.log.apply === 'undefined'),
                textarea = document.getElementById('log'),
                message,
                i,
                n,
                args,
                arg;

            // Write to Console
            if (consoleExists) {
                args = Array.prototype.slice.call(arguments);
                message = args.shift();
                if (typeof console.debug !== 'undefined') {
                    console.debug.apply(console, [message, args]);
                } else {
                    console.log.apply(console, [message, args]);
                }
            } else {
                message = "\n" + arguments[0] + "\n";
            }

            // Write to log
            for (i = 1, n = arguments.length; i < n; ++i) {
                arg = arguments[i];
                if ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) === 'object' && typeof JSON !== 'undefined') {
                    try {
                        arg = JSON.stringify(arg);
                    } catch (Exception) {
                        // Recursive Object
                    }
                }
                message += "\n" + arg + "\n";
            }

            // Textarea
            if (textarea) {
                textarea.value += message + "\n-----\n";
                textarea.scrollTop = textarea.scrollHeight - textarea.clientHeight;
            }
            // No Textarea, No Console
            else if (!consoleExists) {
                    alert(message);
                }

            // Return true
            return true;
        };

        // ====================================================================
        // Emulated Status

        /**
         * History.getInternetExplorerMajorVersion()
         * Get's the major version of Internet Explorer
         * @return {integer}
         * @license Public Domain
         * @author Benjamin Arthur Lupton <contact@balupton.com>
         * @author James Padolsey <https://gist.github.com/527683>
         */
        History.getInternetExplorerMajorVersion = function () {
            var result = History.getInternetExplorerMajorVersion.cached = typeof History.getInternetExplorerMajorVersion.cached !== 'undefined' ? History.getInternetExplorerMajorVersion.cached : function () {
                var v = 3,
                    div = document.createElement('div'),
                    all = div.getElementsByTagName('i');
                while ((div.innerHTML = '<!--[if gt IE ' + ++v + ']><i></i><![endif]-->') && all[0]) {}
                return v > 4 ? v : false;
            }();
            return result;
        };

        /**
         * History.isInternetExplorer()
         * Are we using Internet Explorer?
         * @return {boolean}
         * @license Public Domain
         * @author Benjamin Arthur Lupton <contact@balupton.com>
         */
        History.isInternetExplorer = function () {
            var result = History.isInternetExplorer.cached = typeof History.isInternetExplorer.cached !== 'undefined' ? History.isInternetExplorer.cached : Boolean(History.getInternetExplorerMajorVersion());
            return result;
        };

        /**
         * History.emulated
         * Which features require emulating?
         */

        if (History.options.html4Mode) {
            History.emulated = {
                pushState: true,
                hashChange: true
            };
        } else {

            History.emulated = {
                pushState: !Boolean(window.history && window.history.pushState && window.history.replaceState && !(/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(navigator.userAgent) /* disable for versions of iOS before version 4.3 (8F190) */
                || /AppleWebKit\/5([0-2]|3[0-2])/i.test(navigator.userAgent) /* disable for the mercury iOS browser, or at least older versions of the webkit engine */
                )),
                hashChange: Boolean(!('onhashchange' in window || 'onhashchange' in document) || History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8)
            };
        }

        /**
         * History.enabled
         * Is History enabled?
         */
        History.enabled = !History.emulated.pushState;

        /**
         * History.bugs
         * Which bugs are present
         */
        History.bugs = {
            /**
             * Safari 5 and Safari iOS 4 fail to return to the correct state once a hash is replaced by a `replaceState` call
             * https://bugs.webkit.org/show_bug.cgi?id=56249
             */
            setHash: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

            /**
             * Safari 5 and Safari iOS 4 sometimes fail to apply the state change under busy conditions
             * https://bugs.webkit.org/show_bug.cgi?id=42940
             */
            safariPoll: Boolean(!History.emulated.pushState && navigator.vendor === 'Apple Computer, Inc.' && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),

            /**
             * MSIE 6 and 7 sometimes do not apply a hash even it was told to (requiring a second call to the apply function)
             */
            ieDoubleCheck: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8),

            /**
             * MSIE 6 requires the entire hash to be encoded for the hashes to trigger the onHashChange event
             */
            hashEscape: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 7)
        };

        /**
         * History.isEmptyObject(obj)
         * Checks to see if the Object is Empty
         * @param {Object} obj
         * @return {boolean}
         */
        History.isEmptyObject = function (obj) {
            for (var name in obj) {
                if (obj.hasOwnProperty(name)) {
                    return false;
                }
            }
            return true;
        };

        /**
         * History.cloneObject(obj)
         * Clones a object and eliminate all references to the original contexts
         * @param {Object} obj
         * @return {Object}
         */
        History.cloneObject = function (obj) {
            var hash, newObj;
            if (obj) {
                hash = JSON.stringify(obj);
                newObj = JSON.parse(hash);
            } else {
                newObj = {};
            }
            return newObj;
        };

        // ====================================================================
        // URL Helpers

        /**
         * History.getRootUrl()
         * Turns "http://mysite.com/dir/page.html?asd" into "http://mysite.com"
         * @return {String} rootUrl
         */
        History.getRootUrl = function () {
            // Create
            var rootUrl = document.location.protocol + '//' + (document.location.hostname || document.location.host);
            if (document.location.port || false) {
                rootUrl += ':' + document.location.port;
            }
            rootUrl += '/';

            // Return
            return rootUrl;
        };

        /**
         * History.getBaseHref()
         * Fetches the `href` attribute of the `<base href="...">` element if it exists
         * @return {String} baseHref
         */
        History.getBaseHref = function () {
            // Create
            var baseElements = document.getElementsByTagName('base'),
                baseElement = null,
                baseHref = '';

            // Test for Base Element
            if (baseElements.length === 1) {
                // Prepare for Base Element
                baseElement = baseElements[0];
                baseHref = baseElement.href.replace(/[^\/]+$/, '');
            }

            // Adjust trailing slash
            baseHref = baseHref.replace(/\/+$/, '');
            if (baseHref) baseHref += '/';

            // Return
            return baseHref;
        };

        /**
         * History.getBaseUrl()
         * Fetches the baseHref or basePageUrl or rootUrl (whichever one exists first)
         * @return {String} baseUrl
         */
        History.getBaseUrl = function () {
            // Create
            var baseUrl = History.getBaseHref() || History.getBasePageUrl() || History.getRootUrl();

            // Return
            return baseUrl;
        };

        /**
         * History.getPageUrl()
         * Fetches the URL of the current page
         * @return {String} pageUrl
         */
        History.getPageUrl = function () {
            // Fetch
            var State = History.getState(false, false),
                stateUrl = (State || {}).url || History.getLocationHref(),
                pageUrl;

            // Create
            pageUrl = stateUrl.replace(/\/+$/, '').replace(/[^\/]+$/, function (part, index, string) {
                return (/\./.test(part) ? part : part + '/'
                );
            });

            // Return
            return pageUrl;
        };

        /**
         * History.getBasePageUrl()
         * Fetches the Url of the directory of the current page
         * @return {String} basePageUrl
         */
        History.getBasePageUrl = function () {
            // Create
            var basePageUrl = History.getLocationHref().replace(/[#\?].*/, '').replace(/[^\/]+$/, function (part, index, string) {
                return (/[^\/]$/.test(part) ? '' : part
                );
            }).replace(/\/+$/, '') + '/';

            // Return
            return basePageUrl;
        };

        /**
         * History.getFullUrl(url)
         * Ensures that we have an absolute URL and not a relative URL
         * @param {string} url
         * @param {Boolean} allowBaseHref
         * @return {string} fullUrl
         */
        History.getFullUrl = function (url, allowBaseHref) {
            // Prepare
            var fullUrl = url,
                firstChar = url.substring(0, 1);
            allowBaseHref = typeof allowBaseHref === 'undefined' ? true : allowBaseHref;

            // Check
            if (/[a-z]+\:\/\//.test(url)) {
                // Full URL
            } else if (firstChar === '/') {
                // Root URL
                fullUrl = History.getRootUrl() + url.replace(/^\/+/, '');
            } else if (firstChar === '#') {
                // Anchor URL
                fullUrl = History.getPageUrl().replace(/#.*/, '') + url;
            } else if (firstChar === '?') {
                // Query URL
                fullUrl = History.getPageUrl().replace(/[\?#].*/, '') + url;
            } else {
                // Relative URL
                if (allowBaseHref) {
                    fullUrl = History.getBaseUrl() + url.replace(/^(\.\/)+/, '');
                } else {
                    fullUrl = History.getBasePageUrl() + url.replace(/^(\.\/)+/, '');
                }
                // We have an if condition above as we do not want hashes
                // which are relative to the baseHref in our URLs
                // as if the baseHref changes, then all our bookmarks
                // would now point to different locations
                // whereas the basePageUrl will always stay the same
            }

            // Return
            return fullUrl.replace(/\#$/, '');
        };

        /**
         * History.getShortUrl(url)
         * Ensures that we have a relative URL and not a absolute URL
         * @param {string} url
         * @return {string} url
         */
        History.getShortUrl = function (url) {
            // Prepare
            var shortUrl = url,
                baseUrl = History.getBaseUrl(),
                rootUrl = History.getRootUrl();

            // Trim baseUrl
            if (History.emulated.pushState) {
                // We are in a if statement as when pushState is not emulated
                // The actual url these short urls are relative to can change
                // So within the same session, we the url may end up somewhere different
                shortUrl = shortUrl.replace(baseUrl, '');
            }

            // Trim rootUrl
            shortUrl = shortUrl.replace(rootUrl, '/');

            // Ensure we can still detect it as a state
            if (History.isTraditionalAnchor(shortUrl)) {
                shortUrl = './' + shortUrl;
            }

            // Clean It
            shortUrl = shortUrl.replace(/^(\.\/)+/g, './').replace(/\#$/, '');

            // Return
            return shortUrl;
        };

        /**
         * History.getLocationHref(document)
         * Returns a normalized version of document.location.href
         * accounting for browser inconsistencies, etc.
         *
         * This URL will be URI-encoded and will include the hash
         *
         * @param {object} document
         * @return {string} url
         */
        History.getLocationHref = function (doc) {
            doc = doc || document;

            // most of the time, this will be true
            if (doc.URL === doc.location.href) return doc.location.href;

            // some versions of webkit URI-decode document.location.href
            // but they leave document.URL in an encoded state
            if (doc.location.href === decodeURIComponent(doc.URL)) return doc.URL;

            // FF 3.6 only updates document.URL when a page is reloaded
            // document.location.href is updated correctly
            if (doc.location.hash && decodeURIComponent(doc.location.href.replace(/^[^#]+/, "")) === doc.location.hash) return doc.location.href;

            if (doc.URL.indexOf('#') == -1 && doc.location.href.indexOf('#') != -1) return doc.location.href;

            return doc.URL || doc.location.href;
        };

        // ====================================================================
        // State Storage

        /**
         * History.store
         * The store for all session specific data
         */
        History.store = {};

        /**
         * History.idToState
         * 1-1: State ID to State Object
         */
        History.idToState = History.idToState || {};

        /**
         * History.stateToId
         * 1-1: State String to State ID
         */
        History.stateToId = History.stateToId || {};

        /**
         * History.urlToId
         * 1-1: State URL to State ID
         */
        History.urlToId = History.urlToId || {};

        /**
         * History.storedStates
         * Store the states in an array
         */
        History.storedStates = History.storedStates || [];

        /**
         * History.savedStates
         * Saved the states in an array
         */
        History.savedStates = History.savedStates || [];

        /**
         * History.noramlizeStore()
         * Noramlize the store by adding necessary values
         */
        History.normalizeStore = function () {
            History.store.idToState = History.store.idToState || {};
            History.store.urlToId = History.store.urlToId || {};
            History.store.stateToId = History.store.stateToId || {};
        };

        /**
         * History.getState()
         * Get an object containing the data, title and url of the current state
         * @param {Boolean} friendly
         * @param {Boolean} create
         * @return {Object} State
         */
        History.getState = function (friendly, create) {
            // Prepare
            if (typeof friendly === 'undefined') {
                friendly = true;
            }
            if (typeof create === 'undefined') {
                create = true;
            }

            // Fetch
            var State = History.getLastSavedState();

            // Create
            if (!State && create) {
                State = History.createStateObject();
            }

            // Adjust
            if (friendly) {
                State = History.cloneObject(State);
                State.url = State.cleanUrl || State.url;
            }

            // Return
            return State;
        };

        /**
         * History.getIdByState(State)
         * Gets a ID for a State
         * @param {State} newState
         * @return {String} id
         */
        History.getIdByState = function (newState) {

            // Fetch ID
            var id = History.extractId(newState.url),
                str;

            if (!id) {
                // Find ID via State String
                str = History.getStateString(newState);
                if (typeof History.stateToId[str] !== 'undefined') {
                    id = History.stateToId[str];
                } else if (typeof History.store.stateToId[str] !== 'undefined') {
                    id = History.store.stateToId[str];
                } else {
                    // Generate a new ID
                    while (true) {
                        id = new Date().getTime() + String(Math.random()).replace(/\D/g, '');
                        if (typeof History.idToState[id] === 'undefined' && typeof History.store.idToState[id] === 'undefined') {
                            break;
                        }
                    }

                    // Apply the new State to the ID
                    History.stateToId[str] = id;
                    History.idToState[id] = newState;
                }
            }

            // Return ID
            return id;
        };

        /**
         * History.normalizeState(State)
         * Expands a State Object
         * @param {object} State
         * @return {object}
         */
        History.normalizeState = function (oldState) {
            // Variables
            var newState, dataNotEmpty;

            // Prepare
            if (!oldState || (typeof oldState === "undefined" ? "undefined" : _typeof(oldState)) !== 'object') {
                oldState = {};
            }

            // Check
            if (typeof oldState.normalized !== 'undefined') {
                return oldState;
            }

            // Adjust
            if (!oldState.data || _typeof(oldState.data) !== 'object') {
                oldState.data = {};
            }

            // ----------------------------------------------------------------

            // Create
            newState = {};
            newState.normalized = true;
            newState.title = oldState.title || '';
            newState.url = History.getFullUrl(oldState.url ? oldState.url : History.getLocationHref());
            newState.hash = History.getShortUrl(newState.url);
            newState.data = History.cloneObject(oldState.data);

            // Fetch ID
            newState.id = History.getIdByState(newState);

            // ----------------------------------------------------------------

            // Clean the URL
            newState.cleanUrl = newState.url.replace(/\??\&_suid.*/, '');
            newState.url = newState.cleanUrl;

            // Check to see if we have more than just a url
            dataNotEmpty = !History.isEmptyObject(newState.data);

            // Apply
            if ((newState.title || dataNotEmpty) && History.options.disableSuid !== true) {
                // Add ID to Hash
                newState.hash = History.getShortUrl(newState.url).replace(/\??\&_suid.*/, '');
                if (!/\?/.test(newState.hash)) {
                    newState.hash += '?';
                }
                newState.hash += '&_suid=' + newState.id;
            }

            // Create the Hashed URL
            newState.hashedUrl = History.getFullUrl(newState.hash);

            // ----------------------------------------------------------------

            // Update the URL if we have a duplicate
            if ((History.emulated.pushState || History.bugs.safariPoll) && History.hasUrlDuplicate(newState)) {
                newState.url = newState.hashedUrl;
            }

            // ----------------------------------------------------------------

            // Return
            return newState;
        };

        /**
         * History.createStateObject(data,title,url)
         * Creates a object based on the data, title and url state params
         * @param {object} data
         * @param {string} title
         * @param {string} url
         * @return {object}
         */
        History.createStateObject = function (data, title, url) {
            // Hashify
            var State = {
                'data': data,
                'title': title,
                'url': url
            };

            // Expand the State
            State = History.normalizeState(State);

            // Return object
            return State;
        };

        /**
         * History.getStateById(id)
         * Get a state by it's UID
         * @param {String} id
         */
        History.getStateById = function (id) {
            // Prepare
            id = String(id);

            // Retrieve
            var State = History.idToState[id] || History.store.idToState[id] || undefined;

            // Return State
            return State;
        };

        /**
         * Get a State's String
         * @param {State} passedState
         */
        History.getStateString = function (passedState) {
            // Prepare
            var State, cleanedState, str;

            // Fetch
            State = History.normalizeState(passedState);

            // Clean
            cleanedState = {
                data: State.data,
                title: passedState.title,
                url: passedState.url
            };

            // Fetch
            str = JSON.stringify(cleanedState);

            // Return
            return str;
        };

        /**
         * Get a State's ID
         * @param {State} passedState
         * @return {String} id
         */
        History.getStateId = function (passedState) {
            // Prepare
            var State, id;

            // Fetch
            State = History.normalizeState(passedState);

            // Fetch
            id = State.id;

            // Return
            return id;
        };

        /**
         * History.getHashByState(State)
         * Creates a Hash for the State Object
         * @param {State} passedState
         * @return {String} hash
         */
        History.getHashByState = function (passedState) {
            // Prepare
            var State, hash;

            // Fetch
            State = History.normalizeState(passedState);

            // Hash
            hash = State.hash;

            // Return
            return hash;
        };

        /**
         * History.extractId(url_or_hash)
         * Get a State ID by it's URL or Hash
         * @param {string} url_or_hash
         * @return {string} id
         */
        History.extractId = function (url_or_hash) {
            // Prepare
            var id, parts, url, tmp;

            // Extract

            // If the URL has a #, use the id from before the #
            if (url_or_hash.indexOf('#') != -1) {
                tmp = url_or_hash.split("#")[0];
            } else {
                tmp = url_or_hash;
            }

            parts = /(.*)\&_suid=([0-9]+)$/.exec(tmp);
            url = parts ? parts[1] || url_or_hash : url_or_hash;
            id = parts ? String(parts[2] || '') : '';

            // Return
            return id || false;
        };

        /**
         * History.isTraditionalAnchor
         * Checks to see if the url is a traditional anchor or not
         * @param {String} url_or_hash
         * @return {Boolean}
         */
        History.isTraditionalAnchor = function (url_or_hash) {
            // Check
            var isTraditional = !/[\/\?\.]/.test(url_or_hash);

            // Return
            return isTraditional;
        };

        /**
         * History.extractState
         * Get a State by it's URL or Hash
         * @param {String} url_or_hash
         * @return {State|null}
         */
        History.extractState = function (url_or_hash, create) {
            // Prepare
            var State = null,
                id,
                url;
            create = create || false;

            // Fetch SUID
            id = History.extractId(url_or_hash);
            if (id) {
                State = History.getStateById(id);
            }

            // Fetch SUID returned no State
            if (!State) {
                // Fetch URL
                url = History.getFullUrl(url_or_hash);

                // Check URL
                id = History.getIdByUrl(url) || false;
                if (id) {
                    State = History.getStateById(id);
                }

                // Create State
                if (!State && create && !History.isTraditionalAnchor(url_or_hash)) {
                    State = History.createStateObject(null, null, url);
                }
            }

            // Return
            return State;
        };

        /**
         * History.getIdByUrl()
         * Get a State ID by a State URL
         */
        History.getIdByUrl = function (url) {
            // Fetch
            var id = History.urlToId[url] || History.store.urlToId[url] || undefined;

            // Return
            return id;
        };

        /**
         * History.getLastSavedState()
         * Get an object containing the data, title and url of the current state
         * @return {Object} State
         */
        History.getLastSavedState = function () {
            return History.savedStates[History.savedStates.length - 1] || undefined;
        };

        /**
         * History.getLastStoredState()
         * Get an object containing the data, title and url of the current state
         * @return {Object} State
         */
        History.getLastStoredState = function () {
            return History.storedStates[History.storedStates.length - 1] || undefined;
        };

        /**
         * History.hasUrlDuplicate
         * Checks if a Url will have a url conflict
         * @param {Object} newState
         * @return {Boolean} hasDuplicate
         */
        History.hasUrlDuplicate = function (newState) {
            // Prepare
            var hasDuplicate = false,
                oldState;

            // Fetch
            oldState = History.extractState(newState.url);

            // Check
            hasDuplicate = oldState && oldState.id !== newState.id;

            // Return
            return hasDuplicate;
        };

        /**
         * History.storeState
         * Store a State
         * @param {Object} newState
         * @return {Object} newState
         */
        History.storeState = function (newState) {
            // Store the State
            History.urlToId[newState.url] = newState.id;

            // Push the State
            History.storedStates.push(History.cloneObject(newState));

            // Return newState
            return newState;
        };

        /**
         * History.isLastSavedState(newState)
         * Tests to see if the state is the last state
         * @param {Object} newState
         * @return {boolean} isLast
         */
        History.isLastSavedState = function (newState) {
            // Prepare
            var isLast = false,
                newId,
                oldState,
                oldId;

            // Check
            if (History.savedStates.length) {
                newId = newState.id;
                oldState = History.getLastSavedState();
                oldId = oldState.id;

                // Check
                isLast = newId === oldId;
            }

            // Return
            return isLast;
        };

        /**
         * History.saveState
         * Push a State
         * @param {Object} newState
         * @return {boolean} changed
         */
        History.saveState = function (newState) {
            // Check Hash
            if (History.isLastSavedState(newState)) {
                return false;
            }

            // Push the State
            History.savedStates.push(History.cloneObject(newState));

            // Return true
            return true;
        };

        /**
         * History.getStateByIndex()
         * Gets a state by the index
         * @param {integer} index
         * @return {Object}
         */
        History.getStateByIndex = function (index) {
            // Prepare
            var State = null;

            // Handle
            if (typeof index === 'undefined') {
                // Get the last inserted
                State = History.savedStates[History.savedStates.length - 1];
            } else if (index < 0) {
                // Get from the end
                State = History.savedStates[History.savedStates.length + index];
            } else {
                // Get from the beginning
                State = History.savedStates[index];
            }

            // Return State
            return State;
        };

        /**
         * History.getCurrentIndex()
         * Gets the current index
         * @return (integer)
         */
        History.getCurrentIndex = function () {
            // Prepare
            var index = null;

            // No states saved
            if (History.savedStates.length < 1) {
                index = 0;
            } else {
                index = History.savedStates.length - 1;
            }
            return index;
        };

        // ====================================================================
        // Hash Helpers

        /**
         * History.getHash()
         * @param {Location=} location
         * Gets the current document hash
         * Note: unlike location.hash, this is guaranteed to return the escaped hash in all browsers
         * @return {string}
         */
        History.getHash = function (doc) {
            var url = History.getLocationHref(doc),
                hash;
            hash = History.getHashByUrl(url);
            return hash;
        };

        /**
         * History.unescapeHash()
         * normalize and Unescape a Hash
         * @param {String} hash
         * @return {string}
         */
        History.unescapeHash = function (hash) {
            // Prepare
            var result = History.normalizeHash(hash);

            // Unescape hash
            result = decodeURIComponent(result);

            // Return result
            return result;
        };

        /**
         * History.normalizeHash()
         * normalize a hash across browsers
         * @return {string}
         */
        History.normalizeHash = function (hash) {
            // Prepare
            var result = hash.replace(/[^#]*#/, '').replace(/#.*/, '');

            // Return result
            return result;
        };

        /**
         * History.setHash(hash)
         * Sets the document hash
         * @param {string} hash
         * @return {History}
         */
        History.setHash = function (hash, queue) {
            // Prepare
            var State, pageUrl;

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.setHash: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.setHash,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Log
            //History.debug('History.setHash: called',hash);

            // Make Busy + Continue
            History.busy(true);

            // Check if hash is a state
            State = History.extractState(hash, true);
            if (State && !History.emulated.pushState) {
                // Hash is a state so skip the setHash
                //History.debug('History.setHash: Hash is a state so skipping the hash set with a direct pushState call',arguments);

                // PushState
                History.pushState(State.data, State.title, State.url, false);
            } else if (History.getHash() !== hash) {
                // Hash is a proper hash, so apply it

                // Handle browser bugs
                if (History.bugs.setHash) {
                    // Fix Safari Bug https://bugs.webkit.org/show_bug.cgi?id=56249

                    // Fetch the base page
                    pageUrl = History.getPageUrl();

                    // Safari hash apply
                    History.pushState(null, null, pageUrl + '#' + hash, false);
                } else {
                    // Normal hash apply
                    document.location.hash = hash;
                }
            }

            // Chain
            return History;
        };

        /**
         * History.escape()
         * normalize and Escape a Hash
         * @return {string}
         */
        History.escapeHash = function (hash) {
            // Prepare
            var result = History.normalizeHash(hash);

            // Escape hash
            result = window.encodeURIComponent(result);

            // IE6 Escape Bug
            if (!History.bugs.hashEscape) {
                // Restore common parts
                result = result.replace(/\%21/g, '!').replace(/\%26/g, '&').replace(/\%3D/g, '=').replace(/\%3F/g, '?');
            }

            // Return result
            return result;
        };

        /**
         * History.getHashByUrl(url)
         * Extracts the Hash from a URL
         * @param {string} url
         * @return {string} url
         */
        History.getHashByUrl = function (url) {
            // Extract the hash
            var hash = String(url).replace(/([^#]*)#?([^#]*)#?(.*)/, '$2');

            // Unescape hash
            hash = History.unescapeHash(hash);

            // Return hash
            return hash;
        };

        /**
         * History.setTitle(title)
         * Applies the title to the document
         * @param {State} newState
         * @return {Boolean}
         */
        History.setTitle = function (newState) {
            // Prepare
            var title = newState.title,
                firstState;

            // Initial
            if (!title) {
                firstState = History.getStateByIndex(0);
                if (firstState && firstState.url === newState.url) {
                    title = firstState.title || History.options.initialTitle;
                }
            }

            // Apply
            try {
                document.getElementsByTagName('title')[0].innerHTML = title.replace('<', '&lt;').replace('>', '&gt;').replace(' & ', ' &amp; ');
            } catch (Exception) {}
            document.title = title;

            // Chain
            return History;
        };

        // ====================================================================
        // Queueing

        /**
         * History.queues
         * The list of queues to use
         * First In, First Out
         */
        History.queues = [];

        /**
         * History.busy(value)
         * @param {boolean} value [optional]
         * @return {boolean} busy
         */
        History.busy = function (value) {
            // Apply
            if (typeof value !== 'undefined') {
                //History.debug('History.busy: changing ['+(History.busy.flag||false)+'] to ['+(value||false)+']', History.queues.length);
                History.busy.flag = value;
            }
            // Default
            else if (typeof History.busy.flag === 'undefined') {
                    History.busy.flag = false;
                }

            // Queue
            if (!History.busy.flag) {
                // Execute the next item in the queue
                clearTimeout(History.busy.timeout);
                var fireNext = function fireNext() {
                    var i, queue, item;
                    if (History.busy.flag) return;
                    for (i = History.queues.length - 1; i >= 0; --i) {
                        queue = History.queues[i];
                        if (queue.length === 0) continue;
                        item = queue.shift();
                        History.fireQueueItem(item);
                        History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
                    }
                };
                History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
            }

            // Return
            return History.busy.flag;
        };

        /**
         * History.busy.flag
         */
        History.busy.flag = false;

        /**
         * History.fireQueueItem(item)
         * Fire a Queue Item
         * @param {Object} item
         * @return {Mixed} result
         */
        History.fireQueueItem = function (item) {
            return item.callback.apply(item.scope || History, item.args || []);
        };

        /**
         * History.pushQueue(callback,args)
         * Add an item to the queue
         * @param {Object} item [scope,callback,args,queue]
         */
        History.pushQueue = function (item) {
            // Prepare the queue
            History.queues[item.queue || 0] = History.queues[item.queue || 0] || [];

            // Add to the queue
            History.queues[item.queue || 0].push(item);

            // Chain
            return History;
        };

        /**
         * History.queue (item,queue), (func,queue), (func), (item)
         * Either firs the item now if not busy, or adds it to the queue
         */
        History.queue = function (item, queue) {
            // Prepare
            if (typeof item === 'function') {
                item = {
                    callback: item
                };
            }
            if (typeof queue !== 'undefined') {
                item.queue = queue;
            }

            // Handle
            if (History.busy()) {
                History.pushQueue(item);
            } else {
                History.fireQueueItem(item);
            }

            // Chain
            return History;
        };

        /**
         * History.clearQueue()
         * Clears the Queue
         */
        History.clearQueue = function () {
            History.busy.flag = false;
            History.queues = [];
            return History;
        };

        // ====================================================================
        // IE Bug Fix

        /**
         * History.stateChanged
         * States whether or not the state has changed since the last double check was initialised
         */
        History.stateChanged = false;

        /**
         * History.doubleChecker
         * Contains the timeout used for the double checks
         */
        History.doubleChecker = false;

        /**
         * History.doubleCheckComplete()
         * Complete a double check
         * @return {History}
         */
        History.doubleCheckComplete = function () {
            // Update
            History.stateChanged = true;

            // Clear
            History.doubleCheckClear();

            // Chain
            return History;
        };

        /**
         * History.doubleCheckClear()
         * Clear a double check
         * @return {History}
         */
        History.doubleCheckClear = function () {
            // Clear
            if (History.doubleChecker) {
                clearTimeout(History.doubleChecker);
                History.doubleChecker = false;
            }

            // Chain
            return History;
        };

        /**
         * History.doubleCheck()
         * Create a double check
         * @return {History}
         */
        History.doubleCheck = function (tryAgain) {
            // Reset
            History.stateChanged = false;
            History.doubleCheckClear();

            // Fix IE6,IE7 bug where calling history.back or history.forward does not actually change the hash (whereas doing it manually does)
            // Fix Safari 5 bug where sometimes the state does not change: https://bugs.webkit.org/show_bug.cgi?id=42940
            if (History.bugs.ieDoubleCheck) {
                // Apply Check
                History.doubleChecker = setTimeout(function () {
                    History.doubleCheckClear();
                    if (!History.stateChanged) {
                        //History.debug('History.doubleCheck: State has not yet changed, trying again', arguments);
                        // Re-Attempt
                        tryAgain();
                    }
                    return true;
                }, History.options.doubleCheckInterval);
            }

            // Chain
            return History;
        };

        // ====================================================================
        // Safari Bug Fix

        /**
         * History.safariStatePoll()
         * Poll the current state
         * @return {History}
         */
        History.safariStatePoll = function () {
            // Poll the URL

            // Get the Last State which has the new URL
            var urlState = History.extractState(History.getLocationHref()),
                newState;

            // Check for a difference
            if (!History.isLastSavedState(urlState)) {
                newState = urlState;
            } else {
                return;
            }

            // Check if we have a state with that url
            // If not create it
            if (!newState) {
                //History.debug('History.safariStatePoll: new');
                newState = History.createStateObject();
            }

            // Apply the New State
            //History.debug('History.safariStatePoll: trigger');
            History.Adapter.trigger(window, 'popstate');

            // Chain
            return History;
        };

        // ====================================================================
        // State Aliases

        /**
         * History.back(queue)
         * Send the browser history back one item
         * @param {Integer} queue [optional]
         */
        History.back = function (queue) {
            //History.debug('History.back: called', arguments);

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.back: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.back,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Make Busy + Continue
            History.busy(true);

            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function () {
                History.back(false);
            });

            // Go back
            history.go(-1);

            // End back closure
            return true;
        };

        /**
         * History.forward(queue)
         * Send the browser history forward one item
         * @param {Integer} queue [optional]
         */
        History.forward = function (queue) {
            //History.debug('History.forward: called', arguments);

            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.forward: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.forward,
                    args: arguments,
                    queue: queue
                });
                return false;
            }

            // Make Busy + Continue
            History.busy(true);

            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function () {
                History.forward(false);
            });

            // Go forward
            history.go(1);

            // End forward closure
            return true;
        };

        /**
         * History.go(index,queue)
         * Send the browser history back or forward index times
         * @param {Integer} queue [optional]
         */
        History.go = function (index, queue) {
            //History.debug('History.go: called', arguments);

            // Prepare
            var i;

            // Handle
            if (index > 0) {
                // Forward
                for (i = 1; i <= index; ++i) {
                    History.forward(queue);
                }
            } else if (index < 0) {
                // Backward
                for (i = -1; i >= index; --i) {
                    History.back(queue);
                }
            } else {
                throw new Error('History.go: History.go requires a positive or negative integer passed.');
            }

            // Chain
            return History;
        };

        // ====================================================================
        // HTML5 State Support

        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /*
             * Provide Skeleton for HTML4 Browsers
             */

            // Prepare
            var emptyFunction = function emptyFunction() {};
            History.pushState = History.pushState || emptyFunction;
            History.replaceState = History.replaceState || emptyFunction;
        } // History.emulated.pushState

        // Native pushState Implementation
        else {
                /*
                 * Use native HTML5 History API Implementation
                 */

                /**
                 * History.onPopState(event,extra)
                 * Refresh the Current State
                 */
                History.onPopState = function (event, extra) {
                    // Prepare
                    var stateId = false,
                        newState = false,
                        currentHash,
                        currentState;

                    // Reset the double check
                    History.doubleCheckComplete();

                    // Check for a Hash, and handle apporiatly
                    currentHash = History.getHash();
                    if (currentHash) {
                        // Expand Hash
                        currentState = History.extractState(currentHash || History.getLocationHref(), true);
                        if (currentState) {
                            // We were able to parse it, it must be a State!
                            // Let's forward to replaceState
                            //History.debug('History.onPopState: state anchor', currentHash, currentState);
                            History.replaceState(currentState.data, currentState.title, currentState.url, false);
                        } else {
                            // Traditional Anchor
                            //History.debug('History.onPopState: traditional anchor', currentHash);
                            History.Adapter.trigger(window, 'anchorchange');
                            History.busy(false);
                        }

                        // We don't care for hashes
                        History.expectedStateId = false;
                        return false;
                    }

                    // Ensure
                    stateId = History.Adapter.extractEventData('state', event, extra) || false;

                    // Fetch State
                    if (stateId) {
                        // Vanilla: Back/forward button was used
                        newState = History.getStateById(stateId);
                    } else if (History.expectedStateId) {
                        // Vanilla: A new state was pushed, and popstate was called manually
                        newState = History.getStateById(History.expectedStateId);
                    } else {
                        // Initial State
                        newState = History.extractState(History.getLocationHref());
                    }

                    // The State did not exist in our store
                    if (!newState) {
                        // Regenerate the State
                        newState = History.createStateObject(null, null, History.getLocationHref());
                    }

                    // Clean
                    History.expectedStateId = false;

                    // Check if we are the same state
                    if (History.isLastSavedState(newState)) {
                        // There has been no change (just the page's hash has finally propagated)
                        //History.debug('History.onPopState: no change', newState, History.savedStates);
                        History.busy(false);
                        return false;
                    }

                    // Store the State
                    History.storeState(newState);
                    History.saveState(newState);

                    // Force update of the title
                    History.setTitle(newState);

                    // Fire Our Event
                    History.Adapter.trigger(window, 'statechange');
                    History.busy(false);

                    // Return true
                    return true;
                };
                History.Adapter.bind(window, 'popstate', History.onPopState);

                /**
                 * History.pushState(data,title,url)
                 * Add a new State to the history object, become it, and trigger onpopstate
                 * We have to trigger for HTML4 compatibility
                 * @param {object} data
                 * @param {string} title
                 * @param {string} url
                 * @return {true}
                 */
                History.pushState = function (data, title, url, queue) {
                    //History.debug('History.pushState: called', arguments);

                    // Check the State
                    if (History.getHashByUrl(url) && History.emulated.pushState) {
                        throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
                    }

                    // Handle Queueing
                    if (queue !== false && History.busy()) {
                        // Wait + Push to Queue
                        //History.debug('History.pushState: we must wait', arguments);
                        History.pushQueue({
                            scope: History,
                            callback: History.pushState,
                            args: arguments,
                            queue: queue
                        });
                        return false;
                    }

                    // Make Busy + Continue
                    History.busy(true);

                    // Create the newState
                    var newState = History.createStateObject(data, title, url);

                    // Check it
                    if (History.isLastSavedState(newState)) {
                        // Won't be a change
                        History.busy(false);
                    } else {
                        // Store the newState
                        History.storeState(newState);
                        History.expectedStateId = newState.id;

                        // Push the newState
                        history.pushState(newState.id, newState.title, newState.url);

                        // Fire HTML5 Event
                        History.Adapter.trigger(window, 'popstate');
                    }

                    // End pushState closure
                    return true;
                };

                /**
                 * History.replaceState(data,title,url)
                 * Replace the State and trigger onpopstate
                 * We have to trigger for HTML4 compatibility
                 * @param {object} data
                 * @param {string} title
                 * @param {string} url
                 * @return {true}
                 */
                History.replaceState = function (data, title, url, queue) {
                    //History.debug('History.replaceState: called', arguments);

                    // Check the State
                    if (History.getHashByUrl(url) && History.emulated.pushState) {
                        throw new Error('History.js does not support states with fragement-identifiers (hashes/anchors).');
                    }

                    // Handle Queueing
                    if (queue !== false && History.busy()) {
                        // Wait + Push to Queue
                        //History.debug('History.replaceState: we must wait', arguments);
                        History.pushQueue({
                            scope: History,
                            callback: History.replaceState,
                            args: arguments,
                            queue: queue
                        });
                        return false;
                    }

                    // Make Busy + Continue
                    History.busy(true);

                    // Create the newState
                    var newState = History.createStateObject(data, title, url);

                    // Check it
                    if (History.isLastSavedState(newState)) {
                        // Won't be a change
                        History.busy(false);
                    } else {
                        // Store the newState
                        History.storeState(newState);
                        History.expectedStateId = newState.id;

                        // Push the newState
                        history.replaceState(newState.id, newState.title, newState.url);

                        // Fire HTML5 Event
                        History.Adapter.trigger(window, 'popstate');
                    }

                    // End replaceState closure
                    return true;
                };
            } // !History.emulated.pushState


        // ====================================================================
        // Initialise

        /**
         * Load the Store
         */
        if (sessionStorage) {
            // Fetch
            try {
                History.store = JSON.parse(sessionStorage.getItem('History.store')) || {};
            } catch (err) {
                History.store = {};
            }

            // Normalize
            History.normalizeStore();
        } else {
            // Default Load
            History.store = {};
            History.normalizeStore();
        }

        /**
         * Clear Intervals on exit to prevent memory leaks
         */
        History.Adapter.bind(window, "unload", History.clearAllIntervals);

        /**
         * Create the initial State
         */
        History.saveState(History.storeState(History.extractState(History.getLocationHref(), true)));

        /**
         * Bind for Saving Store
         */
        if (sessionStorage) {
            // When the page is closed
            History.onUnload = function () {
                // Prepare
                var currentStore, item, currentStoreString;

                // Fetch
                try {
                    currentStore = JSON.parse(sessionStorage.getItem('History.store')) || {};
                } catch (err) {
                    currentStore = {};
                }

                // Ensure
                currentStore.idToState = currentStore.idToState || {};
                currentStore.urlToId = currentStore.urlToId || {};
                currentStore.stateToId = currentStore.stateToId || {};

                // Sync
                for (item in History.idToState) {
                    if (!History.idToState.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.idToState[item] = History.idToState[item];
                }
                for (item in History.urlToId) {
                    if (!History.urlToId.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.urlToId[item] = History.urlToId[item];
                }
                for (item in History.stateToId) {
                    if (!History.stateToId.hasOwnProperty(item)) {
                        continue;
                    }
                    currentStore.stateToId[item] = History.stateToId[item];
                }

                // Update
                History.store = currentStore;
                History.normalizeStore();

                // In Safari, going into Private Browsing mode causes the
                // Session Storage object to still exist but if you try and use
                // or set any property/function of it it throws the exception
                // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to
                // add something to storage that exceeded the quota." infinitely
                // every second.
                currentStoreString = JSON.stringify(currentStore);
                try {
                    // Store
                    sessionStorage.setItem('History.store', currentStoreString);
                } catch (e) {
                    if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
                        if (sessionStorage.length) {
                            // Workaround for a bug seen on iPads. Sometimes the quota exceeded error comes up and simply
                            // removing/resetting the storage can work.
                            sessionStorage.removeItem('History.store');
                            sessionStorage.setItem('History.store', currentStoreString);
                        } else {
                            // Otherwise, we're probably private browsing in Safari, so we'll ignore the exception.
                        }
                    } else {
                        throw e;
                    }
                }
            };

            // For Internet Explorer
            History.intervalList.push(setInterval(History.onUnload, History.options.storeInterval));

            // For Other Browsers
            History.Adapter.bind(window, 'beforeunload', History.onUnload);
            History.Adapter.bind(window, 'unload', History.onUnload);

            // Both are enabled for consistency
        }

        // Non-Native pushState Implementation
        if (!History.emulated.pushState) {
            // Be aware, the following is only for native pushState implementations
            // If you are wanting to include something for all browsers
            // Then include it above this if block

            /**
             * Setup Safari Fix
             */
            if (History.bugs.safariPoll) {
                History.intervalList.push(setInterval(History.safariStatePoll, History.options.safariPollInterval));
            }

            /**
             * Ensure Cross Browser Compatibility
             */
            if (navigator.vendor === 'Apple Computer, Inc.' || (navigator.appCodeName || '') === 'Mozilla') {
                /**
                 * Fix Safari HashChange Issue
                 */

                // Setup Alias
                History.Adapter.bind(window, 'hashchange', function () {
                    History.Adapter.trigger(window, 'popstate');
                });

                // Initialise Alias
                if (History.getHash()) {
                    History.Adapter.onDomLoad(function () {
                        History.Adapter.trigger(window, 'hashchange');
                    });
                }
            }
        } // !History.emulated.pushState

    }; // History.initCore

    // Try to Initialise History
    if (!History.options || !History.options.delayInit) {
        History.init();
    }
})(window);

/**
 * View model constructor for social login
 */
app.registerConstructor("SocialLoginCommon", function () {
    var self = this;

    this.remoteLoginFunction = _.noop;

    /**
     * A generic entrance point for remote login. Developer should assign actual specific login logic to self.remoteLoginFunction on different environment.
     * @param token
     * @param id
     * @param fname
     * @param lname
     * @param email
     * @param source
     * @param link
     * @param profile
     * @param profilePicture
     * @returns {*}
     */
    this.doRemoteLogin = function (token, id, fname, lname, email, source, link, profile, profilePicture) {
        return self.remoteLoginFunction(token, id, fname, lname, email, source, link, profile, profilePicture);
    };

    this.redirectPost = function (location, args) {
        var form = '';
        app.console.log(args);
        $.each(args, function (key, value) {
            form += '<input type="hidden" name="' + key + '" value="' + value + '"/>';
        });
        app.console.log(form);
        $('<form action="' + location + '" method="POST">' + form + '</form>').appendTo($(document.body)).submit();
    };
}).createVM();

/*global window, FB */

/**
 * View model constructor for Facebook login
 */
app.registerConstructor("FacebookLogin", function () {
    var self = this;
    this.trace = false;
    self.forceLogout = true;

    this.initFacebook = function (opts) {
        FB.init({
            appId: "" + opts.appId,
            channelUrl: opts.channel,
            status: true,
            xfbml: true,
            cookie: true
        });

        FB.Event.subscribe('auth.statusChange', function (response) {
            if (response.status == 'connected' && self.forceLogout === true) {
                self.forceLogout = false;
                setTimeout(function () {
                    app.vm.FacebookLogin.fbLogout();
                }, 400);
            }
        });
    };

    this.fbLogout = function () {
        try {
            FB.logout();
        } catch (e) {
            app.console.log("Fail to FB Logout on load" + e);
        }
    };

    function getFBdetails() {
        FB.api("/me", { fields: "id,first_name,last_name,email,link,picture" }, function (response) {
            if (response) {
                var token = FB.getAuthResponse().accessToken;
                if (token) {
                    var imageURL;
                    if (response.picture && response.picture.data) {
                        imageURL = response.picture.data.url;
                    }

                    app.vm.SocialLoginCommon.doRemoteLogin(token, response.id, response.first_name, response.last_name, response.email, "Facebook", response.link, response, imageURL);
                } else {
                    app.console.error("Facebook login failed");
                }
            } else {
                app.console.error("An error occurred while fetching detail from Facebook");
            }
        });
    }

    /**
     * A callback listener to check the result of the user status and display login button if necessary
     * @param response Remote response from Facebook API
     * @param shouldPromptLogin Bring up login dialog if the user is not logged in
     */
    function checkLoginStatus(response, shouldPromptLogin) {

        if (response && response.status === "connected") {
            if (self.trace) app.console.log("User authorized " + response.status);
            getFBdetails();
        } else {
            if (self.trace) app.console.log("User is not authorised " + response.status);
            if (shouldPromptLogin) {
                if (self.trace) app.console.log("Prompt to login in");
                FB.login(function (res) {
                    return checkLoginStatus(res, false);
                }, { scope: "email" });
            }
        }
    }

    /**
     * Bind the log in with facebook icon to the authentication API call
     */
    this.attachLoginButton = function (selector) {
        $(selector).click(function () {
            self.forceLogout = false;
            FB.getLoginStatus(function (res) {
                return checkLoginStatus(res, true);
            });
        });
    };

    /*============================== Log out ==============================*/
    this.logoutUser = function (logout_url) {
        // LogOut can't be called directly, so wrapping this in check login status.
        if (self.trace) app.console.log("Check status before logging out.");
        FB.getLoginStatus(function (response) {
            if (response && response.status === "connected") {
                if (self.trace) app.console.log("User connected, try logout " + response.status);
                FB.logout(function () {
                    if (self.trace) app.console.log("Logged out of Facebook");
                    // Redirect to SB logout
                    location.replace(logout_url);
                });
            } else {
                if (self.trace) app.console.log("User is not connected " + response.status);
            }
        }, true);
    };
}).createVM();

/*global window, FB */

/**
 * View model constructor for Facebook login
 */
app.registerConstructor("LinkedinLogin", function () {
    var self = this;
    this.trace = false;

    this.initLinkedin = function () {
        try {
            IN.User.logout();
        } catch (e) {
            app.console.log("fail to Logout on load");
        }
        self.attachLoginButton('a.btn-linkedin');
    };

    this.attachLoginButton = function (selector) {
        $(selector).click(function () {
            IN.UI.Authorize().params({ "scope": ["r_basicprofile", "r_emailaddress"] }).place();
            IN.Event.on(IN, "auth", app.vm.LinkedinLogin.onLinkedInAuth);
            IN.User.setAuthorized(true);
            //IN.Event.on(IN, "logout", onLinkedInLogout);
        });
    };

    this.onLinkedInAuth = function () {
        IN.API.Profile("me").fields("id,firstName,lastName,emailAddress,publicProfileUrl,positions:(company:(name,type,industry,ticker),title,summary,startDate,endDate,isCurrent),industry,location:(name,country:(code)),dateOfBirth,headline,maidenName,currentShare,summary,pictureUrls::(original),pictureUrl,specialties,formattedPhoneticName").result(function (me) {
            var profile = me.values[0];

            var token = IN.ENV.auth.oauth_token;

            var imageURL;
            //console.log(IN.ENV.auth.oauth_token);
            if (!profile.pictureUrls || profile.pictureUrls._total == "0") {
                // No picture provided
                imageURL = profile.pictureUrl;
            } else {
                imageURL = profile.pictureUrls.values[0];
            };
            //app.vm.SocialLoginCommon.doRemoteLogin(token, response.id, response.first_name, response.last_name, response.email, "Facebook", response.link, response);

            app.vm.SocialLoginCommon.doRemoteLogin(token, profile.id, profile.firstName, profile.lastName, profile.emailAddress, 'LinkedIn', profile.publicProfileUrl, profile, imageURL);
        });
    };
}).createVM();

/*global window, FB */

/**
 * View model constructor for Facebook login
 */
app.registerConstructor("GoogleLogin", function () {
    var self = this;
    this.trace = false;
    this.auth2 = null;

    this.initGoogle = function (opts) {
        gapi.load('auth2', function () {
            // Retrieve the singleton for the GoogleAuth library and set up the client.
            self.auth2 = gapi.auth2.init({
                client_id: opts.clientID + '.apps.googleusercontent.com',
                cookiepolicy: 'single_host_origin'
                // Request scopes in addition to 'profile' and 'email'
                //scope: 'profile'
            });
            app.vm.GoogleLogin.attachLoginButton($(opts.googleBtn).get(-1));
        });
    };

    this.attachLoginButton = function (element) {
        self.auth2.attachClickHandler(element, {}, function (googleUser) {
            var profile = googleUser.getBasicProfile();
            var token = googleUser.getAuthResponse().id_token;

            app.vm.SocialLoginCommon.doRemoteLogin(token, profile.getId(), profile.getGivenName(), profile.getFamilyName(), profile.getEmail(), 'Google', profile.getImageUrl(), profile, profile.getImageUrl());
        }, function (error) {
            app.console.log(JSON.stringify(error, undefined, 2));
        });
    };
}).createVM();

/**
 * View model constructor for social login
 */
app.registerConstructor("SocialStorageCommon", function () {
    var self = this;

    /**
     * A generic entrance point for remote social storage handling.
     * Developer should assign actual specific login logic to self.remoteRetrieveFileFunction
     * on different environment.
     *
     * @param files A JSON array contains chosen files. Each item should have the follow fields: name, source, downloadLink, token(optional).
     * @param remoteAction A PrimeFaces remote command function for server side handling
     */
    this.doRemoteRetrieveFile = function (files, remoteAction) {
        remoteAction([{ name: "files", value: JSON.stringify(files) }]);
    };
}).createVM();

/**
 * Make sure you have the following import
 * <script data-app-key="j0ljsiidl5jokcn" id="dropboxjs" src="https://www.dropbox.com/static/api/1/dropbox.js" type="text/javascript"></script>
 */

app.registerConstructor("DropboxStorage", function () {
    var self = this;

    this.chooseFile = function () {
        Dropbox.choose({ linkType: "direct", multiselect: "false", success: self.success });
    };

    this.success = function (filesInResponse) {
        if (!filesInResponse || filesInResponse.length === 0) return;
        var files = _.map(filesInResponse, function (f) {
            return {
                "name": f.name,
                "source": "DROPBOX",
                "downloadLink": f.link
            };
        });
        console.log("Dropbox file picked:");
        console.log(files);
        app.vm.SocialStorageCommon.doRemoteRetrieveFile(files, remoteOnSocialStorageChosen);
    };
}).createVM();

/**
 * Make sure you have the following import
 * <script data-app-key="j0ljsiidl5jokcn" id="dropboxjs" src="https://www.dropbox.com/static/api/1/dropbox.js" type="text/javascript"></script>
 */

app.registerConstructor("GoogleDriveStorage", function (opts) {
    var self = this;
    var apiKey = opts.apiKey;
    var clientId = opts.clientId;
    var scopes = opts.scopes;
    var oauthToken = null;

    var checkAuth = function checkAuth() {
        var opts = {
            'client_id': clientId,
            'scope': scopes,
            'immediate': false
        };
        gapi.auth.authorize(opts, handleAuthResult);
    };

    var handleAuthClick = function handleAuthClick() {
        checkAuth();
    };

    // Create and render a Picker object for searching docs.
    var createPicker = function createPicker() {
        var picker = new google.picker.PickerBuilder().addView(google.picker.ViewId.DOCS).setOAuthToken(oauthToken).setCallback(pickerCallback).build();
        picker.setVisible(true);
    };

    var withURL = function withURL(id, action) {
        gapi.client.load('drive', 'v2', function () {
            var request = gapi.client.drive.files.get({
                'fileId': id
            });
            request.execute(function (resp) {
                var downloadurl = void 0;
                var accessToken = gapi.auth.getToken().access_token;
                if (typeof resp.downloadUrl !== "undefined") {
                    downloadurl = resp.downloadUrl + "&access_token=" + accessToken;
                } else {
                    downloadurl = resp['exportLinks']['application/pdf'] + "&access_token=" + accessToken;
                }
                action(downloadurl);
            });
        });
    };

    var pickerCallback = function pickerCallback(data) {
        if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
            var doc = data[google.picker.Response.DOCUMENTS][0];
            var id = doc[google.picker.Document.ID];
            var filename = doc[google.picker.Document.NAME];
            withURL(id, function (url) {
                var files = [{
                    "name": filename,
                    "source": "GOOGLE_DRIVE",
                    "downloadLink": url
                }];
                app.vm.SocialStorageCommon.doRemoteRetrieveFile(files, remoteOnSocialStorageChosen);
            });
        }
    };

    var handleAuthResult = function handleAuthResult(authResult) {
        if (authResult && !authResult.error) {
            oauthToken = authResult.access_token;
            google.load('picker', '1', { "callback": createPicker });
        } else {
            // handleAuthClick();
        }
    };

    self.newPicker = function () {
        gapi.client.setApiKey(apiKey);
        checkAuth();
    };
});